webpackJsonp([4],{

/***/ "./__mocks__/draft-js.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "convertToRaw", function() { return convertToRaw; });
// Inside draft-convert this is used to convert draft contentState (required param) to raw serialized state.
// We already have raw state (as returned from the API), so we'd like to pass that right to draft-convert
// so we make that line a noop by forcing it to use this module instead of the real draft-js one.
var convertToRaw = function convertToRaw(contentState) {
  return contentState;
};

/***/ }),

/***/ "./src/actions/authDrawer.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "toggleAuthDrawer", function() { return toggleAuthDrawer; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "changeStep", function() { return changeStep; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "setBasicInfo", function() { return setBasicInfo; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "setOptionalInfo", function() { return setOptionalInfo; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "registerEmail", function() { return registerEmail; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "requestPasswordReset", function() { return requestPasswordReset; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "setPasswordResetInfo", function() { return setPasswordResetInfo; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "changePassword", function() { return changePassword; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "setAuthToken", function() { return setAuthToken; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "logOut", function() { return logOut; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "confirmEmail", function() { return confirmEmail; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__constants_actionTypes__ = __webpack_require__("./src/constants/actionTypes.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utils_backend__ = __webpack_require__("./src/utils/backend.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils_auth__ = __webpack_require__("./src/utils/auth.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__utils_localdb__ = __webpack_require__("./src/utils/localdb.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_actions_user__ = __webpack_require__("./src/actions/user.js");






var toggleAuthDrawer = function toggleAuthDrawer(bool) {
  return function (dispatch) {
    dispatch({
      type: __WEBPACK_IMPORTED_MODULE_0__constants_actionTypes__["a" /* AUTH_DRAWER_OPEN */],
      payload: bool
    });
  };
};

var changeStep = function changeStep(step) {
  return function (dispatch) {
    dispatch({
      type: __WEBPACK_IMPORTED_MODULE_0__constants_actionTypes__["e" /* CHANGE_STEP */],
      payload: step
    });
  };
};

var setBasicInfo = function setBasicInfo(userData) {
  return function (dispatch) {
    return __WEBPACK_IMPORTED_MODULE_1__utils_backend__["a" /* default */].request({
      method: "POST",
      url: "/readers/validate-email/",
      data: {
        email: userData.email
      }
    }).then(function (response) {
      if (response.data.available) {
        dispatch({
          type: __WEBPACK_IMPORTED_MODULE_0__constants_actionTypes__["_27" /* SET_BASIC_INFO */],
          payload: userData
        });

        dispatch({
          type: __WEBPACK_IMPORTED_MODULE_0__constants_actionTypes__["l" /* EMAIL_AVAILABLE */]
        });
      } else {
        dispatch({
          type: __WEBPACK_IMPORTED_MODULE_0__constants_actionTypes__["o" /* EMAIL_NOT_AVAILABLE */]
        });
      }
    }).catch(function (err) {
      dispatch({
        type: __WEBPACK_IMPORTED_MODULE_0__constants_actionTypes__["p" /* EMAIL_VALIDATION_REQUEST_ERROR */],
        payload: err
      });
    });
  };
};

var setOptionalInfo = function setOptionalInfo(userData) {
  return function (dispatch) {
    return new Promise(function (resolve) {
      dispatch({
        type: __WEBPACK_IMPORTED_MODULE_0__constants_actionTypes__["_29" /* SET_OPTIONAL_INFO */],
        payload: userData
      });

      resolve();
    });
  };
};

var registerEmail = function registerEmail(userData) {
  return function (dispatch) {
    return __WEBPACK_IMPORTED_MODULE_1__utils_backend__["a" /* default */].request({
      method: "POST",
      url: "/readers/create-user/",
      data: userData
    }).then(function (response) {
      dispatch({
        type: __WEBPACK_IMPORTED_MODULE_0__constants_actionTypes__["h" /* CREATE_USER_SUCCESS */],
        payload: response.data
      });
    }).catch(function (err) {
      dispatch({
        type: __WEBPACK_IMPORTED_MODULE_0__constants_actionTypes__["g" /* CREATE_USER_ERROR */],
        payload: err
      });
    });
  };
};

var requestPasswordReset = function requestPasswordReset(email) {
  return function (dispatch) {
    return __WEBPACK_IMPORTED_MODULE_1__utils_backend__["a" /* default */].request({
      method: "POST",
      url: "/readers/forgot-password/",
      data: {
        email: email
      }
    }).then(function () {
      dispatch({
        type: __WEBPACK_IMPORTED_MODULE_0__constants_actionTypes__["_23" /* PASSWORD_RESET_REQUEST_SUCCESS */]
      });
    }).catch(function (err) {
      dispatch({
        type: __WEBPACK_IMPORTED_MODULE_0__constants_actionTypes__["_22" /* PASSWORD_RESET_REQUEST_ERROR */],
        payload: err
      });
    });
  };
};

var setPasswordResetInfo = function setPasswordResetInfo(token, email) {
  return function (dispatch) {
    dispatch({
      type: __WEBPACK_IMPORTED_MODULE_0__constants_actionTypes__["_30" /* SET_PASSWORD_RESET_INFO */],
      payload: {
        token: token,
        email: email
      }
    });
  };
};

var changePassword = function changePassword(token, email, passwords) {
  return function (dispatch) {
    return __WEBPACK_IMPORTED_MODULE_1__utils_backend__["a" /* default */].request({
      method: "POST",
      url: "/readers/reset-password/",
      data: {
        token: token,
        email: email,
        password1: passwords.password1,
        password2: passwords.password2
      }
    }).then(function () {
      dispatch({
        type: __WEBPACK_IMPORTED_MODULE_0__constants_actionTypes__["_24" /* PASSWORD_RESET_SUCCESS */]
      });
    }).catch(function (err) {
      dispatch({
        type: __WEBPACK_IMPORTED_MODULE_0__constants_actionTypes__["_21" /* PASSWORD_RESET_ERROR */],
        payload: err
      });
    });
  };
};

var setAuthToken = function setAuthToken(authToken) {
  return function (dispatch) {
    return new Promise(function (resolve) {
      dispatch({
        type: __WEBPACK_IMPORTED_MODULE_0__constants_actionTypes__["_26" /* SET_AUTH_TOKEN */],
        payload: authToken
      });

      dispatch({
        type: __WEBPACK_IMPORTED_MODULE_0__constants_actionTypes__["_19" /* LOGGED_IN_STATUS */],
        payload: true
      });

      Object(__WEBPACK_IMPORTED_MODULE_2__utils_auth__["g" /* updateAxiosToken */])(authToken);

      dispatch(Object(__WEBPACK_IMPORTED_MODULE_4_actions_user__["a" /* getUserData */])()).then(function () {
        resolve();
      });
    });
  };
};

var logOut = function logOut() {
  return function (dispatch) {
    return new Promise(function (resolve) {
      Object(__WEBPACK_IMPORTED_MODULE_2__utils_auth__["a" /* backendLogOut */])();

      dispatch({
        type: __WEBPACK_IMPORTED_MODULE_0__constants_actionTypes__["_20" /* LOG_OUT */]
      });

      Object(__WEBPACK_IMPORTED_MODULE_3__utils_localdb__["b" /* removeLocalItem */])("authToken");

      resolve();
    });
  };
};

var confirmEmail = function confirmEmail(token, email) {
  return function (dispatch) {
    return __WEBPACK_IMPORTED_MODULE_1__utils_backend__["a" /* default */].request({
      method: "POST",
      url: "/readers/confirm-email/",
      data: {
        token: token,
        email: email
      }
    }).then(function () {
      dispatch({
        type: __WEBPACK_IMPORTED_MODULE_0__constants_actionTypes__["n" /* EMAIL_CONFIRM_SUCCESS */]
      });
    }).catch(function (err) {
      dispatch({
        type: __WEBPACK_IMPORTED_MODULE_0__constants_actionTypes__["m" /* EMAIL_CONFIRM_ERROR */],
        payload: err
      });
    });
  };
};

/***/ }),

/***/ "./src/actions/latestStories.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return getLatestStories; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils_backend__ = __webpack_require__("./src/utils/backend.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__constants_actionTypes__ = __webpack_require__("./src/constants/actionTypes.js");



var getLatestStories = function getLatestStories() {
  return function (dispatch, getState) {
    var state = getState();
    if (state.latestStories && state.latestStories.isLoading) {
      // Don't dispatch more requests for latest stories while API requests are still pending.
      return;
    }

    dispatch({
      type: __WEBPACK_IMPORTED_MODULE_1__constants_actionTypes__["w" /* GET_LATEST_STORIES */]
    });

    return __WEBPACK_IMPORTED_MODULE_0__utils_backend__["a" /* default */].request({
      method: "GET",
      url: "/most-recent/"
    }).then(function (response) {
      dispatch({
        type: __WEBPACK_IMPORTED_MODULE_1__constants_actionTypes__["y" /* GET_LATEST_STORIES_SUCCESS */],
        payload: response.data.results
      });
    }).catch(function (err) {
      dispatch({
        type: __WEBPACK_IMPORTED_MODULE_1__constants_actionTypes__["x" /* GET_LATEST_STORIES_ERROR */],
        payload: err
      });
    });
  };
};

/***/ }),

/***/ "./src/actions/navigation.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getSections", function() { return getSections; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getSection", function() { return getSection; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "setSection", function() { return setSection; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "setLastSeen", function() { return setLastSeen; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getSpecialFeatures", function() { return getSpecialFeatures; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "setSectionWithTag", function() { return setSectionWithTag; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils_backend__ = __webpack_require__("./src/utils/backend.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_selectn__ = __webpack_require__("./node_modules/selectn/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_selectn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_selectn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__constants_actionTypes__ = __webpack_require__("./src/constants/actionTypes.js");




var getSections = function getSections() {
  return function (dispatch) {
    dispatch({
      type: __WEBPACK_IMPORTED_MODULE_2__constants_actionTypes__["K" /* GET_SECTIONS */]
    });

    return __WEBPACK_IMPORTED_MODULE_0__utils_backend__["a" /* default */].request({
      method: "GET",
      url: "/sections/"
    }).then(function (response) {
      dispatch({
        type: __WEBPACK_IMPORTED_MODULE_2__constants_actionTypes__["M" /* GET_SECTIONS_SUCCESS */],
        payload: response.data.results
      });
    }).catch(function (err) {
      dispatch({
        type: __WEBPACK_IMPORTED_MODULE_2__constants_actionTypes__["L" /* GET_SECTIONS_ERROR */],
        payload: err
      });
    });
  };
};

var getSection = function getSection(slug) {
  return function (dispatch) {
    dispatch({
      type: __WEBPACK_IMPORTED_MODULE_2__constants_actionTypes__["J" /* GET_SECTION */]
    });

    return __WEBPACK_IMPORTED_MODULE_0__utils_backend__["a" /* default */].request({
      method: "GET",
      url: "/sections/" + slug + "/"
    }).then(function (response) {
      dispatch({
        type: __WEBPACK_IMPORTED_MODULE_2__constants_actionTypes__["O" /* GET_SECTION_SUCCESS */],
        payload: response.data
      });
    }).catch(function (err) {
      dispatch({
        type: __WEBPACK_IMPORTED_MODULE_2__constants_actionTypes__["N" /* GET_SECTION_ERROR */],
        payload: err
      });
    });
  };
};

var setSection = function setSection(section) {
  return function (dispatch) {
    dispatch({
      type: __WEBPACK_IMPORTED_MODULE_2__constants_actionTypes__["_31" /* SET_SECTION */],
      section: section
    });
  };
};

var setLastSeen = function setLastSeen(lastSeen) {
  return function (dispatch) {
    dispatch({
      type: __WEBPACK_IMPORTED_MODULE_2__constants_actionTypes__["_28" /* SET_LAST_SEEN */],
      lastSeen: lastSeen
    });
  };
};

var getSpecialFeatures = function getSpecialFeatures() {
  return function (dispatch) {
    dispatch({
      type: __WEBPACK_IMPORTED_MODULE_2__constants_actionTypes__["P" /* GET_SPECIAL_FEATURES */]
    });

    return __WEBPACK_IMPORTED_MODULE_0__utils_backend__["a" /* default */].request({
      method: "GET",
      url: "/special-features/"
    }).then(function (response) {
      dispatch({
        type: __WEBPACK_IMPORTED_MODULE_2__constants_actionTypes__["R" /* GET_SPECIAL_FEATURES_SUCCESS */],
        payload: response.data.results
      });
    }).catch(function (err) {
      dispatch({
        type: __WEBPACK_IMPORTED_MODULE_2__constants_actionTypes__["Q" /* GET_SPECIAL_FEATURES_ERROR */],
        payload: err
      });
    });
  };
};

var setSectionWithTag = function setSectionWithTag(tag) {
  return function (dispatch) {
    dispatch({
      type: __WEBPACK_IMPORTED_MODULE_2__constants_actionTypes__["_9" /* GET_TAG */]
    });

    return __WEBPACK_IMPORTED_MODULE_0__utils_backend__["a" /* default */].request({
      method: "GET",
      url: "/tag/" + tag + "/"
    }).then(function (response) {
      return dispatch(setSection({ slug: tag, name: __WEBPACK_IMPORTED_MODULE_1_selectn___default()("data.name", response) }));
    }).catch(function (err) {
      dispatch({
        type: __WEBPACK_IMPORTED_MODULE_2__constants_actionTypes__["_10" /* GET_TAG_ERROR */],
        payload: err
      });
    });
  };
};

/***/ }),

/***/ "./src/actions/search.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return getSearchResults; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils_backend__ = __webpack_require__("./src/utils/backend.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__constants_actionTypes__ = __webpack_require__("./src/constants/actionTypes.js");



var getSearchResults = function getSearchResults(search) {
  var page = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 1;
  var appendResults = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;

  return function (dispatch) {
    if (!appendResults) {
      dispatch({
        type: __WEBPACK_IMPORTED_MODULE_1__constants_actionTypes__["F" /* GET_SEARCH_RESULTS */]
      });
    }

    return __WEBPACK_IMPORTED_MODULE_0__utils_backend__["a" /* default */].request({
      method: "GET",
      url: "/search/",
      params: {
        search: search,
        page: page
      }
    }).then(function (response) {
      return dispatch({
        type: appendResults ? __WEBPACK_IMPORTED_MODULE_1__constants_actionTypes__["I" /* GET_SEARCH_RESULTS_UPDATE */] : __WEBPACK_IMPORTED_MODULE_1__constants_actionTypes__["H" /* GET_SEARCH_RESULTS_SUCCESS */],
        payload: response.data.results
      });
    }).catch(function (err) {
      dispatch({
        type: __WEBPACK_IMPORTED_MODULE_1__constants_actionTypes__["G" /* GET_SEARCH_RESULTS_ERROR */],
        payload: err
      });
    });
  };
};

/***/ }),

/***/ "./src/actions/storiesStream.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return getStoriesStream; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return loadNextStory; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return loadStory; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return loadRevision; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return loadLatest; });
/* unused harmony export addStory */
/* unused harmony export removeStory */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return resetStoriesStreamError; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return setStoryStream; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__("./node_modules/axios/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_selectn__ = __webpack_require__("./node_modules/selectn/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_selectn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_selectn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils_backend__ = __webpack_require__("./src/utils/backend.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__constants_actionTypes__ = __webpack_require__("./src/constants/actionTypes.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__config_constants__ = __webpack_require__("./src/config/constants.js");
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };








var getStoriesStream = function getStoriesStream(params) {
  var appendResults = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

  return function (dispatch) {
    if (!appendResults) {
      dispatch({
        type: __WEBPACK_IMPORTED_MODULE_3__constants_actionTypes__["S" /* GET_STORIES_STREAM */]
      });
    }
    return __WEBPACK_IMPORTED_MODULE_2__utils_backend__["a" /* default */].request({
      method: "GET",
      url: "/stream/",
      params: params
    }).then(function (response) {
      if (!appendResults && !__WEBPACK_IMPORTED_MODULE_1_selectn___default()("data.results.length", response)) {
        return dispatch({
          type: __WEBPACK_IMPORTED_MODULE_3__constants_actionTypes__["T" /* GET_STORIES_STREAM_ERROR */],
          payload: {
            handleError: true,
            error: { response: { status: 404, message: "API returned empty results" } },
            params: params
          }
        });
      }
      return dispatch({
        type: appendResults ? __WEBPACK_IMPORTED_MODULE_3__constants_actionTypes__["V" /* GET_STORIES_STREAM_UPDATE */] : __WEBPACK_IMPORTED_MODULE_3__constants_actionTypes__["U" /* GET_STORIES_STREAM_SUCCESS */],
        payload: response.data.results
      });
    }).catch(function (err) {
      dispatch({
        type: __WEBPACK_IMPORTED_MODULE_3__constants_actionTypes__["T" /* GET_STORIES_STREAM_ERROR */],
        payload: {
          handleError: true,
          error: err,
          params: params
        }
      });
    });
  };
};

var loadNextStory = function loadNextStory(params, position, alreadyLoadedStories) {
  return function (dispatch) {
    dispatch({
      type: __WEBPACK_IMPORTED_MODULE_3__constants_actionTypes__["W" /* GET_STORY */]
    });

    return __WEBPACK_IMPORTED_MODULE_2__utils_backend__["a" /* default */].request({
      method: "GET",
      url: "/stream/",
      params: params
    }).then(function (response) {
      var payload = void 0;
      var results = response.data.results;

      for (var i = 0; i < results.length; i++) {
        if (!(alreadyLoadedStories || []).includes(results[i].id)) {
          payload = results[i];
          break;
        }
      }

      if (!payload) {
        return dispatch(loadNextStory(_extends({}, params, { page: (params.page || 1) + 1 }), position, alreadyLoadedStories));
      }

      return dispatch({
        type: __WEBPACK_IMPORTED_MODULE_3__constants_actionTypes__["Z" /* GET_STORY_UPDATE */],
        payload: payload,
        position: position
      });
    }).catch(function (err) {
      dispatch({
        type: __WEBPACK_IMPORTED_MODULE_3__constants_actionTypes__["X" /* GET_STORY_ERROR */],
        payload: err
      });
    });
  };
};

var loadStory = function loadStory(params, position) {
  var handleError = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;

  return function (dispatch) {
    dispatch({
      type: __WEBPACK_IMPORTED_MODULE_3__constants_actionTypes__["W" /* GET_STORY */]
    });

    return __WEBPACK_IMPORTED_MODULE_2__utils_backend__["a" /* default */].request({
      method: "GET",
      url: "/stream/",
      params: params || {}
    }).then(function (response) {
      return dispatch({
        type: position ? __WEBPACK_IMPORTED_MODULE_3__constants_actionTypes__["Z" /* GET_STORY_UPDATE */] : __WEBPACK_IMPORTED_MODULE_3__constants_actionTypes__["Y" /* GET_STORY_SUCCESS */],
        payload: response.data.results[0],
        position: position
      });
    }).catch(function (err) {
      return dispatch({
        type: __WEBPACK_IMPORTED_MODULE_3__constants_actionTypes__["X" /* GET_STORY_ERROR */],
        payload: {
          handleError: handleError,
          error: err,
          params: params
        }
      });
    });
  };
};

var loadRevision = function loadRevision(storyId, revision, accessToken, position) {
  return function (dispatch) {
    dispatch({
      type: __WEBPACK_IMPORTED_MODULE_3__constants_actionTypes__["W" /* GET_STORY */]
    });

    return __WEBPACK_IMPORTED_MODULE_0_axios___default.a.request({
      method: "GET",
      url: __WEBPACK_IMPORTED_MODULE_4__config_constants__["b" /* BACKEND_ROOT */] + "/api/content/" + storyId + "/revisions/" + revision + "/",
      headers: {
        "Authorization": "Bearer " + accessToken
      }
    }).then(function (response) {
      var payload = __WEBPACK_IMPORTED_MODULE_1_selectn___default()("data.results[0]", response) || (Array.isArray(response.data) ? __WEBPACK_IMPORTED_MODULE_1_selectn___default()("data[0]", response) : response.data) || null;
      return dispatch({
        type: position ? __WEBPACK_IMPORTED_MODULE_3__constants_actionTypes__["Z" /* GET_STORY_UPDATE */] : __WEBPACK_IMPORTED_MODULE_3__constants_actionTypes__["Y" /* GET_STORY_SUCCESS */],
        payload: payload,
        position: position
      });
    }).catch(function (err) {
      dispatch({
        type: __WEBPACK_IMPORTED_MODULE_3__constants_actionTypes__["X" /* GET_STORY_ERROR */],
        payload: err
      });
    });
  };
};

var loadLatest = function loadLatest(storyId, accessToken, position) {
  return function (dispatch) {
    dispatch({
      type: __WEBPACK_IMPORTED_MODULE_3__constants_actionTypes__["W" /* GET_STORY */]
    });

    return __WEBPACK_IMPORTED_MODULE_0_axios___default.a.request({
      method: "GET",
      url: __WEBPACK_IMPORTED_MODULE_4__config_constants__["b" /* BACKEND_ROOT */] + "/api/content/" + storyId + "/",
      headers: {
        "Authorization": "Bearer " + accessToken
      }
    }).then(function (response) {
      return dispatch({
        type: position ? __WEBPACK_IMPORTED_MODULE_3__constants_actionTypes__["Z" /* GET_STORY_UPDATE */] : __WEBPACK_IMPORTED_MODULE_3__constants_actionTypes__["Y" /* GET_STORY_SUCCESS */],
        payload: "results" in response.data ? response.data.results[0] : response.data,
        position: position
      });
    }).catch(function (err) {
      dispatch({
        type: __WEBPACK_IMPORTED_MODULE_3__constants_actionTypes__["X" /* GET_STORY_ERROR */],
        payload: err
      });
    });
  };
};

var addStory = function addStory(story) {
  return function (dispatch) {
    return dispatch({
      type: __WEBPACK_IMPORTED_MODULE_3__constants_actionTypes__["Z" /* GET_STORY_UPDATE */],
      payload: story
    });
  };
};

var removeStory = function removeStory() {
  return function (dispatch) {
    return dispatch({
      type: __WEBPACK_IMPORTED_MODULE_3__constants_actionTypes__["Y" /* GET_STORY_SUCCESS */],
      payload: null
    });
  };
};

var resetStoriesStreamError = function resetStoriesStreamError() {
  return function (dispatch) {
    return dispatch({
      type: __WEBPACK_IMPORTED_MODULE_3__constants_actionTypes__["_25" /* RESET_STORIES_STREAM_ERROR */]
    });
  };
};

var setStoryStream = function setStoryStream(stories) {
  return function (dispatch) {
    dispatch({
      type: __WEBPACK_IMPORTED_MODULE_3__constants_actionTypes__["_32" /* SET_STORY_STREAM */],
      payload: stories
    });
  };
};

/***/ }),

/***/ "./src/actions/user.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return getUserData; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return updateUserSubscriptions; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return updateUnAuthedSubscriptions; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils_backend__ = __webpack_require__("./src/utils/backend.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__constants_actionTypes__ = __webpack_require__("./src/constants/actionTypes.js");



var getUserData = function getUserData() {
  return function (dispatch) {
    dispatch({
      type: __WEBPACK_IMPORTED_MODULE_1__constants_actionTypes__["_13" /* GET_USER_DATA */]
    });

    return __WEBPACK_IMPORTED_MODULE_0__utils_backend__["a" /* default */].request({
      method: "GET",
      url: "/readers/me/"
    }).then(function (response) {
      dispatch({
        type: __WEBPACK_IMPORTED_MODULE_1__constants_actionTypes__["_15" /* GET_USER_DATA_SUCCESS */],
        payload: response.data
      });
    }).catch(function (err) {
      dispatch({
        type: __WEBPACK_IMPORTED_MODULE_1__constants_actionTypes__["_14" /* GET_USER_DATA_ERROR */],
        payload: err
      });
    });
  };
};

var updateUserSubscriptions = function updateUserSubscriptions(subscriptions, subscription) {
  return function (dispatch) {
    dispatch({
      type: __WEBPACK_IMPORTED_MODULE_1__constants_actionTypes__["_47" /* UPDATE_USER_SUBSCRIPTIONS */]
    });

    return __WEBPACK_IMPORTED_MODULE_0__utils_backend__["a" /* default */].request({
      method: "PATCH",
      url: "/readers/update/",
      data: {
        subscriptions: subscriptions.map(function (s) {
          return s.id;
        }).concat(subscription.id)
      }
    }).then(function () {
      dispatch({
        type: __WEBPACK_IMPORTED_MODULE_1__constants_actionTypes__["_49" /* UPDATE_USER_SUBSCRIPTIONS_SUCCESS */],
        payload: subscriptions.concat(subscription)
      });
    }).catch(function (err) {
      dispatch({
        type: __WEBPACK_IMPORTED_MODULE_1__constants_actionTypes__["_48" /* UPDATE_USER_SUBSCRIPTIONS_ERROR */],
        payload: err
      });
    });
  };
};

var updateUnAuthedSubscriptions = function updateUnAuthedSubscriptions(email, lists) {
  return function (dispatch) {
    dispatch({
      type: __WEBPACK_IMPORTED_MODULE_1__constants_actionTypes__["_33" /* SET_UNAUTHED_SUBSCRIPTIONS */]
    });

    return __WEBPACK_IMPORTED_MODULE_0__utils_backend__["a" /* default */].request({
      method: "POST",
      url: "/readers/unauth-sub/",
      data: {
        email: email,
        lists: lists
      }
    }).then(function () {
      dispatch({
        type: __WEBPACK_IMPORTED_MODULE_1__constants_actionTypes__["_35" /* SET_UNAUTHED_SUBSCRIPTIONS_SUCCESS */]
      });
    }).catch(function (err) {
      dispatch({
        type: __WEBPACK_IMPORTED_MODULE_1__constants_actionTypes__["_34" /* SET_UNAUTHED_SUBSCRIPTIONS_ERROR */],
        payload: err
      });
    });
  };
};

/***/ }),

/***/ "./src/assets recursive ^\\.\\/.*\\.svg$":
/***/ (function(module, exports, __webpack_require__) {

var map = {
	"./icons/caret/down.svg": "./src/assets/icons/caret/down.svg",
	"./icons/caret/left.svg": "./src/assets/icons/caret/left.svg",
	"./icons/caret/right.svg": "./src/assets/icons/caret/right.svg",
	"./icons/caret/up.svg": "./src/assets/icons/caret/up.svg",
	"./icons/check/rounded.svg": "./src/assets/icons/check/rounded.svg",
	"./icons/chevron/down.svg": "./src/assets/icons/chevron/down.svg",
	"./icons/chevron/left.svg": "./src/assets/icons/chevron/left.svg",
	"./icons/chevron/right.svg": "./src/assets/icons/chevron/right.svg",
	"./icons/chevron/up.svg": "./src/assets/icons/chevron/up.svg",
	"./icons/clipboard.svg": "./src/assets/icons/clipboard.svg",
	"./icons/close.svg": "./src/assets/icons/close.svg",
	"./icons/copy.svg": "./src/assets/icons/copy.svg",
	"./icons/refresh.svg": "./src/assets/icons/refresh.svg",
	"./icons/save.svg": "./src/assets/icons/save.svg",
	"./icons/timer.svg": "./src/assets/icons/timer.svg",
	"./icons/user.svg": "./src/assets/icons/user.svg",
	"./img/avatar.svg": "./src/assets/img/avatar.svg",
	"./img/close-blue.svg": "./src/assets/img/close-blue.svg",
	"./img/close.svg": "./src/assets/img/close.svg",
	"./img/confused-person.svg": "./src/assets/img/confused-person.svg",
	"./img/envelope.svg": "./src/assets/img/envelope.svg",
	"./img/facebook-inverse.svg": "./src/assets/img/facebook-inverse.svg",
	"./img/facebook.svg": "./src/assets/img/facebook.svg",
	"./img/hamburger.svg": "./src/assets/img/hamburger.svg",
	"./img/instagram-inverse.svg": "./src/assets/img/instagram-inverse.svg",
	"./img/instagram.svg": "./src/assets/img/instagram.svg",
	"./img/link.svg": "./src/assets/img/link.svg",
	"./img/linkedin-inverse.svg": "./src/assets/img/linkedin-inverse.svg",
	"./img/linkedin.svg": "./src/assets/img/linkedin.svg",
	"./img/logo.svg": "./src/assets/img/logo.svg",
	"./img/plus-box.svg": "./src/assets/img/plus-box.svg",
	"./img/quote.svg": "./src/assets/img/quote.svg",
	"./img/save.svg": "./src/assets/img/save.svg",
	"./img/search.svg": "./src/assets/img/search.svg",
	"./img/twitter-inverse.svg": "./src/assets/img/twitter-inverse.svg",
	"./img/twitter.svg": "./src/assets/img/twitter.svg",
	"./url/a-on-black.svg": "./src/assets/url/a-on-black.svg",
	"./url/a-on-white.svg": "./src/assets/url/a-on-white.svg",
	"./url/clipboard.svg": "./src/assets/url/clipboard.svg",
	"./url/events.svg": "./src/assets/url/events.svg",
	"./url/newsletter.svg": "./src/assets/url/newsletter.svg",
	"./url/tag.svg": "./src/assets/url/tag.svg"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "./src/assets recursive ^\\.\\/.*\\.svg$";

/***/ }),

/***/ "./src/assets/icons/caret/down.svg":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol__ = __webpack_require__("./node_modules/svg-baker-runtime/browser-symbol.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build__ = __webpack_require__("./node_modules/svg-sprite-loader/runtime/browser-sprite.build.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build__);


var symbol = new __WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol___default.a({
  "id": "down",
  "use": "down-usage",
  "viewBox": "0 0 9 5",
  "content": "<symbol viewBox=\"0 0 9 5\" id=\"down\"><path fill-rule=\"evenodd\" d=\"M4.5 4.09L0-.001h9z\" /></symbol>"
});
var result = __WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build___default.a.add(symbol);
/* harmony default export */ __webpack_exports__["default"] = (symbol);

/***/ }),

/***/ "./src/assets/icons/caret/left.svg":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol__ = __webpack_require__("./node_modules/svg-baker-runtime/browser-symbol.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build__ = __webpack_require__("./node_modules/svg-sprite-loader/runtime/browser-sprite.build.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build__);


var symbol = new __WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol___default.a({
  "id": "left",
  "use": "left-usage",
  "viewBox": "0 0 4 9",
  "content": "<symbol viewBox=\"0 0 4 9\" id=\"left\"><path fill-rule=\"evenodd\" d=\"M0 4.5L4 0v9z\" /></symbol>"
});
var result = __WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build___default.a.add(symbol);
/* harmony default export */ __webpack_exports__["default"] = (symbol);

/***/ }),

/***/ "./src/assets/icons/caret/right.svg":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol__ = __webpack_require__("./node_modules/svg-baker-runtime/browser-symbol.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build__ = __webpack_require__("./node_modules/svg-sprite-loader/runtime/browser-sprite.build.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build__);


var symbol = new __WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol___default.a({
  "id": "right",
  "use": "right-usage",
  "viewBox": "0 0 4 9",
  "content": "<symbol viewBox=\"0 0 4 9\" id=\"right\"><path fill-rule=\"evenodd\" d=\"M4.09 4.5L0 9V0z\" /></symbol>"
});
var result = __WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build___default.a.add(symbol);
/* harmony default export */ __webpack_exports__["default"] = (symbol);

/***/ }),

/***/ "./src/assets/icons/caret/up.svg":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol__ = __webpack_require__("./node_modules/svg-baker-runtime/browser-symbol.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build__ = __webpack_require__("./node_modules/svg-sprite-loader/runtime/browser-sprite.build.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build__);


var symbol = new __WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol___default.a({
  "id": "up",
  "use": "up-usage",
  "viewBox": "0 0 9 4",
  "content": "<symbol viewBox=\"0 0 9 4\" id=\"up\"><path fill-rule=\"evenodd\" d=\"M4.5 0L9 4H0z\" /></symbol>"
});
var result = __WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build___default.a.add(symbol);
/* harmony default export */ __webpack_exports__["default"] = (symbol);

/***/ }),

/***/ "./src/assets/icons/check/rounded.svg":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol__ = __webpack_require__("./node_modules/svg-baker-runtime/browser-symbol.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build__ = __webpack_require__("./node_modules/svg-sprite-loader/runtime/browser-sprite.build.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build__);


var symbol = new __WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol___default.a({
  "id": "rounded",
  "use": "rounded-usage",
  "viewBox": "0 0 12 10",
  "content": "<symbol viewBox=\"0 0 12 10\" id=\"rounded\"><path fill-rule=\"evenodd\" d=\"M12.003 1.797a.751.751 0 0 0-.216-.527L10.733.217a.751.751 0 0 0-1.053 0L4.6 5.305 2.323 3.02a.751.751 0 0 0-1.053 0L.217 4.073a.751.751 0 0 0 0 1.054l3.856 3.856a.751.751 0 0 0 1.054 0l6.66-6.66a.751.751 0 0 0 .216-.526z\" /></symbol>"
});
var result = __WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build___default.a.add(symbol);
/* harmony default export */ __webpack_exports__["default"] = (symbol);

/***/ }),

/***/ "./src/assets/icons/chevron/down.svg":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol__ = __webpack_require__("./node_modules/svg-baker-runtime/browser-symbol.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build__ = __webpack_require__("./node_modules/svg-sprite-loader/runtime/browser-sprite.build.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build__);


var symbol = new __WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol___default.a({
  "id": "down",
  "use": "down-usage",
  "viewBox": "0 0 12 8",
  "content": "<symbol viewBox=\"0 0 12 8\" id=\"down\"><path fill-rule=\"evenodd\" d=\"M6 5.602L1.2.8 0 2l6 6.002L12 2 10.8.8 6 5.602z\" /></symbol>"
});
var result = __WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build___default.a.add(symbol);
/* harmony default export */ __webpack_exports__["default"] = (symbol);

/***/ }),

/***/ "./src/assets/icons/chevron/left.svg":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol__ = __webpack_require__("./node_modules/svg-baker-runtime/browser-symbol.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build__ = __webpack_require__("./node_modules/svg-sprite-loader/runtime/browser-sprite.build.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build__);


var symbol = new __WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol___default.a({
  "id": "left",
  "use": "left-usage",
  "viewBox": "0 0 8 12",
  "content": "<symbol viewBox=\"0 0 8 12\" id=\"left\"><path fill-rule=\"evenodd\" d=\"M2.4 6l4.8-4.8L6 0 0 6l6 6 1.2-1.2L2.4 6z\" /></symbol>"
});
var result = __WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build___default.a.add(symbol);
/* harmony default export */ __webpack_exports__["default"] = (symbol);

/***/ }),

/***/ "./src/assets/icons/chevron/right.svg":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol__ = __webpack_require__("./node_modules/svg-baker-runtime/browser-symbol.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build__ = __webpack_require__("./node_modules/svg-sprite-loader/runtime/browser-sprite.build.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build__);


var symbol = new __WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol___default.a({
  "id": "right",
  "use": "right-usage",
  "viewBox": "0 0 8 12",
  "content": "<symbol viewBox=\"0 0 8 12\" id=\"right\"><path fill-rule=\"evenodd\" d=\"M5.6 6L.8 10.8 2 12l6-6-6-6L.8 1.2 5.6 6z\" /></symbol>"
});
var result = __WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build___default.a.add(symbol);
/* harmony default export */ __webpack_exports__["default"] = (symbol);

/***/ }),

/***/ "./src/assets/icons/chevron/up.svg":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol__ = __webpack_require__("./node_modules/svg-baker-runtime/browser-symbol.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build__ = __webpack_require__("./node_modules/svg-sprite-loader/runtime/browser-sprite.build.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build__);


var symbol = new __WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol___default.a({
  "id": "up",
  "use": "up-usage",
  "viewBox": "0 0 12 8",
  "content": "<symbol viewBox=\"0 0 12 8\" id=\"up\"><path fill-rule=\"evenodd\" d=\"M6 2.4l4.8 4.8L12 6 6 0 0 6l1.2 1.2L6 2.4z\" /></symbol>"
});
var result = __WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build___default.a.add(symbol);
/* harmony default export */ __webpack_exports__["default"] = (symbol);

/***/ }),

/***/ "./src/assets/icons/clipboard.svg":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol__ = __webpack_require__("./node_modules/svg-baker-runtime/browser-symbol.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build__ = __webpack_require__("./node_modules/svg-sprite-loader/runtime/browser-sprite.build.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build__);


var symbol = new __WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol___default.a({
  "id": "clipboard",
  "use": "clipboard-usage",
  "viewBox": "0 0 22 22",
  "content": "<symbol viewBox=\"0 0 22 22\" id=\"clipboard\"><path d=\"M15.81 22H2.065A2.068 2.068 0 0 1 0 19.935V4.815C0 3.677.927 2.75 2.065 2.75h2.06a.688.688 0 0 1 0 1.375h-2.06a.69.69 0 0 0-.69.69v15.12c0 .38.31.69.69.69H15.81c.38 0 .69-.31.69-.69v-2.109a.687.687 0 1 1 1.375 0v2.109A2.068 2.068 0 0 1 15.81 22zm1.377-13.063a.687.687 0 0 1-.687-.687V4.815a.69.69 0 0 0-.69-.69h-2.06a.687.687 0 1 1 0-1.375h2.06c1.138 0 2.065.927 2.065 2.065V8.25c0 .38-.307.688-.688.688zm-4.123-2.75H4.812a1.375 1.375 0 0 1-1.375-1.374V3.437c0-.758.616-1.374 1.375-1.374v-.618A1.448 1.448 0 0 1 6.258 0h5.36c.796 0 1.444.648 1.444 1.445l.002.617c.758 0 1.373.617 1.373 1.375v1.377c0 .758-.615 1.373-1.373 1.373zM6.258 1.375a.07.07 0 0 0-.07.07v.616c0 .76-.618 1.377-1.376 1.377v1.375h8.252l-.002-1.375a1.377 1.377 0 0 1-1.374-1.376v-.617a.07.07 0 0 0-.07-.07h-5.36zM16.5 18.563a5.506 5.506 0 0 1-5.5-5.5c0-3.033 2.467-5.5 5.5-5.5s5.5 2.467 5.5 5.5c0 3.032-2.467 5.5-5.5 5.5zm0-9.625a4.13 4.13 0 0 0-4.125 4.124 4.13 4.13 0 0 0 4.125 4.126 4.13 4.13 0 0 0 4.125-4.125A4.13 4.13 0 0 0 16.5 8.936zm-.413 6.874a.684.684 0 0 1-.486-.2l-1.65-1.65a.687.687 0 1 1 .973-.973l1.09 1.09 1.998-2.667a.687.687 0 1 1 1.1.825l-2.475 3.3a.685.685 0 0 1-.501.273l-.049.002z\" /></symbol>"
});
var result = __WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build___default.a.add(symbol);
/* harmony default export */ __webpack_exports__["default"] = (symbol);

/***/ }),

/***/ "./src/assets/icons/close.svg":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol__ = __webpack_require__("./node_modules/svg-baker-runtime/browser-symbol.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build__ = __webpack_require__("./node_modules/svg-sprite-loader/runtime/browser-sprite.build.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build__);


var symbol = new __WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol___default.a({
  "id": "close",
  "use": "close-usage",
  "viewBox": "0 0 14 14",
  "content": "<symbol viewBox=\"0 0 14 14\" id=\"close\"><path d=\"M8.745 7L14 1.745 12.255 0 7 5.255 1.745 0 0 1.745 5.255 7 0 12.255 1.745 14 7 8.745 12.255 14 14 12.255z\" /></symbol>"
});
var result = __WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build___default.a.add(symbol);
/* harmony default export */ __webpack_exports__["default"] = (symbol);

/***/ }),

/***/ "./src/assets/icons/copy.svg":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol__ = __webpack_require__("./node_modules/svg-baker-runtime/browser-symbol.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build__ = __webpack_require__("./node_modules/svg-sprite-loader/runtime/browser-sprite.build.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build__);


var symbol = new __WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol___default.a({
  "id": "copy",
  "use": "copy-usage",
  "viewBox": "0 0 33 31",
  "content": "<symbol viewBox=\"0 0 33 31\" id=\"copy\"><path fill-rule=\"evenodd\" d=\"M12.034 2.67c-.627.705-1.29 1.657-1.986 2.856a31.366 31.366 0 0 0-1.934 3.995 31.829 31.829 0 0 0-1.464 4.63c-.383 1.622-.575 3.527-.575 5.714h.157c.453-.176.889-.3 1.307-.37a7.29 7.29 0 0 1 1.202-.106c.697 0 1.333.141 1.908.423a4.94 4.94 0 0 1 1.49 1.111c.418.459.74.997.967 1.614.226.617.34 1.243.34 1.878 0 .988-.157 1.861-.47 2.62a5.28 5.28 0 0 1-1.308 1.904c-.557.512-1.193.9-1.908 1.164a6.647 6.647 0 0 1-2.326.397c-2.195 0-3.885-.785-5.07-2.354C1.179 26.576.587 24.52.587 21.98c0-1.34.182-2.9.548-4.682.366-1.781.915-3.633 1.647-5.556A42.438 42.438 0 0 1 5.526 5.95 33.663 33.663 0 0 1 9.368.5l2.666 2.17zm18.872 0c-.627.705-1.29 1.657-1.986 2.856a31.366 31.366 0 0 0-1.935 3.995 31.829 31.829 0 0 0-1.463 4.63c-.384 1.622-.575 3.527-.575 5.714h.157c.453-.176.888-.3 1.306-.37a7.31 7.31 0 0 1 1.203-.106c.697 0 1.333.141 1.908.423a4.94 4.94 0 0 1 1.49 1.111c.418.459.74.997.966 1.614a5.4 5.4 0 0 1 .34 1.878c0 .988-.157 1.861-.47 2.62a5.28 5.28 0 0 1-1.307 1.904c-.558.512-1.194.9-1.908 1.164a6.647 6.647 0 0 1-2.326.397c-2.196 0-3.886-.785-5.07-2.354-1.185-1.57-1.778-3.625-1.778-6.165 0-1.34.183-2.9.549-4.682.366-1.781.915-3.633 1.647-5.556a42.438 42.438 0 0 1 2.744-5.793A33.663 33.663 0 0 1 28.24.5l2.666 2.17z\" /></symbol>"
});
var result = __WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build___default.a.add(symbol);
/* harmony default export */ __webpack_exports__["default"] = (symbol);

/***/ }),

/***/ "./src/assets/icons/refresh.svg":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol__ = __webpack_require__("./node_modules/svg-baker-runtime/browser-symbol.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build__ = __webpack_require__("./node_modules/svg-sprite-loader/runtime/browser-sprite.build.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build__);


var symbol = new __WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol___default.a({
  "id": "refresh",
  "use": "refresh-usage",
  "viewBox": "0 0 15 16",
  "content": "<symbol viewBox=\"0 0 15 16\" id=\"refresh\"><path fill-rule=\"evenodd\" d=\"M12.709 2.291A7.703 7.703 0 0 0 7.739.479C3.472.479 0 3.95 0 8.219c0 4.267 3.473 7.738 7.74 7.738 2.13 0 4.062-.865 5.463-2.262l-.902-.902a6.442 6.442 0 0 1-4.56 1.888 6.47 6.47 0 0 1-6.463-6.463 6.47 6.47 0 0 1 6.462-6.463c1.539 0 2.953.542 4.064 1.442L9.574 5.426H15V0l-2.291 2.291z\" /></symbol>"
});
var result = __WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build___default.a.add(symbol);
/* harmony default export */ __webpack_exports__["default"] = (symbol);

/***/ }),

/***/ "./src/assets/icons/save.svg":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol__ = __webpack_require__("./node_modules/svg-baker-runtime/browser-symbol.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build__ = __webpack_require__("./node_modules/svg-sprite-loader/runtime/browser-sprite.build.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build__);


var symbol = new __WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol___default.a({
  "id": "save",
  "use": "save-usage",
  "viewBox": "0 0 15 18",
  "content": "<symbol viewBox=\"0 0 15 18\" id=\"save\"><path stroke-width=\"2\" d=\"M1 1v14.932l6.5-5.149 6.5 5.15V1H1z\" /></symbol>"
});
var result = __WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build___default.a.add(symbol);
/* harmony default export */ __webpack_exports__["default"] = (symbol);

/***/ }),

/***/ "./src/assets/icons/timer.svg":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol__ = __webpack_require__("./node_modules/svg-baker-runtime/browser-symbol.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build__ = __webpack_require__("./node_modules/svg-sprite-loader/runtime/browser-sprite.build.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build__);


var symbol = new __WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol___default.a({
  "id": "timer",
  "use": "timer-usage",
  "viewBox": "0 0 20 23",
  "content": "<symbol viewBox=\"0 0 20 23\" id=\"timer\"><path d=\"M17.294 6.485c-1.333-1.357-2.925-2.224-4.629-2.564V3.47h.185c.408 0 .704-.34.704-.754v-2.3A.415.415 0 0 0 13.147 0H8.48a.415.415 0 0 0-.408.415v2.3c0 .415.333.754.704.754h.185v.452c-1.704.377-3.333 1.207-4.63 2.564-.036.038-.073.076-.073.113l-.482-.528.556-.565-1.593-1.66L0 6.637l1.592 1.66.556-.566.704.754c-2.037 3.62-1.556 8.332 1.48 11.424a9.007 9.007 0 0 0 13 0c3.554-3.733 3.554-9.728-.038-13.423zM15.85 18.362a6.976 6.976 0 0 1-10.073 0C3 15.497 3 10.86 5.777 7.956a6.976 6.976 0 0 1 10.073 0c2.777 2.865 2.777 7.54 0 10.406zm-1.852-8.257L11.85 12.97a1.09 1.09 0 0 1-.296.98 1.037 1.037 0 0 1-1.481 0c-.407-.414-.407-1.093 0-1.545a.972.972 0 0 1 .815-.302l2.814-2.262c.222-.189.445.075.296.264z\" /></symbol>"
});
var result = __WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build___default.a.add(symbol);
/* harmony default export */ __webpack_exports__["default"] = (symbol);

/***/ }),

/***/ "./src/assets/icons/user.svg":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol__ = __webpack_require__("./node_modules/svg-baker-runtime/browser-symbol.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build__ = __webpack_require__("./node_modules/svg-sprite-loader/runtime/browser-sprite.build.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build__);


var symbol = new __WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol___default.a({
  "id": "user",
  "use": "user-usage",
  "viewBox": "0 0 19 19",
  "content": "<symbol viewBox=\"0 0 19 19\" id=\"user\"><path d=\"M18.5 16.56c0-.943-.61-1.744-1.456-2.027-.066-.023-4.398-1.13-5.018-2.36-.283-.563-.004-1.283.278-1.78.13-.174.256-.358.377-.551.734-1.175 1.294-2.72 1.351-4.63C14.118 2.34 11.895.007 9.257 0 6.606.007 4.383 2.34 4.469 5.212c.057 1.91.617 3.455 1.35 4.629.122.194.249.378.378.552.282.497.561 1.217.278 1.78-.619 1.23-4.952 2.337-5.018 2.36A2.138 2.138 0 0 0 0 16.56v1.94h18.5v-1.94z\" /></symbol>"
});
var result = __WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build___default.a.add(symbol);
/* harmony default export */ __webpack_exports__["default"] = (symbol);

/***/ }),

/***/ "./src/assets/img/avatar.svg":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol__ = __webpack_require__("./node_modules/svg-baker-runtime/browser-symbol.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build__ = __webpack_require__("./node_modules/svg-sprite-loader/runtime/browser-sprite.build.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build__);


var symbol = new __WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol___default.a({
  "id": "avatar",
  "use": "avatar-usage",
  "viewBox": "0 0 164 164",
  "content": "<symbol viewBox=\"0 0 164 164\" id=\"avatar\">\n    <defs>\n        <rect id=\"avatar_a\" width=\"164\" height=\"164\" rx=\"3\" />\n    </defs>\n    <g fill=\"none\" fill-rule=\"evenodd\">\n        <mask id=\"avatar_b\" fill=\"#fff\">\n            <use xlink:href=\"#avatar_a\" />\n        </mask>\n        <use fill=\"#3FAFF3\" xlink:href=\"#avatar_a\" />\n        <path fill=\"#B9E5FF\" fill-rule=\"nonzero\" d=\"M137.374 125.702c0-5.67-3.666-10.483-8.756-12.188-.4-.136-26.45-6.79-30.178-14.192-1.7-3.381-.024-7.713 1.674-10.7a51.92 51.92 0 0 0 2.268-3.314c4.413-7.069 7.781-16.358 8.124-27.84.516-17.273-12.85-31.302-28.718-31.343-15.94.04-29.306 14.07-28.787 31.344.343 11.482 3.708 20.77 8.12 27.832a50.029 50.029 0 0 0 2.269 3.32c1.698 2.988 3.374 7.32 1.674 10.702-3.725 7.401-29.778 14.056-30.179 14.192-5.089 1.704-8.76 6.518-8.76 12.188v11.673h111.25v-11.674z\" mask=\"url(#avatar_b)\" />\n    </g>\n</symbol>"
});
var result = __WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build___default.a.add(symbol);
/* harmony default export */ __webpack_exports__["default"] = (symbol);

/***/ }),

/***/ "./src/assets/img/close-blue.svg":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol__ = __webpack_require__("./node_modules/svg-baker-runtime/browser-symbol.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build__ = __webpack_require__("./node_modules/svg-sprite-loader/runtime/browser-sprite.build.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build__);


var symbol = new __WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol___default.a({
  "id": "close-blue",
  "use": "close-blue-usage",
  "viewBox": "0 0 14 14",
  "content": "<symbol viewBox=\"0 0 14 14\" id=\"close-blue\">\n  <polygon fill=\"#0a99e0\" points=\"8.745 7 14 1.745 12.255 0 7 5.255 1.745 0 0 1.745 5.255 7 0 12.255 1.745 14 7 8.745 12.255 14 14 12.255\" />\n</symbol>"
});
var result = __WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build___default.a.add(symbol);
/* harmony default export */ __webpack_exports__["default"] = (symbol);

/***/ }),

/***/ "./src/assets/img/close.svg":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol__ = __webpack_require__("./node_modules/svg-baker-runtime/browser-symbol.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build__ = __webpack_require__("./node_modules/svg-sprite-loader/runtime/browser-sprite.build.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build__);


var symbol = new __WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol___default.a({
  "id": "close",
  "use": "close-usage",
  "viewBox": "0 0 14 14",
  "content": "<symbol viewBox=\"0 0 14 14\" id=\"close\">\n  <polygon fill=\"#4A4A4A\" points=\"8.745 7 14 1.745 12.255 0 7 5.255 1.745 0 0 1.745 5.255 7 0 12.255 1.745 14 7 8.745 12.255 14 14 12.255\" />\n</symbol>"
});
var result = __WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build___default.a.add(symbol);
/* harmony default export */ __webpack_exports__["default"] = (symbol);

/***/ }),

/***/ "./src/assets/img/confused-person.svg":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol__ = __webpack_require__("./node_modules/svg-baker-runtime/browser-symbol.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build__ = __webpack_require__("./node_modules/svg-sprite-loader/runtime/browser-sprite.build.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build__);


var symbol = new __WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol___default.a({
  "id": "confused-person",
  "use": "confused-person-usage",
  "viewBox": "0 0 138 138",
  "content": "<symbol viewBox=\"0 0 138 138\" id=\"confused-person\">\n    <g fill=\"none\" fill-rule=\"evenodd\">\n        <circle cx=\"69\" cy=\"69\" r=\"65\" stroke=\"#DCDCDC\" stroke-width=\"8\" />\n        <circle cx=\"89.5\" cy=\"62.5\" r=\"6.5\" fill=\"#DCDCDC\" />\n        <circle cx=\"49.5\" cy=\"62.5\" r=\"6.5\" fill=\"#DCDCDC\" />\n        <path stroke=\"#DCDCDC\" stroke-linecap=\"round\" stroke-width=\"5\" d=\"M44 93.281c15.854-7.9 19.771 4.281 30.643 4.281 10.87 0 19.823-8.562 19.823-8.562\" />\n    </g>\n</symbol>"
});
var result = __WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build___default.a.add(symbol);
/* harmony default export */ __webpack_exports__["default"] = (symbol);

/***/ }),

/***/ "./src/assets/img/envelope.svg":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol__ = __webpack_require__("./node_modules/svg-baker-runtime/browser-symbol.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build__ = __webpack_require__("./node_modules/svg-sprite-loader/runtime/browser-sprite.build.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build__);


var symbol = new __WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol___default.a({
  "id": "envelope",
  "use": "envelope-usage",
  "viewBox": "0 0 24 16",
  "content": "<symbol viewBox=\"0 0 24 16\" id=\"envelope\">\n  <path fill=\"#4a4a4a\" d=\"M2.39999995,0 C1.08423995,0 0,1.08424 0,2.4 L0,13.600008 C0,14.915768 1.08423995,16.000008 2.39999995,16.000008 L21.0666666,16.000008 C22.3824266,16.000008 23.4666666,14.915768 23.4666666,13.600008 L23.4666666,2.4 C23.4666666,1.08424 22.3824266,0 21.0666666,0 L2.39999995,0 Z M2.39999995,1.6 L21.0666666,1.6 C21.5237066,1.6 21.8666666,1.94296 21.8666666,2.4 L21.8666666,13.600008 C21.8666666,14.057048 21.5237066,14.400008 21.0666666,14.400008 L2.39999995,14.400008 C1.94295995,14.400008 1.59999995,14.057048 1.59999995,13.600008 L1.59999995,2.4 C1.59999995,1.94296 1.94295995,1.6 2.39999995,1.6 Z M19.8499999,3.17498667 C19.6521519,3.18508686 19.4650863,3.26822922 19.3250133,3.40832 L12.2916799,9.900008 C11.9502666,10.2150213 11.4984266,10.2145947 11.1583466,9.900008 L4.14165328,3.40832 C3.98441361,3.26035948 3.77404855,3.18222993 3.55834661,3.19168 C3.23341498,3.20375477 2.94810867,3.41127759 2.83654552,3.71669539 C2.72498237,4.02211319 2.8093545,4.36467232 3.04999995,4.58334133 L6.81666661,8.06667467 L3.06666661,11.400008 C2.82316953,11.5801776 2.70229786,11.8824091 2.75440408,12.1807996 C2.8065103,12.47919 3.02265891,12.7225696 3.31280718,12.8095518 C3.60295546,12.896534 3.91734701,12.8122025 4.12501328,12.591688 L7.99167995,9.150008 L10.0749866,11.0749947 C11.0000266,11.9305413 12.4498666,11.937048 13.3749866,11.0832613 L15.4666666,9.149928 L19.3416533,12.591608 C19.5493195,12.8121225 19.8637111,12.896454 20.1538594,12.8094718 C20.4440077,12.7224896 20.6601563,12.47911 20.7122625,12.1807196 C20.7643687,11.8823291 20.643497,11.5800976 20.3999999,11.399928 L16.6416533,8.05827467 L20.4083199,4.58326133 C20.6692221,4.36119061 20.7597687,3.99764526 20.6335042,3.67914468 C20.5072397,3.3606441 20.1921926,3.15788997 19.8499999,3.17490667 L19.8499999,3.17498667 Z\" />\n</symbol>"
});
var result = __WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build___default.a.add(symbol);
/* harmony default export */ __webpack_exports__["default"] = (symbol);

/***/ }),

/***/ "./src/assets/img/facebook-inverse.svg":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol__ = __webpack_require__("./node_modules/svg-baker-runtime/browser-symbol.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build__ = __webpack_require__("./node_modules/svg-sprite-loader/runtime/browser-sprite.build.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build__);


var symbol = new __WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol___default.a({
  "id": "facebook-inverse",
  "use": "facebook-inverse-usage",
  "viewBox": "0 0 10 19",
  "content": "<symbol viewBox=\"0 0 10 19\" id=\"facebook-inverse\">\n    <path fill=\"#FFF\" fill-rule=\"evenodd\" d=\"M9.74.842V3.64H8.074c-.608 0-1.018.127-1.23.381-.212.255-.318.636-.318 1.145v2.004h3.106L9.22 10.31H6.527v8.047H3.282V10.31H.58V7.17h2.703V4.86c0-1.315.368-2.334 1.103-3.059C5.12 1.077 6.099.714 7.322.714c1.04 0 1.845.043 2.417.128z\" />\n</symbol>"
});
var result = __WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build___default.a.add(symbol);
/* harmony default export */ __webpack_exports__["default"] = (symbol);

/***/ }),

/***/ "./src/assets/img/facebook.svg":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol__ = __webpack_require__("./node_modules/svg-baker-runtime/browser-symbol.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build__ = __webpack_require__("./node_modules/svg-sprite-loader/runtime/browser-sprite.build.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build__);


var symbol = new __WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol___default.a({
  "id": "facebook",
  "use": "facebook-usage",
  "viewBox": "0 0 10 19",
  "content": "<symbol viewBox=\"0 0 10 19\" id=\"facebook\">\n    <path fill=\"#4A4A4A\" fill-rule=\"evenodd\" d=\"M9.74.842V3.64H8.074c-.608 0-1.018.127-1.23.381-.212.255-.318.636-.318 1.145v2.004h3.106L9.22 10.31H6.527v8.047H3.282V10.31H.58V7.17h2.703V4.86c0-1.315.368-2.334 1.103-3.059C5.12 1.077 6.099.714 7.322.714c1.04 0 1.845.043 2.417.128z\" />\n</symbol>"
});
var result = __WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build___default.a.add(symbol);
/* harmony default export */ __webpack_exports__["default"] = (symbol);

/***/ }),

/***/ "./src/assets/img/hamburger.svg":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol__ = __webpack_require__("./node_modules/svg-baker-runtime/browser-symbol.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build__ = __webpack_require__("./node_modules/svg-sprite-loader/runtime/browser-sprite.build.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build__);


var symbol = new __WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol___default.a({
  "id": "hamburger",
  "use": "hamburger-usage",
  "viewBox": "0 0 15 16",
  "content": "<symbol viewBox=\"0 0 15 16\" id=\"hamburger\">\n    <g fill=\"none\" fill-rule=\"evenodd\" stroke=\"#222\" stroke-width=\"2\" opacity=\".99\">\n        <path d=\"M0 1h15M0 8h15M0 15h15\" />\n    </g>\n</symbol>"
});
var result = __WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build___default.a.add(symbol);
/* harmony default export */ __webpack_exports__["default"] = (symbol);

/***/ }),

/***/ "./src/assets/img/instagram-inverse.svg":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol__ = __webpack_require__("./node_modules/svg-baker-runtime/browser-symbol.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build__ = __webpack_require__("./node_modules/svg-sprite-loader/runtime/browser-sprite.build.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build__);


var symbol = new __WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol___default.a({
  "id": "instagram-inverse",
  "use": "instagram-inverse-usage",
  "viewBox": "0 0 16 16",
  "content": "<symbol viewBox=\"0 0 16 16\" id=\"instagram-inverse\">\n    <path fill=\"#FFF\" fill-rule=\"evenodd\" d=\"M4 0h8a4 4 0 0 1 4 4v8a4 4 0 0 1-4 4H4a4 4 0 0 1-4-4V4a4 4 0 0 1 4-4zm4 12a4 4 0 1 0 0-8 4 4 0 0 0 0 8zm4-8a1 1 0 1 0 0-2 1 1 0 0 0 0 2z\" />\n</symbol>"
});
var result = __WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build___default.a.add(symbol);
/* harmony default export */ __webpack_exports__["default"] = (symbol);

/***/ }),

/***/ "./src/assets/img/instagram.svg":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol__ = __webpack_require__("./node_modules/svg-baker-runtime/browser-symbol.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build__ = __webpack_require__("./node_modules/svg-sprite-loader/runtime/browser-sprite.build.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build__);


var symbol = new __WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol___default.a({
  "id": "instagram",
  "use": "instagram-usage",
  "viewBox": "0 0 16 16",
  "content": "<symbol viewBox=\"0 0 16 16\" id=\"instagram\">\n  <path fill=\"#4A4A4A\" fill-rule=\"evenodd\" d=\"M4 0h8a4 4 0 0 1 4 4v8a4 4 0 0 1-4 4H4a4 4 0 0 1-4-4V4a4 4 0 0 1 4-4zm4 12a4 4 0 1 0 0-8 4 4 0 0 0 0 8zm4-8a1 1 0 1 0 0-2 1 1 0 0 0 0 2z\" />\n</symbol>"
});
var result = __WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build___default.a.add(symbol);
/* harmony default export */ __webpack_exports__["default"] = (symbol);

/***/ }),

/***/ "./src/assets/img/large-logo.png":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "8c7766945e1b76f1285485dba86f3d3a.png";

/***/ }),

/***/ "./src/assets/img/link.svg":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol__ = __webpack_require__("./node_modules/svg-baker-runtime/browser-symbol.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build__ = __webpack_require__("./node_modules/svg-sprite-loader/runtime/browser-sprite.build.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build__);


var symbol = new __WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol___default.a({
  "id": "link",
  "use": "link-usage",
  "viewBox": "0 0 18 19",
  "content": "<symbol viewBox=\"0 0 18 19\" id=\"link\">\n    <path fill=\"#4A4A4A\" fill-rule=\"evenodd\" d=\"M15.616 13.607a.982.982 0 0 0-.297-.72l-2.205-2.206a.982.982 0 0 0-.721-.297 1.01 1.01 0 0 0-.764.34l.202.195c.113.11.189.186.228.228.039.043.092.11.159.202a.853.853 0 0 1 .175.562.982.982 0 0 1-.297.72.982.982 0 0 1-.721.298.853.853 0 0 1-.562-.175 2.525 2.525 0 0 1-.201-.16 6.557 6.557 0 0 1-.228-.227l-.197-.202c-.233.22-.35.477-.35.774 0 .283.1.523.297.721l2.185 2.195c.19.19.43.286.72.286.283 0 .524-.092.722-.275l1.558-1.548a.97.97 0 0 0 .297-.71zM8.162 6.132a.982.982 0 0 0-.296-.72L5.68 3.216a.982.982 0 0 0-.72-.297c-.276 0-.517.095-.722.286L2.681 4.754a.97.97 0 0 0-.297.71c0 .283.099.523.297.721l2.205 2.206c.191.19.431.286.721.286.297 0 .551-.11.764-.329a29.155 29.155 0 0 0-.202-.196 6.558 6.558 0 0 1-.228-.228 2.525 2.525 0 0 1-.159-.201.853.853 0 0 1-.175-.562c0-.283.1-.523.297-.721a.982.982 0 0 1 .721-.297.853.853 0 0 1 .562.175c.092.067.159.12.201.159.043.039.119.115.228.228.11.113.175.18.197.201.233-.219.35-.477.35-.774zm9.49 7.475c0 .848-.3 1.566-.901 2.152l-1.559 1.548c-.587.587-1.304.88-2.152.88-.856 0-1.577-.3-2.163-.9l-2.184-2.195c-.587-.587-.88-1.305-.88-2.153 0-.87.31-1.608.933-2.216l-.934-.933a2.97 2.97 0 0 1-2.205.933c-.848 0-1.57-.297-2.163-.89L1.24 7.627a2.945 2.945 0 0 1-.89-2.163c0-.848.3-1.565.9-2.152l1.559-1.548c.587-.587 1.304-.88 2.152-.88.856 0 1.577.3 2.163.901L9.307 3.98c.587.587.88 1.304.88 2.152 0 .87-.31 1.608-.933 2.216l.934.933a2.97 2.97 0 0 1 2.205-.933c.848 0 1.57.297 2.163.89l2.205 2.206c.594.594.89 1.315.89 2.163z\" />\n</symbol>"
});
var result = __WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build___default.a.add(symbol);
/* harmony default export */ __webpack_exports__["default"] = (symbol);

/***/ }),

/***/ "./src/assets/img/linkedin-inverse.svg":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol__ = __webpack_require__("./node_modules/svg-baker-runtime/browser-symbol.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build__ = __webpack_require__("./node_modules/svg-sprite-loader/runtime/browser-sprite.build.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build__);


var symbol = new __WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol___default.a({
  "id": "linkedin-inverse",
  "use": "linkedin-inverse-usage",
  "viewBox": "0 0 14 14",
  "content": "<symbol viewBox=\"0 0 14 14\" id=\"linkedin-inverse\">\n    <path fill=\"#FFF\" fill-rule=\"evenodd\" d=\"M3.259 4.866v8.848H.313V4.866h2.946zm.187-2.732c.006.434-.144.798-.45 1.09-.307.29-.71.437-1.21.437h-.018c-.488 0-.881-.146-1.179-.438a1.463 1.463 0 0 1-.446-1.09c0-.44.153-.804.46-1.093.306-.289.707-.433 1.2-.433.495 0 .89.144 1.188.433.298.289.45.653.455 1.094zm4.375 3.99c.114-.18.23-.336.349-.472.125-.143.293-.298.504-.465a2.32 2.32 0 0 1 .777-.388 3.54 3.54 0 0 1 1.022-.138c1.018 0 1.837.338 2.456 1.013.619.676.928 1.665.928 2.969v5.071H10.92V8.982c0-.625-.12-1.114-.362-1.469-.241-.354-.618-.53-1.13-.53-.374 0-.688.102-.941.307-.253.206-.442.46-.567.764-.066.178-.099.42-.099.723v4.937H4.884c.012-2.375.018-4.3.018-5.777 0-1.476-.003-2.357-.01-2.642l-.008-.429H7.82v1.257z\" />\n</symbol>"
});
var result = __WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build___default.a.add(symbol);
/* harmony default export */ __webpack_exports__["default"] = (symbol);

/***/ }),

/***/ "./src/assets/img/linkedin.svg":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol__ = __webpack_require__("./node_modules/svg-baker-runtime/browser-symbol.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build__ = __webpack_require__("./node_modules/svg-sprite-loader/runtime/browser-sprite.build.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build__);


var symbol = new __WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol___default.a({
  "id": "linkedin",
  "use": "linkedin-usage",
  "viewBox": "0 0 18 16",
  "content": "<symbol viewBox=\"0 0 18 16\" id=\"linkedin\">\n    <path fill=\"#4A4A4A\" fill-rule=\"evenodd\" d=\"M4.557 5.341v10.507H1.06V5.341h3.498zm.223-3.244c.007.516-.171.947-.535 1.293s-.843.52-1.437.52h-.021c-.58 0-1.046-.174-1.4-.52a1.738 1.738 0 0 1-.53-1.293c0-.524.182-.956.546-1.3.364-.342.84-.514 1.426-.514.587 0 1.057.172 1.41.515.354.343.534.775.541 1.299zm5.195 4.737c.135-.212.273-.399.414-.56a4.52 4.52 0 0 1 .599-.551c.25-.198.558-.352.922-.462.364-.11.77-.164 1.214-.164 1.21 0 2.181.401 2.916 1.204.735.802 1.103 1.977 1.103 3.525v6.022h-3.488v-5.62c0-.741-.144-1.323-.43-1.743-.286-.42-.733-.631-1.341-.631-.445 0-.818.122-1.119.366-.3.243-.524.546-.673.906-.078.212-.117.498-.117.859v5.863H6.487c.014-2.82.021-5.107.021-6.86 0-1.753-.003-2.799-.01-3.138l-.01-.509h3.487v1.493z\" />\n</symbol>"
});
var result = __WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build___default.a.add(symbol);
/* harmony default export */ __webpack_exports__["default"] = (symbol);

/***/ }),

/***/ "./src/assets/img/logo.svg":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol__ = __webpack_require__("./node_modules/svg-baker-runtime/browser-symbol.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build__ = __webpack_require__("./node_modules/svg-sprite-loader/runtime/browser-sprite.build.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build__);


var symbol = new __WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol___default.a({
  "id": "logo",
  "use": "logo-usage",
  "viewBox": "0 0 150 39",
  "content": "<symbol viewBox=\"0 0 150 39\" id=\"logo\">\n  <g fill=\"none\" fill-rule=\"evenodd\">\n    <polygon fill=\"#222\" points=\"69.32 36.888 78.257 36.888 78.257 1.236 69.32 1.236\" />\n    <path fill=\"#222\" d=\"M100.448364 29.3796282C106.127414 29.3796282 110.299738 24.5137759 110.299738 19.0515466 110.299738 13.5888455 106.104065 8.76923137 100.448364 8.76923137 94.7693149 8.76923137 90.5738803 13.5888455 90.5738803 19.0515466 90.5738803 24.5137759 94.7693149 29.3796282 100.448364 29.3796282M100.517935.0934541482C111.226788.0934541482 119.849956 8.3101531 119.849956 18.9826613 119.849956 29.7009358 111.157456 38.0780526 100.425015 38.0780526 89.6928128 38.0780526 81.0005507 29.8158233 81.0005507 19.120432 81.0005507 8.44768785 89.8090813.0934541482 100.517935.0934541482M120.877813 26.1061595L129.07784 24.1771343C129.666806 28.4609998 132.815348 30.0087966 136.122329 30.0087966 139.407153 30.0087966 140.60772 28.0797714 140.60772 26.5770332 140.60772 25.3658781 139.905344 24.1771343 137.504209 23.7062606L132.497992 22.74163C126.518027 21.5979448 122.282327 17.8745983 122.282327 12.1552285 122.282327 5.33699614 128.556537.537198355 135.646772.537198355 144.775517.537198355 148.53566 6.18933416 149.192768 10.921898L141.15118 13.1646817C140.720892 10.2488505 138.908723 8.14077067 135.601504 8.14077067 132.747207 8.14077067 131.3882 10.0247373 131.3882 11.4600056 131.3882 12.6487494 131.954532 14.0170197 134.083818 14.4206594L139.293743 15.4074654C146.11189 16.7085017 149.849637 20.8352521 149.849637 26.1958048 149.849637 32.0274671 144.775517 37.6345443 136.077299 37.6345443 126.971188 37.6345443 122.07838 32.9019805 120.877813 26.1061595\" />\n    <polygon fill=\"#0A99E0\" points=\"9.618 36.888 0 36.888 15.904 1.236 25.568 1.236\" />\n    <polygon fill=\"#222\" points=\"55.169 18.658 67.115 1.214 56.185 1.214 49.742 11.774 43.448 1.214 32.37 1.214 44.472 18.658 37.738 28.434 25.606 1.235 15.941 1.235 31.892 36.888 42.207 36.888 49.742 25.586 57.188 36.888 67.616 36.888\" />\n  </g>\n</symbol>"
});
var result = __WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build___default.a.add(symbol);
/* harmony default export */ __webpack_exports__["default"] = (symbol);

/***/ }),

/***/ "./src/assets/img/plus-box.svg":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol__ = __webpack_require__("./node_modules/svg-baker-runtime/browser-symbol.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build__ = __webpack_require__("./node_modules/svg-sprite-loader/runtime/browser-sprite.build.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build__);


var symbol = new __WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol___default.a({
  "id": "plus-box",
  "use": "plus-box-usage",
  "viewBox": "0 0 16 17",
  "content": "<symbol viewBox=\"0 0 16 17\" id=\"plus-box\">\n    <g fill=\"none\" fill-rule=\"evenodd\">\n        <path stroke-width=\"2\" d=\"M1 1.956h10v10.01H1z\" />\n        <path stroke=\"#FFF\" fill=\"#FFF\" d=\"M4 4.96h9v9.006H4z\" />\n        <g stroke-width=\"2\">\n            <path d=\"M11 7.462v9.007M15.5 11.965h-9\" />\n        </g>\n    </g>\n</symbol>"
});
var result = __WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build___default.a.add(symbol);
/* harmony default export */ __webpack_exports__["default"] = (symbol);

/***/ }),

/***/ "./src/assets/img/quote.svg":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol__ = __webpack_require__("./node_modules/svg-baker-runtime/browser-symbol.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build__ = __webpack_require__("./node_modules/svg-sprite-loader/runtime/browser-sprite.build.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build__);


var symbol = new __WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol___default.a({
  "id": "quote",
  "use": "quote-usage",
  "viewBox": "0 0 33 31",
  "content": "<symbol viewBox=\"0 0 33 31\" id=\"quote\">\n    <path fill=\"#FF6602\" fill-rule=\"evenodd\" d=\"M12.034 2.67c-.627.705-1.29 1.657-1.986 2.856a31.366 31.366 0 0 0-1.934 3.995 31.829 31.829 0 0 0-1.464 4.63c-.383 1.622-.575 3.527-.575 5.714h.157c.453-.176.889-.3 1.307-.37.418-.07.819-.106 1.202-.106.697 0 1.333.141 1.908.423a4.94 4.94 0 0 1 1.49 1.111c.418.459.74.997.967 1.614.226.617.34 1.243.34 1.878 0 .988-.157 1.861-.47 2.62a5.28 5.28 0 0 1-1.308 1.904c-.557.512-1.193.9-1.908 1.164a6.647 6.647 0 0 1-2.326.397c-2.195 0-3.885-.785-5.07-2.354C1.179 26.576.587 24.52.587 21.98c0-1.34.182-2.9.548-4.682.366-1.781.915-3.633 1.647-5.556A42.438 42.438 0 0 1 5.526 5.95 33.663 33.663 0 0 1 9.368.5l2.666 2.17zm18.872 0c-.627.705-1.29 1.657-1.986 2.856a31.366 31.366 0 0 0-1.935 3.995 31.829 31.829 0 0 0-1.463 4.63c-.384 1.622-.575 3.527-.575 5.714h.157c.453-.176.888-.3 1.306-.37.419-.07.82-.106 1.203-.106.697 0 1.333.141 1.908.423a4.94 4.94 0 0 1 1.49 1.111c.418.459.74.997.966 1.614.227.617.34 1.243.34 1.878 0 .988-.157 1.861-.47 2.62a5.28 5.28 0 0 1-1.307 1.904c-.558.512-1.194.9-1.908 1.164a6.647 6.647 0 0 1-2.326.397c-2.196 0-3.886-.785-5.07-2.354-1.185-1.57-1.778-3.625-1.778-6.165 0-1.34.183-2.9.549-4.682.366-1.781.915-3.633 1.647-5.556a42.438 42.438 0 0 1 2.744-5.793A33.663 33.663 0 0 1 28.24.5l2.666 2.17z\" />\n</symbol>"
});
var result = __WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build___default.a.add(symbol);
/* harmony default export */ __webpack_exports__["default"] = (symbol);

/***/ }),

/***/ "./src/assets/img/save.svg":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol__ = __webpack_require__("./node_modules/svg-baker-runtime/browser-symbol.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build__ = __webpack_require__("./node_modules/svg-sprite-loader/runtime/browser-sprite.build.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build__);


var symbol = new __WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol___default.a({
  "id": "save",
  "use": "save-usage",
  "viewBox": "0 0 15 18",
  "content": "<symbol viewBox=\"0 0 15 18\" id=\"save\">\n    <path fill=\"none\" fill-rule=\"evenodd\" stroke=\"#4A4A4A\" stroke-width=\"2\" d=\"M1 1v14.932l6.5-5.149 6.5 5.15V1H1z\" />\n</symbol>"
});
var result = __WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build___default.a.add(symbol);
/* harmony default export */ __webpack_exports__["default"] = (symbol);

/***/ }),

/***/ "./src/assets/img/search.svg":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol__ = __webpack_require__("./node_modules/svg-baker-runtime/browser-symbol.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build__ = __webpack_require__("./node_modules/svg-sprite-loader/runtime/browser-sprite.build.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build__);


var symbol = new __WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol___default.a({
  "id": "search",
  "use": "search-usage",
  "viewBox": "0 0 20 19",
  "content": "<symbol viewBox=\"0 0 20 19\" id=\"search\">\n    <g fill=\"none\" fill-rule=\"evenodd\" stroke=\"#222\" stroke-width=\"3\" opacity=\".99\" transform=\"translate(2 2)\">\n        <ellipse cx=\"6.084\" cy=\"5.982\" rx=\"6.084\" ry=\"5.982\" />\n        <path d=\"M10.65 10.33l5.653 5.653\" />\n    </g>\n</symbol>"
});
var result = __WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build___default.a.add(symbol);
/* harmony default export */ __webpack_exports__["default"] = (symbol);

/***/ }),

/***/ "./src/assets/img/smarter-faster@3x.png":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "3912470b12070a36fb06da0f9ed41573.png";

/***/ }),

/***/ "./src/assets/img/social-default.png":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "203e9f932cc97836ac2ff4c6c982676c.png";

/***/ }),

/***/ "./src/assets/img/twitter-inverse.svg":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol__ = __webpack_require__("./node_modules/svg-baker-runtime/browser-symbol.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build__ = __webpack_require__("./node_modules/svg-sprite-loader/runtime/browser-sprite.build.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build__);


var symbol = new __WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol___default.a({
  "id": "twitter-inverse",
  "use": "twitter-inverse-usage",
  "viewBox": "0 0 18 14",
  "content": "<symbol viewBox=\"0 0 18 14\" id=\"twitter-inverse\">\n    <path fill=\"#FFF\" fill-rule=\"evenodd\" d=\"M17.355 2.04a7.176 7.176 0 0 1-1.718 1.77 9.729 9.729 0 0 1-.392 3.197 9.943 9.943 0 0 1-1.225 2.635c-.547.841-1.2 1.585-1.956 2.232-.756.647-1.668 1.163-2.735 1.548A10.011 10.011 0 0 1 5.904 14c-1.916 0-3.669-.512-5.259-1.537.247.028.523.042.827.042 1.59 0 3.008-.488 4.252-1.463a3.339 3.339 0 0 1-1.994-.684 3.35 3.35 0 0 1-1.208-1.691c.233.035.449.053.647.053.303 0 .604-.039.9-.117a3.37 3.37 0 0 1-1.966-1.182 3.309 3.309 0 0 1-.78-2.179V5.2c.481.268.997.413 1.549.434a3.42 3.42 0 0 1-1.114-1.219 3.337 3.337 0 0 1-.413-1.633c0-.622.155-1.198.466-1.728a9.708 9.708 0 0 0 3.123 2.529 9.542 9.542 0 0 0 3.939 1.055 3.804 3.804 0 0 1-.085-.785A3.3 3.3 0 0 1 9.79 1.431 3.3 3.3 0 0 1 12.213.429c.99 0 1.823.36 2.502 1.081a6.715 6.715 0 0 0 2.173-.827 3.325 3.325 0 0 1-1.505 1.887 6.824 6.824 0 0 0 1.972-.53z\" />\n</symbol>"
});
var result = __WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build___default.a.add(symbol);
/* harmony default export */ __webpack_exports__["default"] = (symbol);

/***/ }),

/***/ "./src/assets/img/twitter.svg":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol__ = __webpack_require__("./node_modules/svg-baker-runtime/browser-symbol.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build__ = __webpack_require__("./node_modules/svg-sprite-loader/runtime/browser-sprite.build.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build__);


var symbol = new __WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol___default.a({
  "id": "twitter",
  "use": "twitter-usage",
  "viewBox": "0 0 18 14",
  "content": "<symbol viewBox=\"0 0 18 14\" id=\"twitter\">\n    <path fill=\"#4A4A4A\" fill-rule=\"evenodd\" d=\"M17.355 2.04a7.176 7.176 0 0 1-1.718 1.77 9.729 9.729 0 0 1-.392 3.197 9.943 9.943 0 0 1-1.225 2.635c-.547.841-1.2 1.585-1.956 2.232-.756.647-1.668 1.163-2.735 1.548A10.011 10.011 0 0 1 5.904 14c-1.916 0-3.669-.512-5.259-1.537.247.028.523.042.827.042 1.59 0 3.008-.488 4.252-1.463a3.339 3.339 0 0 1-1.994-.684 3.35 3.35 0 0 1-1.208-1.691c.233.035.449.053.647.053.303 0 .604-.039.9-.117a3.37 3.37 0 0 1-1.966-1.182 3.309 3.309 0 0 1-.78-2.179V5.2c.481.268.997.413 1.549.434a3.42 3.42 0 0 1-1.114-1.219 3.337 3.337 0 0 1-.413-1.633c0-.622.155-1.198.466-1.728a9.708 9.708 0 0 0 3.123 2.529 9.542 9.542 0 0 0 3.939 1.055 3.804 3.804 0 0 1-.085-.785A3.3 3.3 0 0 1 9.79 1.431 3.3 3.3 0 0 1 12.213.429c.99 0 1.823.36 2.502 1.081a6.715 6.715 0 0 0 2.173-.827 3.325 3.325 0 0 1-1.505 1.887 6.824 6.824 0 0 0 1.972-.53z\" />\n</symbol>"
});
var result = __WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build___default.a.add(symbol);
/* harmony default export */ __webpack_exports__["default"] = (symbol);

/***/ }),

/***/ "./src/assets/url/a-on-black.svg":
/***/ (function(module, exports) {

module.exports = "\"data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='195' height='166' viewBox='0 0 195 166'%3E %3Cg fill='none' fill-rule='evenodd'%3E %3Cpath fill='%23D7D7D7' d='M73.275 0L-6 179.483h47.94L121.45 0z'/%3E %3Cpath fill='%23E0E0E0' d='M73.458 0l79.51 179.483h47.94L121.634 0z'/%3E %3C/g%3E %3C/svg%3E\""

/***/ }),

/***/ "./src/assets/url/a-on-white.svg":
/***/ (function(module, exports) {

module.exports = "\"data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='52' height='44' viewBox='0 0 52 44'%3E %3Cg fill='none' fill-rule='evenodd'%3E %3Cpath fill='%23F5F5F5' d='M19.583 0L0 43.484h11.843L31.483 0z'/%3E %3Cpath fill='%23EEE' d='M19.629 0l19.64 43.484h11.843L31.529 0z'/%3E %3C/g%3E %3C/svg%3E\""

/***/ }),

/***/ "./src/assets/url/clipboard.svg":
/***/ (function(module, exports) {

module.exports = "\"data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='233' height='181' viewBox='0 0 233 181'%3E %3Cpath fill='%23E0E0E0' fill-rule='evenodd' d='M116.293.366c-13.765 0-25.244 8.85-29.624 21.11H59.91c-1.846 0-3.524 1.675-3.524 3.517v10.555H3.524C1.148 35.583-.001 37.63 0 39.066v274.416C0 315.324 1.679 317 3.524 317h225.538c1.845 0 3.524-1.676 3.524-3.518V39.066c0-1.842-1.679-3.518-3.524-3.518h-52.86V24.993c0-1.842-1.68-3.517-3.524-3.518h-26.761C141.537 9.216 130.058.366 116.293.366zm0 7.037c11.58 0 21.17 7.837 23.897 18.47.388 1.497 1.866 2.64 3.414 2.639h25.55v28.145H63.433V28.512h25.549c1.549 0 3.026-1.142 3.414-2.639a24.582 24.582 0 0 1 23.897-18.47zM7.048 42.584h49.337v17.59c0 1.843 1.678 3.519 3.524 3.52h112.769c1.845-.001 3.523-1.677 3.524-3.52v-17.59h49.336v267.38H7.048V42.584zM49.336 88.32c-5.838 0-10.572 4.726-10.572 10.555 0 5.828 4.734 10.554 10.572 10.554 5.84 0 10.573-4.726 10.573-10.554 0-5.83-4.734-10.555-10.573-10.555zm45.813 7.036a3.521 3.521 0 0 0-3.524 3.519 3.521 3.521 0 0 0 3.524 3.518h95.149a3.521 3.521 0 0 0 3.524-3.518 3.521 3.521 0 0 0-3.524-3.519h-95.15zm-45.813 29.656c-5.838 0-10.572 4.726-10.572 10.555s4.734 10.554 10.572 10.554c5.84 0 10.573-4.725 10.573-10.554 0-5.83-4.734-10.555-10.573-10.555zm45.813 7.037a3.521 3.521 0 0 0-3.524 3.518 3.521 3.521 0 0 0 3.524 3.518h95.149a3.521 3.521 0 0 0 3.524-3.518 3.521 3.521 0 0 0-3.524-3.518h-95.15zm-45.813 32.16c-5.838 0-10.572 4.725-10.572 10.554 0 5.83 4.734 10.555 10.572 10.555 5.84 0 10.573-4.726 10.573-10.555s-4.734-10.554-10.573-10.554zm45.813 7.036a3.521 3.521 0 0 0-3.524 3.518 3.521 3.521 0 0 0 3.524 3.518h95.149a3.521 3.521 0 0 0 3.524-3.518 3.521 3.521 0 0 0-3.524-3.518h-95.15z'/%3E %3C/svg%3E\""

/***/ }),

/***/ "./src/assets/url/events.svg":
/***/ (function(module, exports) {

module.exports = "\"data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='365' height='304' viewBox='0 0 365 304'%3E %3Cg fill='%23E0E0E0' fill-rule='nonzero'%3E %3Cpath d='M259.807 155.746c-.799-2.207-3.144-3.3-5.213-2.467-2.08.846-3.124 3.317-2.325 5.52l9.924 27.454c.617 1.704 2.143 2.747 3.769 2.747.483 0 .969-.092 1.444-.285 2.08-.846 3.124-3.316 2.325-5.52l-9.924-27.45z'/%3E %3Cpath d='M348.238 163.899l-3.865 1.482a26.334 26.334 0 0 1-9.47 1.767c-10.552 0-19.734-6.178-23.396-15.745-2.356-6.17-2.092-12.93.738-19.032 2.855-6.146 7.965-10.891 14.402-13.357l3.865-1.483-16.766-43.869-35.032 13.434-11.274-13.34-3.156 2.677c-4.765 4.038-10.767 6.26-16.907 6.26-7.292.004-14.114-3.128-18.72-8.58-4.263-5.041-6.246-11.509-5.581-18.207.665-6.744 3.93-12.914 9.186-17.37l3.159-2.678L205.12 0 0 173.88l30.66 36.292 3.18-3.274a25.87 25.87 0 0 1 1.942-1.812c4.761-4.037 10.764-6.26 16.9-6.26 7.292 0 14.117 3.128 18.724 8.58 8.83 10.448 7.207 26.41-3.601 35.578a26.874 26.874 0 0 1-2.11 1.613l-3.759 2.6 30.669 36.3 10.264-8.705L114.034 304l173.282-66.443h.008L365 207.772l-16.762-43.873zM52.686 190.53c-7.734 0-15.298 2.67-21.41 7.536L11.664 174.85 143.822 62.82l13.371 15.823a4.123 4.123 0 0 0 3.164 1.466c.94 0 1.89-.32 2.668-.983a4.151 4.151 0 0 0 .49-5.842l-13.37-15.826 54.012-45.783 19.754 23.383c-5.146 5.516-8.33 12.492-9.072 20.023-.884 8.95 1.776 17.606 7.499 24.378 6.189 7.32 15.314 11.517 25.043 11.517 6.72 0 13.31-2.011 18.931-5.732l4.218 4.984-34.452 13.211-35.624 13.662c-.065-.09-.081-.195-.154-.28l-18.392-21.77a4.13 4.13 0 0 0-5.832-.488 4.151 4.151 0 0 0-.49 5.841l16.732 19.808-100.675 38.605 66.516-52.193c2.104-1.65 2.555-4.879 1.005-7.207-1.549-2.336-4.513-2.88-6.614-1.227L72.37 161.104c-1.69 1.324-2.25 3.652-1.63 5.732l-7.957 3.05 10.69 27.982c-5.779-4.713-13.095-7.337-20.788-7.337zm48.788 67.853l-4.404 1.207 2.672 6.995-6.16 5.224-19.613-23.212c10.443-9.42 13.878-23.842 9.628-36.22l.248-.122c.778-.39 1.59-.747 2.425-1.068a26.34 26.34 0 0 1 9.474-1.767c9.234 0 17.414 4.733 21.766 12.325a24.543 24.543 0 0 1 1.622 3.425c2.356 6.17 2.093 12.93-.738 19.032-2.855 6.146-7.965 10.89-14.401 13.357-.84.316-1.675.589-2.519.824zm179.357-49.414a4.148 4.148 0 0 0-5.345-2.393 4.152 4.152 0 0 0-2.385 5.354l7.397 19.357-161.69 62.004-10.853-28.396c7.977-3.343 14.324-9.416 17.938-17.2 3.787-8.153 4.132-17.208.96-25.49a32.701 32.701 0 0 0-2.165-4.583C118.885 207.463 108 201.13 95.74 201.13c-3.886 0-7.722.654-11.409 1.942l-10.856-28.4 161.695-62 7.4 19.358a4.136 4.136 0 0 0 5.346 2.388 4.149 4.149 0 0 0 2.385-5.354l-7.402-19.357 66.082-25.337 10.933 28.607c-6.675 3.506-11.984 9.035-15.167 15.896-3.788 8.153-4.133 17.208-.962 25.491 4.891 12.805 17.11 21.076 31.123 21.076a34.25 34.25 0 0 0 8.476-1.06l10.934 28.606-66.09 25.341-7.397-19.357z'/%3E %3Cpath d='M231.766 144.372c-.808-2.659-3.48-4.029-5.956-3.062l-94.55 36.76c-2.48.962-3.834 3.9-3.026 6.555.541 1.78 1.923 2.986 3.516 3.296a4.348 4.348 0 0 0 2.44-.234l94.55-36.759c2.48-.963 3.834-3.896 3.026-6.556zM241.766 177.372c-.808-2.659-3.48-4.029-5.956-3.062l-94.55 36.76c-2.48.962-3.834 3.9-3.026 6.555.541 1.78 1.923 2.986 3.52 3.296a4.348 4.348 0 0 0 2.44-.234l94.55-36.759c2.477-.963 3.83-3.9 3.022-6.556zM180.743 233.317l-29.447 11.553c-2.508.982-3.877 3.979-3.06 6.687.548 1.817 1.944 3.046 3.554 3.362.792.156 1.642.09 2.467-.238l29.447-11.558c2.508-.982 3.877-3.978 3.06-6.687-.813-2.712-3.517-4.106-6.02-3.12zM246.743 206.314l-29.447 11.557c-2.508.983-3.877 3.979-3.06 6.687.548 1.817 1.944 3.046 3.554 3.362a4.393 4.393 0 0 0 2.467-.238l29.447-11.553c2.508-.983 3.877-3.979 3.06-6.687-.813-2.713-3.517-4.11-6.02-3.128z'/%3E %3C/g%3E %3C/svg%3E\""

/***/ }),

/***/ "./src/assets/url/newsletter.svg":
/***/ (function(module, exports) {

module.exports = "\"data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='356' height='173' viewBox='0 0 356 173'%3E %3Cg fill='%23E0E0E0' fill-rule='evenodd'%3E %3Cpath d='M122.743 11.787L114.183.891H8.728L.168 11.787zM153.874 51.867l-8.172-10.506H39.86l-8.172 10.506zM185.393 92.337l-8.56-10.896H70.989l-8.172 10.896zM216.524 132.417l-8.561-10.895H102.509l-8.561 10.895zM133.64 161.602l-8.562 10.896h122.576l-8.56-10.896zM134.028.502l105.455 136.585h14.787l89.5-117.907v141.255h-89.5l8.95 11.674h92.613V.502H134.028zM246.876 127.36l-89.11-115.183H334.43L246.876 127.36z'/%3E %3C/g%3E %3C/svg%3E\""

/***/ }),

/***/ "./src/assets/url/tag.svg":
/***/ (function(module, exports) {

module.exports = "\"data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='293' height='293' viewBox='0 0 293 293'%3E %3Cg fill='%23E0E0E0' fill-rule='evenodd'%3E %3Cpath d='M214.449 58.58c0 5.344 2.075 10.358 5.842 14.129 3.768 3.77 8.785 5.842 14.126 5.846h.004c5.34 0 10.358-2.075 14.126-5.846 3.767-3.77 5.842-8.789 5.842-14.13 0-5.34-2.075-10.358-5.842-14.13-3.768-3.77-8.785-5.842-14.126-5.842-5.341 0-10.362 2.075-14.13 5.843-3.767 3.767-5.842 8.785-5.842 14.13zM234.42 43.8c3.952 0 7.663 1.534 10.454 4.325a14.69 14.69 0 0 1 4.325 10.454 14.697 14.697 0 0 1-4.325 10.455 14.695 14.695 0 0 1-10.454 4.325v2.6l-.004-2.6a14.668 14.668 0 0 1-10.45-4.325 14.67 14.67 0 0 1-4.326-10.455 14.68 14.68 0 0 1 4.322-10.454A14.683 14.683 0 0 1 234.42 43.8z'/%3E %3Cpath d='M291.004 57.814L235.186 1.996a4.318 4.318 0 0 0-3.078-1.267L176.62.91a4.327 4.327 0 0 0-3.049 1.267L1.996 173.756a4.333 4.333 0 0 0 0 6.123L113.12 291.004a4.333 4.333 0 0 0 3.062 1.27c1.148 0 2.25-.458 3.061-1.27l170.537-170.536 1.035-1.036a4.33 4.33 0 0 0 1.27-3.048l.182-55.492a4.312 4.312 0 0 0-1.264-3.078zm-7.567 56.752L116.183 281.82 11.18 176.814 178.434 9.564l51.903-.172 53.268 53.268-.168 51.906z'/%3E %3Cpath d='M216.117 137.75L155.25 76.885l3.672-3.672 60.867 60.867zM197.994 155.879l-60.867-60.867 3.672-3.672 60.867 60.867zM179.858 174.008l-60.867-60.867 3.674-3.674 60.867 60.867zM161.735 192.137l-60.867-60.867 3.672-3.672 60.867 60.867z'/%3E %3C/g%3E %3C/svg%3E\""

/***/ }),

/***/ "./src/author/actions/author.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return getAuthor; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return getAuthorStories; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils_backend__ = __webpack_require__("./src/utils/backend.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__constants_actionTypes__ = __webpack_require__("./src/constants/actionTypes.js");



var getAuthor = function getAuthor(username) {
  return function (dispatch) {
    dispatch({
      type: __WEBPACK_IMPORTED_MODULE_1__constants_actionTypes__["q" /* GET_AUTHOR */]
    });

    return __WEBPACK_IMPORTED_MODULE_0__utils_backend__["a" /* default */].request({
      method: "GET",
      url: "/author/" + username + "/"
    }).then(function (response) {
      dispatch({
        type: __WEBPACK_IMPORTED_MODULE_1__constants_actionTypes__["s" /* GET_AUTHOR_SUCCESS */],
        payload: response.data
      });
    }).catch(function (err) {
      dispatch({
        type: __WEBPACK_IMPORTED_MODULE_1__constants_actionTypes__["r" /* GET_AUTHOR_ERROR */],
        payload: err
      });
    });
  };
};

var getAuthorStories = function getAuthorStories(username, params) {
  var appendResults = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;

  return function (dispatch) {
    if (!appendResults) {
      dispatch({
        type: __WEBPACK_IMPORTED_MODULE_1__constants_actionTypes__["S" /* GET_STORIES_STREAM */]
      });
    }

    return __WEBPACK_IMPORTED_MODULE_0__utils_backend__["a" /* default */].request({
      method: "GET",
      url: "/author/" + username + "/stories/",
      params: params
    }).then(function (response) {
      dispatch({
        type: appendResults ? __WEBPACK_IMPORTED_MODULE_1__constants_actionTypes__["V" /* GET_STORIES_STREAM_UPDATE */] : __WEBPACK_IMPORTED_MODULE_1__constants_actionTypes__["U" /* GET_STORIES_STREAM_SUCCESS */],
        payload: response.data.results
      });
    }).catch(function (err) {
      dispatch({
        type: __WEBPACK_IMPORTED_MODULE_1__constants_actionTypes__["T" /* GET_STORIES_STREAM_ERROR */],
        payload: {
          handleError: true,
          error: err
        }
      });
    });
  };
};

/***/ }),

/***/ "./src/author/components/Author/Author.css":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"root":"Author__root--1K3ne","featured":"Author__featured--39l6X","sidebar":"Author__sidebar--36WrD","bounce":"Author__bounce--3qdvy"};

/***/ }),

/***/ "./src/author/components/Author/Author.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__("./node_modules/react/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__("./node_modules/react-redux/es/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_selectn__ = __webpack_require__("./node_modules/selectn/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_selectn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_selectn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash_debounce__ = __webpack_require__("./node_modules/lodash/debounce.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash_debounce___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_lodash_debounce__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_helmet__ = __webpack_require__("./node_modules/react-helmet/lib/Helmet.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_helmet___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react_helmet__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__AuthorSubscribe__ = __webpack_require__("./src/author/components/AuthorSubscribe/AuthorSubscribe.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_Library_UserHeader__ = __webpack_require__("./src/components/Library/UserHeader/UserHeader.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_Library_Layout__ = __webpack_require__("./src/components/Library/Layout/Layout.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_Library_Layout_Sidebar__ = __webpack_require__("./src/components/Library/Layout/Sidebar.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_Library_Layout_Content__ = __webpack_require__("./src/components/Library/Layout/Content.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__components_Library_StoriesStream__ = __webpack_require__("./src/components/Library/StoriesStream/StoriesStream.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__actions_author__ = __webpack_require__("./src/author/actions/author.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__utils_analytics__ = __webpack_require__("./src/utils/analytics.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__Author_css__ = __webpack_require__("./src/author/components/Author/Author.css");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__Author_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13__Author_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__config_constants__ = __webpack_require__("./src/config/constants.js");
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }




















var Author = function (_Component) {
  _inherits(Author, _Component);

  function Author(props) {
    _classCallCheck(this, Author);

    var _this = _possibleConstructorReturn(this, (Author.__proto__ || Object.getPrototypeOf(Author)).call(this, props));

    _this.handleScroll = function () {
      var cards = document.getElementsByClassName("story-card");
      if (cards) {
        var _loop = function _loop(i) {
          var card = cards[i];

          if (__WEBPACK_IMPORTED_MODULE_12__utils_analytics__["a" /* default */].isStoryInView(card) && _this.state.inViewId !== card.id) {
            _this.setState({ inViewId: card.id });
            setTimeout(function () {
              if (__WEBPACK_IMPORTED_MODULE_12__utils_analytics__["a" /* default */].isStoryInView(card)) {
                var stories = _this.props.storiesStream.results.filter(function (story) {
                  return story.id === card.id;
                });
                if (stories && stories.length) {
                  var stream = _this.props.author.display_name;
                  __WEBPACK_IMPORTED_MODULE_12__utils_analytics__["a" /* default */].userScrollsStoryIntoView({ story: stories[0], stream: stream });
                }
              }
            }, 3000);
            return "break";
          }
        };

        for (var i = 0; i < cards.length; i++) {
          var _ret = _loop(i);

          if (_ret === "break") break;
        }
      }
    };

    _this.loadNextStories = _this.loadNextStories.bind(_this);
    _this.state = {
      username: null
    };
    return _this;
  }

  _createClass(Author, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this.scrollListener = __WEBPACK_IMPORTED_MODULE_3_lodash_debounce___default()(this.handleScroll, 50);
      window.addEventListener("scroll", this.scrollListener);

      this.setState({ username: __WEBPACK_IMPORTED_MODULE_2_selectn___default()("match.params.username", this.props) });
    }
  }, {
    key: "componentWillReceiveProps",
    value: function componentWillReceiveProps(nextProps) {
      var username = __WEBPACK_IMPORTED_MODULE_2_selectn___default()("match.params.username", this.props);
      var nextUsername = __WEBPACK_IMPORTED_MODULE_2_selectn___default()("match.params.username", nextProps);
      if (username !== nextUsername) {
        this.setState({ username: nextUsername });
      }
    }
  }, {
    key: "componentWillUpdate",
    value: function componentWillUpdate(nextProps, nextState) {
      if (this.state.username !== nextState.username) {
        this.props.getAuthor(nextState.username);
        this.props.getAuthorStories(nextState.username);
      }
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      window.removeEventListener("scroll", this.scrollListener);
    }
  }, {
    key: "loadNextStories",
    value: function loadNextStories(page) {
      return this.props.getAuthorStories(this.state.username, { page: page }, true);
    }
  }, {
    key: "renderMeta",
    value: function renderMeta() {
      if (!this.props.author || !this.props.author.display_name) return null;
      var ogUrl = __WEBPACK_IMPORTED_MODULE_14__config_constants__["j" /* FRONTEND_ROOT */] + "/authors/" + this.props.match.params.username + "/";
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_4_react_helmet__["Helmet"],
        null,
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "title",
          null,
          this.props.author.display_name,
          " - Axios"
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("meta", { property: "og:url", content: ogUrl }),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("meta", { property: "og:title", content: this.props.author.display_name + " on Axios" })
      );
    }
  }, {
    key: "render",
    value: function render() {
      var author = this.props.author;

      if (!author) return null;

      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_7__components_Library_Layout__["a" /* default */],
        { className: __WEBPACK_IMPORTED_MODULE_13__Author_css___default.a.root, includeHeader: true, headerComponent: __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__components_Library_UserHeader__["a" /* default */], { person: author }) },
        this.renderMeta(),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_8__components_Library_Layout_Sidebar__["a" /* default */],
          { className: __WEBPACK_IMPORTED_MODULE_13__Author_css___default.a.sidebar },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__AuthorSubscribe__["a" /* default */], { author: author })
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_9__components_Library_Layout_Content__["a" /* default */],
          { ariaLabel: "Stories" },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__components_Library_StoriesStream__["a" /* default */], { stories: this.props.storiesStream, next: this.loadNextStories, showUnread: false })
        )
      );
    }
  }]);

  return Author;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

var mapStateToProps = function mapStateToProps(state) {
  return {
    author: state.authors.data,
    storiesStream: state.storiesStream
  };
};

/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1_react_redux__["b" /* connect */])(mapStateToProps, { getAuthor: __WEBPACK_IMPORTED_MODULE_11__actions_author__["a" /* getAuthor */], getAuthorStories: __WEBPACK_IMPORTED_MODULE_11__actions_author__["b" /* getAuthorStories */] })(Author));

/***/ }),

/***/ "./src/author/components/AuthorSubscribe/AuthorSubscribe.css":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"root":"AuthorSubscribe__root--25ZbV","featured":"AuthorSubscribe__featured--TsglR","caret":"AuthorSubscribe__caret--30Ydq","close":"AuthorSubscribe__close--20v97 AuthorSubscribe__caret--30Ydq","left":"AuthorSubscribe__left--3lsTl AuthorSubscribe__caret--30Ydq","right":"AuthorSubscribe__right--a14uh AuthorSubscribe__caret--30Ydq","subscribe":"AuthorSubscribe__subscribe--1KNnL","bounce":"AuthorSubscribe__bounce--3x19J"};

/***/ }),

/***/ "./src/author/components/AuthorSubscribe/AuthorSubscribe.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__("./node_modules/react/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__("./node_modules/prop-types/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_redux__ = __webpack_require__("./node_modules/react-redux/es/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__SubscribeToNewsletter__ = __webpack_require__("./src/author/components/AuthorSubscribe/SubscribeToNewsletter.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_Library_Icon_Icon__ = __webpack_require__("./src/components/Library/Icon/Icon.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__actions_user__ = __webpack_require__("./src/actions/user.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__utils_localdb__ = __webpack_require__("./src/utils/localdb.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__AuthorSubscribe_css__ = __webpack_require__("./src/author/components/AuthorSubscribe/AuthorSubscribe.css");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__AuthorSubscribe_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__AuthorSubscribe_css__);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }












var AuthorSubscribe = function (_Component) {
  _inherits(AuthorSubscribe, _Component);

  function AuthorSubscribe(props) {
    _classCallCheck(this, AuthorSubscribe);

    var _this = _possibleConstructorReturn(this, (AuthorSubscribe.__proto__ || Object.getPrototypeOf(AuthorSubscribe)).call(this, props));

    _this.onSubscribed = function (email, subscription) {
      if (_this.props.isLoggedIn) {
        _this.props.updateUserSubscriptions(_this.props.user.subscriptions, subscription);
      } else {
        _this.props.updateUnAuthedSubscriptions(email, [subscription.id]).then(function () {
          Object(__WEBPACK_IMPORTED_MODULE_6__utils_localdb__["c" /* setLocalItem */])("AxiosSubscriptions", [].concat(_toConsumableArray(Object(__WEBPACK_IMPORTED_MODULE_6__utils_localdb__["a" /* getLocalItem */])("AxiosSubscriptions") || []), [_this.props.subscription.id]), { expires: 30 });
        });
      }
      _this.setState({
        subscribing: false,
        thanks: !_this.props.isLoggedIn,
        alreadySubscribedTo: [].concat(_toConsumableArray(_this.state.alreadySubscribedTo), [subscription.id])
      });
    };

    _this.onSubscribing = function () {
      _this.setState({ subscribing: true });
    };

    _this.onClose = function () {
      _this.setState({ subscribing: false, thanks: false });
    };

    _this.onLeft = function () {
      var length = _this.props.author.primary_contributor_for.length;
      _this.setState({ index: (length + _this.state.index - 1) % length });
    };

    _this.onRight = function () {
      var length = _this.props.author.primary_contributor_for.length;
      _this.setState({ index: (_this.state.index + 1) % length });
    };

    _this.state = {
      alreadySubscribedTo: [],
      subscriptions: null,
      subscribing: false,
      thanks: false,
      index: 0
    };
    return _this;
  }

  _createClass(AuthorSubscribe, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      if (!this.props.isLoggedIn) {
        var alreadySubscribedTo = Object(__WEBPACK_IMPORTED_MODULE_6__utils_localdb__["a" /* getLocalItem */])("AxiosSubscriptions");
        this.setState({ alreadySubscribedTo: alreadySubscribedTo || [] });
      } else if (this.props.user) {
        this.setState({ alreadySubscribedTo: this.props.user.subscriptions.map(function (s) {
            return s.id;
          }) });
      }
    }
  }, {
    key: "componentWillReceiveProps",
    value: function componentWillReceiveProps(nextProps) {
      if (this.props.isLoggedIn && !this.props.user && nextProps.user) {
        this.setState({ alreadySubscribedTo: nextProps.user.subscriptions.map(function (s) {
            return s.id;
          }) });
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      var author = this.props.author;

      if (!author || !author.primary_contributor_for || author.primary_contributor_for.length === 0) return null;

      var subscriptions = author.primary_contributor_for.map(function (subscription) {
        return _extends({}, subscription, {
          isSubscribed: _this2.state.alreadySubscribedTo.includes(subscription.id)
        });
      });

      var subscription = subscriptions[this.state.index];

      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "div",
        { className: __WEBPACK_IMPORTED_MODULE_7__AuthorSubscribe_css___default.a.root },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "div",
          { className: __WEBPACK_IMPORTED_MODULE_7__AuthorSubscribe_css___default.a.featured },
          author.display_name + "'s Newsletters"
        ),
        this.state.subscribing || this.state.thanks ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__components_Library_Icon_Icon__["a" /* default */], {
          className: __WEBPACK_IMPORTED_MODULE_7__AuthorSubscribe_css___default.a.close,
          name: "close",
          description: "Cancel attempting to subscribe to author's newsletter",
          onClick: this.onClose }) : __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "div",
          null,
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__components_Library_Icon_Icon__["a" /* default */], {
            className: __WEBPACK_IMPORTED_MODULE_7__AuthorSubscribe_css___default.a.left,
            name: "caret/left",
            description: "Move left through author's newsletters",
            onClick: this.onLeft }),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__components_Library_Icon_Icon__["a" /* default */], {
            className: __WEBPACK_IMPORTED_MODULE_7__AuthorSubscribe_css___default.a.right,
            name: "caret/right",
            description: "Move right through author's newsletters",
            onClick: this.onRight })
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__SubscribeToNewsletter__["a" /* default */], {
          subscription: subscription,
          subscribing: this.state.subscribing,
          thanks: this.state.thanks,
          onSubscribed: this.onSubscribed,
          onSubscribing: this.onSubscribing })
      );
    }
  }]);

  return AuthorSubscribe;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

var mapStateToProps = function mapStateToProps(state) {
  return {
    user: state.user.data,
    isLoggedIn: !!state.authDrawer.authToken // TODO: implement this when user stuff is done
  };
};

AuthorSubscribe.propTypes = {
  user: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,
  author: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,
  isLoggedIn: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool.isRequired
};

/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_2_react_redux__["b" /* connect */])(mapStateToProps, { updateUnAuthedSubscriptions: __WEBPACK_IMPORTED_MODULE_5__actions_user__["b" /* updateUnAuthedSubscriptions */], updateUserSubscriptions: __WEBPACK_IMPORTED_MODULE_5__actions_user__["c" /* updateUserSubscriptions */] })(AuthorSubscribe));

/***/ }),

/***/ "./src/author/components/AuthorSubscribe/SubscribeToNewsletter.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__("./node_modules/react/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__("./node_modules/react-redux/es/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Subscribing_Subscribing__ = __webpack_require__("./src/author/components/Subscribing/Subscribing.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Subscribe_Subscribe__ = __webpack_require__("./src/author/components/Subscribe/Subscribe.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__SubscribeComplete_SubscribeComplete__ = __webpack_require__("./src/author/components/SubscribeComplete/SubscribeComplete.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__AuthorSubscribe_css__ = __webpack_require__("./src/author/components/AuthorSubscribe/AuthorSubscribe.css");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__AuthorSubscribe_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__AuthorSubscribe_css__);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }










var SubscribeToNewsletter = function (_Component) {
  _inherits(SubscribeToNewsletter, _Component);

  function SubscribeToNewsletter() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, SubscribeToNewsletter);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = SubscribeToNewsletter.__proto__ || Object.getPrototypeOf(SubscribeToNewsletter)).call.apply(_ref, [this].concat(args))), _this), _this.onSubscribe = function (email) {
      _this.props.onSubscribed(email, _this.props.subscription);
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(SubscribeToNewsletter, [{
    key: "render",
    value: function render() {
      var subscription = this.props.subscription;


      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "div",
        { className: __WEBPACK_IMPORTED_MODULE_5__AuthorSubscribe_css___default.a.subscribe },
        !this.props.isLoggedIn && this.props.thanks ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__SubscribeComplete_SubscribeComplete__["a" /* default */], { subscription: subscription }) : this.props.subscribing ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__Subscribing_Subscribing__["a" /* default */], { subscription: subscription, onSubscribe: this.onSubscribe }) : __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__Subscribe_Subscribe__["a" /* default */], {
          subscription: subscription,
          onClickSubscribe: this.props.isLoggedIn ? this.onSubscribe : this.props.onSubscribing })
      );
    }
  }]);

  return SubscribeToNewsletter;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

var mapStateToProps = function mapStateToProps(state) {
  return {
    isLoggedIn: !!state.authDrawer.authToken // TODO: implement this when user stuff is done
  };
};

/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1_react_redux__["b" /* connect */])(mapStateToProps)(SubscribeToNewsletter));

/***/ }),

/***/ "./src/author/components/Subscribe/Subscribe.css":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"content":"Subscribe__content--33RUf","text":"Subscribe__text--qni3B","subscribe":"Subscribe__subscribe--3ygSI","subscribed":"Subscribe__subscribed--1trcK Subscribe__subscribe--3ygSI","check":"Subscribe__check--2YUDd","bounce":"Subscribe__bounce--mkG0J"};

/***/ }),

/***/ "./src/author/components/Subscribe/Subscribe.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__("./node_modules/react/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_Library_Icon_Icon__ = __webpack_require__("./src/components/Library/Icon/Icon.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_Library_SubscribeButton__ = __webpack_require__("./src/components/Library/SubscribeButton/SubscribeButton.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Subscribe_css__ = __webpack_require__("./src/author/components/Subscribe/Subscribe.css");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Subscribe_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__Subscribe_css__);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }







var Subscribe = function (_Component) {
  _inherits(Subscribe, _Component);

  function Subscribe() {
    _classCallCheck(this, Subscribe);

    return _possibleConstructorReturn(this, (Subscribe.__proto__ || Object.getPrototypeOf(Subscribe)).apply(this, arguments));
  }

  _createClass(Subscribe, [{
    key: "render",
    value: function render() {
      var subscription = this.props.subscription;

      if (!subscription) return null;

      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "div",
        null,
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "div",
          { className: __WEBPACK_IMPORTED_MODULE_3__Subscribe_css___default.a.content },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            "div",
            { className: __WEBPACK_IMPORTED_MODULE_3__Subscribe_css___default.a.text },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              "strong",
              null,
              subscription.name
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              "div",
              null,
              subscription.description
            )
          )
        ),
        subscription.isSubscribed ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_2__components_Library_SubscribeButton__["a" /* default */],
          { className: __WEBPACK_IMPORTED_MODULE_3__Subscribe_css___default.a.subscribed, disabled: true },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__components_Library_Icon_Icon__["a" /* default */], { name: "check/rounded", className: __WEBPACK_IMPORTED_MODULE_3__Subscribe_css___default.a.check }),
          "Subscribed"
        ) : __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_2__components_Library_SubscribeButton__["a" /* default */],
          { className: __WEBPACK_IMPORTED_MODULE_3__Subscribe_css___default.a.subscribe, onClickSubscribe: this.props.onClickSubscribe },
          "Subscribe"
        )
      );
    }
  }]);

  return Subscribe;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

/* harmony default export */ __webpack_exports__["a"] = (Subscribe);

/***/ }),

/***/ "./src/author/components/SubscribeComplete/SubscribeComplete.css":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"root":"SubscribeComplete__root--2niBO","text":"SubscribeComplete__text--xgwDB","separator":"SubscribeComplete__separator--D5ocN","signUp":"SubscribeComplete__signUp--3_e35","checkmark":"SubscribeComplete__checkmark--3gB3j","bounce":"SubscribeComplete__bounce--a82IU"};

/***/ }),

/***/ "./src/author/components/SubscribeComplete/SubscribeComplete.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__("./node_modules/react/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__("./node_modules/react-redux/es/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__constants_authDrawer__ = __webpack_require__("./src/constants/authDrawer.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__actions_authDrawer__ = __webpack_require__("./src/actions/authDrawer.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_Library_Icon_Icon__ = __webpack_require__("./src/components/Library/Icon/Icon.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__SubscribeComplete_css__ = __webpack_require__("./src/author/components/SubscribeComplete/SubscribeComplete.css");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__SubscribeComplete_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__SubscribeComplete_css__);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }










var SubscribeComplete = function (_Component) {
  _inherits(SubscribeComplete, _Component);

  function SubscribeComplete() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, SubscribeComplete);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = SubscribeComplete.__proto__ || Object.getPrototypeOf(SubscribeComplete)).call.apply(_ref, [this].concat(args))), _this), _this.onSignUpNow = function () {
      _this.props.toggleAuthDrawer(true);
      _this.props.changeStep(__WEBPACK_IMPORTED_MODULE_2__constants_authDrawer__["j" /* REGISTER1 */]);
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(SubscribeComplete, [{
    key: "render",
    value: function render() {
      var subscription = this.props.subscription;

      if (!subscription) return null;

      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "div",
        { className: __WEBPACK_IMPORTED_MODULE_5__SubscribeComplete_css___default.a.root },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__components_Library_Icon_Icon__["a" /* default */], { className: __WEBPACK_IMPORTED_MODULE_5__SubscribeComplete_css___default.a.checkmark, name: "check/rounded" }),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "div",
          { className: __WEBPACK_IMPORTED_MODULE_5__SubscribeComplete_css___default.a.text },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            "div",
            null,
            "Thanks for subscribing to ",
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              "strong",
              null,
              subscription.name
            ),
            "!"
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("hr", { className: __WEBPACK_IMPORTED_MODULE_5__SubscribeComplete_css___default.a.separator, "aria-hidden": true }),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            "div",
            null,
            "Sign up for an account to save stories and manage your subscriptions."
          )
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "button",
          { className: __WEBPACK_IMPORTED_MODULE_5__SubscribeComplete_css___default.a.signUp, onClick: this.onSignUpNow, alt: "Sign up now" },
          "Sign up now"
        )
      );
    }
  }]);

  return SubscribeComplete;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1_react_redux__["b" /* connect */])(null, { toggleAuthDrawer: __WEBPACK_IMPORTED_MODULE_3__actions_authDrawer__["toggleAuthDrawer"], changeStep: __WEBPACK_IMPORTED_MODULE_3__actions_authDrawer__["changeStep"] })(SubscribeComplete));

/***/ }),

/***/ "./src/author/components/Subscribing/Subscribing.css":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"content":"Subscribing__content--2Bx9n","text":"Subscribing__text--3v_Px","input":"Subscribing__input--2lNvH","subscribe":"Subscribing__subscribe--1BHsi","bounce":"Subscribing__bounce--2bngw"};

/***/ }),

/***/ "./src/author/components/Subscribing/Subscribing.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__("./node_modules/react/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_Library_SubscribeButton__ = __webpack_require__("./src/components/Library/SubscribeButton/SubscribeButton.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Subscribing_css__ = __webpack_require__("./src/author/components/Subscribing/Subscribing.css");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Subscribing_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__Subscribing_css__);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }







var Subscribing = function (_Component) {
  _inherits(Subscribing, _Component);

  function Subscribing(props) {
    _classCallCheck(this, Subscribing);

    var _this = _possibleConstructorReturn(this, (Subscribing.__proto__ || Object.getPrototypeOf(Subscribing)).call(this, props));

    _this.onChange = function (event) {
      _this.setState(_defineProperty({}, event.target.name, event.target.value));
    };

    _this.state = {
      email: ""
    };
    return _this;
  }

  _createClass(Subscribing, [{
    key: "render",
    value: function render() {
      var _this2 = this;

      var subscription = this.props.subscription;

      if (!subscription) return null;

      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "div",
        null,
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "div",
          { className: __WEBPACK_IMPORTED_MODULE_2__Subscribing_css___default.a.content },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            "div",
            { className: __WEBPACK_IMPORTED_MODULE_2__Subscribing_css___default.a.text },
            "Great choice. Enter your email to subscribe to ",
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              "strong",
              null,
              subscription.name
            ),
            "."
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("input", {
            name: "email",
            "aria-label": "Enter Your Email Address",
            className: __WEBPACK_IMPORTED_MODULE_2__Subscribing_css___default.a.input,
            placeholder: "Your Email Address",
            value: this.state.email,
            onChange: this.onChange
          })
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_1__components_Library_SubscribeButton__["a" /* default */],
          {
            className: __WEBPACK_IMPORTED_MODULE_2__Subscribing_css___default.a.subscribe,
            disabled: this.state.email === "",
            onClickSubscribe: function onClickSubscribe() {
              return _this2.props.onSubscribe(_this2.state.email);
            } },
          "Submit"
        )
      );
    }
  }]);

  return Subscribing;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

/* harmony default export */ __webpack_exports__["a"] = (Subscribing);

/***/ }),

/***/ "./src/author/reducers/authors.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__constants_actionTypes__ = __webpack_require__("./src/constants/actionTypes.js");
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };



var initialState = {
  isLoading: false,
  isFinished: false,
  isError: false,
  error: null,
  data: null,
  results: []
};

/* harmony default export */ __webpack_exports__["a"] = (function () {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
  var action = arguments[1];

  switch (action.type) {
    case __WEBPACK_IMPORTED_MODULE_0__constants_actionTypes__["q" /* GET_AUTHOR */]:
      {
        return _extends({}, state, {
          isLoading: true,
          isFinished: false,
          isError: false,
          error: null
        });
      }

    case __WEBPACK_IMPORTED_MODULE_0__constants_actionTypes__["s" /* GET_AUTHOR_SUCCESS */]:
      {
        return _extends({}, state, {
          isLoading: false,
          isFinished: true,
          data: action.payload
        });
      }

    case __WEBPACK_IMPORTED_MODULE_0__constants_actionTypes__["r" /* GET_AUTHOR_ERROR */]:
      {
        return _extends({}, state, {
          isLoading: false,
          isFinished: true,
          isError: true,
          error: action.payload
        });
      }

    default:
      {
        return state;
      }
  }
});

/***/ }),

/***/ "./src/browser.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__polyfills_js__ = __webpack_require__("./src/polyfills.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__robots_txt__ = __webpack_require__("./src/robots.txt");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__robots_txt___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__robots_txt__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react__ = __webpack_require__("./node_modules/react/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_dom__ = __webpack_require__("./node_modules/react-dom/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_dom___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react_dom__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_loadable__ = __webpack_require__("./node_modules/react-loadable/lib/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_loadable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react_loadable__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_redux__ = __webpack_require__("./node_modules/react-redux/es/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__store_configureStore__ = __webpack_require__("./src/store/configureStore.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_normalize_css__ = __webpack_require__("./node_modules/normalize.css/normalize.css");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_normalize_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_normalize_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__styles_main__ = __webpack_require__("./src/styles/main.scss");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__styles_main___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__styles_main__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_App__ = __webpack_require__("./src/components/App/App.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__actions_authDrawer__ = __webpack_require__("./src/actions/authDrawer.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__actions_user__ = __webpack_require__("./src/actions/user.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__utils_localdb__ = __webpack_require__("./src/utils/localdb.js");















if (typeof window !== "undefined") {
  var preloadedState = window.__PRELOADED_STATE__;
  delete window.__PRELOADED_STATE__;

  var store = Object(__WEBPACK_IMPORTED_MODULE_6__store_configureStore__["a" /* default */])(preloadedState);

  var token = Object(__WEBPACK_IMPORTED_MODULE_12__utils_localdb__["a" /* getLocalItem */])("authToken");
  if (token) {
    store.dispatch(Object(__WEBPACK_IMPORTED_MODULE_10__actions_authDrawer__["setAuthToken"])(token)).then(function () {
      return store.dispatch(Object(__WEBPACK_IMPORTED_MODULE_11__actions_user__["a" /* getUserData */])());
    });
  }

  var render = function render() {
    (preloadedState ? __WEBPACK_IMPORTED_MODULE_3_react_dom___default.a.hydrate : __WEBPACK_IMPORTED_MODULE_3_react_dom___default.a.render)(__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
      __WEBPACK_IMPORTED_MODULE_5_react_redux__["a" /* Provider */],
      { store: store },
      __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__components_App__["a" /* default */], null)
    ), document.getElementById("app"));
  };

  if (false) {
    module.hot.accept("./components/App", function () {
      render();
    });
  }

  __WEBPACK_IMPORTED_MODULE_4_react_loadable___default.a.preloadReady().then(function () {
    render();
  });
}

/***/ }),

/***/ "./src/components/App/App.css":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"root":"App__root--3neFT"};

/***/ }),

/***/ "./src/components/App/App.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__("./node_modules/react/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__("./node_modules/react-redux/es/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_redux__ = __webpack_require__("./node_modules/redux/es/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_router_dom__ = __webpack_require__("./node_modules/react-router-dom/es/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_helmet__ = __webpack_require__("./node_modules/react-helmet/lib/Helmet.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_helmet___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react_helmet__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_shortid__ = __webpack_require__("./node_modules/shortid/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_shortid___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_shortid__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_selectn__ = __webpack_require__("./node_modules/selectn/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_selectn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_selectn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__Library_Navigation__ = __webpack_require__("./src/components/Library/Navigation/Navigation.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__Library_AuthDrawer_AuthDrawer__ = __webpack_require__("./src/components/Library/AuthDrawer/AuthDrawer.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__dashboard_components_NotFound__ = __webpack_require__("./src/dashboard/components/NotFound/NotFound.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__Library_ScrollToTop__ = __webpack_require__("./src/components/Library/ScrollToTop/ScrollToTop.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_components_Library_CookieWarning__ = __webpack_require__("./src/components/Library/CookieWarning/CookieWarning.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__utils_UniversalRouter__ = __webpack_require__("./src/utils/UniversalRouter.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_routes__ = __webpack_require__("./src/routes.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__utils_auth__ = __webpack_require__("./src/utils/auth.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__utils_analytics__ = __webpack_require__("./src/utils/analytics.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__utils_localdb__ = __webpack_require__("./src/utils/localdb.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__App_css__ = __webpack_require__("./src/components/App/App.css");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__App_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_17__App_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18_assets_img_social_default_png__ = __webpack_require__("./src/assets/img/social-default.png");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18_assets_img_social_default_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_18_assets_img_social_default_png__);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
























var App = function (_Component) {
  _inherits(App, _Component);

  function App(props) {
    _classCallCheck(this, App);

    var _this = _possibleConstructorReturn(this, (App.__proto__ || Object.getPrototypeOf(App)).call(this, props));

    _this.setAnonymousUser = function () {
      var anonUser = Object(__WEBPACK_IMPORTED_MODULE_16__utils_localdb__["a" /* getLocalItem */])("anonUser");
      if (!anonUser) {
        anonUser = __WEBPACK_IMPORTED_MODULE_5_shortid___default.a.generate();
        Object(__WEBPACK_IMPORTED_MODULE_16__utils_localdb__["c" /* setLocalItem */])("anonUser", anonUser);
      }
      __WEBPACK_IMPORTED_MODULE_15__utils_analytics__["a" /* default */].setUser(anonUser);
    };

    _this.state = {
      isError: false
    };
    return _this;
  }

  _createClass(App, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this.props.checkAuthStatus();
      __WEBPACK_IMPORTED_MODULE_15__utils_analytics__["a" /* default */].initialize();
    }
  }, {
    key: "componentWillReceiveProps",
    value: function componentWillReceiveProps(nextProps) {
      // If we are trying to log in but didn't succeed or if user logs out, create anon user ga token
      if ((this.props.loggedIn === undefined || this.props.loggedIn) && nextProps.loggedIn === false) {
        this.setAnonymousUser();
      }

      if (!this.props.user && nextProps.user) {
        __WEBPACK_IMPORTED_MODULE_15__utils_analytics__["a" /* default */].setUser(nextProps.user.id);
      }

      if (!this.props.storiesStream.isError && nextProps.storiesStream.isError) {
        var payload = nextProps.storiesStream.error;
        if (payload && payload.handleError && __WEBPACK_IMPORTED_MODULE_6_selectn___default()("error.response.status", payload) === 404 && !nextProps.storiesStream.results.length) {
          this.setState({ isError: true });
        }
      } else if (this.state.isError && this.props.storiesStream.isError && !nextProps.storiesStream.isError) {
        this.setState({ isError: false });
      }
    }
  }, {
    key: "render",
    value: function render() {
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "div",
        null,
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_4_react_helmet__["Helmet"],
          null,
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            "title",
            null,
            "Axios"
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("meta", { property: "og:type", content: "website" }),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("meta", { property: "og:url", content: "https://www.axios.com/" }),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("meta", { property: "og:site_name", content: "Axios" }),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("meta", { property: "og:image", content: __WEBPACK_IMPORTED_MODULE_18_assets_img_social_default_png___default.a }),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("meta", { name: "description", content: "Smart, efficient news worthy of your time, attention, and trust" }),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("meta", { property: "og:description", content: "Smart, efficient news worthy of your time, attention, and trust" }),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("meta", { property: "fb:app_id", content: "650172611997232" }),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("meta", { name: "twitter:card", content: "summary_large_image" }),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("meta", { name: "twitter:site", content: "@axios" })
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_12__utils_UniversalRouter__["a" /* default */],
          { context: this.props.context, path: this.props.path },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_10__Library_ScrollToTop__["a" /* default */],
            null,
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              "div",
              null,
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_components_Library_CookieWarning__["a" /* default */], null),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__Library_Navigation__["a" /* default */], null),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__Library_AuthDrawer_AuthDrawer__["a" /* default */], null),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                "div",
                { className: __WEBPACK_IMPORTED_MODULE_17__App_css___default.a.root },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  __WEBPACK_IMPORTED_MODULE_3_react_router_dom__["d" /* Switch */],
                  null,
                  this.state.isError && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_router_dom__["b" /* Route */], { render: function render(_ref) {
                      var staticContext = _ref.staticContext;

                      if (staticContext) staticContext.status = 404;
                      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__dashboard_components_NotFound__["a" /* default */], null);
                    } }),
                  __WEBPACK_IMPORTED_MODULE_13_routes__["a" /* routes */].map(function (route) {
                    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_router_dom__["b" /* Route */], _extends({}, route, { key: route.path }));
                  })
                )
              )
            )
          )
        )
      );
    }
  }]);

  return App;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

var mapStateToProps = function mapStateToProps(state) {
  return {
    user: state.user.data,
    loggedIn: state.authDrawer.loggedIn,
    storiesStream: state.storiesStream
  };
};

var mapDispatchToProps = function mapDispatchToProps(dispatch) {
  return {
    checkAuthStatus: Object(__WEBPACK_IMPORTED_MODULE_2_redux__["b" /* bindActionCreators */])(__WEBPACK_IMPORTED_MODULE_14__utils_auth__["b" /* checkAuthStatus */], dispatch)
  };
};

/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1_react_redux__["b" /* connect */])(mapStateToProps, mapDispatchToProps)(App));

/***/ }),

/***/ "./src/components/Library/Ad/Ad.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = Ad;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__("./node_modules/react/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__("./node_modules/prop-types/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_gpt__ = __webpack_require__("./node_modules/react-gpt/lib/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_gpt___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react_gpt__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_components_Library_ErrorBoundary__ = __webpack_require__("./src/components/Library/ErrorBoundary/ErrorBoundary.js");
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }







function Ad(_ref) {
  var adUnit = _ref.adUnit,
      props = _objectWithoutProperties(_ref, ["adUnit"]);

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_3_components_Library_ErrorBoundary__["a" /* default */],
    null,
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_gpt__["Bling"], _extends({
      adUnitPath: "/227892952/axios/" + adUnit
    }, props))
  );
}

Ad.propTypes = {
  adUnit: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string.isRequired
};

/***/ }),

/***/ "./src/components/Library/AuthDrawer/AuthDrawer.css":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"marginTop10":"AuthDrawer__marginTop10--1IZVB","marginTop20":"AuthDrawer__marginTop20--1MsWn","marginTop40":"AuthDrawer__marginTop40--1Ts9G","marginLeft20":"AuthDrawer__marginLeft20--2jw9i","textCenter":"AuthDrawer__textCenter--p9GqA","bold":"AuthDrawer__bold--3DrAx","blackLink":"AuthDrawer__blackLink--jl3QE","underline":"AuthDrawer__underline--3dEGO","blueButton1":"AuthDrawer__blueButton1--30_5G","bottomBlock":"AuthDrawer__bottomBlock--2c6OP","block":"AuthDrawer__block--1jP0o","centered":"AuthDrawer__centered--3STI2","mobileBlock":"AuthDrawer__mobileBlock--XgK3z","disabled":"AuthDrawer__disabled--1m1jt","blueButton2":"AuthDrawer__blueButton2--2y_UN","grayButton1":"AuthDrawer__grayButton1--15P15","root":"AuthDrawer__root--2WW6N","container":"AuthDrawer__container--ViD5c","muted":"AuthDrawer__muted--1p8UY","linkedInButton":"AuthDrawer__linkedInButton--2tIs_","icon":"AuthDrawer__icon--MqxZG","facebookButton":"AuthDrawer__facebookButton--2S8zb","registerWithEmailButton":"AuthDrawer__registerWithEmailButton--oS0FR","nextButton":"AuthDrawer__nextButton--3B3te","orWord":"AuthDrawer__orWord--2B-2q","checkmark":"AuthDrawer__checkmark--3xMCS","authFrame":"AuthDrawer__authFrame---0Li5","skipButton":"AuthDrawer__skipButton--2rCn6"};

/***/ }),

/***/ "./src/components/Library/AuthDrawer/AuthDrawer.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__("./node_modules/react/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_drawer__ = __webpack_require__("./node_modules/react-drawer/lib/react-drawer.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_drawer___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react_drawer__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_redux__ = __webpack_require__("./node_modules/react-redux/es/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_redux__ = __webpack_require__("./node_modules/redux/es/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__actions_authDrawer__ = __webpack_require__("./src/actions/authDrawer.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__SignIn__ = __webpack_require__("./src/components/Library/AuthDrawer/SignIn.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__RegisterOne__ = __webpack_require__("./src/components/Library/AuthDrawer/RegisterOne.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__RegisterTwo__ = __webpack_require__("./src/components/Library/AuthDrawer/RegisterTwo.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__RegisterThree__ = __webpack_require__("./src/components/Library/AuthDrawer/RegisterThree.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__ForgotPasswordOne__ = __webpack_require__("./src/components/Library/AuthDrawer/ForgotPasswordOne.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__ForgotPasswordTwo__ = __webpack_require__("./src/components/Library/AuthDrawer/ForgotPasswordTwo.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__ForgotPasswordThree__ = __webpack_require__("./src/components/Library/AuthDrawer/ForgotPasswordThree.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__ForgotPasswordFour__ = __webpack_require__("./src/components/Library/AuthDrawer/ForgotPasswordFour.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__config_constants__ = __webpack_require__("./src/config/constants.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__constants_authDrawer__ = __webpack_require__("./src/constants/authDrawer.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__utils_toggleScroll__ = __webpack_require__("./src/utils/toggleScroll.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__AuthDrawer_css__ = __webpack_require__("./src/components/Library/AuthDrawer/AuthDrawer.css");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__AuthDrawer_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_16__AuthDrawer_css__);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }




















var AuthDrawer = function (_Component) {
  _inherits(AuthDrawer, _Component);

  function AuthDrawer() {
    _classCallCheck(this, AuthDrawer);

    var _this = _possibleConstructorReturn(this, (AuthDrawer.__proto__ || Object.getPrototypeOf(AuthDrawer)).call(this));

    _this.onDrawerClose = _this.onDrawerClose.bind(_this);
    _this.state = {
      position: "right",
      mobileDrawer: false
    };
    return _this;
  }

  _createClass(AuthDrawer, [{
    key: "onDrawerClose",
    value: function onDrawerClose() {
      this.props.authDrawerActions.toggleAuthDrawer(false);
    }
  }, {
    key: "componentDidMount",
    value: function componentDidMount() {
      var _this2 = this;

      // Ensure that the drawer opens on the left if screen size is mobile
      if (window.matchMedia(__WEBPACK_IMPORTED_MODULE_13__config_constants__["d" /* BREAKPOINT_DOWN_MEDIUM */]).matches) {
        this.setState({
          position: "left",
          mobileDrawer: true
        });
      }

      window.addEventListener("message", function (event) {
        if (event.data && event.data.authToken && event.source.name === __WEBPACK_IMPORTED_MODULE_14__constants_authDrawer__["g" /* FRAME_NAME */]) {
          _this2.props.authDrawerActions.setAuthToken(event.data.authToken).then(function () {
            // Close the auth drawer when authentication is complete
            _this2.props.authDrawerActions.toggleAuthDrawer(false);
          });
        }
      });
    }
  }, {
    key: "render",
    value: function render() {
      if (this.props.authDrawer.authDrawerOpen) {
        Object(__WEBPACK_IMPORTED_MODULE_15__utils_toggleScroll__["b" /* freezeScroll */])();
      } else {
        Object(__WEBPACK_IMPORTED_MODULE_15__utils_toggleScroll__["c" /* thawScroll */])();
      }

      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "div",
        { className: __WEBPACK_IMPORTED_MODULE_16__AuthDrawer_css___default.a.root },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_1_react_drawer___default.a,
          {
            open: this.props.authDrawer.authDrawerOpen,
            onClose: this.onDrawerClose,
            position: this.state.position,
            className: this.state.mobileDrawer ? __WEBPACK_IMPORTED_MODULE_16__AuthDrawer_css___default.a.mobileDrawer : null },
          this.props.authDrawer.step === __WEBPACK_IMPORTED_MODULE_14__constants_authDrawer__["m" /* SIGNIN */] ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__SignIn__["a" /* default */], null) : null,
          this.props.authDrawer.step === __WEBPACK_IMPORTED_MODULE_14__constants_authDrawer__["j" /* REGISTER1 */] ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__RegisterOne__["a" /* default */], null) : null,
          this.props.authDrawer.step === __WEBPACK_IMPORTED_MODULE_14__constants_authDrawer__["k" /* REGISTER2 */] ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__RegisterTwo__["a" /* default */], null) : null,
          this.props.authDrawer.step === __WEBPACK_IMPORTED_MODULE_14__constants_authDrawer__["l" /* REGISTER3 */] ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__RegisterThree__["a" /* default */], null) : null,
          this.props.authDrawer.step === __WEBPACK_IMPORTED_MODULE_14__constants_authDrawer__["c" /* FORGOTPASSWORD1 */] ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__ForgotPasswordOne__["a" /* default */], null) : null,
          this.props.authDrawer.step === __WEBPACK_IMPORTED_MODULE_14__constants_authDrawer__["d" /* FORGOTPASSWORD2 */] ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__ForgotPasswordTwo__["a" /* default */], null) : null,
          this.props.authDrawer.step === __WEBPACK_IMPORTED_MODULE_14__constants_authDrawer__["e" /* FORGOTPASSWORD3 */] ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__ForgotPasswordThree__["a" /* default */], null) : null,
          this.props.authDrawer.step === __WEBPACK_IMPORTED_MODULE_14__constants_authDrawer__["f" /* FORGOTPASSWORD4 */] ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12__ForgotPasswordFour__["a" /* default */], null) : null
        )
      );
    }
  }]);

  return AuthDrawer;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

var mapStateToProps = function mapStateToProps(state) {
  return {
    authDrawer: state.authDrawer
  };
};

var mapDispatchToProps = function mapDispatchToProps(dispatch) {
  return {
    authDrawerActions: Object(__WEBPACK_IMPORTED_MODULE_3_redux__["b" /* bindActionCreators */])(__WEBPACK_IMPORTED_MODULE_4__actions_authDrawer__, dispatch)
  };
};

/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_2_react_redux__["b" /* connect */])(mapStateToProps, mapDispatchToProps)(AuthDrawer));

/***/ }),

/***/ "./src/components/Library/AuthDrawer/ForgotPasswordFour.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__("./node_modules/react/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames__ = __webpack_require__("./node_modules/classnames/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Icon_Icon__ = __webpack_require__("./src/components/Library/Icon/Icon.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_redux__ = __webpack_require__("./node_modules/react-redux/es/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_redux__ = __webpack_require__("./node_modules/redux/es/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__actions_authDrawer__ = __webpack_require__("./src/actions/authDrawer.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__constants_authDrawer__ = __webpack_require__("./src/constants/authDrawer.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__AuthDrawer_css__ = __webpack_require__("./src/components/Library/AuthDrawer/AuthDrawer.css");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__AuthDrawer_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__AuthDrawer_css__);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }











var ForgotPasswordFour = function (_Component) {
  _inherits(ForgotPasswordFour, _Component);

  function ForgotPasswordFour() {
    _classCallCheck(this, ForgotPasswordFour);

    return _possibleConstructorReturn(this, (ForgotPasswordFour.__proto__ || Object.getPrototypeOf(ForgotPasswordFour)).apply(this, arguments));
  }

  _createClass(ForgotPasswordFour, [{
    key: "changeStep",
    value: function changeStep(step) {
      this.props.authDrawerActions.changeStep(step);
    }
  }, {
    key: "render",
    value: function render() {
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "div",
        { className: __WEBPACK_IMPORTED_MODULE_7__AuthDrawer_css___default.a.container },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "div",
          { className: __WEBPACK_IMPORTED_MODULE_7__AuthDrawer_css___default.a.textCenter },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__Icon_Icon__["a" /* default */], { className: __WEBPACK_IMPORTED_MODULE_7__AuthDrawer_css___default.a.checkmark, name: "check/rounded" })
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "div",
          { className: __WEBPACK_IMPORTED_MODULE_7__AuthDrawer_css___default.a.marginTop20 },
          "We have updated your password. You can now log in."
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "div",
          { className: __WEBPACK_IMPORTED_MODULE_1_classnames___default()(__WEBPACK_IMPORTED_MODULE_7__AuthDrawer_css___default.a.nextButton, __WEBPACK_IMPORTED_MODULE_7__AuthDrawer_css___default.a.marginTop20) },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            "button",
            { onClick: this.changeStep.bind(this, __WEBPACK_IMPORTED_MODULE_6__constants_authDrawer__["m" /* SIGNIN */]), className: __WEBPACK_IMPORTED_MODULE_1_classnames___default()(__WEBPACK_IMPORTED_MODULE_7__AuthDrawer_css___default.a.blueButton1, __WEBPACK_IMPORTED_MODULE_7__AuthDrawer_css___default.a.block, __WEBPACK_IMPORTED_MODULE_7__AuthDrawer_css___default.a.centered) },
            "Sign In"
          )
        )
      );
    }
  }]);

  return ForgotPasswordFour;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

var mapStateToProps = function mapStateToProps(state) {
  return {
    authDrawer: state.authDrawer
  };
};

var mapDispatchToProps = function mapDispatchToProps(dispatch) {
  return {
    authDrawerActions: Object(__WEBPACK_IMPORTED_MODULE_4_redux__["b" /* bindActionCreators */])(__WEBPACK_IMPORTED_MODULE_5__actions_authDrawer__, dispatch)
  };
};

/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_3_react_redux__["b" /* connect */])(mapStateToProps, mapDispatchToProps)(ForgotPasswordFour));

/***/ }),

/***/ "./src/components/Library/AuthDrawer/ForgotPasswordOne.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__("./node_modules/react/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames__ = __webpack_require__("./node_modules/classnames/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_redux__ = __webpack_require__("./node_modules/react-redux/es/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_redux__ = __webpack_require__("./node_modules/redux/es/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__actions_authDrawer__ = __webpack_require__("./src/actions/authDrawer.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__constants_authDrawer__ = __webpack_require__("./src/constants/authDrawer.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__AuthDrawer_css__ = __webpack_require__("./src/components/Library/AuthDrawer/AuthDrawer.css");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__AuthDrawer_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__AuthDrawer_css__);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }










var ForgotPasswordOne = function (_Component) {
  _inherits(ForgotPasswordOne, _Component);

  function ForgotPasswordOne() {
    _classCallCheck(this, ForgotPasswordOne);

    var _this = _possibleConstructorReturn(this, (ForgotPasswordOne.__proto__ || Object.getPrototypeOf(ForgotPasswordOne)).call(this));

    _this.handleChange = _this.handleChange.bind(_this);
    _this.handleSubmit = _this.handleSubmit.bind(_this);

    _this.state = {
      email: ""
    };
    return _this;
  }

  _createClass(ForgotPasswordOne, [{
    key: "handleChange",
    value: function handleChange(event) {
      this.setState({
        email: event.target.value
      });
    }
  }, {
    key: "handleSubmit",
    value: function handleSubmit(event) {
      var _this2 = this;

      event.preventDefault();

      this.props.authDrawerActions.requestPasswordReset(this.state.email).then(function () {
        _this2.setState({
          email: ""
        });

        _this2.changeStep(__WEBPACK_IMPORTED_MODULE_5__constants_authDrawer__["d" /* FORGOTPASSWORD2 */]);
      });
    }
  }, {
    key: "changeStep",
    value: function changeStep(step, event) {
      if (event) {
        event.preventDefault();
      }

      this.props.authDrawerActions.changeStep(step);
    }
  }, {
    key: "render",
    value: function render() {
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "div",
        { className: __WEBPACK_IMPORTED_MODULE_6__AuthDrawer_css___default.a.container },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "h3",
          null,
          "Reset password"
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "div",
          { className: __WEBPACK_IMPORTED_MODULE_6__AuthDrawer_css___default.a.marginTop20 },
          "Let us know your email address so we can send you a link to reset your password."
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "form",
          { onSubmit: this.handleSubmit },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            "div",
            { className: __WEBPACK_IMPORTED_MODULE_6__AuthDrawer_css___default.a.marginTop40 },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("input", { onChange: this.handleChange, name: "email", type: "text", placeholder: "Email", value: this.state.email })
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            "div",
            { className: __WEBPACK_IMPORTED_MODULE_6__AuthDrawer_css___default.a.nextButton },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              "button",
              { type: "submit", className: __WEBPACK_IMPORTED_MODULE_1_classnames___default()(__WEBPACK_IMPORTED_MODULE_6__AuthDrawer_css___default.a.blueButton1, __WEBPACK_IMPORTED_MODULE_6__AuthDrawer_css___default.a.block, __WEBPACK_IMPORTED_MODULE_6__AuthDrawer_css___default.a.centered) },
              "Reset Password"
            )
          )
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "div",
          { className: __WEBPACK_IMPORTED_MODULE_1_classnames___default()(__WEBPACK_IMPORTED_MODULE_6__AuthDrawer_css___default.a.marginTop10, __WEBPACK_IMPORTED_MODULE_6__AuthDrawer_css___default.a.textCenter) },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            "a",
            { onClick: this.changeStep.bind(this, __WEBPACK_IMPORTED_MODULE_5__constants_authDrawer__["m" /* SIGNIN */]), href: "#", className: __WEBPACK_IMPORTED_MODULE_1_classnames___default()(__WEBPACK_IMPORTED_MODULE_6__AuthDrawer_css___default.a.blackLink, __WEBPACK_IMPORTED_MODULE_6__AuthDrawer_css___default.a.bold) },
            "Cancel"
          )
        )
      );
    }
  }]);

  return ForgotPasswordOne;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

var mapStateToProps = function mapStateToProps(state) {
  return {
    authDrawer: state.authDrawer
  };
};

var mapDispatchToProps = function mapDispatchToProps(dispatch) {
  return {
    authDrawerActions: Object(__WEBPACK_IMPORTED_MODULE_3_redux__["b" /* bindActionCreators */])(__WEBPACK_IMPORTED_MODULE_4__actions_authDrawer__, dispatch)
  };
};

/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_2_react_redux__["b" /* connect */])(mapStateToProps, mapDispatchToProps)(ForgotPasswordOne));

/***/ }),

/***/ "./src/components/Library/AuthDrawer/ForgotPasswordThree.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__("./node_modules/react/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames__ = __webpack_require__("./node_modules/classnames/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_redux__ = __webpack_require__("./node_modules/react-redux/es/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_redux__ = __webpack_require__("./node_modules/redux/es/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__actions_authDrawer__ = __webpack_require__("./src/actions/authDrawer.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__constants_authDrawer__ = __webpack_require__("./src/constants/authDrawer.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__AuthDrawer_css__ = __webpack_require__("./src/components/Library/AuthDrawer/AuthDrawer.css");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__AuthDrawer_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__AuthDrawer_css__);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }










var ForgotPasswordThree = function (_Component) {
  _inherits(ForgotPasswordThree, _Component);

  function ForgotPasswordThree() {
    _classCallCheck(this, ForgotPasswordThree);

    var _this = _possibleConstructorReturn(this, (ForgotPasswordThree.__proto__ || Object.getPrototypeOf(ForgotPasswordThree)).call(this));

    _this.handleChange = _this.handleChange.bind(_this);
    _this.handleSubmit = _this.handleSubmit.bind(_this);

    _this.state = {
      password1: "",
      password2: ""
    };
    return _this;
  }

  _createClass(ForgotPasswordThree, [{
    key: "handleChange",
    value: function handleChange(event) {
      this.setState(_defineProperty({}, event.target.name, event.target.value));
    }
  }, {
    key: "handleSubmit",
    value: function handleSubmit(event) {
      var _this2 = this;

      event.preventDefault();

      this.props.authDrawerActions.changePassword(this.props.authDrawer.passwordResetToken, this.props.authDrawer.passwordResetEmail, this.state).then(function () {
        _this2.changeStep(__WEBPACK_IMPORTED_MODULE_5__constants_authDrawer__["f" /* FORGOTPASSWORD4 */]);
      });
    }
  }, {
    key: "changeStep",
    value: function changeStep(step, event) {
      if (event) {
        event.preventDefault();
      }

      this.props.authDrawerActions.changeStep(step);
    }
  }, {
    key: "render",
    value: function render() {
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "div",
        { className: __WEBPACK_IMPORTED_MODULE_6__AuthDrawer_css___default.a.container },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "h3",
          null,
          "Resetting password"
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "form",
          { onSubmit: this.handleSubmit },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            "div",
            { className: __WEBPACK_IMPORTED_MODULE_6__AuthDrawer_css___default.a.marginTop40 },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("input", { onChange: this.handleChange, name: "password1", type: "password", placeholder: "New password", value: this.state.password1 })
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            "div",
            { className: __WEBPACK_IMPORTED_MODULE_6__AuthDrawer_css___default.a.marginTop20 },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("input", { onChange: this.handleChange, name: "password2", type: "password", placeholder: "Type it again", value: this.state.password2 })
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            "div",
            { className: __WEBPACK_IMPORTED_MODULE_6__AuthDrawer_css___default.a.nextButton },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              "button",
              { type: "submit", className: __WEBPACK_IMPORTED_MODULE_1_classnames___default()(__WEBPACK_IMPORTED_MODULE_6__AuthDrawer_css___default.a.blueButton1, __WEBPACK_IMPORTED_MODULE_6__AuthDrawer_css___default.a.block, __WEBPACK_IMPORTED_MODULE_6__AuthDrawer_css___default.a.centered) },
              "Set New Password"
            )
          )
        )
      );
    }
  }]);

  return ForgotPasswordThree;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

var mapStateToProps = function mapStateToProps(state) {
  return {
    authDrawer: state.authDrawer
  };
};

var mapDispatchToProps = function mapDispatchToProps(dispatch) {
  return {
    authDrawerActions: Object(__WEBPACK_IMPORTED_MODULE_3_redux__["b" /* bindActionCreators */])(__WEBPACK_IMPORTED_MODULE_4__actions_authDrawer__, dispatch)
  };
};

/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_2_react_redux__["b" /* connect */])(mapStateToProps, mapDispatchToProps)(ForgotPasswordThree));

/***/ }),

/***/ "./src/components/Library/AuthDrawer/ForgotPasswordTwo.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__("./node_modules/react/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Icon_Icon__ = __webpack_require__("./src/components/Library/Icon/Icon.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__AuthDrawer_css__ = __webpack_require__("./src/components/Library/AuthDrawer/AuthDrawer.css");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__AuthDrawer_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__AuthDrawer_css__);





var ForgotPasswordTwo = function ForgotPasswordTwo() {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    "div",
    { className: __WEBPACK_IMPORTED_MODULE_2__AuthDrawer_css___default.a.container },
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      "div",
      { className: __WEBPACK_IMPORTED_MODULE_2__AuthDrawer_css___default.a.textCenter },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__Icon_Icon__["a" /* default */], { className: __WEBPACK_IMPORTED_MODULE_2__AuthDrawer_css___default.a.checkmark, name: "check/rounded" })
    ),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      "h3",
      { className: __WEBPACK_IMPORTED_MODULE_2__AuthDrawer_css___default.a.marginTop20 },
      "Email sent!"
    ),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      "div",
      { className: __WEBPACK_IMPORTED_MODULE_2__AuthDrawer_css___default.a.marginTop20 },
      "You should receive instructions on resetting your password shortly. If you don't receive an email, please make sure you've entered the address you've registered, and check your spam folder."
    )
  );
};

/* harmony default export */ __webpack_exports__["a"] = (ForgotPasswordTwo);

/***/ }),

/***/ "./src/components/Library/AuthDrawer/RegisterOne.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__("./node_modules/react/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames__ = __webpack_require__("./node_modules/classnames/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Icon_Icon__ = __webpack_require__("./src/components/Library/Icon/Icon.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_redux__ = __webpack_require__("./node_modules/react-redux/es/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_redux__ = __webpack_require__("./node_modules/redux/es/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__actions_authDrawer__ = __webpack_require__("./src/actions/authDrawer.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__constants_authDrawer__ = __webpack_require__("./src/constants/authDrawer.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_utils_auth__ = __webpack_require__("./src/utils/auth.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__AuthDrawer_css__ = __webpack_require__("./src/components/Library/AuthDrawer/AuthDrawer.css");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__AuthDrawer_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__AuthDrawer_css__);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }












var RegisterOne = function (_Component) {
  _inherits(RegisterOne, _Component);

  function RegisterOne(props) {
    _classCallCheck(this, RegisterOne);

    var _this = _possibleConstructorReturn(this, (RegisterOne.__proto__ || Object.getPrototypeOf(RegisterOne)).call(this, props));

    _this.state = {};
    return _this;
  }

  _createClass(RegisterOne, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      __WEBPACK_IMPORTED_MODULE_7_utils_auth__["f" /* setNonce */]();
      this.setState({
        fbAuthUrl: __WEBPACK_IMPORTED_MODULE_7_utils_auth__["c" /* getFacebookUrl */](),
        linkedInAuthUrl: __WEBPACK_IMPORTED_MODULE_7_utils_auth__["d" /* getLinkedInUrl */]()
      });
    }
  }, {
    key: "changeStep",
    value: function changeStep(step, event) {
      if (event) {
        event.preventDefault();
      }

      this.props.authDrawerActions.changeStep(step);
    }
  }, {
    key: "render",
    value: function render() {
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "div",
        { className: __WEBPACK_IMPORTED_MODULE_8__AuthDrawer_css___default.a.container },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "div",
          { className: __WEBPACK_IMPORTED_MODULE_8__AuthDrawer_css___default.a.muted },
          "Join Axios to save stories for later, get personalized news, and more!"
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "div",
          { className: __WEBPACK_IMPORTED_MODULE_8__AuthDrawer_css___default.a.linkedInButton },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            "a",
            { href: this.state.linkedInAuthUrl, className: __WEBPACK_IMPORTED_MODULE_1_classnames___default()(__WEBPACK_IMPORTED_MODULE_8__AuthDrawer_css___default.a.blueButton1, __WEBPACK_IMPORTED_MODULE_8__AuthDrawer_css___default.a.block, __WEBPACK_IMPORTED_MODULE_8__AuthDrawer_css___default.a.centered) },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__Icon_Icon__["a" /* default */], { name: "linkedin-inverse", path: "img", className: __WEBPACK_IMPORTED_MODULE_8__AuthDrawer_css___default.a.icon }),
            "Register with LinkedIn"
          )
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "div",
          { className: __WEBPACK_IMPORTED_MODULE_8__AuthDrawer_css___default.a.facebookButton },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            "a",
            { href: this.state.fbAuthUrl, className: __WEBPACK_IMPORTED_MODULE_1_classnames___default()(__WEBPACK_IMPORTED_MODULE_8__AuthDrawer_css___default.a.blueButton2, __WEBPACK_IMPORTED_MODULE_8__AuthDrawer_css___default.a.block, __WEBPACK_IMPORTED_MODULE_8__AuthDrawer_css___default.a.centered) },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__Icon_Icon__["a" /* default */], { name: "facebook-inverse", path: "img", className: __WEBPACK_IMPORTED_MODULE_8__AuthDrawer_css___default.a.icon }),
            "Register with Facebook"
          )
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "div",
          { className: __WEBPACK_IMPORTED_MODULE_8__AuthDrawer_css___default.a.orWord },
          "OR"
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "div",
          { className: __WEBPACK_IMPORTED_MODULE_1_classnames___default()(__WEBPACK_IMPORTED_MODULE_8__AuthDrawer_css___default.a.marginTop10, __WEBPACK_IMPORTED_MODULE_8__AuthDrawer_css___default.a.registerWithEmailButton) },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            "a",
            { onClick: this.changeStep.bind(this, __WEBPACK_IMPORTED_MODULE_6__constants_authDrawer__["k" /* REGISTER2 */]), href: "#", className: __WEBPACK_IMPORTED_MODULE_1_classnames___default()(__WEBPACK_IMPORTED_MODULE_8__AuthDrawer_css___default.a.grayButton1, __WEBPACK_IMPORTED_MODULE_8__AuthDrawer_css___default.a.block, __WEBPACK_IMPORTED_MODULE_8__AuthDrawer_css___default.a.centered) },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__Icon_Icon__["a" /* default */], { name: "envelope", path: "img", className: __WEBPACK_IMPORTED_MODULE_8__AuthDrawer_css___default.a.icon }),
            "Register with Email"
          )
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "div",
          { className: __WEBPACK_IMPORTED_MODULE_1_classnames___default()(__WEBPACK_IMPORTED_MODULE_8__AuthDrawer_css___default.a.marginTop40, __WEBPACK_IMPORTED_MODULE_8__AuthDrawer_css___default.a.textCenter) },
          "Already an Axios member? ",
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            "a",
            { onClick: this.changeStep.bind(this, __WEBPACK_IMPORTED_MODULE_6__constants_authDrawer__["m" /* SIGNIN */]), href: "#", className: __WEBPACK_IMPORTED_MODULE_1_classnames___default()(__WEBPACK_IMPORTED_MODULE_8__AuthDrawer_css___default.a.blackLink, __WEBPACK_IMPORTED_MODULE_8__AuthDrawer_css___default.a.bold) },
            "Sign in now."
          )
        )
      );
    }
  }]);

  return RegisterOne;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

var mapStateToProps = function mapStateToProps(state) {
  return {
    authDrawer: state.authDrawer
  };
};

var mapDispatchToProps = function mapDispatchToProps(dispatch) {
  return {
    authDrawerActions: Object(__WEBPACK_IMPORTED_MODULE_4_redux__["b" /* bindActionCreators */])(__WEBPACK_IMPORTED_MODULE_5__actions_authDrawer__, dispatch)
  };
};

/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_3_react_redux__["b" /* connect */])(mapStateToProps, mapDispatchToProps)(RegisterOne));

/***/ }),

/***/ "./src/components/Library/AuthDrawer/RegisterThree.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__("./node_modules/react/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames__ = __webpack_require__("./node_modules/classnames/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_redux__ = __webpack_require__("./node_modules/react-redux/es/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_redux__ = __webpack_require__("./node_modules/redux/es/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__actions_authDrawer__ = __webpack_require__("./src/actions/authDrawer.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__constants_authDrawer__ = __webpack_require__("./src/constants/authDrawer.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__AuthDrawer_css__ = __webpack_require__("./src/components/Library/AuthDrawer/AuthDrawer.css");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__AuthDrawer_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__AuthDrawer_css__);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }










var RegisterThree = function (_Component) {
  _inherits(RegisterThree, _Component);

  function RegisterThree() {
    _classCallCheck(this, RegisterThree);

    var _this = _possibleConstructorReturn(this, (RegisterThree.__proto__ || Object.getPrototypeOf(RegisterThree)).call(this));

    _this.handleChange = _this.handleChange.bind(_this);
    _this.handleSubmit = _this.handleSubmit.bind(_this);
    _this.handleSkip = _this.handleSkip.bind(_this);

    _this.state = {
      industry: "",
      industries: __WEBPACK_IMPORTED_MODULE_5__constants_authDrawer__["h" /* INDUSTRIES */],
      job_title: ""
    };
    return _this;
  }

  _createClass(RegisterThree, [{
    key: "handleChange",
    value: function handleChange(event) {
      this.setState(_defineProperty({}, event.target.name, event.target.value));
    }
  }, {
    key: "handleSubmit",
    value: function handleSubmit(event) {
      var _this2 = this;

      event.preventDefault();

      this.props.authDrawerActions.setOptionalInfo({
        industry: this.state.industry,
        job_title: this.state.job_title
      }).then(function () {
        _this2.props.authDrawerActions.registerEmail(_this2.props.authDrawer.userData).then(function () {
          _this2.props.authDrawerActions.toggleAuthDrawer(false);
        });
      });
    }
  }, {
    key: "handleSkip",
    value: function handleSkip() {
      var _this3 = this;

      return this.props.authDrawerActions.registerEmail(this.props.authDrawer.userData).then(function () {
        _this3.props.authDrawerActions.toggleAuthDrawer(false);
      });
    }
  }, {
    key: "render",
    value: function render() {
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "div",
        { className: __WEBPACK_IMPORTED_MODULE_6__AuthDrawer_css___default.a.container },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "h3",
          null,
          "Thanks for signing up!"
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "div",
          { className: __WEBPACK_IMPORTED_MODULE_6__AuthDrawer_css___default.a.marginTop20 },
          "In order to help us deliver news that will be most relevant to you, please tell us a little about yourself."
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "form",
          { onSubmit: this.handleSubmit },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            "div",
            { className: __WEBPACK_IMPORTED_MODULE_6__AuthDrawer_css___default.a.marginTop40 },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              "select",
              { onChange: this.handleChange, name: "industry" },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                "option",
                null,
                "What industry do you work in?"
              ),
              this.state.industries.map(function (industry, index) {
                return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  "option",
                  { key: index, value: industry },
                  industry
                );
              })
            )
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            "div",
            { className: __WEBPACK_IMPORTED_MODULE_6__AuthDrawer_css___default.a.marginTop20 },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("input", { onChange: this.handleChange, name: "job_title", type: "text", placeholder: "In what role?" })
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            "div",
            { className: __WEBPACK_IMPORTED_MODULE_6__AuthDrawer_css___default.a.nextButton },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              "button",
              { type: "submit", className: __WEBPACK_IMPORTED_MODULE_1_classnames___default()(__WEBPACK_IMPORTED_MODULE_6__AuthDrawer_css___default.a.blueButton1, __WEBPACK_IMPORTED_MODULE_6__AuthDrawer_css___default.a.block, __WEBPACK_IMPORTED_MODULE_6__AuthDrawer_css___default.a.centered) },
              "Finish"
            )
          )
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "div",
          { className: __WEBPACK_IMPORTED_MODULE_1_classnames___default()(__WEBPACK_IMPORTED_MODULE_6__AuthDrawer_css___default.a.marginTop20, __WEBPACK_IMPORTED_MODULE_6__AuthDrawer_css___default.a.textCenter) },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            "button",
            { onClick: this.handleSkip, className: __WEBPACK_IMPORTED_MODULE_1_classnames___default()(__WEBPACK_IMPORTED_MODULE_6__AuthDrawer_css___default.a.blackLink, __WEBPACK_IMPORTED_MODULE_6__AuthDrawer_css___default.a.bold, __WEBPACK_IMPORTED_MODULE_6__AuthDrawer_css___default.a.skipButton) },
            "Skip for now"
          )
        )
      );
    }
  }]);

  return RegisterThree;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

var mapStateToProps = function mapStateToProps(state) {
  return {
    authDrawer: state.authDrawer
  };
};

var mapDispatchToProps = function mapDispatchToProps(dispatch) {
  return {
    authDrawerActions: Object(__WEBPACK_IMPORTED_MODULE_3_redux__["b" /* bindActionCreators */])(__WEBPACK_IMPORTED_MODULE_4__actions_authDrawer__, dispatch)
  };
};

/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_2_react_redux__["b" /* connect */])(mapStateToProps, mapDispatchToProps)(RegisterThree));

/***/ }),

/***/ "./src/components/Library/AuthDrawer/RegisterTwo.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__("./node_modules/react/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames__ = __webpack_require__("./node_modules/classnames/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Icon_Icon__ = __webpack_require__("./src/components/Library/Icon/Icon.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_redux__ = __webpack_require__("./node_modules/react-redux/es/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_redux__ = __webpack_require__("./node_modules/redux/es/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__actions_authDrawer__ = __webpack_require__("./src/actions/authDrawer.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__constants_authDrawer__ = __webpack_require__("./src/constants/authDrawer.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__AuthDrawer_css__ = __webpack_require__("./src/components/Library/AuthDrawer/AuthDrawer.css");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__AuthDrawer_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__AuthDrawer_css__);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }











var initialState = {
  first_name: "",
  last_name: "",
  email: "",
  password1: "",
  password2: ""
};

var RegisterTwo = function (_Component) {
  _inherits(RegisterTwo, _Component);

  function RegisterTwo() {
    _classCallCheck(this, RegisterTwo);

    var _this = _possibleConstructorReturn(this, (RegisterTwo.__proto__ || Object.getPrototypeOf(RegisterTwo)).call(this));

    _this.handleChange = _this.handleChange.bind(_this);
    _this.handleSubmit = _this.handleSubmit.bind(_this);

    _this.state = initialState;
    return _this;
  }

  _createClass(RegisterTwo, [{
    key: "handleChange",
    value: function handleChange(event) {
      this.setState(_defineProperty({}, event.target.name, event.target.value));
    }
  }, {
    key: "handleSubmit",
    value: function handleSubmit(event) {
      var _this2 = this;

      event.preventDefault();

      this.props.authDrawerActions.setBasicInfo(this.state).then(function () {
        if (!_this2.props.authDrawer.emailAvailable) {
          return alert("Email is not available");
        }

        _this2.setState(initialState);
        _this2.changeStep(__WEBPACK_IMPORTED_MODULE_6__constants_authDrawer__["l" /* REGISTER3 */]);
      });
    }
  }, {
    key: "changeStep",
    value: function changeStep(step, event) {
      if (event) {
        event.preventDefault();
      }

      this.props.authDrawerActions.changeStep(step);
    }
  }, {
    key: "render",
    value: function render() {
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "div",
        { className: __WEBPACK_IMPORTED_MODULE_7__AuthDrawer_css___default.a.container },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "h3",
          null,
          "Register with email"
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "form",
          { onSubmit: this.handleSubmit },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            "div",
            { className: __WEBPACK_IMPORTED_MODULE_7__AuthDrawer_css___default.a.marginTop40 },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("input", { onChange: this.handleChange, name: "first_name", type: "text", placeholder: "First name", value: this.state.first_name })
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            "div",
            { className: __WEBPACK_IMPORTED_MODULE_7__AuthDrawer_css___default.a.marginTop20 },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("input", { onChange: this.handleChange, name: "last_name", type: "text", placeholder: "Last name", value: this.state.last_name })
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            "div",
            { className: __WEBPACK_IMPORTED_MODULE_7__AuthDrawer_css___default.a.marginTop20 },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("input", { onChange: this.handleChange, name: "email", type: "email", placeholder: "Email", value: this.state.email })
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            "div",
            { className: __WEBPACK_IMPORTED_MODULE_7__AuthDrawer_css___default.a.marginTop20 },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("input", { onChange: this.handleChange, name: "password1", type: "password", placeholder: "Create a password", value: this.state.password1 })
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            "div",
            { className: __WEBPACK_IMPORTED_MODULE_7__AuthDrawer_css___default.a.marginTop20 },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("input", { onChange: this.handleChange, name: "password2", type: "password", placeholder: "Confirm your password", value: this.state.password2 })
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            "div",
            { className: __WEBPACK_IMPORTED_MODULE_7__AuthDrawer_css___default.a.nextButton },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              "button",
              { type: "submit", className: __WEBPACK_IMPORTED_MODULE_1_classnames___default()(__WEBPACK_IMPORTED_MODULE_7__AuthDrawer_css___default.a.blueButton1, __WEBPACK_IMPORTED_MODULE_7__AuthDrawer_css___default.a.block, __WEBPACK_IMPORTED_MODULE_7__AuthDrawer_css___default.a.centered) },
              "Next",
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__Icon_Icon__["a" /* default */], { name: "chevron/right", className: __WEBPACK_IMPORTED_MODULE_7__AuthDrawer_css___default.a.icon })
            )
          )
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "div",
          { className: __WEBPACK_IMPORTED_MODULE_1_classnames___default()(__WEBPACK_IMPORTED_MODULE_7__AuthDrawer_css___default.a.marginTop40, __WEBPACK_IMPORTED_MODULE_7__AuthDrawer_css___default.a.textCenter) },
          "Already an Axios member? ",
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            "a",
            { onClick: this.changeStep.bind(this, __WEBPACK_IMPORTED_MODULE_6__constants_authDrawer__["m" /* SIGNIN */]), href: "#", className: __WEBPACK_IMPORTED_MODULE_1_classnames___default()(__WEBPACK_IMPORTED_MODULE_7__AuthDrawer_css___default.a.blackLink, __WEBPACK_IMPORTED_MODULE_7__AuthDrawer_css___default.a.bold) },
            "Sign in now."
          )
        )
      );
    }
  }]);

  return RegisterTwo;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

var mapStateToProps = function mapStateToProps(state) {
  return {
    authDrawer: state.authDrawer
  };
};

var mapDispatchToProps = function mapDispatchToProps(dispatch) {
  return {
    authDrawerActions: Object(__WEBPACK_IMPORTED_MODULE_4_redux__["b" /* bindActionCreators */])(__WEBPACK_IMPORTED_MODULE_5__actions_authDrawer__, dispatch)
  };
};

/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_3_react_redux__["b" /* connect */])(mapStateToProps, mapDispatchToProps)(RegisterTwo));

/***/ }),

/***/ "./src/components/Library/AuthDrawer/SignIn.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__("./node_modules/react/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames__ = __webpack_require__("./node_modules/classnames/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Icon_Icon__ = __webpack_require__("./src/components/Library/Icon/Icon.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_redux__ = __webpack_require__("./node_modules/react-redux/es/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_redux__ = __webpack_require__("./node_modules/redux/es/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__actions_authDrawer__ = __webpack_require__("./src/actions/authDrawer.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__constants_authDrawer__ = __webpack_require__("./src/constants/authDrawer.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_utils_auth__ = __webpack_require__("./src/utils/auth.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__AuthDrawer_css__ = __webpack_require__("./src/components/Library/AuthDrawer/AuthDrawer.css");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__AuthDrawer_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__AuthDrawer_css__);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }












var SignIn = function (_Component) {
  _inherits(SignIn, _Component);

  function SignIn() {
    _classCallCheck(this, SignIn);

    var _this = _possibleConstructorReturn(this, (SignIn.__proto__ || Object.getPrototypeOf(SignIn)).call(this));

    _this.authString = __WEBPACK_IMPORTED_MODULE_6__constants_authDrawer__["a" /* AUTH_URL */];
    _this.state = {};
    return _this;
  }

  _createClass(SignIn, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      __WEBPACK_IMPORTED_MODULE_7_utils_auth__["f" /* setNonce */]();
      this.setState({
        fbAuthUrl: __WEBPACK_IMPORTED_MODULE_7_utils_auth__["c" /* getFacebookUrl */](),
        linkedInAuthUrl: __WEBPACK_IMPORTED_MODULE_7_utils_auth__["d" /* getLinkedInUrl */]()
      });
    }
  }, {
    key: "changeStep",
    value: function changeStep(step, event) {
      if (event) {
        event.preventDefault();
      }

      this.props.authDrawerActions.changeStep(step);
    }
  }, {
    key: "render",
    value: function render() {
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "div",
        { className: __WEBPACK_IMPORTED_MODULE_8__AuthDrawer_css___default.a.container },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "div",
          { className: __WEBPACK_IMPORTED_MODULE_8__AuthDrawer_css___default.a.muted },
          "Sign in to Axios to save stories for later, get personalized news, and more!"
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "div",
          { className: __WEBPACK_IMPORTED_MODULE_8__AuthDrawer_css___default.a.linkedInButton },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            "a",
            { href: this.state.linkedInAuthUrl, className: __WEBPACK_IMPORTED_MODULE_1_classnames___default()(__WEBPACK_IMPORTED_MODULE_8__AuthDrawer_css___default.a.blueButton1, __WEBPACK_IMPORTED_MODULE_8__AuthDrawer_css___default.a.block, __WEBPACK_IMPORTED_MODULE_8__AuthDrawer_css___default.a.centered) },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__Icon_Icon__["a" /* default */], { name: "linkedin-inverse", path: "img", className: __WEBPACK_IMPORTED_MODULE_8__AuthDrawer_css___default.a.icon }),
            "Sign in with LinkedIn"
          )
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "div",
          { className: __WEBPACK_IMPORTED_MODULE_8__AuthDrawer_css___default.a.facebookButton },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            "a",
            { href: this.state.fbAuthUrl, className: __WEBPACK_IMPORTED_MODULE_1_classnames___default()(__WEBPACK_IMPORTED_MODULE_8__AuthDrawer_css___default.a.blueButton2, __WEBPACK_IMPORTED_MODULE_8__AuthDrawer_css___default.a.block, __WEBPACK_IMPORTED_MODULE_8__AuthDrawer_css___default.a.centered) },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__Icon_Icon__["a" /* default */], { name: "facebook-inverse", path: "img", className: __WEBPACK_IMPORTED_MODULE_8__AuthDrawer_css___default.a.icon }),
            "Sign in with Facebook"
          )
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "div",
          { className: __WEBPACK_IMPORTED_MODULE_8__AuthDrawer_css___default.a.orWord },
          "OR"
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "div",
          null,
          this.props.authDrawer.authDrawerOpen && this.props.authDrawer.step === __WEBPACK_IMPORTED_MODULE_6__constants_authDrawer__["m" /* SIGNIN */] ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("iframe", { name: "authframe", className: __WEBPACK_IMPORTED_MODULE_8__AuthDrawer_css___default.a.authFrame, src: this.authString }) : null
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "div",
          { className: __WEBPACK_IMPORTED_MODULE_1_classnames___default()(__WEBPACK_IMPORTED_MODULE_8__AuthDrawer_css___default.a.marginTop10, __WEBPACK_IMPORTED_MODULE_8__AuthDrawer_css___default.a.textCenter) },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            "a",
            { onClick: this.changeStep.bind(this, __WEBPACK_IMPORTED_MODULE_6__constants_authDrawer__["c" /* FORGOTPASSWORD1 */]), href: "#", className: __WEBPACK_IMPORTED_MODULE_1_classnames___default()(__WEBPACK_IMPORTED_MODULE_8__AuthDrawer_css___default.a.bold, __WEBPACK_IMPORTED_MODULE_8__AuthDrawer_css___default.a.blackLink) },
            "Forgot your password?"
          )
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "div",
          { className: __WEBPACK_IMPORTED_MODULE_1_classnames___default()(__WEBPACK_IMPORTED_MODULE_8__AuthDrawer_css___default.a.marginTop40, __WEBPACK_IMPORTED_MODULE_8__AuthDrawer_css___default.a.textCenter) },
          "Don't have an account? ",
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            "a",
            { onClick: this.changeStep.bind(this, __WEBPACK_IMPORTED_MODULE_6__constants_authDrawer__["j" /* REGISTER1 */]), href: "#", className: __WEBPACK_IMPORTED_MODULE_1_classnames___default()(__WEBPACK_IMPORTED_MODULE_8__AuthDrawer_css___default.a.blackLink, __WEBPACK_IMPORTED_MODULE_8__AuthDrawer_css___default.a.bold) },
            "Register now."
          )
        )
      );
    }
  }]);

  return SignIn;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

var mapStateToProps = function mapStateToProps(state) {
  return {
    authDrawer: state.authDrawer
  };
};

var mapDispatchToProps = function mapDispatchToProps(dispatch) {
  return {
    authDrawerActions: Object(__WEBPACK_IMPORTED_MODULE_4_redux__["b" /* bindActionCreators */])(__WEBPACK_IMPORTED_MODULE_5__actions_authDrawer__, dispatch)
  };
};

/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_3_react_redux__["b" /* connect */])(mapStateToProps, mapDispatchToProps)(SignIn));

/***/ }),

/***/ "./src/components/Library/Authorize/Authorize.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__("./node_modules/react/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_router_dom__ = __webpack_require__("./node_modules/react-router-dom/es/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_redux__ = __webpack_require__("./node_modules/react-redux/es/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_redux__ = __webpack_require__("./node_modules/redux/es/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_query_string__ = __webpack_require__("./node_modules/query-string/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_query_string___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_query_string__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__config_constants__ = __webpack_require__("./src/config/constants.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__actions_authDrawer__ = __webpack_require__("./src/actions/authDrawer.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__utils_localdb__ = __webpack_require__("./src/utils/localdb.js");
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }










var Authorize = function (_Component) {
  _inherits(Authorize, _Component);

  function Authorize() {
    _classCallCheck(this, Authorize);

    return _possibleConstructorReturn(this, (Authorize.__proto__ || Object.getPrototypeOf(Authorize)).apply(this, arguments));
  }

  _createClass(Authorize, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var parsedQs = __WEBPACK_IMPORTED_MODULE_4_query_string___default.a.parse(this.props.location.search);
      var parsedHash = __WEBPACK_IMPORTED_MODULE_4_query_string___default.a.parse(this.props.location.hash);

      // If there is an access token present (this happens when Eden iframes in a page) persist it
      if (parsedQs.access_token) {
        Object(__WEBPACK_IMPORTED_MODULE_7__utils_localdb__["c" /* setLocalItem */])("adminToken", parsedQs.access_token);
      }

      // If there is an access token present in the hash (this happens during FB and LI oAuth) set login session
      if (parsedHash.access_token && parsedHash.state && Object(__WEBPACK_IMPORTED_MODULE_7__utils_localdb__["a" /* getLocalItem */])("socialNonce") && parsedHash.state === Object(__WEBPACK_IMPORTED_MODULE_7__utils_localdb__["a" /* getLocalItem */])("socialNonce").toString()) {
        this.props.authDrawerActions.setAuthToken(parsedHash.access_token);

        Object(__WEBPACK_IMPORTED_MODULE_7__utils_localdb__["b" /* removeLocalItem */])("socialNonce");
      }

      if (window.frameElement && !parsedQs.access_token) {
        window.parent.postMessage({
          authToken: __WEBPACK_IMPORTED_MODULE_4_query_string___default.a.parse(window.location.hash).access_token
        }, __WEBPACK_IMPORTED_MODULE_5__config_constants__["j" /* FRONTEND_ROOT */]);
      }

      // If there is a next direction, go to it
      if (parsedQs.next) {
        window.location.href = parsedQs.next;
      }
    }
  }, {
    key: "render",
    value: function render() {
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "h2",
        null,
        "Loading..."
      );
    }
  }]);

  return Authorize;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

var mapStateToProps = function mapStateToProps(state) {
  return {
    authDrawer: state.authDrawer
  };
};

var mapDispatchToProps = function mapDispatchToProps(dispatch) {
  return {
    authDrawerActions: Object(__WEBPACK_IMPORTED_MODULE_3_redux__["b" /* bindActionCreators */])(__WEBPACK_IMPORTED_MODULE_6__actions_authDrawer__, dispatch)
  };
};

/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["e" /* withRouter */])(Object(__WEBPACK_IMPORTED_MODULE_2_react_redux__["b" /* connect */])(mapStateToProps, mapDispatchToProps)(Authorize)));

/***/ }),

/***/ "./src/components/Library/Caption/Caption.css":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"caption":"Caption__caption--1HFyq","bounce":"Caption__bounce--1g8o5"};

/***/ }),

/***/ "./src/components/Library/Caption/Caption.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = Caption;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__("./node_modules/react/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Caption_css__ = __webpack_require__("./src/components/Library/Caption/Caption.css");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Caption_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__Caption_css__);




function Caption(props) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    "figcaption",
    { className: __WEBPACK_IMPORTED_MODULE_1__Caption_css___default.a.caption },
    props.children
  );
}

/***/ }),

/***/ "./src/components/Library/CookieWarning/CookieWarning.css":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"root":"CookieWarning__root--2SXrE","isActive":"CookieWarning__isActive--2Hhi2","adSlot":"CookieWarning__adSlot--3OccD","message":"CookieWarning__message--2lj7T","okay":"CookieWarning__okay--2zSRV","closeButton":"CookieWarning__closeButton--3s5Ux","closeIcon":"CookieWarning__closeIcon--1fjep","bounce":"CookieWarning__bounce--T5OUq"};

/***/ }),

/***/ "./src/components/Library/CookieWarning/CookieWarning.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__("./node_modules/react/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames__ = __webpack_require__("./node_modules/classnames/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_utils_localdb__ = __webpack_require__("./src/utils/localdb.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_components_Library_Icon__ = __webpack_require__("./src/components/Library/Icon/Icon.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_components_Library_Ad__ = __webpack_require__("./src/components/Library/Ad/Ad.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__CookieWarning_css__ = __webpack_require__("./src/components/Library/CookieWarning/CookieWarning.css");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__CookieWarning_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__CookieWarning_css__);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }










var CookieWarning = function (_React$Component) {
  _inherits(CookieWarning, _React$Component);

  function CookieWarning(props) {
    _classCallCheck(this, CookieWarning);

    var _this = _possibleConstructorReturn(this, (CookieWarning.__proto__ || Object.getPrototypeOf(CookieWarning)).call(this, props));

    _this.elementId = "ad-cookie-warning";
    _this.onClose = _this._onClose.bind(_this);
    _this.onSlotRenderEnded = _this._onSlotRenderEnded.bind(_this);
    _this.state = {
      isVisible: false,
      seenCookieWarning: false
    };
    return _this;
  }

  _createClass(CookieWarning, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this.setState({ seenCookieWarning: Object(__WEBPACK_IMPORTED_MODULE_2_utils_localdb__["a" /* getLocalItem */])("seenCookieWarning") });
    }
  }, {
    key: "_onSlotRenderEnded",
    value: function _onSlotRenderEnded(_ref) {
      var isEmpty = _ref.isEmpty;

      if (!isEmpty) {
        this.setState({
          isVisible: true
        });
      }
    }
  }, {
    key: "_onClose",
    value: function _onClose() {
      Object(__WEBPACK_IMPORTED_MODULE_2_utils_localdb__["c" /* setLocalItem */])("seenCookieWarning", true, { expires: 30 });
      this.setState({
        isVisible: false
      });
    }
  }, {
    key: "render",
    value: function render() {
      if (this.state.seenCookieWarning) return null;

      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "div",
        { className: __WEBPACK_IMPORTED_MODULE_1_classnames___default()(__WEBPACK_IMPORTED_MODULE_5__CookieWarning_css___default.a.root, _defineProperty({}, __WEBPACK_IMPORTED_MODULE_5__CookieWarning_css___default.a.isActive, this.state.isVisible)) },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "div",
          { className: __WEBPACK_IMPORTED_MODULE_5__CookieWarning_css___default.a.adSlot },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_components_Library_Ad__["a" /* default */], {
            adUnit: "cookie",
            outOfPage: true,
            id: this.elementId,
            onSlotRenderEnded: this.onSlotRenderEnded,
            renderWhenViewable: false
          })
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "div",
          { className: __WEBPACK_IMPORTED_MODULE_5__CookieWarning_css___default.a.message },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            "span",
            null,
            "This site uses cookies to enhance your reading experience. By using this site, you consent to our use of cookies."
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            "span",
            { className: __WEBPACK_IMPORTED_MODULE_5__CookieWarning_css___default.a.okay, onClick: this.onClose },
            "Okay"
          )
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "button",
          { onClick: this.onClose, className: __WEBPACK_IMPORTED_MODULE_5__CookieWarning_css___default.a.closeButton },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_components_Library_Icon__["a" /* default */], { name: "close", className: __WEBPACK_IMPORTED_MODULE_5__CookieWarning_css___default.a.closeIcon })
        )
      );
    }
  }]);

  return CookieWarning;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

/* harmony default export */ __webpack_exports__["a"] = (CookieWarning);

/***/ }),

/***/ "./src/components/Library/Embed/Embed.css":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"root":"Embed__root--xU4tk","embedContainer":"Embed__embedContainer--2z7Wi","responsiveIframe":"Embed__responsiveIframe--2HKkM","fullBleed":"Embed__fullBleed--3XP5F","hide":"Embed__hide--ke6PL","bounce":"Embed__bounce--1Vb4r"};

/***/ }),

/***/ "./src/components/Library/Embed/Embed.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__("./node_modules/react/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__("./node_modules/prop-types/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_classnames__ = __webpack_require__("./node_modules/classnames/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Image__ = __webpack_require__("./src/components/Library/Image/Image.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Embed_css__ = __webpack_require__("./src/components/Library/Embed/Embed.css");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Embed_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__Embed_css__);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }








var Embed = function (_Component) {
  _inherits(Embed, _Component);

  function Embed() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, Embed);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = Embed.__proto__ || Object.getPrototypeOf(Embed)).call.apply(_ref, [this].concat(args))), _this), _this.calculateAspectRatio = function () {
      var _this$props$block$dat = _this.props.block.data,
          oembed = _this$props$block$dat.oembed,
          type = _this$props$block$dat.type;

      var aspectRatio = void 0;
      if (oembed.height && oembed.width) {
        // if there's a width and height, then create a placeholder
        aspectRatio = oembed.height / oembed.width;
      }
      if (type === "jwplayer-video") {
        // JW player's metadata includes some, but not all of the controls' height
        // Hardcoding the height, 44px, ensures controls are always visible
        aspectRatio = (oembed.height + 44) / oembed.width;
      }
      return aspectRatio;
    }, _this.renderEmbed = function (isFullbleed, embedAspectRatio) {
      // see handleEmbed in utils/embed.js for additional rendering
      var _this$props$block$dat2 = _this.props.block.data,
          oembed = _this$props$block$dat2.oembed,
          type = _this$props$block$dat2.type;

      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "figure",
        null,
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", _extends({
          className: __WEBPACK_IMPORTED_MODULE_2_classnames___default()(__WEBPACK_IMPORTED_MODULE_4__Embed_css___default.a.embedContainer, _defineProperty({}, __WEBPACK_IMPORTED_MODULE_4__Embed_css___default.a.responsiveIframe, embedAspectRatio), _defineProperty({}, __WEBPACK_IMPORTED_MODULE_4__Embed_css___default.a.fullBleed, isFullbleed), "block-" + _this.props.block.key),
          style: embedAspectRatio && { paddingBottom: embedAspectRatio * 100 + "%" }
        }, _this.props.isClient && { dangerouslySetInnerHTML: { __html: oembed.html } })),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "figcaption",
          { className: __WEBPACK_IMPORTED_MODULE_2_classnames___default()(_defineProperty({}, __WEBPACK_IMPORTED_MODULE_4__Embed_css___default.a.hide, type !== "axios-visual")) },
          _this.props.children
        )
      );
    }, _this.renderPhoto = function () {
      var oembed = _this.props.block.data.oembed;

      var blockData = {
        data: {
          image_id: _this.props.block.key,
          src: oembed.url,
          alt_text: oembed.title
        }
      };
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "figure",
        null,
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_3__Image__["a" /* default */],
          { block: blockData },
          _this.props.children
        )
      );
    }, _this.renderJWVideo = function (isFullbleed, embedAspectRatio) {
      // div#botr is required for rendering JW videos
      // BOTR is a proprietary JW API for loading videos, "Bits on the Run" (︶︿︶ )
      // see handleEmbed in utils/embed.js for additional rendering
      var _this$props$block$dat3 = _this.props.block.data,
          oembed = _this$props$block$dat3.oembed,
          _this$props$block$dat4 = _this$props$block$dat3.config,
          config = _this$props$block$dat4 === undefined ? {} : _this$props$block$dat4;

      var playerId = config.autoplay ? oembed.autoplay_player_id : oembed.default_player_id;
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "figure",
        null,
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "div",
          {
            className: __WEBPACK_IMPORTED_MODULE_2_classnames___default()(__WEBPACK_IMPORTED_MODULE_4__Embed_css___default.a.embedContainer, _defineProperty({}, __WEBPACK_IMPORTED_MODULE_4__Embed_css___default.a.responsiveIframe, embedAspectRatio), _defineProperty({}, __WEBPACK_IMPORTED_MODULE_4__Embed_css___default.a.fullBleed, isFullbleed), "block-" + _this.props.block.key),
            style: embedAspectRatio && { paddingBottom: embedAspectRatio * 100 + "%" } },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            "div",
            { id: "jw-" + oembed.media_id },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", { id: "botr_" + oembed.media_id + "_" + playerId + "_div" })
          )
        ),
        _this.props.children
      );
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(Embed, [{
    key: "render",
    value: function render() {
      var _props$block$data = this.props.block.data,
          oembed = _props$block$data.oembed,
          type = _props$block$data.type;

      if (!oembed) return null;
      var isFullbleed = oembed.is_fullbleed;
      var embedAspectRatio = this.calculateAspectRatio(oembed, type);
      if (type === "jwplayer-video" || type === "youtube") {
        // Youtube and JW Player videos should stretch edge-to-edge
        // The following boolean adds a CSS classname to do that
        isFullbleed = true;
      }

      var renderMethod = void 0;
      switch (type) {
        case "giphy":
          renderMethod = this.renderPhoto;
          break;
        case "jwplayer-video":
          renderMethod = this.renderJWVideo;
          break;
        default:
          renderMethod = this.renderEmbed;
          break;
      }

      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "div",
        { className: __WEBPACK_IMPORTED_MODULE_4__Embed_css___default.a.root },
        renderMethod(isFullbleed, embedAspectRatio)
      );
    }
  }]);

  return Embed;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

Embed.propTypes = {
  block: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object.isRequired,
  isClient: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool
};

/* harmony default export */ __webpack_exports__["a"] = (Embed);

/***/ }),

/***/ "./src/components/Library/ErrorBoundary/ErrorBoundary.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__("./node_modules/react/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__("./node_modules/prop-types/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_utils_log__ = __webpack_require__("./src/utils/log.js");
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }






var ErrorBoundary = function (_React$Component) {
  _inherits(ErrorBoundary, _React$Component);

  function ErrorBoundary(props) {
    _classCallCheck(this, ErrorBoundary);

    var _this = _possibleConstructorReturn(this, (ErrorBoundary.__proto__ || Object.getPrototypeOf(ErrorBoundary)).call(this, props));

    _this.state = { error: null, info: null };
    return _this;
  }

  _createClass(ErrorBoundary, [{
    key: "componentDidCatch",
    value: function componentDidCatch(error, info) {
      this.setState({ error: error, info: info });
      __WEBPACK_IMPORTED_MODULE_2_utils_log__["a" /* default */].logger(error, "error", info, false);
    }
  }, {
    key: "render",
    value: function render() {
      if (this.state.error) {
        // Render the error visibly in dev and staging. In prod, just don't render the content at all
        if (true) return null;
        return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "div",
          null,
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            "pre",
            null,
            this.state.error.message
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            "pre",
            null,
            this.state.info.componentStack
          )
        );
      }
      return this.props.children;
    }
  }]);

  return ErrorBoundary;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

/* harmony default export */ __webpack_exports__["a"] = (ErrorBoundary);


ErrorBoundary.propTypes = {
  children: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.node
};

/***/ }),

/***/ "./src/components/Library/EventCard/EventCard.css":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"root":"EventCard__root--18zgq","image":"EventCard__image--j2jTB","description":"EventCard__description--3QUqT","separator":"EventCard__separator--1HY6G","bounce":"EventCard__bounce--1qPxC"};

/***/ }),

/***/ "./src/components/Library/EventCard/EventCard.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__("./node_modules/react/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_selectn__ = __webpack_require__("./node_modules/selectn/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_selectn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_selectn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Headline__ = __webpack_require__("./src/components/Library/Headline/Headline.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__EventCard_css__ = __webpack_require__("./src/components/Library/EventCard/EventCard.css");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__EventCard_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__EventCard_css__);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }







var EventCard = function (_Component) {
  _inherits(EventCard, _Component);

  function EventCard() {
    _classCallCheck(this, EventCard);

    return _possibleConstructorReturn(this, (EventCard.__proto__ || Object.getPrototypeOf(EventCard)).apply(this, arguments));
  }

  _createClass(EventCard, [{
    key: "render",
    value: function render() {
      var _props = this.props,
          story = _props.story,
          isLastStory = _props.isLastStory;

      if (!story) return null;
      var image = __WEBPACK_IMPORTED_MODULE_1_selectn___default()("primary_image.crops.1x1.url", story);

      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "div",
        null,
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "div",
          { key: story.id, className: __WEBPACK_IMPORTED_MODULE_3__EventCard_css___default.a.root },
          image && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("img", { className: __WEBPACK_IMPORTED_MODULE_3__EventCard_css___default.a.image, src: image, alt: story.primary_image.alt_text }),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            "div",
            null,
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__Headline__["a" /* default */], {
              headline: story.headline,
              permalink: story.permalink }),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              "div",
              { className: __WEBPACK_IMPORTED_MODULE_3__EventCard_css___default.a.description },
              story.og_description
            )
          )
        ),
        !isLastStory && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("hr", { className: __WEBPACK_IMPORTED_MODULE_3__EventCard_css___default.a.separator, "aria-hidden": true })
      );
    }
  }]);

  return EventCard;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

/* harmony default export */ __webpack_exports__["a"] = (EventCard);

/***/ }),

/***/ "./src/components/Library/Header/Header.css":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"header":"Header__header--3d1x-","content":"Header__content--1uOn_","mainText":"Header__mainText--2Kv10","active":"Header__active--2oWU5","subText":"Header__subText--2esen","subscribe":"Header__subscribe--19kIn","bounce":"Header__bounce--3CfVj"};

/***/ }),

/***/ "./src/components/Library/Header/Header.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__("./node_modules/react/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__("./node_modules/prop-types/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_classnames__ = __webpack_require__("./node_modules/classnames/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_router_dom__ = __webpack_require__("./node_modules/react-router-dom/es/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_Library_Subscribe__ = __webpack_require__("./src/components/Library/Subscribe/Subscribe.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__Header_css__ = __webpack_require__("./src/components/Library/Header/Header.css");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__Header_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__Header_css__);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }









var Header = function (_Component) {
  _inherits(Header, _Component);

  function Header() {
    _classCallCheck(this, Header);

    return _possibleConstructorReturn(this, (Header.__proto__ || Object.getPrototypeOf(Header)).apply(this, arguments));
  }

  _createClass(Header, [{
    key: "render",
    value: function render() {
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "div",
        { className: __WEBPACK_IMPORTED_MODULE_2_classnames___default()(__WEBPACK_IMPORTED_MODULE_5__Header_css___default.a.header, this.props.className) },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "div",
          { className: __WEBPACK_IMPORTED_MODULE_5__Header_css___default.a.content },
          this.props.subText && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            "div",
            { className: __WEBPACK_IMPORTED_MODULE_5__Header_css___default.a.subText },
            this.props.subText
          ),
          this.props.subscription ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_3_react_router_dom__["a" /* Link */],
            { to: "/newsletters/" + this.props.subscription.slug, className: __WEBPACK_IMPORTED_MODULE_5__Header_css___default.a.mainText },
            this.props.text
          ) : __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            "div",
            { className: __WEBPACK_IMPORTED_MODULE_5__Header_css___default.a.mainText },
            this.props.text
          ),
          this.props.subscription && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__components_Library_Subscribe__["a" /* default */], { className: __WEBPACK_IMPORTED_MODULE_5__Header_css___default.a.subscribe, subscription: this.props.subscription })
        )
      );
    }
  }]);

  return Header;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

Header.propTypes = {
  subText: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  className: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  text: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  subscription: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({
    slug: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string.isRequired
  })
};

/* harmony default export */ __webpack_exports__["a"] = (Header);

/***/ }),

/***/ "./src/components/Library/Headline/Headline.css":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"headline":"Headline__headline--2AbDE","bounce":"Headline__bounce--1Tvo7"};

/***/ }),

/***/ "./src/components/Library/Headline/Headline.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = Headline;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__("./node_modules/react/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__("./node_modules/prop-types/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_router_dom__ = __webpack_require__("./node_modules/react-router-dom/es/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__config_constants__ = __webpack_require__("./src/config/constants.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Headline_css__ = __webpack_require__("./src/components/Library/Headline/Headline.css");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Headline_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__Headline_css__);







function Headline(_ref) {
  var headline = _ref.headline,
      permalink = _ref.permalink,
      noLink = _ref.noLink;

  if (headline && permalink && !noLink) {
    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      __WEBPACK_IMPORTED_MODULE_2_react_router_dom__["a" /* Link */],
      { to: permalink.replace(__WEBPACK_IMPORTED_MODULE_3__config_constants__["j" /* FRONTEND_ROOT */], ""), className: __WEBPACK_IMPORTED_MODULE_4__Headline_css___default.a.headline },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "h3",
        null,
        headline
      )
    );
  } else if (headline) {
    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      "h3",
      { className: __WEBPACK_IMPORTED_MODULE_4__Headline_css___default.a.headline },
      headline
    );
  } else {
    return null;
  }
}

Headline.propTypes = {
  headline: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string.isRequired,
  permalink: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  noLink: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool
};

/***/ }),

/***/ "./src/components/Library/Icon/Icon.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = Icon;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__("./node_modules/react/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__("./node_modules/prop-types/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };




function Icon(props) {
  var icon = __webpack_require__("./src/assets recursive ^\\.\\/.*\\.svg$")("./" + (props.hasOwnProperty("path") ? props.path : "icons") + "/" + props.name + ".svg").default;

  // Keep the DOM clean by not putting name or description in it.
  var filteredProps = Object.keys(props).filter(function (key) {
    return !["name", "description", "tooltip", "setTooltipText", "path"].includes(key);
  }).reduce(function (obj, key) {
    obj[key] = props[key];
    return obj;
  }, {});

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    "svg",
    _extends({ viewBox: icon.viewBox }, filteredProps),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      "title",
      null,
      props.hasOwnProperty("description") ? props.description : props.name + " icon"
    ),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("use", { xlinkHref: "#" + icon.id })
  );
}

Icon.propTypes = {
  name: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string.isRequired,
  description: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string
};

/***/ }),

/***/ "./src/components/Library/Image/Image.css":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"root":"Image__root--2yUDP","container":"Image__container--1I_M-","image":"Image__image--1g11_","bounce":"Image__bounce--1k2NJ"};

/***/ }),

/***/ "./src/components/Library/Image/Image.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__("./node_modules/react/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__("./node_modules/prop-types/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Caption__ = __webpack_require__("./src/components/Library/Caption/Caption.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Image_css__ = __webpack_require__("./src/components/Library/Image/Image.css");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Image_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__Image_css__);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }






var Image = function (_Component) {
  _inherits(Image, _Component);

  function Image() {
    _classCallCheck(this, Image);

    return _possibleConstructorReturn(this, (Image.__proto__ || Object.getPrototypeOf(Image)).apply(this, arguments));
  }

  _createClass(Image, [{
    key: "render",
    value: function render() {
      var data = this.props.block.data;

      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "div",
        { className: __WEBPACK_IMPORTED_MODULE_3__Image_css___default.a.root },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "div",
          { className: __WEBPACK_IMPORTED_MODULE_3__Image_css___default.a.container },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("img", { id: data.image_id, src: data.src, alt: data.alt_text, className: __WEBPACK_IMPORTED_MODULE_3__Image_css___default.a.image }),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_2__Caption__["a" /* default */],
            null,
            this.props.children
          )
        )
      );
    }
  }]);

  return Image;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

Image.propTypes = {
  block: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object.isRequired
};

/* harmony default export */ __webpack_exports__["a"] = (Image);

/***/ }),

/***/ "./src/components/Library/InternalLoadLink/InternalLoadLink.css":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"root":"InternalLoadLink__root--17C4m","bounce":"InternalLoadLink__bounce--2fSQD"};

/***/ }),

/***/ "./src/components/Library/InternalLoadLink/InternalLoadLink.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__("./node_modules/react/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames__ = __webpack_require__("./node_modules/classnames/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__InternalLoadLink_css__ = __webpack_require__("./src/components/Library/InternalLoadLink/InternalLoadLink.css");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__InternalLoadLink_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__InternalLoadLink_css__);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }






var InternalLoadLink = function (_Component) {
  _inherits(InternalLoadLink, _Component);

  function InternalLoadLink() {
    _classCallCheck(this, InternalLoadLink);

    return _possibleConstructorReturn(this, (InternalLoadLink.__proto__ || Object.getPrototypeOf(InternalLoadLink)).apply(this, arguments));
  }

  _createClass(InternalLoadLink, [{
    key: "render",
    value: function render() {
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "a",
        { role: "button",
          name: this.props.name,
          href: this.props.href,
          className: __WEBPACK_IMPORTED_MODULE_1_classnames___default()(__WEBPACK_IMPORTED_MODULE_2__InternalLoadLink_css___default.a.root, this.props.className, this.props.identifier) },
        this.props.children
      );
    }
  }]);

  return InternalLoadLink;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

/* harmony default export */ __webpack_exports__["a"] = (InternalLoadLink);

/***/ }),

/***/ "./src/components/Library/KeepReading/KeepReading.css":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"root":"KeepReading__root--3o5fu","icon":"KeepReading__icon--1knnO","wordCount":"KeepReading__wordCount--1PMdk","hide":"KeepReading__hide--2qQxD","showLess":"KeepReading__showLess--2y-8w KeepReading__hide--2qQxD","keepReading":"KeepReading__keepReading--3wXA5","keepReadingOpen":"KeepReading__keepReadingOpen--24exR","keepReadingFixed":"KeepReading__keepReadingFixed--3RBun","bounce":"KeepReading__bounce--12I7r"};

/***/ }),

/***/ "./src/components/Library/KeepReading/KeepReading.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = KeepReading;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__("./node_modules/react/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__("./node_modules/prop-types/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Icon__ = __webpack_require__("./src/components/Library/Icon/Icon.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__KeepReading_css__ = __webpack_require__("./src/components/Library/KeepReading/KeepReading.css");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__KeepReading_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__KeepReading_css__);






function KeepReading(props) {
  var block = props.block,
      extras = props.extras;
  var data = block.data;

  var _ref = extras || {},
      wordCount = _ref.wordCount;

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    "button",
    { id: "keep-reading-" + block.key, className: __WEBPACK_IMPORTED_MODULE_3__KeepReading_css___default.a.root, "aria-expanded": false },
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__Icon__["a" /* default */], { name: "chevron/down", description: "Read more toggle", className: __WEBPACK_IMPORTED_MODULE_3__KeepReading_css___default.a.icon }),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      "div",
      { className: __WEBPACK_IMPORTED_MODULE_3__KeepReading_css___default.a.showLess },
      "Show less"
    ),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      "div",
      { className: __WEBPACK_IMPORTED_MODULE_3__KeepReading_css___default.a.keepReading },
      data.buttonText,
      data.showWordCount && wordCount && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "span",
        { className: __WEBPACK_IMPORTED_MODULE_3__KeepReading_css___default.a.wordCount },
        wordCount,
        " Words"
      )
    ),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      "div",
      { className: __WEBPACK_IMPORTED_MODULE_3__KeepReading_css___default.a.hide },
      props.children
    )
  );
}

KeepReading.propTypes = {
  block: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object.isRequired,
  extras: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object
};

/***/ }),

/***/ "./src/components/Library/LatestStories/LatestStories.css":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"root":"LatestStories__root--KB2wG","heading":"LatestStories__heading--i1xKm","hiddenLarge":"LatestStories__hiddenLarge--Qy-p3","hiddenSmall":"LatestStories__hiddenSmall--3PbmY","promo":"LatestStories__promo--1HQbZ","bounce":"LatestStories__bounce--3rQ7Y"};

/***/ }),

/***/ "./src/components/Library/LatestStories/LatestStories.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__("./node_modules/react/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__("./node_modules/react-redux/es/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_classnames__ = __webpack_require__("./node_modules/classnames/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__actions_latestStories__ = __webpack_require__("./src/actions/latestStories.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__MiniStoryCard__ = __webpack_require__("./src/components/Library/MiniStoryCard/MiniStoryCard.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__Spinner__ = __webpack_require__("./src/components/Library/Spinner/Spinner.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_components_Library_Ad__ = __webpack_require__("./src/components/Library/Ad/Ad.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__LatestStories_css__ = __webpack_require__("./src/components/Library/LatestStories/LatestStories.css");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__LatestStories_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__LatestStories_css__);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }











var LatestStories = function (_Component) {
  _inherits(LatestStories, _Component);

  function LatestStories() {
    _classCallCheck(this, LatestStories);

    return _possibleConstructorReturn(this, (LatestStories.__proto__ || Object.getPrototypeOf(LatestStories)).apply(this, arguments));
  }

  _createClass(LatestStories, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      if (!this.props.latestStories.results.length) {
        this.props.getLatestStories();
      }
    }
  }, {
    key: "renderPromo",
    value: function renderPromo() {
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "div",
        { className: __WEBPACK_IMPORTED_MODULE_7__LatestStories_css___default.a.promo },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_components_Library_Ad__["a" /* default */], { adUnit: "sidebar", slotSize: [300, 275] })
      );
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      if (this.props.latestStories.results.length === 0) {
        if (this.props.latestStories.isLoading) {
          return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__Spinner__["a" /* default */], null);
        }
        return null;
      }

      var latestSorted = [].concat(_toConsumableArray(this.props.latestStories.results)).sort(function (a, b) {
        return a.published_date > b.published_date ? -1 : a.published_date < b.published_date ? 1 : 0;
      });

      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "div",
        { className: this.props.className },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "h2",
          { className: __WEBPACK_IMPORTED_MODULE_2_classnames___default()(__WEBPACK_IMPORTED_MODULE_7__LatestStories_css___default.a.heading, __WEBPACK_IMPORTED_MODULE_7__LatestStories_css___default.a.hiddenLarge) },
          "Latest Stories"
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "div",
          { className: __WEBPACK_IMPORTED_MODULE_7__LatestStories_css___default.a.root },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            "h2",
            { className: __WEBPACK_IMPORTED_MODULE_2_classnames___default()(__WEBPACK_IMPORTED_MODULE_7__LatestStories_css___default.a.heading, __WEBPACK_IMPORTED_MODULE_7__LatestStories_css___default.a.hiddenSmall) },
            "Latest Stories"
          ),
          latestSorted.map(function (latest, i) {
            return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              "div",
              { key: latest.id },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__MiniStoryCard__["a" /* default */], { latest: latest }),
              i === 4 && _this2.renderPromo()
            );
          })
        )
      );
    }
  }]);

  return LatestStories;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

var mapStateToProps = function mapStateToProps(state) {
  return {
    latestStories: state.latestStories
  };
};

/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1_react_redux__["b" /* connect */])(mapStateToProps, { getLatestStories: __WEBPACK_IMPORTED_MODULE_3__actions_latestStories__["a" /* getLatestStories */] })(LatestStories));

/***/ }),

/***/ "./src/components/Library/Layout/Content.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = Content;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__("./node_modules/react/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames__ = __webpack_require__("./node_modules/classnames/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Layout_css__ = __webpack_require__("./src/components/Library/Layout/Layout.css");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Layout_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__Layout_css__);





function Content(_ref) {
  var children = _ref.children,
      className = _ref.className,
      ariaLabel = _ref.ariaLabel;

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    "main",
    { id: "main", role: "main", "aria-label": ariaLabel, tabIndex: "-1", className: __WEBPACK_IMPORTED_MODULE_1_classnames___default()(__WEBPACK_IMPORTED_MODULE_2__Layout_css___default.a.main, className) },
    children
  );
}

/***/ }),

/***/ "./src/components/Library/Layout/Layout.css":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"root":"Layout__root--hXdm-","sidebar":"Layout__sidebar--KClvl","main":"Layout__main--2G1WR"};

/***/ }),

/***/ "./src/components/Library/Layout/Layout.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = Layout;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__("./node_modules/react/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames__ = __webpack_require__("./node_modules/classnames/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Layout_css__ = __webpack_require__("./src/components/Library/Layout/Layout.css");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Layout_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__Layout_css__);





function Layout(_ref) {
  var includeHeader = _ref.includeHeader,
      headerComponent = _ref.headerComponent,
      children = _ref.children,
      className = _ref.className;

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    "div",
    null,
    includeHeader && headerComponent || null,
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      "div",
      { className: __WEBPACK_IMPORTED_MODULE_1_classnames___default()(__WEBPACK_IMPORTED_MODULE_2__Layout_css___default.a.root, className) },
      children
    )
  );
}

/***/ }),

/***/ "./src/components/Library/Layout/Sidebar.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = Sidebar;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__("./node_modules/react/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames__ = __webpack_require__("./node_modules/classnames/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Layout_css__ = __webpack_require__("./src/components/Library/Layout/Layout.css");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Layout_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__Layout_css__);





function Sidebar(_ref) {
  var children = _ref.children,
      className = _ref.className;

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    "div",
    { role: "complementary", className: __WEBPACK_IMPORTED_MODULE_1_classnames___default()(__WEBPACK_IMPORTED_MODULE_2__Layout_css___default.a.sidebar, className) },
    children
  );
}

/***/ }),

/***/ "./src/components/Library/Logo/Logo.css":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"root":"Logo__root--HMg9n","compressed":"Logo__compressed--1HrUV"};

/***/ }),

/***/ "./src/components/Library/Logo/Logo.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = Logo;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__("./node_modules/react/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames__ = __webpack_require__("./node_modules/classnames/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__assets_img_logo_svg__ = __webpack_require__("./src/assets/img/logo.svg");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Logo_css__ = __webpack_require__("./src/components/Library/Logo/Logo.css");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Logo_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__Logo_css__);





function Logo(props) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    "svg",
    { viewBox: __WEBPACK_IMPORTED_MODULE_2__assets_img_logo_svg__["default"].viewBox, className: __WEBPACK_IMPORTED_MODULE_1_classnames___default()(__WEBPACK_IMPORTED_MODULE_3__Logo_css___default.a.root, props.isCompressed ? __WEBPACK_IMPORTED_MODULE_3__Logo_css___default.a.compressed : {}) },
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      "title",
      null,
      "Axios"
    ),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("use", { xlinkHref: "#" + __WEBPACK_IMPORTED_MODULE_2__assets_img_logo_svg__["default"].id })
  );
}

/***/ }),

/***/ "./src/components/Library/MiniStoryCard/MiniStoryCard.css":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"root":"MiniStoryCard__root--1S8As","headline":"MiniStoryCard__headline--3wPnn","subtext":"MiniStoryCard__subtext--3lzhn","featured":"MiniStoryCard__featured--1hk0W","bounce":"MiniStoryCard__bounce--1aQpx"};

/***/ }),

/***/ "./src/components/Library/MiniStoryCard/MiniStoryCard.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__("./node_modules/react/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_selectn__ = __webpack_require__("./node_modules/selectn/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_selectn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_selectn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_router_dom__ = __webpack_require__("./node_modules/react-router-dom/es/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__utils_formatPublishedDate__ = __webpack_require__("./src/utils/formatPublishedDate.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__config_constants__ = __webpack_require__("./src/config/constants.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__MiniStoryCard_css__ = __webpack_require__("./src/components/Library/MiniStoryCard/MiniStoryCard.css");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__MiniStoryCard_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__MiniStoryCard_css__);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }









var MiniStoryCard = function (_Component) {
  _inherits(MiniStoryCard, _Component);

  function MiniStoryCard() {
    _classCallCheck(this, MiniStoryCard);

    return _possibleConstructorReturn(this, (MiniStoryCard.__proto__ || Object.getPrototypeOf(MiniStoryCard)).apply(this, arguments));
  }

  _createClass(MiniStoryCard, [{
    key: "render",
    value: function render() {
      var latest = this.props.latest;
      if (!latest) return null;
      var section = latest.content_type === "newsletter" ? "Newsletters" : __WEBPACK_IMPORTED_MODULE_1_selectn___default()("primary_section.name", latest);
      var publishedDateFormatted = Object(__WEBPACK_IMPORTED_MODULE_3__utils_formatPublishedDate__["a" /* default */])(latest);
      var divider = (latest.is_featured || publishedDateFormatted) && section && " / ";
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "div",
        { key: latest.id, className: __WEBPACK_IMPORTED_MODULE_5__MiniStoryCard_css___default.a.root },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_2_react_router_dom__["a" /* Link */],
          { className: __WEBPACK_IMPORTED_MODULE_5__MiniStoryCard_css___default.a.headline, to: latest.permalink.replace(__WEBPACK_IMPORTED_MODULE_4__config_constants__["j" /* FRONTEND_ROOT */], "") + "?utm_source=sidebar" },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            "h3",
            { className: __WEBPACK_IMPORTED_MODULE_5__MiniStoryCard_css___default.a.headline },
            latest.headline
          )
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "div",
          { className: __WEBPACK_IMPORTED_MODULE_5__MiniStoryCard_css___default.a.subtext },
          latest.is_featured ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            "span",
            { className: __WEBPACK_IMPORTED_MODULE_5__MiniStoryCard_css___default.a.featured },
            "Featured"
          ) : publishedDateFormatted,
          divider,
          section
        )
      );
    }
  }]);

  return MiniStoryCard;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

/* harmony default export */ __webpack_exports__["a"] = (MiniStoryCard);

/***/ }),

/***/ "./src/components/Library/Navigation/Navigation.css":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"root":"Navigation__root--dndsI","open":"Navigation__open--2eUho","compressed":"Navigation__compressed--1VpjA","fixed":"Navigation__fixed--IcbA_","brand":"Navigation__brand--2pgFM","logoContainer":"Navigation__logoContainer--24mxj","aOnWhite":"Navigation__aOnWhite--VCABZ","tag":"Navigation__tag--1YYic","left":"Navigation__left--29qKF","right":"Navigation__right--3fX9H","toggler":"Navigation__toggler--2Dbbr","togglerOpen":"Navigation__togglerOpen--3zxKR Navigation__toggler--2Dbbr","menu":"Navigation__menu--2ttAU","item":"Navigation__item--3p0iU","toggle":"Navigation__toggle--Srsub","icon":"Navigation__icon--3kuL1","timerIcon":"Navigation__timerIcon--3FxT4","searchIcon":"Navigation__searchIcon--36g0G","menuOpen":"Navigation__menuOpen--1ERCQ","hidden":"Navigation__hidden--HiAu4","sidebar":"Navigation__sidebar--2lGY3","mobileSectionHeader":"Navigation__mobileSectionHeader--3sjqq","mobileList":"Navigation__mobileList--1fEjw","buttonItem":"Navigation__buttonItem--syHh_ Navigation__item--3p0iU","searchWindow":"Navigation__searchWindow--1wgCO","mobileSearchWindow":"Navigation__mobileSearchWindow--Z5Sxt","bottomLineInputs":"Navigation__bottomLineInputs--2fuu_","bounce":"Navigation__bounce--37PIc"};

/***/ }),

/***/ "./src/components/Library/Navigation/Navigation.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__("./node_modules/react/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__("./node_modules/react-redux/es/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_redux__ = __webpack_require__("./node_modules/redux/es/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_router_dom__ = __webpack_require__("./node_modules/react-router-dom/es/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_classnames__ = __webpack_require__("./node_modules/classnames/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_reactstrap_lib_Nav__ = __webpack_require__("./node_modules/reactstrap/lib/Nav.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_reactstrap_lib_Nav___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_reactstrap_lib_Nav__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_reactstrap_lib_Navbar__ = __webpack_require__("./node_modules/reactstrap/lib/Navbar.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_reactstrap_lib_Navbar___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_reactstrap_lib_Navbar__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_reactstrap_lib_NavbarBrand__ = __webpack_require__("./node_modules/reactstrap/lib/NavbarBrand.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_reactstrap_lib_NavbarBrand___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_reactstrap_lib_NavbarBrand__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_reactstrap_lib_NavbarToggler__ = __webpack_require__("./node_modules/reactstrap/lib/NavbarToggler.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_reactstrap_lib_NavbarToggler___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_reactstrap_lib_NavbarToggler__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_reactstrap_lib_Collapse__ = __webpack_require__("./node_modules/reactstrap/lib/Collapse.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_reactstrap_lib_Collapse___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_reactstrap_lib_Collapse__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_lodash_debounce__ = __webpack_require__("./node_modules/lodash/debounce.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_lodash_debounce___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_lodash_debounce__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_selectn__ = __webpack_require__("./node_modules/selectn/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_selectn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_selectn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__actions_navigation__ = __webpack_require__("./src/actions/navigation.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__Logo__ = __webpack_require__("./src/components/Library/Logo/Logo.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__Icon__ = __webpack_require__("./src/components/Library/Icon/Icon.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__ProfileIcon__ = __webpack_require__("./src/components/Library/ProfileIcon/ProfileIcon.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__LatestStories__ = __webpack_require__("./src/components/Library/LatestStories/LatestStories.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__SearchWindow__ = __webpack_require__("./src/components/Library/Navigation/SearchWindow.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__Overlay_Overlay__ = __webpack_require__("./src/components/Library/Overlay/Overlay.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__NavigationDropdown__ = __webpack_require__("./src/components/Library/Navigation/NavigationDropdown.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__config_constants__ = __webpack_require__("./src/config/constants.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__actions_authDrawer__ = __webpack_require__("./src/actions/authDrawer.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__constants_authDrawer__ = __webpack_require__("./src/constants/authDrawer.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__utils_toggleScroll__ = __webpack_require__("./src/utils/toggleScroll.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24__Navigation_css__ = __webpack_require__("./src/components/Library/Navigation/Navigation.css");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24__Navigation_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_24__Navigation_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25__styles_global_css__ = __webpack_require__("./src/styles/global.css");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25__styles_global_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_25__styles_global_css__);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }





























var Navigation = function (_Component) {
  _inherits(Navigation, _Component);

  function Navigation(props) {
    _classCallCheck(this, Navigation);

    var _this = _possibleConstructorReturn(this, (Navigation.__proto__ || Object.getPrototypeOf(Navigation)).call(this, props));

    _this.toggle = _this.toggle.bind(_this);
    _this.toggleLatest = _this.toggleLatest.bind(_this);
    _this.handleResize = _this.handleResize.bind(_this);
    _this.openAuthDrawer = _this.openAuthDrawer.bind(_this);
    _this.toggleSearchWindow = _this.toggleSearchWindow.bind(_this);

    _this.state = {
      isOpen: false,
      isLatestOpen: false,
      navigationScrolled: false,
      isMobile: false,
      searchWindowOpen: false
    };
    return _this;
  }

  _createClass(Navigation, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this.mediaQuery = window.matchMedia(__WEBPACK_IMPORTED_MODULE_20__config_constants__["d" /* BREAKPOINT_DOWN_MEDIUM */]);

      this.setState({ isMobile: this.mediaQuery.matches });

      if (!this.props.navigation.results.sections.length) this.props.navigationActions.getSections();
      if (!this.props.navigation.results.specialFeatures.length) this.props.navigationActions.getSpecialFeatures();

      this.mediaQuery.addListener(this.handleResize);
      this.scrollHandler = __WEBPACK_IMPORTED_MODULE_10_lodash_debounce___default()(this.handleScroll.bind(this), 20);
      window.addEventListener("scroll", this.scrollHandler);
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      this.mediaQuery.removeListener(this.handleResize);
      window.removeEventListener("scroll", this.scrollHandler);
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps) {
      // If URL changes, close the search window
      if (this.props.location !== prevProps.location) {
        this.setState({ searchWindowOpen: false, isOpen: false, isLatestOpen: false });
      }
    }
  }, {
    key: "handleScroll",
    value: function handleScroll() {
      if (window.scrollY > 110 && !this.state.navigationScrolled) {
        this.setState({
          navigationScrolled: true
        });
      } else if (window.scrollY < 110 && this.state.navigationScrolled) {
        this.setState({
          navigationScrolled: false
        });
      }
    }
  }, {
    key: "handleResize",
    value: function handleResize(event) {
      this.setState({ isMobile: event.matches });
    }
  }, {
    key: "toggle",
    value: function toggle() {
      this.setState({
        isOpen: !this.state.isOpen,
        searchWindowOpen: false,
        isLatestOpen: false
      });
    }
  }, {
    key: "toggleLatest",
    value: function toggleLatest() {
      this.setState({
        isLatestOpen: !this.state.isLatestOpen,
        searchWindowOpen: false,
        isOpen: false
      });
    }
  }, {
    key: "openAuthDrawer",
    value: function openAuthDrawer(step) {
      this.setState({
        isLatestOpen: false,
        searchWindowOpen: false,
        isOpen: false
      });
      this.props.authDrawerActions.toggleAuthDrawer(true);
      this.props.authDrawerActions.changeStep(step);
    }
  }, {
    key: "toggleSearchWindow",
    value: function toggleSearchWindow() {
      this.setState({
        searchWindowOpen: !this.state.searchWindowOpen,
        isLatestOpen: false,
        isOpen: false
      });
    }
  }, {
    key: "getMoreItems",
    value: function getMoreItems() {
      return [{ name: "Newsletters", url: "/newsletters", internal: true }, { name: "Events", url: "/events", internal: true }, { name: "About", url: "/about", internal: true }, { name: "Contact Newsroom", url: "mailto:news@axios.com" }, { name: "Search", onClick: this.toggleSearchWindow, className: "gtm-search-more-menu" }, { name: "Privacy & Terms", url: "/legal", internal: true }, { name: "Advertise With Us", url: "mailto:ads@axios.com" }];
    }
  }, {
    key: "getAccountItems",
    value: function getAccountItems() {
      var _this2 = this;

      if (this.props.isLoggedIn) {
        return [{ name: "Saved Stories", url: "/users/saved-stories", internal: true, className: "gtm-saved-stories" }, { name: "Your Account", url: "/users/settings", internal: true, className: "gtm-your-account" }, { name: "Log Out", onClick: function onClick() {
            return _this2.props.authDrawerActions.logOut().then(function () {
              return _this2.props.history.push("/");
            });
          }, className: "gtm-log-out" }];
      }
      return [{ name: "Sign In", onClick: function onClick() {
          return _this2.openAuthDrawer(__WEBPACK_IMPORTED_MODULE_22__constants_authDrawer__["m" /* SIGNIN */]);
        }, className: "gtm-sign-in" }, { name: "Create Account", onClick: function onClick() {
          return _this2.openAuthDrawer(__WEBPACK_IMPORTED_MODULE_22__constants_authDrawer__["j" /* REGISTER1 */]);
        }, className: "gtm-create-account" }];
    }
  }, {
    key: "render",
    value: function render() {
      var _state = this.state,
          searchWindowOpen = _state.searchWindowOpen,
          isLatestOpen = _state.isLatestOpen,
          isOpen = _state.isOpen;

      if (searchWindowOpen || isLatestOpen || isOpen) {
        Object(__WEBPACK_IMPORTED_MODULE_23__utils_toggleScroll__["b" /* freezeScroll */])();
      } else {
        Object(__WEBPACK_IMPORTED_MODULE_23__utils_toggleScroll__["c" /* thawScroll */])();
      }

      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "div",
        null,
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_6_reactstrap_lib_Navbar___default.a,
          {
            role: "navigation",
            fixed: "top",
            className: __WEBPACK_IMPORTED_MODULE_4_classnames___default()(__WEBPACK_IMPORTED_MODULE_24__Navigation_css___default.a.root, __WEBPACK_IMPORTED_MODULE_24__Navigation_css___default.a.fixed, this.state.navigationScrolled ? __WEBPACK_IMPORTED_MODULE_24__Navigation_css___default.a.compressed : {}, this.state.isOpen || this.state.isLatestOpen ? __WEBPACK_IMPORTED_MODULE_24__Navigation_css___default.a.open : {}),
            toggleable: "md" },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            "a",
            { href: "#main", className: __WEBPACK_IMPORTED_MODULE_4_classnames___default()(__WEBPACK_IMPORTED_MODULE_25__styles_global_css___default.a.a11yOnly, __WEBPACK_IMPORTED_MODULE_24__Navigation_css___default.a.item) },
            "Skip to content"
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_8_reactstrap_lib_NavbarToggler___default.a,
            {
              left: true,
              onClick: this.toggle,
              className: __WEBPACK_IMPORTED_MODULE_4_classnames___default()(__WEBPACK_IMPORTED_MODULE_24__Navigation_css___default.a.left, "gtm-hamburger-menu", this.state.isOpen ? __WEBPACK_IMPORTED_MODULE_24__Navigation_css___default.a.togglerOpen : __WEBPACK_IMPORTED_MODULE_24__Navigation_css___default.a.toggler),
              role: "button",
              "aria-haspopup": "true",
              "aria-expanded": this.state.isOpen,
              "aria-hidden": !this.state.isMobile,
              alt: "Toggle main menu" },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_14__Icon__["a" /* default */], { name: "hamburger", description: "Mobile toggle main menu", path: "img", className: __WEBPACK_IMPORTED_MODULE_24__Navigation_css___default.a.icon })
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_7_reactstrap_lib_NavbarBrand___default.a,
            { className: __WEBPACK_IMPORTED_MODULE_24__Navigation_css___default.a.brand, href: "/" },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              "div",
              { className: __WEBPACK_IMPORTED_MODULE_24__Navigation_css___default.a.logoContainer },
              this.props.section && this.state.navigationScrolled && this.mediaQuery.matches ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                "div",
                { className: __WEBPACK_IMPORTED_MODULE_24__Navigation_css___default.a.aOnWhite },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  "span",
                  { className: __WEBPACK_IMPORTED_MODULE_24__Navigation_css___default.a.tag },
                  this.props.section.name
                )
              ) : __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13__Logo__["a" /* default */], { isCompressed: this.state.navigationScrolled }),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                "h1",
                { className: __WEBPACK_IMPORTED_MODULE_25__styles_global_css___default.a.a11yOnly },
                "Axios"
              )
            )
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_8_reactstrap_lib_NavbarToggler___default.a,
            {
              right: true,
              alt: "Sidebar toggle",
              onClick: this.toggleLatest,
              className: __WEBPACK_IMPORTED_MODULE_4_classnames___default()(__WEBPACK_IMPORTED_MODULE_24__Navigation_css___default.a.right, "gtm-timer-icon", this.state.isLatestOpen ? __WEBPACK_IMPORTED_MODULE_24__Navigation_css___default.a.togglerOpen : __WEBPACK_IMPORTED_MODULE_24__Navigation_css___default.a.toggler) },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_14__Icon__["a" /* default */], { name: "timer", description: "Mobile toggle complementary sections", className: __WEBPACK_IMPORTED_MODULE_4_classnames___default()(__WEBPACK_IMPORTED_MODULE_24__Navigation_css___default.a.icon, __WEBPACK_IMPORTED_MODULE_24__Navigation_css___default.a.timerIcon) })
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_9_reactstrap_lib_Collapse___default.a,
            {
              navbar: true,
              id: "main-menu",
              isOpen: this.state.isOpen,
              role: this.state.isMobile ? "menu" : "none",
              className: this.state.isOpen && __WEBPACK_IMPORTED_MODULE_24__Navigation_css___default.a.menuOpen },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              __WEBPACK_IMPORTED_MODULE_5_reactstrap_lib_Nav___default.a,
              { className: "mr-auto", navbar: true },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_19__NavigationDropdown__["a" /* default */], {
                name: "Sections",
                isMobile: this.state.isMobile,
                mobileToggle: this.toggle,
                items: this.props.navigation.results.sections,
                className: "gtm-menu-dropdown" }),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_19__NavigationDropdown__["a" /* default */], {
                name: "Special Features",
                isMobile: this.state.isMobile,
                mobileToggle: this.toggle,
                items: [].concat(_toConsumableArray(this.props.navigation.results.specialFeatures || [])),
                className: "gtm-menu-dropdown" }),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_19__NavigationDropdown__["a" /* default */], {
                name: "More",
                isMobile: this.state.isMobile,
                mobileToggle: this.toggle,
                items: this.getMoreItems(),
                className: "gtm-menu-dropdown" })
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              __WEBPACK_IMPORTED_MODULE_5_reactstrap_lib_Nav___default.a,
              { navbar: true, className: "ml-auto" },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_19__NavigationDropdown__["a" /* default */], {
                name: "Account",
                toggle: __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15__ProfileIcon__["a" /* default */], null),
                isMobile: this.state.isMobile,
                mobileToggle: this.toggle,
                items: this.getAccountItems() }),
              !this.state.isMobile && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                "div",
                { className: __WEBPACK_IMPORTED_MODULE_4_classnames___default()(__WEBPACK_IMPORTED_MODULE_24__Navigation_css___default.a.searchIcon, "gtm-search-icon") },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_14__Icon__["a" /* default */], {
                  name: "search",
                  description: "Search",
                  path: "img",
                  onClick: this.toggleSearchWindow,
                  className: __WEBPACK_IMPORTED_MODULE_4_classnames___default()("mr-1", __WEBPACK_IMPORTED_MODULE_24__Navigation_css___default.a.icon) })
              )
            )
          ),
          this.state.isLatestOpen && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            "div",
            {
              role: "complementary",
              className: __WEBPACK_IMPORTED_MODULE_4_classnames___default()(__WEBPACK_IMPORTED_MODULE_24__Navigation_css___default.a.menuOpen, __WEBPACK_IMPORTED_MODULE_24__Navigation_css___default.a.sidebar)
            },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_16__LatestStories__["a" /* default */], null)
          )
        ),
        this.state.searchWindowOpen ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "div",
          null,
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_17__SearchWindow__["a" /* default */], { isCompressed: this.state.navigationScrolled, onHideSearch: this.toggleSearchWindow }),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_18__Overlay_Overlay__["a" /* default */], { onClick: this.toggleSearchWindow })
        ) : null
      );
    }
  }]);

  return Navigation;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

var mapStateToProps = function mapStateToProps(state) {
  return {
    navigation: state.navigation,
    section: __WEBPACK_IMPORTED_MODULE_11_selectn___default()("navigation.data.section", state),
    authDrawer: state.authDrawer,
    isLoggedIn: !!state.authDrawer.authToken // TODO: implement this properly when singup etc is done
  };
};

var mapDispatchToProps = function mapDispatchToProps(dispatch) {
  return {
    navigationActions: Object(__WEBPACK_IMPORTED_MODULE_2_redux__["b" /* bindActionCreators */])(__WEBPACK_IMPORTED_MODULE_12__actions_navigation__, dispatch),
    authDrawerActions: Object(__WEBPACK_IMPORTED_MODULE_2_redux__["b" /* bindActionCreators */])(__WEBPACK_IMPORTED_MODULE_21__actions_authDrawer__, dispatch)
  };
};

/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_3_react_router_dom__["e" /* withRouter */])(Object(__WEBPACK_IMPORTED_MODULE_1_react_redux__["b" /* connect */])(mapStateToProps, mapDispatchToProps)(Navigation)));

/***/ }),

/***/ "./src/components/Library/Navigation/NavigationDropdown.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__("./node_modules/react/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames__ = __webpack_require__("./node_modules/classnames/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_reactstrap_lib_NavDropdown__ = __webpack_require__("./node_modules/reactstrap/lib/NavDropdown.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_reactstrap_lib_NavDropdown___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_reactstrap_lib_NavDropdown__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_reactstrap_lib_DropdownMenu__ = __webpack_require__("./node_modules/reactstrap/lib/DropdownMenu.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_reactstrap_lib_DropdownMenu___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_reactstrap_lib_DropdownMenu__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_reactstrap_lib_DropdownToggle__ = __webpack_require__("./node_modules/reactstrap/lib/DropdownToggle.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_reactstrap_lib_DropdownToggle___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_reactstrap_lib_DropdownToggle__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_reactstrap_lib_DropdownItem__ = __webpack_require__("./node_modules/reactstrap/lib/DropdownItem.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_reactstrap_lib_DropdownItem___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_reactstrap_lib_DropdownItem__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react_router_dom__ = __webpack_require__("./node_modules/react-router-dom/es/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__Navigation_css__ = __webpack_require__("./src/components/Library/Navigation/Navigation.css");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__Navigation_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__Navigation_css__);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }












var NavigationDropdown = function (_Component) {
  _inherits(NavigationDropdown, _Component);

  function NavigationDropdown(props) {
    _classCallCheck(this, NavigationDropdown);

    var _this = _possibleConstructorReturn(this, (NavigationDropdown.__proto__ || Object.getPrototypeOf(NavigationDropdown)).call(this, props));

    _this.toggle = _this.toggle.bind(_this);
    _this.state = {
      isOpen: false
    };
    return _this;
  }

  _createClass(NavigationDropdown, [{
    key: "toggle",
    value: function toggle() {
      this.setState({
        isOpen: !this.state.isOpen
      });
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      if (!this.props.items || this.props.items.length === 0) return null;
      var name = this.props.name.replace(" ", "-").toLowerCase();
      if (this.props.isMobile) return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "div",
        null,
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "div",
          { className: __WEBPACK_IMPORTED_MODULE_7__Navigation_css___default.a.mobileSectionHeader },
          this.props.name
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "div",
          { className: __WEBPACK_IMPORTED_MODULE_7__Navigation_css___default.a.mobileList },
          this.props.items.map(function (item, index) {
            var key = item.id || item.url + "-" + index;
            if (!item.url) {
              return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                "button",
                {
                  key: key,
                  onClick: function onClick(event) {
                    _this2.props.mobileToggle();
                    item.onClick(event);
                  },
                  className: __WEBPACK_IMPORTED_MODULE_1_classnames___default()(__WEBPACK_IMPORTED_MODULE_7__Navigation_css___default.a.buttonItem, _defineProperty({}, item.className + "-hamburger", item.className)) },
                item.name
              );
            } else if (item.internal || item.url.indexOf("https://www.axios.com") >= 0) {
              return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_6_react_router_dom__["a" /* Link */],
                {
                  key: key,
                  onClick: _this2.props.mobileToggle,
                  to: item.url.replace("https://www.axios.com", ""),
                  className: __WEBPACK_IMPORTED_MODULE_1_classnames___default()(__WEBPACK_IMPORTED_MODULE_7__Navigation_css___default.a.item, _defineProperty({}, item.className + "-hamburger", item.className)) },
                item.name
              );
            } else {
              return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                "a",
                { key: key, href: item.url, className: __WEBPACK_IMPORTED_MODULE_1_classnames___default()(__WEBPACK_IMPORTED_MODULE_7__Navigation_css___default.a.item, _defineProperty({}, item.className + "-hamburger", item.className)) },
                item.name
              );
            }
          })
        )
      );

      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_2_reactstrap_lib_NavDropdown___default.a,
        { isOpen: this.state.isOpen, toggle: this.toggle },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_4_reactstrap_lib_DropdownToggle___default.a,
          { id: name + "-toggle", nav: true, caret: !this.props.toggle, className: __WEBPACK_IMPORTED_MODULE_1_classnames___default()(__WEBPACK_IMPORTED_MODULE_7__Navigation_css___default.a.toggle, this.props.className) },
          this.props.toggle || this.props.name
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_3_reactstrap_lib_DropdownMenu___default.a,
          { id: name + "-menu", className: __WEBPACK_IMPORTED_MODULE_7__Navigation_css___default.a.menu, "aria-labelledby": name + "-toggle" },
          this.props.items.map(function (item, index) {
            var key = item.id || item.url + "-" + index;
            if (!item.url) {
              return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                "button",
                {
                  key: key,
                  role: "menuitem",
                  tabIndex: "0",
                  onClick: function onClick(event) {
                    _this2.toggle();
                    item.onClick(event);
                  },
                  className: __WEBPACK_IMPORTED_MODULE_1_classnames___default()(__WEBPACK_IMPORTED_MODULE_7__Navigation_css___default.a.buttonItem, item.className) },
                item.name
              );
            } else if (item.internal || item.url.indexOf("https://www.axios.com") >= 0) {
              return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_6_react_router_dom__["a" /* Link */],
                {
                  key: key,
                  role: "menuitem",
                  to: item.url.replace("https://www.axios.com", ""),
                  onClick: _this2.toggle,
                  className: __WEBPACK_IMPORTED_MODULE_1_classnames___default()(__WEBPACK_IMPORTED_MODULE_7__Navigation_css___default.a.item, item.className) },
                item.name
              );
            } else {
              return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_5_reactstrap_lib_DropdownItem___default.a,
                {
                  key: item.id || item.url + "-" + index,
                  role: "menuitem",
                  href: item.url,
                  onClick: item.onClick,
                  className: __WEBPACK_IMPORTED_MODULE_1_classnames___default()(__WEBPACK_IMPORTED_MODULE_7__Navigation_css___default.a.item, item.className) },
                item.name
              );
            }
          })
        )
      );
    }
  }]);

  return NavigationDropdown;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

/* harmony default export */ __webpack_exports__["a"] = (NavigationDropdown);

/***/ }),

/***/ "./src/components/Library/Navigation/SearchWindow.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__("./node_modules/react/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_router_dom__ = __webpack_require__("./node_modules/react-router-dom/es/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_classnames__ = __webpack_require__("./node_modules/classnames/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Navigation_css__ = __webpack_require__("./src/components/Library/Navigation/Navigation.css");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Navigation_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__Navigation_css__);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }







var SearchWindow = function (_Component) {
  _inherits(SearchWindow, _Component);

  function SearchWindow(props, context) {
    _classCallCheck(this, SearchWindow);

    var _this = _possibleConstructorReturn(this, (SearchWindow.__proto__ || Object.getPrototypeOf(SearchWindow)).call(this, props, context));

    _this.handleChange = _this.handleChange.bind(_this);
    _this.handleSubmit = _this.handleSubmit.bind(_this);

    _this.state = {
      search: null
    };
    return _this;
  }

  _createClass(SearchWindow, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this.searchInput.focus();
    }
  }, {
    key: "handleChange",
    value: function handleChange(event) {
      this.setState({ search: event.target.value });
    }
  }, {
    key: "handleSubmit",
    value: function handleSubmit(e) {
      e.preventDefault();

      if (this.state.search) {
        this.props.onHideSearch();
        this.props.history.push({ pathname: "/results", search: this.state.search });
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "form",
        { onSubmit: this.handleSubmit },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "div",
          { role: "search", className: __WEBPACK_IMPORTED_MODULE_2_classnames___default()(__WEBPACK_IMPORTED_MODULE_3__Navigation_css___default.a.searchWindow, this.props.isCompressed ? __WEBPACK_IMPORTED_MODULE_3__Navigation_css___default.a.mobileSearchWindow : null) },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("input", {
            ref: function ref(input) {
              _this2.searchInput = input;
            },
            "aria-label": "Search Axios",
            onChange: this.handleChange,
            className: __WEBPACK_IMPORTED_MODULE_3__Navigation_css___default.a.bottomLineInputs, placeholder: "Search Axios" })
        )
      );
    }
  }]);

  return SearchWindow;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["e" /* withRouter */])(SearchWindow));

/***/ }),

/***/ "./src/components/Library/Overlay/Overlay.css":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"overlay":"Overlay__overlay--sA81s"};

/***/ }),

/***/ "./src/components/Library/Overlay/Overlay.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__("./node_modules/react/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Overlay_css__ = __webpack_require__("./src/components/Library/Overlay/Overlay.css");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Overlay_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__Overlay_css__);




var Overlay = function Overlay(props) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", { onClick: props.onClick, className: __WEBPACK_IMPORTED_MODULE_1__Overlay_css___default.a.overlay });
};

/* harmony default export */ __webpack_exports__["a"] = (Overlay);

/***/ }),

/***/ "./src/components/Library/PrimaryImage/PrimaryImage.css":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"imageWrapper":"PrimaryImage__imageWrapper--3XRoE","placeholder":"PrimaryImage__placeholder--1a1TC","img":"PrimaryImage__img--25evc"};

/***/ }),

/***/ "./src/components/Library/PrimaryImage/PrimaryImage.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__("./node_modules/react/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__("./node_modules/prop-types/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_classnames__ = __webpack_require__("./node_modules/classnames/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__StoryBody__ = __webpack_require__("./src/components/Library/StoryBody/StoryBody.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__PrimaryImage_css__ = __webpack_require__("./src/components/Library/PrimaryImage/PrimaryImage.css");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__PrimaryImage_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__PrimaryImage_css__);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }








// Import the lazyloading module if the window context is defined.
if (typeof window !== "undefined") {
  __webpack_require__.e/* import() */(0/* duplicate */).then(__webpack_require__.bind(null, "./node_modules/lazysizes/lazysizes.js"));
}

var PrimaryImage = function (_Component) {
  _inherits(PrimaryImage, _Component);

  function PrimaryImage() {
    _classCallCheck(this, PrimaryImage);

    return _possibleConstructorReturn(this, (PrimaryImage.__proto__ || Object.getPrototypeOf(PrimaryImage)).apply(this, arguments));
  }

  _createClass(PrimaryImage, [{
    key: "render",
    value: function render() {
      var image = this.props.image;


      if (!image || !Object.keys(image).length) {
        return null;
      } // APIs are inconsistent between null and empty object

      // Handle entity maps, add "caption" type
      var captionBlocks = image.caption && image.caption.blocks && _extends({}, image.caption, {
        blocks: image.caption.blocks.map(function (block) {
          return _extends({}, block, { type: "caption" });
        })
      });

      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "figure",
        null,
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "div",
          { className: __WEBPACK_IMPORTED_MODULE_4__PrimaryImage_css___default.a.imageWrapper },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            "div",
            { className: __WEBPACK_IMPORTED_MODULE_4__PrimaryImage_css___default.a.placeholder },
            this.props.lazyload ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("img", { className: __WEBPACK_IMPORTED_MODULE_2_classnames___default()(__WEBPACK_IMPORTED_MODULE_4__PrimaryImage_css___default.a.img, "lazyload"), "data-src": image.crops["16x9"].url, alt: image.alt_text }) : __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("img", { className: __WEBPACK_IMPORTED_MODULE_4__PrimaryImage_css___default.a.img, src: image.crops["16x9"].url, alt: image.alt_text })
          )
        ),
        captionBlocks && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "figcaption",
          { className: __WEBPACK_IMPORTED_MODULE_4__PrimaryImage_css___default.a.caption },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__StoryBody__["a" /* default */], { story: { blocks: captionBlocks } })
        )
      );
    }
  }]);

  return PrimaryImage;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

PrimaryImage.defaultProps = {
  lazyload: true
};

PrimaryImage.propTypes = {
  lazyload: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  image: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({
    alt_text: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
    crops: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({
      "16x9": __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({
        url: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string
      })
    })
  })
};

/* harmony default export */ __webpack_exports__["a"] = (PrimaryImage);

/***/ }),

/***/ "./src/components/Library/ProfileIcon/ProfileIcon.css":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"root":"ProfileIcon__root--3kRUa"};

/***/ }),

/***/ "./src/components/Library/ProfileIcon/ProfileIcon.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = ProfileIcon;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__("./node_modules/react/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames__ = __webpack_require__("./node_modules/classnames/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Icon__ = __webpack_require__("./src/components/Library/Icon/Icon.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__ProfileIcon_css__ = __webpack_require__("./src/components/Library/ProfileIcon/ProfileIcon.css");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__ProfileIcon_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__ProfileIcon_css__);





function ProfileIcon(props) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__Icon__["a" /* default */], { name: "user", description: "profile", role: "presentation", alt: "", className: __WEBPACK_IMPORTED_MODULE_1_classnames___default()(__WEBPACK_IMPORTED_MODULE_3__ProfileIcon_css___default.a.root, props.className) });
}

/***/ }),

/***/ "./src/components/Library/Quote/Quote.css":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"root":"Quote__root--fHvPf","styled":"Quote__styled--2BOAA","plain":"Quote__plain--kY7a_","icon":"Quote__icon--322W3","bounce":"Quote__bounce--1A_v3"};

/***/ }),

/***/ "./src/components/Library/Quote/Quote.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__("./node_modules/react/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames__ = __webpack_require__("./node_modules/classnames/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Icon__ = __webpack_require__("./src/components/Library/Icon/Icon.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Quote_css__ = __webpack_require__("./src/components/Library/Quote/Quote.css");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Quote_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__Quote_css__);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }







var Quote = function (_Component) {
  _inherits(Quote, _Component);

  function Quote() {
    _classCallCheck(this, Quote);

    return _possibleConstructorReturn(this, (Quote.__proto__ || Object.getPrototypeOf(Quote)).apply(this, arguments));
  }

  _createClass(Quote, [{
    key: "render",
    value: function render() {
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "div",
        { className: __WEBPACK_IMPORTED_MODULE_1_classnames___default()(__WEBPACK_IMPORTED_MODULE_3__Quote_css___default.a.root, this.props.styled ? __WEBPACK_IMPORTED_MODULE_3__Quote_css___default.a.styled : __WEBPACK_IMPORTED_MODULE_3__Quote_css___default.a.plain) },
        this.props.styled && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__Icon__["a" /* default */], { name: "quote", description: "Quote", path: "img", className: __WEBPACK_IMPORTED_MODULE_3__Quote_css___default.a.icon }),
        this.props.children
      );
    }
  }]);

  return Quote;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

/* harmony default export */ __webpack_exports__["a"] = (Quote);

/***/ }),

/***/ "./src/components/Library/QuoteAttribution/QuoteAttribution.css":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"root":"QuoteAttribution__root--vrUkY","centered":"QuoteAttribution__centered--3ix6X","bounce":"QuoteAttribution__bounce--1rNaU"};

/***/ }),

/***/ "./src/components/Library/QuoteAttribution/QuoteAttribution.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__("./node_modules/react/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__("./node_modules/prop-types/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_classnames__ = __webpack_require__("./node_modules/classnames/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__QuoteAttribution_css__ = __webpack_require__("./src/components/Library/QuoteAttribution/QuoteAttribution.css");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__QuoteAttribution_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__QuoteAttribution_css__);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }







var QuoteAttribution = function (_Component) {
  _inherits(QuoteAttribution, _Component);

  function QuoteAttribution() {
    _classCallCheck(this, QuoteAttribution);

    return _possibleConstructorReturn(this, (QuoteAttribution.__proto__ || Object.getPrototypeOf(QuoteAttribution)).apply(this, arguments));
  }

  _createClass(QuoteAttribution, [{
    key: "render",
    value: function render() {
      var _props = this.props,
          block = _props.block,
          extras = _props.extras;

      var isStyledQ = extras.styledQuoteAttributions.includes(block.key);
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "div",
        { className: __WEBPACK_IMPORTED_MODULE_2_classnames___default()(__WEBPACK_IMPORTED_MODULE_3__QuoteAttribution_css___default.a.root, isStyledQ ? __WEBPACK_IMPORTED_MODULE_3__QuoteAttribution_css___default.a.centered : {}) },
        "" + (block.text && "— ") + this.props.children
      );
    }
  }]);

  return QuoteAttribution;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

QuoteAttribution.propTypes = {
  block: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object.isRequired,
  extras: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object.isRequired
};

/* harmony default export */ __webpack_exports__["a"] = (QuoteAttribution);

/***/ }),

/***/ "./src/components/Library/SaveTag/SaveTag.css":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"root":"SaveTag__root--3XGDP","save":"SaveTag__save--18RhD","saved":"SaveTag__saved--34zn1","icon":"SaveTag__icon--1vT2X","absolute":"SaveTag__absolute--1g0nc","bounce":"SaveTag__bounce--1Ttac"};

/***/ }),

/***/ "./src/components/Library/SaveTag/SaveTag.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__("./node_modules/react/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__("./node_modules/prop-types/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_redux__ = __webpack_require__("./node_modules/react-redux/es/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_redux__ = __webpack_require__("./node_modules/redux/es/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_classnames__ = __webpack_require__("./node_modules/classnames/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__users_actions_userSettings__ = __webpack_require__("./src/users/actions/userSettings.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__actions_authDrawer__ = __webpack_require__("./src/actions/authDrawer.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__constants_authDrawer__ = __webpack_require__("./src/constants/authDrawer.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__SaveTag_css__ = __webpack_require__("./src/components/Library/SaveTag/SaveTag.css");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__SaveTag_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__SaveTag_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__Icon__ = __webpack_require__("./src/components/Library/Icon/Icon.js");
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }














var SaveTag = function (_Component) {
  _inherits(SaveTag, _Component);

  function SaveTag() {
    _classCallCheck(this, SaveTag);

    var _this = _possibleConstructorReturn(this, (SaveTag.__proto__ || Object.getPrototypeOf(SaveTag)).call(this));

    _this.saveStory = _this.saveStory.bind(_this);
    return _this;
  }

  _createClass(SaveTag, [{
    key: "saveStory",
    value: function saveStory() {
      var _this2 = this;

      // If we are not logged in, open the auth drawer
      if (!this.props.authDrawer.loggedIn) {
        this.props.authDrawerActions.changeStep(__WEBPACK_IMPORTED_MODULE_7__constants_authDrawer__["m" /* SIGNIN */]);
        return this.props.authDrawerActions.toggleAuthDrawer(true);
      }

      var savedStories = this.props.userSettings.data.profileInfo.savedStoryIds;

      // Save a story if not already saved
      if (savedStories && savedStories.indexOf(this.props.storyId) < 0) {
        var newSavedStories = savedStories.concat(this.props.storyId);

        this.props.userSettingsActions.submitSavedStories(newSavedStories);
      }

      // Remove a saved story if previously saved
      if (savedStories && savedStories.indexOf(this.props.storyId) >= 0) {
        var _newSavedStories = savedStories.filter(function (savedStory) {
          return savedStory !== _this2.props.storyId;
        });

        this.props.userSettingsActions.submitSavedStories(_newSavedStories);
      }
    }
  }, {
    key: "render",
    value: function render() {
      var saved = this.props.userSettings.data.profileInfo.savedStoryIds.indexOf(this.props.storyId) >= 0;

      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "div",
        { onClick: this.saveStory, className: __WEBPACK_IMPORTED_MODULE_4_classnames___default()(__WEBPACK_IMPORTED_MODULE_8__SaveTag_css___default.a.root, this.props.absolute ? __WEBPACK_IMPORTED_MODULE_8__SaveTag_css___default.a.absolute : {}) },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "span",
          { className: __WEBPACK_IMPORTED_MODULE_4_classnames___default()(__WEBPACK_IMPORTED_MODULE_8__SaveTag_css___default.a.save, _defineProperty({}, __WEBPACK_IMPORTED_MODULE_8__SaveTag_css___default.a.saved, saved)) },
          "Save",
          saved && "d"
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__Icon__["a" /* default */], { name: "save", description: "Save story", className: __WEBPACK_IMPORTED_MODULE_4_classnames___default()(__WEBPACK_IMPORTED_MODULE_8__SaveTag_css___default.a.icon, saved ? __WEBPACK_IMPORTED_MODULE_8__SaveTag_css___default.a.saved : {}) })
      );
    }
  }]);

  return SaveTag;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

var mapStateToProps = function mapStateToProps(state) {
  return {
    userSettings: state.userSettings,
    authDrawer: state.authDrawer
  };
};

var mapDispatchToProps = function mapDispatchToProps(dispatch) {
  return {
    userSettingsActions: Object(__WEBPACK_IMPORTED_MODULE_3_redux__["b" /* bindActionCreators */])(__WEBPACK_IMPORTED_MODULE_5__users_actions_userSettings__, dispatch),
    authDrawerActions: Object(__WEBPACK_IMPORTED_MODULE_3_redux__["b" /* bindActionCreators */])(__WEBPACK_IMPORTED_MODULE_6__actions_authDrawer__, dispatch)
  };
};

SaveTag.propTypes = {
  absolute: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  storyId: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string.isRequired,
  stream: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  userSettings: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({
    data: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({
      profileInfo: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({
        savedStoryIds: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.array.isRequired
      }).isRequired
    }).isRequired
  }).isRequired,
  authDrawer: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({
    loggedIn: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool
  }).isRequired,
  userSettingsActions: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({
    submitSavedStories: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired
  }).isRequired,
  authDrawerActions: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({
    changeStep: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,
    toggleAuthDrawer: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired
  }).isRequired
};

/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_2_react_redux__["b" /* connect */])(mapStateToProps, mapDispatchToProps)(SaveTag));

/***/ }),

/***/ "./src/components/Library/ScrollToTop/ScrollToTop.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__("./node_modules/react/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__("./node_modules/react-redux/es/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_router_dom__ = __webpack_require__("./node_modules/react-router-dom/es/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__actions_storiesStream__ = __webpack_require__("./src/actions/storiesStream.js");
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }






var ScrollToTop = function (_Component) {
  _inherits(ScrollToTop, _Component);

  function ScrollToTop() {
    _classCallCheck(this, ScrollToTop);

    return _possibleConstructorReturn(this, (ScrollToTop.__proto__ || Object.getPrototypeOf(ScrollToTop)).apply(this, arguments));
  }

  _createClass(ScrollToTop, [{
    key: "componentWillReceiveProps",
    value: function componentWillReceiveProps(nextProps) {
      if (this.props.storiesStream.isError && nextProps.storiesStream.isError) {
        this.props.resetStoriesStreamError();
      }
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps) {
      var prevLoc = prevProps.location;
      var loc = this.props.location;

      if (prevLoc.pathname !== loc.pathname || prevLoc.search !== loc.search) {
        setTimeout(window.scrollTo(0, 0), 300);
      }
    }
  }, {
    key: "render",
    value: function render() {
      return this.props.children;
    }
  }]);

  return ScrollToTop;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

var mapStateToProps = function mapStateToProps(state) {
  return {
    storiesStream: state.storiesStream
  };
};

/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_2_react_router_dom__["e" /* withRouter */])(Object(__WEBPACK_IMPORTED_MODULE_1_react_redux__["b" /* connect */])(mapStateToProps, { resetStoriesStreamError: __WEBPACK_IMPORTED_MODULE_3__actions_storiesStream__["f" /* resetStoriesStreamError */] })(ScrollToTop)));

/***/ }),

/***/ "./src/components/Library/SectionContainer/SectionContainer.css":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"root":"SectionContainer__root--3Lflx","header":"SectionContainer__header--2SXVe","bounce":"SectionContainer__bounce--2T4oE"};

/***/ }),

/***/ "./src/components/Library/SectionContainer/SectionContainer.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__("./node_modules/react/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__("./node_modules/prop-types/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_classnames__ = __webpack_require__("./node_modules/classnames/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__SectionContainer_css__ = __webpack_require__("./src/components/Library/SectionContainer/SectionContainer.css");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__SectionContainer_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__SectionContainer_css__);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }







var SectionContainer = function (_Component) {
  _inherits(SectionContainer, _Component);

  function SectionContainer() {
    _classCallCheck(this, SectionContainer);

    return _possibleConstructorReturn(this, (SectionContainer.__proto__ || Object.getPrototypeOf(SectionContainer)).apply(this, arguments));
  }

  _createClass(SectionContainer, [{
    key: "render",
    value: function render() {
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "div",
        { className: __WEBPACK_IMPORTED_MODULE_2_classnames___default()(__WEBPACK_IMPORTED_MODULE_3__SectionContainer_css___default.a.root, this.props.className) },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "div",
          { className: __WEBPACK_IMPORTED_MODULE_3__SectionContainer_css___default.a.header },
          this.props.header
        ),
        this.props.children
      );
    }
  }]);

  return SectionContainer;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

SectionContainer.propTypes = {
  header: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string.isRequired,
  children: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.any.isRequired,
  className: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string
};

/* harmony default export */ __webpack_exports__["a"] = (SectionContainer);

/***/ }),

/***/ "./src/components/Library/SocialIcons/SocialIcons.css":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"root":"SocialIcons__root--2_SjQ","button":"SocialIcons__button--_Re2H","circle":"SocialIcons__circle--2nd4R","container":"SocialIcons__container--1U_qc","icon":"SocialIcons__icon--245Iz","clipboardWrapper":"SocialIcons__clipboardWrapper--SeMbf","clipboardConfirm":"SocialIcons__clipboardConfirm--1Dh3R"};

/***/ }),

/***/ "./src/components/Library/SocialIcons/SocialIcons.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__("./node_modules/react/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__("./node_modules/prop-types/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_classnames__ = __webpack_require__("./node_modules/classnames/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_qs__ = __webpack_require__("./node_modules/qs/lib/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_qs___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_qs__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Icon__ = __webpack_require__("./src/components/Library/Icon/Icon.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_utils_clipboard__ = __webpack_require__("./src/utils/clipboard.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__SocialIcons_css__ = __webpack_require__("./src/components/Library/SocialIcons/SocialIcons.css");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__SocialIcons_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__SocialIcons_css__);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }










var SocialIcons = function (_React$Component) {
  _inherits(SocialIcons, _React$Component);

  function SocialIcons(props) {
    _classCallCheck(this, SocialIcons);

    var _this = _possibleConstructorReturn(this, (SocialIcons.__proto__ || Object.getPrototypeOf(SocialIcons)).call(this, props));

    _this.state = { clipboardConfirmOpen: false };
    _this.copyPermalink = _this._copyPermalink.bind(_this);
    _this.openInNewWindow = _this._openInNewWindow.bind(_this);
    return _this;
  }

  _createClass(SocialIcons, [{
    key: "_openInNewWindow",
    value: function _openInNewWindow(url) {
      var strParam = "width=500,height=400,resizable=yes";
      window.open(url, "Share story", strParam).focus();
    }
  }, {
    key: "_copyPermalink",
    value: function _copyPermalink(e) {
      var _this2 = this;

      e.preventDefault();

      Object(__WEBPACK_IMPORTED_MODULE_5_utils_clipboard__["a" /* default */])(this.props.permalink);
      this.setState({ clipboardConfirmOpen: true });
      setTimeout(function () {
        _this2.setState({ clipboardConfirmOpen: false });
      }, 1000);
    }
  }, {
    key: "render",
    value: function render() {
      var _this3 = this;

      var endpoints = [{
        url: "https://www.facebook.com/sharer/sharer.php?u=",
        name: "facebook",
        params: { utm_source: "linkedin", utm_medium: "lisocialshare", utm_campaign: "organic" }
      }, {
        url: "https://twitter.com/intent/tweet?url=",
        name: "twitter",
        params: { utm_source: "twitter", utm_medium: "twsocialshare", utm_campaign: "organic" },
        extraParams: { text: this.props.headline }
      }, {
        url: "https://www.linkedin.com/sharing/share-offsite?url=",
        name: "linkedin",
        params: { utm_source: "linkedin", utm_medium: "lisocialshare", utm_campaign: "organic" },
        extraParams: { mini: false }
      }];

      var shareLocations = endpoints.map(function (share) {
        var url = void 0,
            rest = void 0,
            hash = void 0;
        var params = {};

        var _props$permalink$spli = _this3.props.permalink.split("?");

        var _props$permalink$spli2 = _slicedToArray(_props$permalink$spli, 2);

        url = _props$permalink$spli2[0];
        rest = _props$permalink$spli2[1];

        if (rest) {
          var _rest$split = rest.split("#");

          var _rest$split2 = _slicedToArray(_rest$split, 2);

          params = _rest$split2[0];
          hash = _rest$split2[1];
        }

        var newParams = _extends({}, __WEBPACK_IMPORTED_MODULE_3_qs___default.a.parse(params), share.params);
        var sharedUrl = encodeURIComponent(url + "?" + __WEBPACK_IMPORTED_MODULE_3_qs___default.a.stringify(newParams) + (hash ? "#" + hash : ""));

        return {
          url: "" + share.url + sharedUrl + (share.extraParams ? "&" + __WEBPACK_IMPORTED_MODULE_3_qs___default.a.stringify(share.extraParams) : ""),
          name: share.name
        };
      });

      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "div",
        { className: __WEBPACK_IMPORTED_MODULE_2_classnames___default()(__WEBPACK_IMPORTED_MODULE_6__SocialIcons_css___default.a.root, this.props.className) },
        Object.values(shareLocations).map(function (share) {
          return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            "a",
            { key: share.name, target: "_new", onClick: function onClick(e) {
                e.preventDefault();_this3.openInNewWindow(share.url);
              }, "aria-label": share.name, className: __WEBPACK_IMPORTED_MODULE_2_classnames___default()(__WEBPACK_IMPORTED_MODULE_6__SocialIcons_css___default.a.button, "gtm-" + share.name) },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              "div",
              { className: __WEBPACK_IMPORTED_MODULE_2_classnames___default()(__WEBPACK_IMPORTED_MODULE_6__SocialIcons_css___default.a.container, _this3.props.inverse ? __WEBPACK_IMPORTED_MODULE_6__SocialIcons_css___default.a.circle : {}) },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__Icon__["a" /* default */], { name: "" + share.name + (_this3.props.inverse ? "-inverse" : ""), path: "img", description: share.name, className: __WEBPACK_IMPORTED_MODULE_6__SocialIcons_css___default.a.icon })
            )
          );
        }),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "div",
          { className: __WEBPACK_IMPORTED_MODULE_2_classnames___default()(__WEBPACK_IMPORTED_MODULE_6__SocialIcons_css___default.a.clipboardWrapper, "gtm-copy-link") },
          this.state.clipboardConfirmOpen ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            "div",
            { className: __WEBPACK_IMPORTED_MODULE_6__SocialIcons_css___default.a.clipboardConfirm },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__Icon__["a" /* default */], { name: "clipboard", path: "icons", description: "copy", className: __WEBPACK_IMPORTED_MODULE_6__SocialIcons_css___default.a.icon }),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              "span",
              null,
              "Link copied to clipboard"
            )
          ) : null,
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            "a",
            { onClick: this.copyPermalink, "aria-label": "Copy url", className: __WEBPACK_IMPORTED_MODULE_6__SocialIcons_css___default.a.button },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              "div",
              { className: __WEBPACK_IMPORTED_MODULE_2_classnames___default()(__WEBPACK_IMPORTED_MODULE_6__SocialIcons_css___default.a.container, this.props.inverse ? __WEBPACK_IMPORTED_MODULE_6__SocialIcons_css___default.a.circle : {}) },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__Icon__["a" /* default */], { name: "link" + (this.props.inverse ? "-inverse" : ""), path: "img", description: "copy", className: __WEBPACK_IMPORTED_MODULE_6__SocialIcons_css___default.a.icon })
            )
          )
        )
      );
    }
  }]);

  return SocialIcons;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

/* harmony default export */ __webpack_exports__["a"] = (SocialIcons);


SocialIcons.propTypes = {
  permalink: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string.isRequired,
  headline: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string.isRequired,
  className: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  inverse: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool
};

SocialIcons.defaultProps = {
  inverse: false
};

/***/ }),

/***/ "./src/components/Library/Spinner/Spinner.css":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"container":"Spinner__container--1e3yT","root":"Spinner__root--18wRE","node":"Spinner__node--2aM8s","bounce":"Spinner__bounce--2ETkq","node-0":"Spinner__node-0--158wa","node-1":"Spinner__node-1--1zpgE","node-2":"Spinner__node-2--D3IhM","node-3":"Spinner__node-3--3Mcad","node-4":"Spinner__node-4--lkXJ-","node-5":"Spinner__node-5--2ojsv","node-6":"Spinner__node-6--FMoC1","node-7":"Spinner__node-7--3XmyV"};

/***/ }),

/***/ "./src/components/Library/Spinner/Spinner.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = Spinner;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__("./node_modules/react/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames__ = __webpack_require__("./node_modules/classnames/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Spinner_css__ = __webpack_require__("./src/components/Library/Spinner/Spinner.css");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Spinner_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__Spinner_css__);





function Spinner(props) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    "div",
    { className: !props.noContainer && __WEBPACK_IMPORTED_MODULE_2__Spinner_css___default.a.container },
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      "div",
      { className: __WEBPACK_IMPORTED_MODULE_2__Spinner_css___default.a.root },
      Array.from(Array(8)).map(function (x, i) {
        return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", {
          key: i,
          className: __WEBPACK_IMPORTED_MODULE_1_classnames___default()(__WEBPACK_IMPORTED_MODULE_2__Spinner_css___default.a["node-" + i], __WEBPACK_IMPORTED_MODULE_2__Spinner_css___default.a.node),
          style: {
            left: 15 * Math.cos(-0.25 * Math.PI * i) + "px",
            top: 15 * Math.sin(-0.25 * Math.PI * i) + "px"
          }
        });
      })
    )
  );
}

/***/ }),

/***/ "./src/components/Library/StoriesStream/StoriesStream.css":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"separator":"StoriesStream__separator--4I88W","spinnerWrapper":"StoriesStream__spinnerWrapper--2mgmn","infinite":"StoriesStream__infinite--3rpZE"};

/***/ }),

/***/ "./src/components/Library/StoriesStream/StoriesStream.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__("./node_modules/react/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__("./node_modules/prop-types/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_classnames__ = __webpack_require__("./node_modules/classnames/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_infinite__ = __webpack_require__("./node_modules/react-infinite/build/react-infinite.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_infinite___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react_infinite__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_measure__ = __webpack_require__("./node_modules/react-measure/lib/react-measure.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_measure___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react_measure__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_selectn__ = __webpack_require__("./node_modules/selectn/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_selectn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_selectn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__Library_Spinner__ = __webpack_require__("./src/components/Library/Spinner/Spinner.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__Library_StoryCard__ = __webpack_require__("./src/components/Library/StoryCard/StoryCard.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__Library_SummaryCard__ = __webpack_require__("./src/components/Library/SummaryCard/SummaryCard.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__Library_EventCard__ = __webpack_require__("./src/components/Library/EventCard/EventCard.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__Library_StreamAd__ = __webpack_require__("./src/components/Library/StreamAd/StreamAd.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__StoriesStream_css__ = __webpack_require__("./src/components/Library/StoriesStream/StoriesStream.css");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__StoriesStream_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11__StoriesStream_css__);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
















var contentRectHoc = typeof window === "undefined" ? function () {
  return function (callback) {
    return callback;
  };
} : __WEBPACK_IMPORTED_MODULE_4_react_measure__["withContentRect"];
var MeasuredStory = contentRectHoc("client")(function (_ref) {
  var measureRef = _ref.measureRef,
      Wrapper = _ref.Wrapper,
      story = _ref.story,
      storyClassName = _ref.storyClassName,
      showDivider = _ref.showDivider,
      index = _ref.index,
      isLastStory = _ref.isLastStory,
      adId = _ref.adId,
      stream = _ref.stream,
      permalinkId = _ref.permalinkId;
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    "div",
    { ref: measureRef, role: "article", "aria-label": story.headline, tabIndex: "-1" },
    showDivider === "start" && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("hr", { className: __WEBPACK_IMPORTED_MODULE_2_classnames___default()("mx-4", __WEBPACK_IMPORTED_MODULE_11__StoriesStream_css___default.a.separator), "aria-hidden": true }),
    story.isAd ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__Library_StreamAd__["a" /* default */], { advert: story, adId: adId, stream: stream }) : __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Wrapper, { story: story, isLastStory: isLastStory, permalinkId: permalinkId, index: index, className: __WEBPACK_IMPORTED_MODULE_2_classnames___default()(index !== 0 ? "my-3" : "mb-3", storyClassName) }),
    showDivider === "end" && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("hr", { className: __WEBPACK_IMPORTED_MODULE_2_classnames___default()("mx-4", __WEBPACK_IMPORTED_MODULE_11__StoriesStream_css___default.a.separator), "aria-hidden": true })
  );
});

var StoriesStream = function (_Component) {
  _inherits(StoriesStream, _Component);

  function StoriesStream(props) {
    _classCallCheck(this, StoriesStream);

    var _this = _possibleConstructorReturn(this, (StoriesStream.__proto__ || Object.getPrototypeOf(StoriesStream)).call(this, props));

    _this.getStream = function (stream) {
      if (!stream) return "misc";
      if (stream === "top") return "homepage";
      return "section-" + stream;
    };

    _this.getStoriesAndAds = function (stories) {
      // Only server render the first 3 stories in any stream and let the rest mount on the client.
      var results = _this.state.isClient ? [].concat(_toConsumableArray(stories.results)) : stories.results.slice(0, 3);

      if (!_this.props.showAds) return results;

      var placedAds = 0;
      var startAd = 2;
      var gap = 4;

      // If there is an adId prop passed in, put an ad first in the response.
      if (_this.props.adId) {
        results.splice(0, 0, _this.getAd(1, undefined, undefined));
        return results;
      }

      // First ad after 1st post for top
      if (_this.props.stream === "top" && stories.results.length >= 2) {
        results.splice(1, 0, _this.getAd(1, results[0], results[1]));
        startAd = 7;
      }

      if (results.length < startAd) return results;

      var insertIndex = startAd + placedAds + placedAds * gap;

      // Ads every 4 posts starting after 6th for top and 2nd for other streams
      while (insertIndex <= results.length) {
        results.splice(insertIndex, 0, _this.getAd(placedAds + 2, results[insertIndex - 1], results[insertIndex]));
        placedAds += 1;
        insertIndex = startAd + placedAds + placedAds * gap;
      }

      return results;
    };

    _this.getAd = function (index, beforePost, afterPost) {
      var postIds = [__WEBPACK_IMPORTED_MODULE_5_selectn___default()("id", beforePost), __WEBPACK_IMPORTED_MODULE_5_selectn___default()("id", afterPost)];
      var beforeTags = beforePost ? (beforePost.tags || []).map(function (t) {
        return t.name;
      }).concat(__WEBPACK_IMPORTED_MODULE_5_selectn___default()("primary_tag.name", beforePost)) : [];
      var afterTags = afterPost ? (afterPost.tags || []).map(function (t) {
        return t.name;
      }).concat(__WEBPACK_IMPORTED_MODULE_5_selectn___default()("primary_tag.name", afterPost)) : [];

      return {
        id: "ad_" + index,
        isAd: true,
        index: index,
        postIds: postIds,
        beforeTags: beforeTags,
        afterTags: afterTags
      };
    };

    _this.defaultCardHeight = _this.props.isSummary || _this.props.isEvent ? 200 : 500;

    _this._handleInfiniteLoad = _this._handleInfiniteLoad.bind(_this);

    _this.state = {
      loading: false,
      page: 1,
      //prevent auto loading of second page on pages where results aren't rendered yet
      //TODO remove > 1 - this is a hack until permalinks render correctly on server: https://jira.axios.com/browse/SITE-387
      attemptInfiniteLoad: props.stories.results && props.stories.results.length > 1 ? true : undefined,
      elementHeights: {},
      isClient: false
    };
    return _this;
  }

  _createClass(StoriesStream, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this.setState({ isClient: true });

      if (this.props.stories.isFinished) {
        this.setElementHeights(this.props.stories);
      }
    }
  }, {
    key: "componentWillReceiveProps",
    value: function componentWillReceiveProps(nextProps) {
      var nextStories = nextProps.stories;
      var currentStories = this.props.stories;
      if (nextStories.isFinished && nextStories.results && nextStories.results !== currentStories.results) {
        this.setElementHeights(nextStories);
        this.setState({ attemptInfiniteLoad: true });
      }
      if (!currentStories.isError && nextStories.isError) {
        this.setState({ attemptInfiniteLoad: undefined, loading: false });
      }
      if (!nextStories.results || nextStories.isLoading) {
        this.setState({ page: 1 });
      }
    }
  }, {
    key: "setElementHeights",
    value: function setElementHeights(stories) {
      var _this2 = this;

      var results = this.getStoriesAndAds(stories);
      // Because children haven't been measured yet, set height initially to an approximate value: 500px
      var elemHeights = results.reduce(function (accum, story) {
        return _extends({}, accum, _defineProperty({}, story.id, __WEBPACK_IMPORTED_MODULE_5_selectn___default()("elementHeights." + story.id, _this2.state) || _this2.defaultCardHeight));
      }, {});
      this.setState({
        // Keep heights that have already been calculated
        elementHeights: elemHeights
      });
    }
  }, {
    key: "_updateSize",
    value: function _updateSize(id, height) {
      if (this.state.elementHeights[id] !== height) {
        this.setState({
          elementHeights: _extends({}, this.state.elementHeights, _defineProperty({}, id, height))
        });
      }
    }
  }, {
    key: "_handleInfiniteLoad",
    value: function _handleInfiniteLoad() {
      var _this3 = this;

      var page = this.state.page + 1;
      this.setState({ loading: true, page: page });
      this.props.next(page).then(function () {
        return _this3.setState({ loading: false });
      });
    }
  }, {
    key: "render",
    value: function render() {
      var _this4 = this;

      var _props = this.props,
          stories = _props.stories,
          storyClassName = _props.storyClassName,
          isSummary = _props.isSummary,
          isEvent = _props.isEvent,
          showUnread = _props.showUnread;

      if (!stories.results || stories.isLoading) return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "div",
        { className: __WEBPACK_IMPORTED_MODULE_11__StoriesStream_css___default.a.spinnerWrapper },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__Library_Spinner__["a" /* default */], null)
      );

      var Wrapper = isSummary ? __WEBPACK_IMPORTED_MODULE_8__Library_SummaryCard__["a" /* default */] : isEvent ? __WEBPACK_IMPORTED_MODULE_9__Library_EventCard__["a" /* default */] : __WEBPACK_IMPORTED_MODULE_7__Library_StoryCard__["a" /* default */];

      var storyStreamWithAds = this.getStoriesAndAds(stories);
      // We cannot guarantee the uniqueness of IDs in elementHeights so we need
      // to map them back against storyStreamWithAds to return an array of element heights.
      // When ads don't render assign height of 0 or infinite scroll breaks
      var elementHeights = storyStreamWithAds.map(function (story) {
        return _this4.state.elementHeights[story.id] || (story.isAd ? 0 : _this4.defaultCardHeight);
      });
      var containerProps = this.state.isClient ? { useWindowAsScrollContainer: true } : { containerHeight: 2000 };

      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_3_react_infinite___default.a,
        _extends({}, containerProps, {
          className: __WEBPACK_IMPORTED_MODULE_11__StoriesStream_css___default.a.infinite,
          elementHeight: elementHeights,
          infiniteLoadBeginEdgeOffset: this.state.attemptInfiniteLoad && this.defaultCardHeight,
          preloadBatchSize: __WEBPACK_IMPORTED_MODULE_3_react_infinite___default.a.containerHeightScaleFactor(2),
          preloadAdditionalHeight: __WEBPACK_IMPORTED_MODULE_3_react_infinite___default.a.containerHeightScaleFactor(30),
          loadingSpinnerDelegate: __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__Library_Spinner__["a" /* default */], null),
          onInfiniteLoad: this._handleInfiniteLoad,
          isInfiniteLoading: this.state.loading
        }),
        storyStreamWithAds.map(function (story, index) {
          var showDivider = _this4.props.lastSeenId === story.id && index !== 0 ? "start" : !_this4.props.lastSeenId && index === stories.results.length - 1 ? "end" : false;
          return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(MeasuredStory, {
            key: story.id,
            index: index,
            adId: _this4.props.adId,
            stream: _this4.getStream(_this4.props.stream),
            isLastStory: stories.results.length - 1 === index,
            story: story,
            showDivider: showUnread && showDivider,
            Wrapper: Wrapper,
            storyClassName: storyClassName,
            onResize: function onResize(contentRect) {
              _this4._updateSize(story.id, contentRect.client.height);
            },
            permalinkId: _this4.props.permalinkId
          });
        })
      );
    }
  }]);

  return StoriesStream;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

StoriesStream.propTypes = {
  next: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,
  stories: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object.isRequired,
  isSummary: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  isEvent: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  showUnread: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  storyClassName: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string
};

/* harmony default export */ __webpack_exports__["a"] = (StoriesStream);

/***/ }),

/***/ "./src/components/Library/StoryBody/StoryBody.css":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"root":"StoryBody__root--2VihO","hidden":"StoryBody__hidden--284qb","item":"StoryBody__item--1cHYD","paragraph":"StoryBody__paragraph--2-Doz","caption":"StoryBody__caption--z-cgi","subhead":"StoryBody__subhead--3hgz5","factsMatter":"StoryBody__factsMatter--MiwD4","link":"StoryBody__link--10w8x","orderedList":"StoryBody__orderedList--3hKT0","bounce":"StoryBody__bounce--1aTcv"};

/***/ }),

/***/ "./src/components/Library/StoryBody/StoryBody.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__("./node_modules/react/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__("./node_modules/prop-types/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_redux__ = __webpack_require__("./node_modules/react-redux/es/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_draft_convert_lib_convertToHTML__ = __webpack_require__("./node_modules/draft-convert/lib/convertToHTML.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_draft_convert_lib_convertToHTML___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_draft_convert_lib_convertToHTML__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_selectn__ = __webpack_require__("./node_modules/selectn/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_selectn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_selectn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_lodash_debounce__ = __webpack_require__("./node_modules/lodash/debounce.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_lodash_debounce___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_lodash_debounce__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_classnames__ = __webpack_require__("./node_modules/classnames/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__actions_storiesStream__ = __webpack_require__("./src/actions/storiesStream.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__config_constants__ = __webpack_require__("./src/config/constants.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__conversionHelpers__ = __webpack_require__("./src/components/Library/StoryBody/conversionHelpers.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__utils_entityToHTML__ = __webpack_require__("./src/utils/entityToHTML.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__utils_embed__ = __webpack_require__("./src/utils/embed.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__utils_utils__ = __webpack_require__("./src/utils/utils.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__constants_actionTypes__ = __webpack_require__("./src/constants/actionTypes.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__utils_log__ = __webpack_require__("./src/utils/log.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__StoryBody_css__ = __webpack_require__("./src/components/Library/StoryBody/StoryBody.css");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__StoryBody_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_15__StoryBody_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__components_Library_KeepReading_KeepReading_css__ = __webpack_require__("./src/components/Library/KeepReading/KeepReading.css");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__components_Library_KeepReading_KeepReading_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_16__components_Library_KeepReading_KeepReading_css__);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }





















var StoryBody = function (_Component) {
  _inherits(StoryBody, _Component);

  function StoryBody(props) {
    _classCallCheck(this, StoryBody);

    var _this = _possibleConstructorReturn(this, (StoryBody.__proto__ || Object.getPrototypeOf(StoryBody)).call(this, props));

    _this.addInternalClickEventHandler = function (identifier) {
      var elements = document.getElementsByClassName(identifier + "-" + _this.props.story.id);

      var _loop = function _loop(i) {
        elements[i].onclick = function (e) {
          e.preventDefault();
          _this.loadInternalStory(identifier).then(function (storyElement) {
            _this.scrollToStory(storyElement);
          }).catch(function () {
            window.location = elements[i].href;
          });
        };
      };

      for (var i = 0; i < elements.length; i++) {
        _loop(i);
      }
    };

    _this.loadInternalStory = function (internalStoryId) {
      return new Promise(function (resolve, reject) {
        //if this is a newsletter, redirect to the permalink without bothering with api call
        if (_this.props.storyType === "newsletter") {
          reject();
          return;
        }

        //otherwise, load the story into the stream
        _this.props.loadStory({ story: internalStoryId }, _this.props.story.id).then(function (res) {
          //this will usually happen if it's a RM link
          if (res.type === __WEBPACK_IMPORTED_MODULE_13__constants_actionTypes__["X" /* GET_STORY_ERROR */]) {
            reject();
          } else {
            setTimeout(function () {
              //scroll to the story if it's on the page. if not, permalink
              var storyElement = document.getElementById(internalStoryId);
              storyElement ? resolve(storyElement) : reject();
            }, 200);
          }
        });
      });
    };

    _this.scrollToStory = function (element) {
      var bounds = element.getBoundingClientRect();
      window.scrollBy(0, bounds.top - 100);
    };

    _this.processBlocks = function (blocks) {
      var newBlocks = [];
      var hiddenBlocks = [];
      var keepReading = null;
      var wordCount = 0;
      var styledQuoteAttributions = [];

      for (var i = 0; i < blocks.length; i++) {
        if (!blocks[i]) continue;
        if (i !== 0 && blocks[i].type.toLowerCase() === __WEBPACK_IMPORTED_MODULE_8__config_constants__["c" /* BLOCK_TYPE */].QUOTE_ATTRIBUTION && blocks[i - 1].type.toLowerCase() === __WEBPACK_IMPORTED_MODULE_8__config_constants__["c" /* BLOCK_TYPE */].STYLED_QUOTE) {
          styledQuoteAttributions.push(blocks[i].key);
        }
        if (blocks[i].type.toLowerCase() === __WEBPACK_IMPORTED_MODULE_8__config_constants__["c" /* BLOCK_TYPE */].KEEP_READING) {
          keepReading = blocks[i];
        } else if (keepReading) {
          hiddenBlocks.push(blocks[i]);
          wordCount += blocks[i].text.split(" ").length;
        } else {
          newBlocks.push(blocks[i]);
        }
      }

      return {
        blocks: newBlocks,
        keepReadingBlock: keepReading,
        hiddenBlocks: hiddenBlocks,
        wordCount: wordCount,
        styledQuoteAttributions: styledQuoteAttributions
      };
    };

    _this.addListeners = function () {
      _this.mediaQuery.addListener(_this.handleResize);

      if (_this.mediaQuery.matches) {
        window.addEventListener("scroll", _this.scrollListener);
      }
    };

    _this.removeListeners = function () {
      _this.mediaQuery.removeListener(_this.handleResize);
      window.removeEventListener("scroll", _this.scrollListener);
    };

    _this.handleScroll = function () {
      if (_this.processedBlocks.keepReadingBlock && _this.state.isOpen) {
        var hidden = document.getElementById("hidden-" + _this.props.story.id);
        if (hidden) {
          var isFixed = _this.mediaQuery.matches && _this.state.isOpen && !_this.isKeepReadingVisible(hidden);
          if (_this.state.isFixed !== isFixed) {
            _this.setState({ isFixed: isFixed });
          }
        }
      }
    };

    _this.handleResize = function (event) {
      if (event.matches) {
        window.addEventListener("scroll", _this.scrollListener);
      } else {
        if (_this.state.isFixed) {
          _this.setState({ isFixed: false });
        }
        window.removeEventListener("scroll", _this.scrollListener);
      }
    };

    _this.isKeepReadingVisible = function (element) {
      var bounds = element.getBoundingClientRect();
      return bounds.bottom < (window.innerHeight || document.documentElement.clientHeight);
    };

    _this._onKeepReadingClick = function () {
      var isOpen = !_this.state.isOpen;
      _this.setState({ isOpen: isOpen });

      if (isOpen) {
        _this.addListeners();
      } else {
        _this.removeListeners();

        // If next headline is not visible, scroll to just show it
        var bounds = _this.keepReadingButton.getBoundingClientRect();
        var scrollValue = 275 + bounds.top - (window.innerHeight || document.documentElement.clientHeight);

        if (scrollValue > 0) {
          window.scrollBy(0, scrollValue);
        } else if (bounds.top < 60) {
          // If keep reading button is not visible, scroll so it just shows
          window.scrollBy(0, bounds.top - 60);
        }
      }
    };

    _this.getHTML = function (blocks, entityMap, extras) {
      var html = false;
      try {
        html = __WEBPACK_IMPORTED_MODULE_3_draft_convert_lib_convertToHTML___default()({
          styleToHTML: __WEBPACK_IMPORTED_MODULE_9__conversionHelpers__["b" /* styleToHTML */],
          blockToHTML: Object(__WEBPACK_IMPORTED_MODULE_9__conversionHelpers__["a" /* blockToHTML */])(extras, _this.state.isClient),
          // This shouldn't normally work, but we've tricked draft-convert into requiring a version of draft-js where
          // convertToRaw is a noop - thus we can pass raw draft data right into draft-convert
          entityToHTML: Object(__WEBPACK_IMPORTED_MODULE_10__utils_entityToHTML__["a" /* entityToHTML */])(_this.props.story, __WEBPACK_IMPORTED_MODULE_15__StoryBody_css___default.a)
        })({ blocks: blocks, entityMap: entityMap });
      } catch (e) {
        __WEBPACK_IMPORTED_MODULE_14__utils_log__["a" /* default */].logger("draft-convert failure. story id: " + _this.props.story.id, "error", { id: _this.props.story.id, error: e });
      }
      return html;
    };

    _this.state = {
      isOpen: !!props.permalinkId && props.permalinkId === props.story.id,
      isFixed: false,
      isClient: false,
      shouldProcess: true
    };

    _this.onKeepReadingClick = _this._onKeepReadingClick.bind(_this);
    return _this;
  }

  _createClass(StoryBody, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this.mediaQuery = window.matchMedia(__WEBPACK_IMPORTED_MODULE_8__config_constants__["e" /* BREAKPOINT_DOWN_SMALL */]);
      this.scrollListener = __WEBPACK_IMPORTED_MODULE_5_lodash_debounce___default()(this.handleScroll, 50);
      this.setState({ isClient: true });
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate() {
      var _this2 = this;

      if (!this.state.isClient || !this.processedBlocks || !this.state.shouldProcess) return;

      if (this.processedBlocks.blocks) {
        this.processedBlocks.blocks.filter(function (block) {
          return block.type === __WEBPACK_IMPORTED_MODULE_8__config_constants__["c" /* BLOCK_TYPE */].EMBED;
        }).map(__WEBPACK_IMPORTED_MODULE_11__utils_embed__["a" /* handleEmbed */]);

        (__WEBPACK_IMPORTED_MODULE_4_selectn___default()("story.blocks.entityMap", this.props) || []).filter(function (entity) {
          return entity.type.toLowerCase() === __WEBPACK_IMPORTED_MODULE_8__config_constants__["f" /* ENTITY_TYPE */].LINK;
        }).map(function (entity) {
          var matches = Object(__WEBPACK_IMPORTED_MODULE_12__utils_utils__["a" /* isInternalURL */])(entity.data.url);
          if (matches && matches.length > 1) {
            _this2.addInternalClickEventHandler(matches[1]);
          }
        });
      }

      if (this.processedBlocks.hiddenBlocks) {
        this.processedBlocks.hiddenBlocks.filter(function (block) {
          return block.type === __WEBPACK_IMPORTED_MODULE_8__config_constants__["c" /* BLOCK_TYPE */].EMBED;
        }).map(__WEBPACK_IMPORTED_MODULE_11__utils_embed__["a" /* handleEmbed */]);
      }

      this.setState({ shouldProcess: false });
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      this.removeListeners();
    }
  }, {
    key: "render",
    value: function render() {
      var _this3 = this,
          _classNames2;

      var currentBlocks = __WEBPACK_IMPORTED_MODULE_4_selectn___default()("story.blocks.blocks", this.props);
      if (!currentBlocks) return null;
      this.processedBlocks = this.processBlocks(currentBlocks);
      var _processedBlocks = this.processedBlocks,
          blocks = _processedBlocks.blocks,
          hiddenBlocks = _processedBlocks.hiddenBlocks,
          keepReadingBlock = _processedBlocks.keepReadingBlock,
          wordCount = _processedBlocks.wordCount,
          styledQuoteAttributions = _processedBlocks.styledQuoteAttributions;
      var entityMap = this.props.story.blocks.entityMap;

      var extras = { styledQuoteAttributions: styledQuoteAttributions };

      var html = this.getHTML(blocks, entityMap, extras);
      var keepReadingHTML = keepReadingBlock && this.getHTML([keepReadingBlock], entityMap, { wordCount: wordCount });
      var hiddenHTML = hiddenBlocks && this.getHTML(hiddenBlocks, entityMap, extras);

      // don't render the story if draft-convert failed
      if (!html || keepReadingHTML && !hiddenHTML) return null;

      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "div",
        { className: __WEBPACK_IMPORTED_MODULE_6_classnames___default()(__WEBPACK_IMPORTED_MODULE_15__StoryBody_css___default.a.root, _defineProperty({}, __WEBPACK_IMPORTED_MODULE_15__StoryBody_css___default.a.factsMatter, this.props.story.template === __WEBPACK_IMPORTED_MODULE_8__config_constants__["h" /* FACTS_MATTER_TEMPLATE */])) },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", { dangerouslySetInnerHTML: { __html: html } }),
        keepReadingHTML && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", {
          dangerouslySetInnerHTML: { __html: keepReadingHTML },
          onClick: this.onKeepReadingClick,
          ref: function ref(node) {
            _this3.keepReadingButton = node;
          },
          className: __WEBPACK_IMPORTED_MODULE_6_classnames___default()("qa-keep-reading", (_classNames2 = {}, _defineProperty(_classNames2, __WEBPACK_IMPORTED_MODULE_16__components_Library_KeepReading_KeepReading_css___default.a.keepReadingOpen, this.state.isOpen), _defineProperty(_classNames2, __WEBPACK_IMPORTED_MODULE_16__components_Library_KeepReading_KeepReading_css___default.a.keepReadingFixed, this.state.isFixed), _classNames2))
        }),
        hiddenHTML && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", {
          id: "hidden-" + this.props.story.id,
          style: { display: this.state.isOpen ? "block" : "none", paddingBottom: "65px" },
          "aria-hidden": !this.state.isOpen,
          "aria-expanded": this.state.isOpen,
          dangerouslySetInnerHTML: { __html: hiddenHTML } })
      );
    }
  }]);

  return StoryBody;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

var mapStateToProps = function mapStateToProps(state) {
  return {
    stream: __WEBPACK_IMPORTED_MODULE_4_selectn___default()("navigation.data.section.slug", state)
  };
};

StoryBody.propTypes = {
  story: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object.isRequired,
  storyType: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOf(["newsletter"]),
  permalinkId: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string
};

/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_2_react_redux__["b" /* connect */])(mapStateToProps, { loadStory: __WEBPACK_IMPORTED_MODULE_7__actions_storiesStream__["e" /* loadStory */] })(StoryBody));

/***/ }),

/***/ "./src/components/Library/StoryBody/conversionHelpers.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return styleToHTML; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return blockToHTML; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__("./node_modules/react/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__config_constants__ = __webpack_require__("./src/config/constants.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils_blockHTML__ = __webpack_require__("./src/utils/blockHTML.js");
var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };





var styleToHTML = function styleToHTML(style) {
  switch (style.toLowerCase()) {
    case __WEBPACK_IMPORTED_MODULE_1__config_constants__["m" /* STYLE_TYPE */].BOLD:
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("strong", null);

    case __WEBPACK_IMPORTED_MODULE_1__config_constants__["m" /* STYLE_TYPE */].ITALIC:
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("em", null);

    default:
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span", null);
  }
};

var blockToHTML = function blockToHTML(extras, isClient) {
  return function (block) {
    var html = __WEBPACK_IMPORTED_MODULE_2__utils_blockHTML__["a" /* default */][block.type.toLowerCase()];

    switch (typeof html === "undefined" ? "undefined" : _typeof(html)) {
      case "undefined":
        return __WEBPACK_IMPORTED_MODULE_2__utils_blockHTML__["a" /* default */]["default"];

      case "function":
        return html(block, extras, isClient);

      default:
        return html;
    }
  };
};

/***/ }),

/***/ "./src/components/Library/StoryCard/StoryCard.css":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"root":"StoryCard__root--3D7So","featured":"StoryCard__featured--2LRFT","factsMatter":"StoryCard__factsMatter--1GsxW","slideIn":"StoryCard__slideIn--r9piN","bounce":"StoryCard__bounce--_IQ4j","hide":"StoryCard__hide--3MQDh"};

/***/ }),

/***/ "./src/components/Library/StoryCard/StoryCard.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__("./node_modules/react/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__("./node_modules/prop-types/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_classnames__ = __webpack_require__("./node_modules/classnames/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_selectn__ = __webpack_require__("./node_modules/selectn/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_selectn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_selectn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__StoryHeader__ = __webpack_require__("./src/components/Library/StoryHeader/StoryHeader.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__StoryContent__ = __webpack_require__("./src/components/Library/StoryContent/StoryContent.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__StoryFooter__ = __webpack_require__("./src/components/Library/StoryFooter/StoryFooter.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_components_Library_ErrorBoundary__ = __webpack_require__("./src/components/Library/ErrorBoundary/ErrorBoundary.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_assets_img_social_default_png__ = __webpack_require__("./src/assets/img/social-default.png");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_assets_img_social_default_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_assets_img_social_default_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_assets_img_large_logo_png__ = __webpack_require__("./src/assets/img/large-logo.png");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_assets_img_large_logo_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_assets_img_large_logo_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__StoryCard_css__ = __webpack_require__("./src/components/Library/StoryCard/StoryCard.css");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__StoryCard_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10__StoryCard_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__config_constants__ = __webpack_require__("./src/config/constants.js");
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
















var StoryCard = function (_Component) {
  _inherits(StoryCard, _Component);

  function StoryCard() {
    _classCallCheck(this, StoryCard);

    return _possibleConstructorReturn(this, (StoryCard.__proto__ || Object.getPrototypeOf(StoryCard)).apply(this, arguments));
  }

  _createClass(StoryCard, [{
    key: "generateJSONLD",
    value: function generateJSONLD(story) {
      var image = story.primary_image && story.primary_image.base_image_url || story.social_image && story.social_image.base_image_url || __WEBPACK_IMPORTED_MODULE_8_assets_img_social_default_png___default.a;
      var authors = story.authors.map(function (author) {
        return {
          "@type": "Person",
          "name": author.display_name
        };
      });

      return "<script type=\"application/ld+json\">\n      " + JSON.stringify({
        "@context": "http://schema.org",
        "@type": "NewsArticle",
        "mainEntityOfPage": {
          "@type": "WebPage",
          "@id": story.permalink
        },
        "headline": story.headline,
        image: image,
        "datePublished": story.published_date,
        "author": authors,
        "publisher": {
          "@type": "Organization",
          "name": "Axios",
          "logo": {
            "@type": "ImageObject",
            "url": __WEBPACK_IMPORTED_MODULE_9_assets_img_large_logo_png___default.a
          }
        },
        "description": story.og_description,
        "articleSection": story.primary_section && story.primary_section.name
      }) + "\n    </script>";
    }
  }, {
    key: "render",
    value: function render() {
      var _props = this.props,
          story = _props.story,
          hideHeader = _props.hideHeader,
          hideFooter = _props.hideFooter,
          header = _props.header,
          storyType = _props.storyType,
          permalinkId = _props.permalinkId,
          index = _props.index;

      if (!story) return null;

      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_7_components_Library_ErrorBoundary__["a" /* default */],
        null,
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "div",
          {
            id: story.id,
            className: __WEBPACK_IMPORTED_MODULE_2_classnames___default()("story-card", __WEBPACK_IMPORTED_MODULE_10__StoryCard_css___default.a.root, this.props.className, story.slideIn ? __WEBPACK_IMPORTED_MODULE_10__StoryCard_css___default.a.slideIn : {}, story.template === __WEBPACK_IMPORTED_MODULE_11__config_constants__["h" /* FACTS_MATTER_TEMPLATE */] && __WEBPACK_IMPORTED_MODULE_10__StoryCard_css___default.a.factsMatter || story.is_featured && !__WEBPACK_IMPORTED_MODULE_3_selectn___default()("rubric.name", story) && __WEBPACK_IMPORTED_MODULE_10__StoryCard_css___default.a.featured) },
          storyType !== "newsletter" && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", { dangerouslySetInnerHTML: { __html: this.generateJSONLD(story) } }),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            "div",
            { className: __WEBPACK_IMPORTED_MODULE_2_classnames___default()("permalink", __WEBPACK_IMPORTED_MODULE_10__StoryCard_css___default.a.hide) },
            story.permalink
          ),
          !hideHeader && (header || __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__StoryHeader__["a" /* default */], { story: story })),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__StoryContent__["a" /* default */], { story: story, storyType: storyType, permalinkId: permalinkId, index: index }),
          !hideFooter && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__StoryFooter__["a" /* default */], { story: story })
        )
      );
    }
  }]);

  return StoryCard;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

StoryCard.propTypes = {
  story: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,
  storyType: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOf(["newsletter"]),
  hideHeader: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  hideFooter: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  header: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.element,
  className: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  permalinkId: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string
};

/* harmony default export */ __webpack_exports__["a"] = (StoryCard);

/***/ }),

/***/ "./src/components/Library/StoryContent/StoryContent.css":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"headline":"StoryContent__headline--2-2FM","featured":"StoryContent__featured--22hK-","bounce":"StoryContent__bounce--2KCYB"};

/***/ }),

/***/ "./src/components/Library/StoryContent/StoryContent.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__("./node_modules/react/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__("./node_modules/prop-types/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_selectn__ = __webpack_require__("./node_modules/selectn/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_selectn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_selectn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Headline__ = __webpack_require__("./src/components/Library/Headline/Headline.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__StoryBody__ = __webpack_require__("./src/components/Library/StoryBody/StoryBody.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__PrimaryImage__ = __webpack_require__("./src/components/Library/PrimaryImage/PrimaryImage.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__StoryContent_css__ = __webpack_require__("./src/components/Library/StoryContent/StoryContent.css");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__StoryContent_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__StoryContent_css__);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }










var StoryContent = function (_Component) {
  _inherits(StoryContent, _Component);

  function StoryContent() {
    _classCallCheck(this, StoryContent);

    return _possibleConstructorReturn(this, (StoryContent.__proto__ || Object.getPrototypeOf(StoryContent)).apply(this, arguments));
  }

  _createClass(StoryContent, [{
    key: "render",
    value: function render() {
      var _props = this.props,
          story = _props.story,
          isSummary = _props.isSummary,
          storyType = _props.storyType,
          permalinkId = _props.permalinkId,
          index = _props.index;

      if (!story) return null;
      var isFeatured = story.is_featured && !isSummary;

      var textOverStory = __WEBPACK_IMPORTED_MODULE_2_selectn___default()("rubric.name", story) || isFeatured && "Featured";
      var textOverColor = __WEBPACK_IMPORTED_MODULE_2_selectn___default()("rubric.hex_color", story);

      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "div",
        null,
        textOverStory && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "div",
          { className: __WEBPACK_IMPORTED_MODULE_6__StoryContent_css___default.a.featured, style: textOverColor && { color: "#" + textOverColor } },
          textOverStory
        ),
        story.headline && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__Headline__["a" /* default */], { headline: story.headline, permalink: story.permalink, noLink: !isSummary }),
        !isSummary && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__PrimaryImage__["a" /* default */], { image: story.primary_image, lazyload: index !== 0 }),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__StoryBody__["a" /* default */], { story: story, storyType: storyType, permalinkId: permalinkId })
      );
    }
  }]);

  return StoryContent;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

StoryContent.propTypes = {
  story: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,
  storyType: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOf(["newsletter"]),
  isSummary: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  permalinkId: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string
};

/* harmony default export */ __webpack_exports__["a"] = (StoryContent);

/***/ }),

/***/ "./src/components/Library/StoryFooter/StoryFooter.css":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"root":"StoryFooter__root--1dV2E","center":"StoryFooter__center--3mtm-","icon":"StoryFooter__icon--2--K0","section":"StoryFooter__section--1mAV5","primary":"StoryFooter__primary--1UxmJ","bounce":"StoryFooter__bounce--11Q1R"};

/***/ }),

/***/ "./src/components/Library/StoryFooter/StoryFooter.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__("./node_modules/react/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__("./node_modules/react-redux/es/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_classnames__ = __webpack_require__("./node_modules/classnames/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_selectn__ = __webpack_require__("./node_modules/selectn/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_selectn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_selectn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Icon__ = __webpack_require__("./src/components/Library/Icon/Icon.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__SocialIcons__ = __webpack_require__("./src/components/Library/SocialIcons/SocialIcons.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__actions_storiesStream__ = __webpack_require__("./src/actions/storiesStream.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__StoryFooter_css__ = __webpack_require__("./src/components/Library/StoryFooter/StoryFooter.css");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__StoryFooter_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__StoryFooter_css__);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }












var StoryFooter = function (_Component) {
  _inherits(StoryFooter, _Component);

  function StoryFooter() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, StoryFooter);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = StoryFooter.__proto__ || Object.getPrototypeOf(StoryFooter)).call.apply(_ref, [this].concat(args))), _this), _this.onReadAnother = function () {
      var section = _this.getSection();
      _this.props.loadNextStory({ stream: section.slug }, _this.props.story.id, _this.getLoadedStoriesForStream(section.slug)).then(function () {
        return _this.scrollToStory(_this.props.story.id);
      });
    }, _this.getLoadedStoriesForStream = function (stream) {
      return _this.props.storiesStream.results.filter(function (story) {
        return __WEBPACK_IMPORTED_MODULE_3_selectn___default()("primary_section.slug", story) === stream || story.sections.map(function (section) {
          return section.slug;
        }).includes(stream);
      }).map(function (story) {
        return story.id;
      });
    }, _this.scrollToStory = function (id) {
      try {
        var element = document.getElementById(id);
        if (element) {
          var nextArticle = element.closest("[role='article']").nextSibling;
          var isAdvert = nextArticle.children[0].classList.contains("advert-card");
          if (isAdvert) {
            var bounds = nextArticle.getBoundingClientRect();
            window.scrollBy(0, bounds.height + 100);
          }
        }
      } catch (e) {
        // Ignore error
      }
    }, _this.getSection = function () {
      return _this.props.story.primary_section || __WEBPACK_IMPORTED_MODULE_3_selectn___default()("sections[0]", _this.props.story);
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(StoryFooter, [{
    key: "render",
    value: function render() {
      var story = this.props.story;
      if (!story) return null;
      var section = this.getSection();

      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "div",
        { className: __WEBPACK_IMPORTED_MODULE_2_classnames___default()(__WEBPACK_IMPORTED_MODULE_7__StoryFooter_css___default.a.root, !section ? __WEBPACK_IMPORTED_MODULE_7__StoryFooter_css___default.a.center : {}) },
        section && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "div",
          { className: __WEBPACK_IMPORTED_MODULE_2_classnames___default()(__WEBPACK_IMPORTED_MODULE_7__StoryFooter_css___default.a.section, "gtm-read-another"), onClick: this.onReadAnother },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__Icon__["a" /* default */], {
            name: "plus-box",
            description: "Plus box",
            path: "img",
            className: __WEBPACK_IMPORTED_MODULE_7__StoryFooter_css___default.a.icon }),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            "div",
            { role: "link", "aria-label": "Read another " + section.name + " story", className: __WEBPACK_IMPORTED_MODULE_7__StoryFooter_css___default.a.primary },
            section.name
          )
        ),
        story.permalink && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__SocialIcons__["a" /* default */], {
          permalink: story.permalink,
          headline: story.headline
        })
      );
    }
  }]);

  return StoryFooter;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

var mapStateToProps = function mapStateToProps(state) {
  return {
    storiesStream: state.storiesStream
  };
};

/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1_react_redux__["b" /* connect */])(mapStateToProps, { loadNextStory: __WEBPACK_IMPORTED_MODULE_6__actions_storiesStream__["c" /* loadNextStory */] })(StoryFooter));

/***/ }),

/***/ "./src/components/Library/StoryHeader/StoryHeader.css":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"root":"StoryHeader__root--1qbLT","icon":"StoryHeader__icon--QKyJm","profile":"StoryHeader__profile--2m8a_","bylinePhoto":"StoryHeader__bylinePhoto--1gS0W StoryHeader__icon--QKyJm","author":"StoryHeader__author--3R4v5","date":"StoryHeader__date--1ij89","bounce":"StoryHeader__bounce--3lKol"};

/***/ }),

/***/ "./src/components/Library/StoryHeader/StoryHeader.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__("./node_modules/react/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_router_dom__ = __webpack_require__("./node_modules/react-router-dom/es/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__ProfileIcon__ = __webpack_require__("./src/components/Library/ProfileIcon/ProfileIcon.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__SaveTag__ = __webpack_require__("./src/components/Library/SaveTag/SaveTag.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__utils_formatPublishedDate__ = __webpack_require__("./src/utils/formatPublishedDate.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__StoryHeader_css__ = __webpack_require__("./src/components/Library/StoryHeader/StoryHeader.css");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__StoryHeader_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__StoryHeader_css__);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }









var StoryHeader = function (_Component) {
  _inherits(StoryHeader, _Component);

  function StoryHeader() {
    _classCallCheck(this, StoryHeader);

    return _possibleConstructorReturn(this, (StoryHeader.__proto__ || Object.getPrototypeOf(StoryHeader)).apply(this, arguments));
  }

  _createClass(StoryHeader, [{
    key: "render",
    value: function render() {
      var story = this.props.story;
      if (!story) return null;
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "div",
        { className: __WEBPACK_IMPORTED_MODULE_5__StoryHeader_css___default.a.root },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "div",
          { className: __WEBPACK_IMPORTED_MODULE_5__StoryHeader_css___default.a.profile },
          story.byline_photo ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("img", { src: story.byline_photo, role: "presentation", alt: "", className: __WEBPACK_IMPORTED_MODULE_5__StoryHeader_css___default.a.bylinePhoto }) : __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__ProfileIcon__["a" /* default */], { className: __WEBPACK_IMPORTED_MODULE_5__StoryHeader_css___default.a.icon }),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            "div",
            null,
            story.authors && story.authors.map(function (author, index) {
              return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_1_react_router_dom__["a" /* Link */],
                { key: author.username, to: "/authors/" + author.username, className: __WEBPACK_IMPORTED_MODULE_5__StoryHeader_css___default.a.author },
                author.display_name,
                index < story.authors.length - 1 && ", "
              );
            }),
            " ",
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              "span",
              { className: __WEBPACK_IMPORTED_MODULE_5__StoryHeader_css___default.a.date },
              Object(__WEBPACK_IMPORTED_MODULE_4__utils_formatPublishedDate__["a" /* default */])(story)
            )
          )
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__SaveTag__["a" /* default */], { storyId: story.id })
      );
    }
  }]);

  return StoryHeader;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

/* harmony default export */ __webpack_exports__["a"] = (StoryHeader);

/***/ }),

/***/ "./src/components/Library/StreamAd/StreamAd.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__("./node_modules/react/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__("./node_modules/prop-types/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_components_Library_Ad__ = __webpack_require__("./src/components/Library/Ad/Ad.js");
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }





if (typeof window !== "undefined") {
  __webpack_require__.e/* import() */(0).then(__webpack_require__.bind(null, "./node_modules/lazysizes/lazysizes.js"));
}

var StreamAd = function (_Component) {
  _inherits(StreamAd, _Component);

  function StreamAd(props) {
    _classCallCheck(this, StreamAd);

    var _this = _possibleConstructorReturn(this, (StreamAd.__proto__ || Object.getPrototypeOf(StreamAd)).call(this, props));

    _this.onLazyload = _this._onLazyload.bind(_this);

    // Don't lazyload (read; automatically load) the first ad. props.advert.index is 1-indexed.
    _this.state = { shouldLoad: props.advert.index === 1 };
    return _this;
  }

  _createClass(StreamAd, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      document.addEventListener("lazybeforeunveil", this.onLazyload);
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      document.removeEventListener("lazybeforeunveil", this.onLazyload);
    }
  }, {
    key: "_onLazyload",
    value: function _onLazyload(e) {
      if (this.node === e.target) {
        this.setState({ shouldLoad: true });
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "div",
        { className: "lazyload advert-card", "data-expand": "1000", ref: function ref(node) {
            return _this2.node = node;
          } },
        this.state.shouldLoad && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_components_Library_Ad__["a" /* default */], {
          adUnit: this.props.stream,
          slotSize: "fluid",
          renderWhenViewable: false,
          collapseEmptyDiv: true,
          targeting: {
            "s1": this.props.stream,
            "pos": "mid" + this.props.advert.index,
            "pid": this.props.advert.postIds,
            "kw-before": this.props.advert.beforeTags,
            "kw-after": this.props.advert.afterTags,
            "adid": this.props.adId || ""
          }
        })
      );
    }
  }]);

  return StreamAd;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

StreamAd.propTypes = {
  advert: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object.isRequired,
  stream: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string.isRequired,
  adId: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string
};

/* harmony default export */ __webpack_exports__["a"] = (StreamAd);

/***/ }),

/***/ "./src/components/Library/Subscribe/Subscribe.css":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"subscribing":"Subscribe__subscribing--2ICoB","input":"Subscribe__input--3Ggbg","lightInput":"Subscribe__lightInput--2v3Bn","submit":"Subscribe__submit--pSClF","submitIcon":"Subscribe__submitIcon--eDQ-V","subscribe":"Subscribe__subscribe--3j3K1","subscribed":"Subscribe__subscribed--rf9C3 Subscribe__subscribe--3j3K1","lightButton":"Subscribe__lightButton--1aQdC","check":"Subscribe__check--1pu6O","lightCheck":"Subscribe__lightCheck--KcwRe","bounce":"Subscribe__bounce--2l1Zq"};

/***/ }),

/***/ "./src/components/Library/Subscribe/Subscribe.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__("./node_modules/react/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__("./node_modules/prop-types/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_redux__ = __webpack_require__("./node_modules/react-redux/es/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_classnames__ = __webpack_require__("./node_modules/classnames/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Icon__ = __webpack_require__("./src/components/Library/Icon/Icon.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_Library_SubscribeButton__ = __webpack_require__("./src/components/Library/SubscribeButton/SubscribeButton.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__actions_user__ = __webpack_require__("./src/actions/user.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__utils_localdb__ = __webpack_require__("./src/utils/localdb.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__Subscribe_css__ = __webpack_require__("./src/components/Library/Subscribe/Subscribe.css");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__Subscribe_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__Subscribe_css__);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }













var Subscribe = function (_Component) {
  _inherits(Subscribe, _Component);

  function Subscribe(props) {
    _classCallCheck(this, Subscribe);

    var _this = _possibleConstructorReturn(this, (Subscribe.__proto__ || Object.getPrototypeOf(Subscribe)).call(this, props));

    _this.onChange = function (event) {
      _this.setState(_defineProperty({}, event.target.name, event.target.value));
    };

    _this.onSubscribing = function () {
      _this.setState({ subscribing: true });
    };

    _this.onSubscribe = function () {
      if (_this.props.isLoggedIn) {
        _this.props.updateUserSubscriptions(_this.props.user.subscriptions, _this.props.subscription);
      } else {
        _this.props.updateUnAuthedSubscriptions(_this.state.email, [_this.props.subscription.id]).then(function () {
          Object(__WEBPACK_IMPORTED_MODULE_7__utils_localdb__["c" /* setLocalItem */])("AxiosSubscriptions", [].concat(_toConsumableArray(Object(__WEBPACK_IMPORTED_MODULE_7__utils_localdb__["a" /* getLocalItem */])("AxiosSubscriptions") || []), [_this.props.subscription.id]), { expires: 30 });
        });
      }
      _this.setState({
        subscribing: false,
        alreadySubscribedTo: [].concat(_toConsumableArray(_this.state.alreadySubscribedTo), [_this.props.subscription.id])
      });
    };

    _this.state = {
      subscribing: false,
      alreadySubscribedTo: [],
      email: ""
    };
    return _this;
  }

  _createClass(Subscribe, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      if (!this.props.isLoggedIn) {
        var alreadySubscribedTo = Object(__WEBPACK_IMPORTED_MODULE_7__utils_localdb__["a" /* getLocalItem */])("AxiosSubscriptions");
        this.setState({ alreadySubscribedTo: alreadySubscribedTo || [] });
      } else if (this.props.user) {
        this.setState({ alreadySubscribedTo: this.props.user.subscriptions.map(function (s) {
            return s.id;
          }) });
      }
    }
  }, {
    key: "componentWillReceiveProps",
    value: function componentWillReceiveProps(nextProps) {
      if (this.props.isLoggedIn && !this.props.user && nextProps.user) {
        this.setState({ alreadySubscribedTo: nextProps.user.subscriptions.map(function (s) {
            return s.id;
          }) });
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _props = this.props,
          subscription = _props.subscription,
          light = _props.light;

      if (!subscription) return null;
      var isSubscribed = this.state.alreadySubscribedTo.includes(subscription.id);

      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "div",
        { className: this.props.className },
        this.state.subscribing ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "div",
          { className: __WEBPACK_IMPORTED_MODULE_8__Subscribe_css___default.a.subscribing },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("input", {
            name: "email",
            "aria-label": "Enter Your Email Address",
            className: __WEBPACK_IMPORTED_MODULE_3_classnames___default()(__WEBPACK_IMPORTED_MODULE_8__Subscribe_css___default.a.input, light && __WEBPACK_IMPORTED_MODULE_8__Subscribe_css___default.a.lightInput),
            placeholder: "Your Email Address",
            value: this.state.email,
            onChange: this.onChange
          }),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            "button",
            { className: __WEBPACK_IMPORTED_MODULE_8__Subscribe_css___default.a.submit, alt: "Subscribe", onClick: this.onSubscribe },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__Icon__["a" /* default */], { name: "chevron/right", className: __WEBPACK_IMPORTED_MODULE_8__Subscribe_css___default.a.submitIcon })
          )
        ) : isSubscribed ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_5__components_Library_SubscribeButton__["a" /* default */],
          {
            className: __WEBPACK_IMPORTED_MODULE_3_classnames___default()(__WEBPACK_IMPORTED_MODULE_8__Subscribe_css___default.a.subscribed, light && __WEBPACK_IMPORTED_MODULE_8__Subscribe_css___default.a.lightButton),
            disabled: true },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__Icon__["a" /* default */], { name: "check/rounded", className: __WEBPACK_IMPORTED_MODULE_3_classnames___default()(__WEBPACK_IMPORTED_MODULE_8__Subscribe_css___default.a.check, light && __WEBPACK_IMPORTED_MODULE_8__Subscribe_css___default.a.lightCheck) }),
          "Subscribed"
        ) : __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_5__components_Library_SubscribeButton__["a" /* default */],
          {
            className: __WEBPACK_IMPORTED_MODULE_3_classnames___default()(__WEBPACK_IMPORTED_MODULE_8__Subscribe_css___default.a.subscribe, light && __WEBPACK_IMPORTED_MODULE_8__Subscribe_css___default.a.lightButton),
            onClickSubscribe: this.props.isLoggedIn ? this.onSubscribe : this.onSubscribing,
            disabled: this.state.subscribing && this.state.email === "" },
          "Subscribe"
        )
      );
    }
  }]);

  return Subscribe;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

var mapStateToProps = function mapStateToProps(state) {
  return {
    user: state.user.data,
    isLoggedIn: !!state.authDrawer.authToken // TODO: implement this when user stuff is done
  };
};

Subscribe.propTypes = {
  subscription: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,
  isLoggedIn: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool.isRequired,
  light: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool
};

/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_2_react_redux__["b" /* connect */])(mapStateToProps, { updateUnAuthedSubscriptions: __WEBPACK_IMPORTED_MODULE_6__actions_user__["b" /* updateUnAuthedSubscriptions */], updateUserSubscriptions: __WEBPACK_IMPORTED_MODULE_6__actions_user__["c" /* updateUserSubscriptions */] })(Subscribe));

/***/ }),

/***/ "./src/components/Library/SubscribeButton/SubscribeButton.css":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"subscribe":"SubscribeButton__subscribe--CvS7a","bounce":"SubscribeButton__bounce--1JLQQ"};

/***/ }),

/***/ "./src/components/Library/SubscribeButton/SubscribeButton.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__("./node_modules/react/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__("./node_modules/prop-types/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_classnames__ = __webpack_require__("./node_modules/classnames/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__SubscribeButton_css__ = __webpack_require__("./src/components/Library/SubscribeButton/SubscribeButton.css");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__SubscribeButton_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__SubscribeButton_css__);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }







var SubscribeButton = function (_Component) {
  _inherits(SubscribeButton, _Component);

  function SubscribeButton() {
    _classCallCheck(this, SubscribeButton);

    return _possibleConstructorReturn(this, (SubscribeButton.__proto__ || Object.getPrototypeOf(SubscribeButton)).apply(this, arguments));
  }

  _createClass(SubscribeButton, [{
    key: "render",
    value: function render() {
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "button",
        {
          className: __WEBPACK_IMPORTED_MODULE_2_classnames___default()(__WEBPACK_IMPORTED_MODULE_3__SubscribeButton_css___default.a.subscribe, this.props.className),
          onClick: this.props.onClickSubscribe,
          disabled: this.props.disabled,
          alt: "Subscribe" },
        this.props.children
      );
    }
  }]);

  return SubscribeButton;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

SubscribeButton.propTypes = {
  children: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.any,
  className: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  onClickSubscribe: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
  disabled: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool
};

SubscribeButton.defaultProps = {
  disabled: false
};

/* harmony default export */ __webpack_exports__["a"] = (SubscribeButton);

/***/ }),

/***/ "./src/components/Library/SummaryCard/SummaryCard.css":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"root":"SummaryCard__root--1IB_B","image":"SummaryCard__image--FZmeA","bounce":"SummaryCard__bounce--2zSpK"};

/***/ }),

/***/ "./src/components/Library/SummaryCard/SummaryCard.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__("./node_modules/react/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_selectn__ = __webpack_require__("./node_modules/selectn/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_selectn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_selectn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__StoryContent__ = __webpack_require__("./src/components/Library/StoryContent/StoryContent.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__SaveTag__ = __webpack_require__("./src/components/Library/SaveTag/SaveTag.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__SummaryCard_css__ = __webpack_require__("./src/components/Library/SummaryCard/SummaryCard.css");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__SummaryCard_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__SummaryCard_css__);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }




// import PrimaryImage from "../PrimaryImage";





var SummaryCard = function (_Component) {
  _inherits(SummaryCard, _Component);

  function SummaryCard() {
    _classCallCheck(this, SummaryCard);

    return _possibleConstructorReturn(this, (SummaryCard.__proto__ || Object.getPrototypeOf(SummaryCard)).apply(this, arguments));
  }

  _createClass(SummaryCard, [{
    key: "render",
    value: function render() {
      var story = this.props.story;
      if (!story) return null;
      var image = __WEBPACK_IMPORTED_MODULE_1_selectn___default()("primary_image.crops.1x1.url", story);

      var summary = _extends({}, story, {
        blocks: _extends({}, story.blocks, {
          blocks: [story.blocks.blocks[0]]
        })
      });

      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "div",
        { key: story.id, className: __WEBPACK_IMPORTED_MODULE_4__SummaryCard_css___default.a.root },
        this.props.showSaveTag ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__SaveTag__["a" /* default */], { storyId: story.id, absolute: true }) : null,
        image && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("img", { className: __WEBPACK_IMPORTED_MODULE_4__SummaryCard_css___default.a.image, src: image, alt: story.primary_image.alt_text }),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__StoryContent__["a" /* default */], { story: summary, isSummary: true })
      );
    }
  }]);

  return SummaryCard;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

/* harmony default export */ __webpack_exports__["a"] = (SummaryCard);

/***/ }),

/***/ "./src/components/Library/UserHeader/UserHeader.css":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"header":"UserHeader__header--3I3es","content":"UserHeader__content--3ARYM","avatar":"UserHeader__avatar--35Eky","displayName":"UserHeader__displayName--eulDr","bioContainer":"UserHeader__bioContainer--3wnaB","bio":"UserHeader__bio--3Ruer","socialIcons":"UserHeader__socialIcons--Jwta6","icon":"UserHeader__icon--phWeW","bounce":"UserHeader__bounce--1akYi"};

/***/ }),

/***/ "./src/components/Library/UserHeader/UserHeader.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__("./node_modules/react/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__("./node_modules/prop-types/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Icon__ = __webpack_require__("./src/components/Library/Icon/Icon.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__UserHeader_css__ = __webpack_require__("./src/components/Library/UserHeader/UserHeader.css");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__UserHeader_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__UserHeader_css__);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }







var UserHeader = function (_Component) {
  _inherits(UserHeader, _Component);

  function UserHeader() {
    _classCallCheck(this, UserHeader);

    return _possibleConstructorReturn(this, (UserHeader.__proto__ || Object.getPrototypeOf(UserHeader)).apply(this, arguments));
  }

  _createClass(UserHeader, [{
    key: "render",
    value: function render() {
      var person = this.props.person;


      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "div",
        { className: __WEBPACK_IMPORTED_MODULE_3__UserHeader_css___default.a.header },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "div",
          { className: __WEBPACK_IMPORTED_MODULE_3__UserHeader_css___default.a.content },
          person.avatar_url ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("img", { src: person.avatar_url, alt: "Profile picture", className: __WEBPACK_IMPORTED_MODULE_3__UserHeader_css___default.a.avatar }) : __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__Icon__["a" /* default */], { name: "avatar", path: "img", description: "Avatar Placeholder", className: __WEBPACK_IMPORTED_MODULE_3__UserHeader_css___default.a.avatar }),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            "div",
            { className: __WEBPACK_IMPORTED_MODULE_3__UserHeader_css___default.a.displayName },
            person.display_name
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            "div",
            { className: __WEBPACK_IMPORTED_MODULE_3__UserHeader_css___default.a.bioContainer },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              "div",
              { className: __WEBPACK_IMPORTED_MODULE_3__UserHeader_css___default.a.bio },
              person.bio_line
            ),
            person.social_profiles ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              "div",
              { className: __WEBPACK_IMPORTED_MODULE_3__UserHeader_css___default.a.socialIcons },
              person.social_profiles.facebook ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                "a",
                { target: "_blank", href: person.social_profiles.facebook },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__Icon__["a" /* default */], { name: "facebook-inverse", path: "img", description: "facebook", className: __WEBPACK_IMPORTED_MODULE_3__UserHeader_css___default.a.icon })
              ) : null,
              person.social_profiles.twitter ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                "a",
                { target: "_blank", href: person.social_profiles.twitter },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__Icon__["a" /* default */], { name: "twitter-inverse", path: "img", description: "twitter", className: __WEBPACK_IMPORTED_MODULE_3__UserHeader_css___default.a.icon })
              ) : null,
              person.social_profiles.linkedin ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                "a",
                { target: "_blank", href: person.social_profiles.linkedin },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__Icon__["a" /* default */], { name: "linkedin-inverse", path: "img", description: "linkedin", className: __WEBPACK_IMPORTED_MODULE_3__UserHeader_css___default.a.icon })
              ) : null,
              person.social_profiles.instagram ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                "a",
                { target: "_blank", href: person.social_profiles.instagram },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__Icon__["a" /* default */], { name: "instagram-inverse", path: "img", description: "instagram", className: __WEBPACK_IMPORTED_MODULE_3__UserHeader_css___default.a.icon })
              ) : null
            ) : null
          )
        )
      );
    }
  }]);

  return UserHeader;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

UserHeader.propTypes = {
  person: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object.isRequired
};

/* harmony default export */ __webpack_exports__["a"] = (UserHeader);

/***/ }),

/***/ "./src/config/constants.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return BREAKPOINT_DOWN_SMALL; });
/* unused harmony export BREAKPOINT_UP_MEDIUM */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return BREAKPOINT_DOWN_MEDIUM; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return BACKEND_ROOT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return FRONTEND_ROOT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "k", function() { return IS_PROD; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return API_ROOT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return EVENTS_API; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return BLOCK_TYPE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "m", function() { return STYLE_TYPE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return ENTITY_TYPE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "n", function() { return URL_ID_REGEXP; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "l", function() { return RAVEN_DSN; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return FACTS_MATTER_TEMPLATE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return FB_JS_SDK_VERSION; });
// Breakpoints
var BREAKPOINT_DOWN_SMALL = "(max-width: 767px)";
var BREAKPOINT_UP_MEDIUM = "(min-width: 1025px)";
var BREAKPOINT_DOWN_MEDIUM = "(max-width: 1024px)";

var BACKEND_ROOT = void 0;
var FRONTEND_ROOT = void 0;

var IS_PROD = ["production", "staging"].includes("production");

switch ("production") {
  case "production":
    BACKEND_ROOT = "https://api.axios.com";
    FRONTEND_ROOT = "https://www.axios.com";
    break;
  case "staging":
    BACKEND_ROOT = "https://api-stage.axios.com";
    FRONTEND_ROOT = "https://firstorder-stage.axios.com";
    break;
  default:
    BACKEND_ROOT = "http://localhost:8000";
    FRONTEND_ROOT = "http://localhost:3006";
    break;
}

var API_ROOT = BACKEND_ROOT + "/api/render/";

var EVENTS_API = "https://eventsdata.axios.com/upcoming-events.json";

// Draft js
var BLOCK_TYPE = {
  EMBED: "embed",
  KEEP_READING: "keep-reading",
  QUOTE_ATTRIBUTION: "quote-attribution",
  STYLED_QUOTE: "styled-quote"
};

var STYLE_TYPE = {
  BOLD: "bold",
  ITALIC: "italic"
};

var ENTITY_TYPE = {
  LINK: "link"
};

var URL_ID_REGEXP = "([0-9a-f]{8}-[0-9a-f]{4}-[1-5][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}|[0-9]+)";

// "Musical Meerkat" key - the default key's secret component was exposed to GitHub
var RAVEN_DSN = "https://1b87f5b715e44d8496741fe423b7c3de@sentry.io/247977";

var FACTS_MATTER_TEMPLATE = "00000000-0000-0000-0003-000000000001";

var FB_JS_SDK_VERSION = "2.12";

/***/ }),

/***/ "./src/constants/actionTypes.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "K", function() { return GET_SECTIONS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "M", function() { return GET_SECTIONS_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "L", function() { return GET_SECTIONS_ERROR; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_31", function() { return SET_SECTION; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "J", function() { return GET_SECTION; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "O", function() { return GET_SECTION_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "N", function() { return GET_SECTION_ERROR; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_28", function() { return SET_LAST_SEEN; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "P", function() { return GET_SPECIAL_FEATURES; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "R", function() { return GET_SPECIAL_FEATURES_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Q", function() { return GET_SPECIAL_FEATURES_ERROR; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_9", function() { return GET_TAG; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_10", function() { return GET_TAG_ERROR; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return AUTH_DRAWER_OPEN; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return CHANGE_STEP; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "o", function() { return EMAIL_NOT_AVAILABLE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "l", function() { return EMAIL_AVAILABLE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "p", function() { return EMAIL_VALIDATION_REQUEST_ERROR; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "n", function() { return EMAIL_CONFIRM_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "m", function() { return EMAIL_CONFIRM_ERROR; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_27", function() { return SET_BASIC_INFO; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_29", function() { return SET_OPTIONAL_INFO; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return CREATE_USER_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return CREATE_USER_ERROR; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_23", function() { return PASSWORD_RESET_REQUEST_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_22", function() { return PASSWORD_RESET_REQUEST_ERROR; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_30", function() { return SET_PASSWORD_RESET_INFO; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_24", function() { return PASSWORD_RESET_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_21", function() { return PASSWORD_RESET_ERROR; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_26", function() { return SET_AUTH_TOKEN; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_20", function() { return LOG_OUT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_19", function() { return LOGGED_IN_STATUS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_12", function() { return GET_TRENDING_TOPICS_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_11", function() { return GET_TRENDING_TOPICS_ERROR; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_45", function() { return TOGGLE_OFFSET; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "w", function() { return GET_LATEST_STORIES; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "y", function() { return GET_LATEST_STORIES_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "x", function() { return GET_LATEST_STORIES_ERROR; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "S", function() { return GET_STORIES_STREAM; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "U", function() { return GET_STORIES_STREAM_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "V", function() { return GET_STORIES_STREAM_UPDATE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "T", function() { return GET_STORIES_STREAM_ERROR; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_25", function() { return RESET_STORIES_STREAM_ERROR; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_32", function() { return SET_STORY_STREAM; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "W", function() { return GET_STORY; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Y", function() { return GET_STORY_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Z", function() { return GET_STORY_UPDATE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "X", function() { return GET_STORY_ERROR; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "q", function() { return GET_AUTHOR; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "s", function() { return GET_AUTHOR_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "r", function() { return GET_AUTHOR_ERROR; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_0", function() { return GET_SUBSCRIPTION; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_8", function() { return GET_SUBSCRIPTION_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_4", function() { return GET_SUBSCRIPTION_ERROR; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_1", function() { return GET_SUBSCRIPTIONS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_3", function() { return GET_SUBSCRIPTIONS_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_2", function() { return GET_SUBSCRIPTIONS_ERROR; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_5", function() { return GET_SUBSCRIPTION_NEWSLETTERS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_7", function() { return GET_SUBSCRIPTION_NEWSLETTERS_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_6", function() { return GET_SUBSCRIPTION_NEWSLETTERS_ERROR; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "z", function() { return GET_NEWSLETTER; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "E", function() { return GET_NEWSLETTER_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "D", function() { return GET_NEWSLETTER_ERROR; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "A", function() { return GET_NEWSLETTERS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "C", function() { return GET_NEWSLETTERS_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "B", function() { return GET_NEWSLETTERS_ERROR; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "F", function() { return GET_SEARCH_RESULTS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "H", function() { return GET_SEARCH_RESULTS_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "I", function() { return GET_SEARCH_RESULTS_UPDATE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "G", function() { return GET_SEARCH_RESULTS_ERROR; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_13", function() { return GET_USER_DATA; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_15", function() { return GET_USER_DATA_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_14", function() { return GET_USER_DATA_ERROR; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_46", function() { return TYPING_USER_SETTINGS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_39", function() { return SUBMIT_USER_SETTINGS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_41", function() { return SUBMIT_USER_SETTINGS_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_40", function() { return SUBMIT_USER_SETTINGS_ERROR; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_16", function() { return GET_USER_SUBSCRIPTIONS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_18", function() { return GET_USER_SUBSCRIPTIONS_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_17", function() { return GET_USER_SUBSCRIPTIONS_ERROR; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return CHANGE_USER_SUBSCRIPTIONS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_42", function() { return SUBMIT_USER_SUBSCRIPTIONS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_44", function() { return SUBMIT_USER_SUBSCRIPTIONS_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_43", function() { return SUBMIT_USER_SUBSCRIPTIONS_ERROR; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_36", function() { return SUBMIT_USER_SAVED_STORIES; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_38", function() { return SUBMIT_USER_SAVED_STORIES_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_37", function() { return SUBMIT_USER_SAVED_STORIES_ERROR; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return DELETE_ACCOUNT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "k", function() { return DELETE_ACCOUNT_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return DELETE_ACCOUNT_ERROR; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return CHANGE_PASSWORD; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return CHANGE_PASSWORD_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return CHANGE_PASSWORD_ERROR; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_33", function() { return SET_UNAUTHED_SUBSCRIPTIONS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_35", function() { return SET_UNAUTHED_SUBSCRIPTIONS_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_34", function() { return SET_UNAUTHED_SUBSCRIPTIONS_ERROR; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_47", function() { return UPDATE_USER_SUBSCRIPTIONS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_49", function() { return UPDATE_USER_SUBSCRIPTIONS_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_48", function() { return UPDATE_USER_SUBSCRIPTIONS_ERROR; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "t", function() { return GET_EVENTS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "v", function() { return GET_EVENTS_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "u", function() { return GET_EVENTS_ERROR; });
// Navigation
var GET_SECTIONS = "GET_SECTIONS";
var GET_SECTIONS_SUCCESS = "GET_SECTIONS_SUCCESS";
var GET_SECTIONS_ERROR = "GET_SECTIONS_ERROR";
var SET_SECTION = "SET_SECTION";
var GET_SECTION = "GET_SECTION";
var GET_SECTION_SUCCESS = "GET_SECTION_SUCCESS";
var GET_SECTION_ERROR = "GET_SECTION_ERROR";
var SET_LAST_SEEN = "SET_LAST_SEEN";

var GET_SPECIAL_FEATURES = "GET_SPECIAL_FEATURES";
var GET_SPECIAL_FEATURES_SUCCESS = "GET_SPECIAL_FEATURES_SUCCESS";
var GET_SPECIAL_FEATURES_ERROR = "GET_SPECIAL_FEATURES_ERROR";

// Tag
var GET_TAG = "GET_TAG";
var GET_TAG_ERROR = "GET_TAG_ERROR";

// Auth Drawer
var AUTH_DRAWER_OPEN = "AUTH_DRAWER_OPEN";
var CHANGE_STEP = "CHANGE_STEP";

var EMAIL_NOT_AVAILABLE = "EMAIL_NOT_AVAILABLE";
var EMAIL_AVAILABLE = "EMAIL_AVAILABLE";
var EMAIL_VALIDATION_REQUEST_ERROR = "EMAIL_VALIDATION_REQUEST_ERROR";

var EMAIL_CONFIRM_SUCCESS = "EMAIL_CONFIRM_SUCCESS";
var EMAIL_CONFIRM_ERROR = "EMAIL_CONFIRM_ERROR";

var SET_BASIC_INFO = "SET_BASIC_INFO";
var SET_OPTIONAL_INFO = "SET_OPTIONAL_INFO";

var CREATE_USER_SUCCESS = "CREATE_USER_SUCCESS";
var CREATE_USER_ERROR = "CREATE_USER_ERROR";

var PASSWORD_RESET_REQUEST_SUCCESS = "PASSWORD_RESET_REQUEST_SUCCESS";
var PASSWORD_RESET_REQUEST_ERROR = "PASSWORD_RESET_REQUEST_ERROR";
var SET_PASSWORD_RESET_INFO = "SET_PASSWORD_RESET_INFO";
var PASSWORD_RESET_SUCCESS = "PASSWORD_RESET_SUCCESS";
var PASSWORD_RESET_ERROR = "PASSWORD_RESET_ERROR";

var SET_AUTH_TOKEN = "SET_AUTH_TOKEN";
var LOG_OUT = "LOG_OUT";

var LOGGED_IN_STATUS = "LOGGED_IN_STATUS";

// Trending
var GET_TRENDING_TOPICS_SUCCESS = "GET_TRENDING_TOPICS_SUCCESS";
var GET_TRENDING_TOPICS_ERROR = "GET_TRENDING_TOPICS_ERROR";
var TOGGLE_OFFSET = "TOGGLE_OFFSET";

// Latest
var GET_LATEST_STORIES = "GET_LATEST_STORIES";
var GET_LATEST_STORIES_SUCCESS = "GET_LATEST_STORIES_SUCCESS";
var GET_LATEST_STORIES_ERROR = "GET_LATEST_STORIES_ERROR";

// Stream
var GET_STORIES_STREAM = "GET_STORIES_STREAM";
var GET_STORIES_STREAM_SUCCESS = "GET_STORIES_STREAM_SUCCESS";
var GET_STORIES_STREAM_UPDATE = "GET_STORIES_STREAM_UPDATE";
var GET_STORIES_STREAM_ERROR = "GET_STORIES_STREAM_ERROR";
var RESET_STORIES_STREAM_ERROR = "RESET_STORIES_STREAM_ERROR";
var SET_STORY_STREAM = "SET_STORY_STREAM";

// Story
var GET_STORY = "GET_STORY";
var GET_STORY_SUCCESS = "GET_STORY_SUCCESS";
var GET_STORY_UPDATE = "GET_STORY_UPDATE";
var GET_STORY_ERROR = "GET_STORY_ERROR";

// Author
var GET_AUTHOR = "GET_AUTHOR";
var GET_AUTHOR_SUCCESS = "GET_AUTHOR_SUCCESS";
var GET_AUTHOR_ERROR = "GET_AUTHOR_ERROR";

// Subscription
var GET_SUBSCRIPTION = "GET_SUBSCRIPTION";
var GET_SUBSCRIPTION_SUCCESS = "GET_SUBSCRIPTION_SUCCESS";
var GET_SUBSCRIPTION_ERROR = "GET_SUBSCRIPTION_ERROR";

// Subscriptions
var GET_SUBSCRIPTIONS = "GET_SUBSCRIPTIONS";
var GET_SUBSCRIPTIONS_SUCCESS = "GET_SUBSCRIPTIONS_SUCCESS";
var GET_SUBSCRIPTIONS_ERROR = "GET_SUBSCRIPTIONS_ERROR";

// Subscription Newsletters
var GET_SUBSCRIPTION_NEWSLETTERS = "GET_SUBSCRIPTION_NEWSLETTERS";
var GET_SUBSCRIPTION_NEWSLETTERS_SUCCESS = "GET_SUBSCRIPTION_NEWSLETTERS_SUCCESS";
var GET_SUBSCRIPTION_NEWSLETTERS_ERROR = "GET_SUBSCRIPTION_NEWSLETTERS_ERROR";

// Newsletter
var GET_NEWSLETTER = "GET_NEWSLETTER";
var GET_NEWSLETTER_SUCCESS = "GET_NEWSLETTER_SUCCESS";
var GET_NEWSLETTER_ERROR = "GET_NEWSLETTER_ERROR";

// Newsletters
var GET_NEWSLETTERS = "GET_NEWSLETTERS";
var GET_NEWSLETTERS_SUCCESS = "GET_NEWSLETTERS_SUCCESS";
var GET_NEWSLETTERS_ERROR = "GET_NEWSLETTERS_ERROR";

// Search
var GET_SEARCH_RESULTS = "GET_SEARCH_RESULTS";
var GET_SEARCH_RESULTS_SUCCESS = "GET_SEARCH_RESULTS_SUCCESS";
var GET_SEARCH_RESULTS_UPDATE = "GET_SEARCH_RESULTS_UPDATE";
var GET_SEARCH_RESULTS_ERROR = "GET_SEARCH_RESULTS_ERROR";

// User Settings
var GET_USER_DATA = "GET_USER_DATA";
var GET_USER_DATA_SUCCESS = "GET_USER_DATA_SUCCESS";
var GET_USER_DATA_ERROR = "GET_USER_DATA_ERROR";

var TYPING_USER_SETTINGS = "TYPING_USER_SETTINGS";
var SUBMIT_USER_SETTINGS = "SUBMIT_USER_SETTINGS";
var SUBMIT_USER_SETTINGS_SUCCESS = "SUBMIT_USER_SETTINGS_SUCCESS";
var SUBMIT_USER_SETTINGS_ERROR = "SUBMIT_USER_SETTINGS_ERROR";

var GET_USER_SUBSCRIPTIONS = "GET_USER_SUBSCRIPTIONS";
var GET_USER_SUBSCRIPTIONS_SUCCESS = "GET_USER_SUBSCRIPTIONS_SUCCESS";
var GET_USER_SUBSCRIPTIONS_ERROR = "GET_USER_SUBSCRIPTIONS_ERROR";
var CHANGE_USER_SUBSCRIPTIONS = "CHANGE_USER_SUBSCRIPTIONS";
var SUBMIT_USER_SUBSCRIPTIONS = "SUBMIT_USER_SUBSCRIPTIONS";
var SUBMIT_USER_SUBSCRIPTIONS_SUCCESS = "SUBMIT_USER_SUBSCRIPTIONS_SUCCESS";
var SUBMIT_USER_SUBSCRIPTIONS_ERROR = "SUBMIT_USER_SUBSCRIPTIONS_ERROR";

var SUBMIT_USER_SAVED_STORIES = "SUBMIT_USER_SAVED_STORIES";
var SUBMIT_USER_SAVED_STORIES_SUCCESS = "SUBMIT_USER_SAVED_STORIES_SUCCESS";
var SUBMIT_USER_SAVED_STORIES_ERROR = "SUBMIT_USER_SAVED_STORIES_ERROR";

var DELETE_ACCOUNT = "DELETE_ACCOUNT";
var DELETE_ACCOUNT_SUCCESS = "DELETE_ACCOUNT_SUCCESS";
var DELETE_ACCOUNT_ERROR = "DELETE_ACCOUNT_ERROR";

var CHANGE_PASSWORD = "CHANGE_PASSWORD";
var CHANGE_PASSWORD_SUCCESS = "CHANGE_PASSWORD_SUCCESS";
var CHANGE_PASSWORD_ERROR = "CHANGE_PASSWORD_ERROR";

// Unauthed Subscriptions
var SET_UNAUTHED_SUBSCRIPTIONS = "SET_UNAUTHED_SUBSCRIPTIONS";
var SET_UNAUTHED_SUBSCRIPTIONS_SUCCESS = "SET_UNAUTHED_SUBSCRIPTIONS_SUCCESS";
var SET_UNAUTHED_SUBSCRIPTIONS_ERROR = "SET_UNAUTHED_SUBSCRIPTIONS_ERROR";

// User Subscriptions
var UPDATE_USER_SUBSCRIPTIONS = "UPDATE_USER_SUBSCRIPTIONS";
var UPDATE_USER_SUBSCRIPTIONS_SUCCESS = "UPDATE_USER_SUBSCRIPTIONS_SUCCESS";
var UPDATE_USER_SUBSCRIPTIONS_ERROR = "UPDATE_USER_SUBSCRIPTIONS_ERROR";

// Events
var GET_EVENTS = "GET_EVENTS";
var GET_EVENTS_SUCCESS = "GET_EVENTS_SUCCESS";
var GET_EVENTS_ERROR = "GET_EVENTS_ERROR";

/***/ }),

/***/ "./src/constants/authDrawer.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return FRAME_NAME; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "m", function() { return SIGNIN; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return REGISTER1; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "k", function() { return REGISTER2; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "l", function() { return REGISTER3; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return FORGOTPASSWORD1; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return FORGOTPASSWORD2; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return FORGOTPASSWORD3; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return FORGOTPASSWORD4; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return CLIENT_ID; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return AUTH_URL; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return LOGOUT_URL; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return INDUSTRIES; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_query_string__ = __webpack_require__("./node_modules/query-string/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_query_string___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_query_string__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__config_constants__ = __webpack_require__("./src/config/constants.js");



var FRAME_NAME = "authframe";

var SIGNIN = "SIGNIN";

var REGISTER1 = "REGISTER1";
var REGISTER2 = "REGISTER2";
var REGISTER3 = "REGISTER3";

var FORGOTPASSWORD1 = "FORGOTPASSWORD1";
var FORGOTPASSWORD2 = "FORGOTPASSWORD2";
var FORGOTPASSWORD3 = "FORGOTPASSWORD3";
var FORGOTPASSWORD4 = "FORGOTPASSWORD4";

var CLIENT_ID = void 0;
switch ("production") {
  case "production":
    CLIENT_ID = "platform-site-prod";
    break;
  default:
    // staging and development use the same client id
    CLIENT_ID = "platform-site";
}

// Build auth URL as query string
var authObj = {
  client_id: CLIENT_ID,
  redirect_uri: encodeURI(__WEBPACK_IMPORTED_MODULE_1__config_constants__["j" /* FRONTEND_ROOT */] + "/authorize"),
  scope: "read write",
  response_type: "token",
  state: Date.now()
};

var AUTH_URL = __WEBPACK_IMPORTED_MODULE_1__config_constants__["b" /* BACKEND_ROOT */] + "/o/authorize/?" + __WEBPACK_IMPORTED_MODULE_0_query_string___default.a.stringify(authObj);

var LOGOUT_URL = __WEBPACK_IMPORTED_MODULE_1__config_constants__["b" /* BACKEND_ROOT */] + "/logout/";

var INDUSTRIES = ["Aerospace / Defense", "Agency", "Agriculture", "Architecture / Engineering / Construction", "Banking / Financial Services / Insurance", "Education", "Energy / Environment / Utilities", "Government", "Healthcare / Pharmaceuticals", "Hospitality", "Manufacturing", "Media / Entertainment", "Not For Profit", "Other", "Professional Services", "Retail / Consumer", "Technology / Telecommunications"];

/***/ }),

/***/ "./src/dashboard/components/NotFound/NotFound.css":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"root":"NotFound__root--1gmEq","icon":"NotFound__icon--1LhfZ","description":"NotFound__description--1zPLg","button":"NotFound__button--nFr0l","bounce":"NotFound__bounce--13piK"};

/***/ }),

/***/ "./src/dashboard/components/NotFound/NotFound.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = NotFound;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__("./node_modules/react/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_router_dom__ = __webpack_require__("./node_modules/react-router-dom/es/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_Library_Icon__ = __webpack_require__("./src/components/Library/Icon/Icon.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__NotFound_css__ = __webpack_require__("./src/dashboard/components/NotFound/NotFound.css");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__NotFound_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__NotFound_css__);






function NotFound() {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    "div",
    { className: __WEBPACK_IMPORTED_MODULE_3__NotFound_css___default.a.root },
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__components_Library_Icon__["a" /* default */], { name: "confused-person", description: "Confused person image", path: "img", className: __WEBPACK_IMPORTED_MODULE_3__NotFound_css___default.a.icon }),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      "div",
      { className: __WEBPACK_IMPORTED_MODULE_3__NotFound_css___default.a.description },
      "404! In other words, something went wrong."
    ),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      __WEBPACK_IMPORTED_MODULE_1_react_router_dom__["a" /* Link */],
      { to: "/", className: __WEBPACK_IMPORTED_MODULE_3__NotFound_css___default.a.button },
      "Read top stories"
    )
  );
}

/***/ }),

/***/ "./src/dashboard/components/TopStories/SmarterFaster.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__("./node_modules/react/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__TopStories_css__ = __webpack_require__("./src/dashboard/components/TopStories/TopStories.css");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__TopStories_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__TopStories_css__);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }





var SmarterFaster = function (_Component) {
  _inherits(SmarterFaster, _Component);

  function SmarterFaster() {
    _classCallCheck(this, SmarterFaster);

    return _possibleConstructorReturn(this, (SmarterFaster.__proto__ || Object.getPrototypeOf(SmarterFaster)).apply(this, arguments));
  }

  _createClass(SmarterFaster, [{
    key: "render",
    value: function render() {
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "div",
        { className: __WEBPACK_IMPORTED_MODULE_1__TopStories_css___default.a.smarterFaster },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("img", { src: __webpack_require__("./src/assets/img/smarter-faster@3x.png"), alt: "Smarter Faster Heading" }),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "div",
          { className: __WEBPACK_IMPORTED_MODULE_1__TopStories_css___default.a.section },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            "i",
            null,
            "Thank you to JPMorgan Chase & Co. for underwriting the Axios Smarter Faster series, featuring leaders explaining the ideas shaping their lives and worldviews. This series contains both underwritten videos, over which Axios retains full editorial control, and branded videos co-created by Axios on behalf of JPMorgan Chase & Co. Videos are labeled accordingly below."
          )
        )
      );
    }
  }]);

  return SmarterFaster;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

/* harmony default export */ __webpack_exports__["a"] = (SmarterFaster);

/***/ }),

/***/ "./src/dashboard/components/TopStories/TopStories.css":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"trending":"TopStories__trending--MLOxP","content":"TopStories__content--3hCQq","unread":"TopStories__unread--2TuS9","section":"TopStories__section--1t5W8","smarterFaster":"TopStories__smarterFaster--2jOK5","tag":"TopStories__tag--D715d","bounce":"TopStories__bounce--2B7gq"};

/***/ }),

/***/ "./src/dashboard/components/TopStories/TopStories.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__("./node_modules/react/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__("./node_modules/prop-types/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_redux__ = __webpack_require__("./node_modules/react-redux/es/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_router_dom__ = __webpack_require__("./node_modules/react-router-dom/es/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_query_string__ = __webpack_require__("./node_modules/query-string/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_query_string___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_query_string__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_selectn__ = __webpack_require__("./node_modules/selectn/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_selectn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_selectn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_lodash_debounce__ = __webpack_require__("./node_modules/lodash/debounce.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_lodash_debounce___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_lodash_debounce__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_classnames__ = __webpack_require__("./node_modules/classnames/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__config_constants__ = __webpack_require__("./src/config/constants.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__actions_storiesStream__ = __webpack_require__("./src/actions/storiesStream.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__actions_authDrawer__ = __webpack_require__("./src/actions/authDrawer.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__components_Library_Header__ = __webpack_require__("./src/components/Library/Header/Header.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__components_Library_Layout__ = __webpack_require__("./src/components/Library/Layout/Layout.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__components_Library_Layout_Sidebar__ = __webpack_require__("./src/components/Library/Layout/Sidebar.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__components_Library_Layout_Content__ = __webpack_require__("./src/components/Library/Layout/Content.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__components_Library_LatestStories__ = __webpack_require__("./src/components/Library/LatestStories/LatestStories.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__components_Library_StoriesStream__ = __webpack_require__("./src/components/Library/StoriesStream/StoriesStream.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__SmarterFaster__ = __webpack_require__("./src/dashboard/components/TopStories/SmarterFaster.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__constants_authDrawer__ = __webpack_require__("./src/constants/authDrawer.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__utils_analytics__ = __webpack_require__("./src/utils/analytics.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__TopStories_css__ = __webpack_require__("./src/dashboard/components/TopStories/TopStories.css");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__TopStories_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_20__TopStories_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21_styles_global_css__ = __webpack_require__("./src/styles/global.css");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21_styles_global_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_21_styles_global_css__);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }


























var TopStories = function (_Component) {
  _inherits(TopStories, _Component);

  function TopStories(props) {
    _classCallCheck(this, TopStories);

    var _this = _possibleConstructorReturn(this, (TopStories.__proto__ || Object.getPrototypeOf(TopStories)).call(this, props));

    _initialiseProps.call(_this);

    _this.loadNextStories = _this.loadNextStories.bind(_this);
    return _this;
  }

  _createClass(TopStories, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this.scrollListener = __WEBPACK_IMPORTED_MODULE_6_lodash_debounce___default()(this.handleScroll, 50);
      window.addEventListener("scroll", this.scrollListener);

      var parsedQs = this.props.location ? __WEBPACK_IMPORTED_MODULE_4_query_string___default.a.parse(this.props.location.search) : null;

      // If reset_password_token is present in the query string, open the drawer and point to the new password option
      if (parsedQs && parsedQs.reset_password_token) {
        this.props.changeStep(__WEBPACK_IMPORTED_MODULE_18__constants_authDrawer__["e" /* FORGOTPASSWORD3 */]);
        this.props.toggleAuthDrawer(true);
        this.props.setPasswordResetInfo(parsedQs.reset_password_token, parsedQs.email);
      }

      // If email_confirmation_token is present, confirm the email
      if (parsedQs && parsedQs.email_confirmation_token && parsedQs.email) {
        this.props.confirmEmail(parsedQs.email_confirmation_token, parsedQs.email);
      }
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      window.removeEventListener("scroll", this.scrollListener);
    }
  }, {
    key: "loadNextStories",
    value: function loadNextStories(page) {
      return this.props.getStoriesStream(this.getParams(this.props, this.state, page), true);
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      var unread = 0;
      var isSmarterFaster = this.props.section && this.props.section.slug === "smarter-faster";

      this.props.lastSeen && this.props.storiesStream.results.slice(0, 21).map(function (story, index) {
        if (_this2.props.lastSeen === story.id) {
          unread = index;
        }
      });

      var header = this.getHeader();
      var sectionName = __WEBPACK_IMPORTED_MODULE_5_selectn___default()("section.name", this.props) || this.props.onlyShowSectionForA11y && "Stories";

      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_12__components_Library_Layout__["a" /* default */],
        { includeHeader: !!header, headerComponent: header },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_13__components_Library_Layout_Sidebar__["a" /* default */],
          null,
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15__components_Library_LatestStories__["a" /* default */], null)
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_14__components_Library_Layout_Content__["a" /* default */],
          { className: __WEBPACK_IMPORTED_MODULE_20__TopStories_css___default.a.content, ariaLabel: "Stories" },
          isSmarterFaster ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_17__SmarterFaster__["a" /* default */], null) : (sectionName || unread > 0) && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            "h2",
            { className: __WEBPACK_IMPORTED_MODULE_7_classnames___default()(__WEBPACK_IMPORTED_MODULE_20__TopStories_css___default.a.unread, _defineProperty({}, __WEBPACK_IMPORTED_MODULE_21_styles_global_css__["a11yOnly"], this.props.onlyShowSectionForA11y)) },
            sectionName || null,
            sectionName && unread > 0 && " / ",
            unread > 0 && (unread > 20 ? "20+" : unread) + " Unread Stor" + (unread === 1 ? "y" : "ies")
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_16__components_Library_StoriesStream__["a" /* default */], {
            stream: this.props.stream || "top",
            adId: this.props.adId,
            showAds: true,
            stories: this.props.storiesStream,
            lastSeenId: this.props.lastSeen,
            showUnread: true,
            next: this.props.loadNextPage || this.loadNextStories,
            permalinkId: this.props.permalinkId
          })
        )
      );
    }
  }]);

  return TopStories;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

var _initialiseProps = function _initialiseProps() {
  var _this3 = this;

  this.handleScroll = function () {
    var cards = document.getElementsByClassName("story-card");
    if (cards) {
      var _loop = function _loop(i) {
        var card = cards[i];

        if (__WEBPACK_IMPORTED_MODULE_19__utils_analytics__["a" /* default */].isStoryInView(card)) {

          // Find hidden permalink
          var permalink = card.getElementsByClassName("permalink");
          permalink = permalink && permalink.length && permalink[0].innerHTML;
          var to = permalink && permalink.replace(__WEBPACK_IMPORTED_MODULE_8__config_constants__["j" /* FRONTEND_ROOT */], "");

          // Change history if it's different from url
          if (to && window.location.pathname !== to) {
            history.pushState({}, "", to);

            setTimeout(function () {
              if (window.location.pathname === to) {
                var stream = _this3.props.stream || __WEBPACK_IMPORTED_MODULE_5_selectn___default()("match.params.tag", _this3.props) || "top";
                if (__WEBPACK_IMPORTED_MODULE_5_selectn___default()("story.id", _this3.props) === card.id) {
                  __WEBPACK_IMPORTED_MODULE_19__utils_analytics__["a" /* default */].userScrollsStoryIntoView({ story: _this3.props.story, stream: stream });
                } else {
                  var stories = _this3.props.storiesStream.results.filter(function (story) {
                    return story.id === card.id;
                  });
                  if (stories && stories.length) {
                    __WEBPACK_IMPORTED_MODULE_19__utils_analytics__["a" /* default */].userScrollsStoryIntoView({ story: stories[0], stream: stream });
                  }
                }
              }
            }, 3000);
          }
          return "break";
        }
      };

      for (var i = 0; i < cards.length; i++) {
        var _ret = _loop(i);

        if (_ret === "break") break;
      }
    }
  };

  this.getParams = function (props, state, page) {
    var section = props.section;
    var lastSeen = props.lastSeen;

    return Object.assign({}, page && { page: page } || {}, section && { stream: section.slug.toLowerCase() } || {}, lastSeen && { featured_return_id: lastSeen } || {});
  };

  this.getHeader = function () {
    if (!_this3.props.isTagPage) return null;
    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__components_Library_Header__["a" /* default */], { className: __WEBPACK_IMPORTED_MODULE_20__TopStories_css___default.a.tag, text: __WEBPACK_IMPORTED_MODULE_5_selectn___default()("section.name", _this3.props) });
  };
};

var mapStateToProps = function mapStateToProps(state) {
  return {
    story: state.storiesStream.data,
    storiesStream: state.storiesStream,
    sections: __WEBPACK_IMPORTED_MODULE_5_selectn___default()("navigation.results.sections", state),
    section: __WEBPACK_IMPORTED_MODULE_5_selectn___default()("navigation.data.section", state),
    lastSeen: __WEBPACK_IMPORTED_MODULE_5_selectn___default()("navigation.data.lastSeen", state)
  };
};

TopStories.propTypes = {
  storiesStream: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,
  stream: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  permalinkId: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  onlyShowSectionForA11y: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool
};

/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_3_react_router_dom__["e" /* withRouter */])(Object(__WEBPACK_IMPORTED_MODULE_2_react_redux__["b" /* connect */])(mapStateToProps, { getStoriesStream: __WEBPACK_IMPORTED_MODULE_9__actions_storiesStream__["a" /* getStoriesStream */], toggleAuthDrawer: __WEBPACK_IMPORTED_MODULE_10__actions_authDrawer__["toggleAuthDrawer"], confirmEmail: __WEBPACK_IMPORTED_MODULE_10__actions_authDrawer__["confirmEmail"], changeStep: __WEBPACK_IMPORTED_MODULE_10__actions_authDrawer__["changeStep"], setPasswordResetInfo: __WEBPACK_IMPORTED_MODULE_10__actions_authDrawer__["setPasswordResetInfo"] })(TopStories)));

/***/ }),

/***/ "./src/dashboard/containers/SectionStream/SectionStream.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__("./node_modules/react/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__("./node_modules/prop-types/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_helmet__ = __webpack_require__("./node_modules/react-helmet/lib/Helmet.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_helmet___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react_helmet__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_redux__ = __webpack_require__("./node_modules/react-redux/es/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_qs__ = __webpack_require__("./node_modules/qs/lib/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_qs___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_qs__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_dashboard_components_TopStories__ = __webpack_require__("./src/dashboard/components/TopStories/TopStories.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_actions_navigation__ = __webpack_require__("./src/actions/navigation.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_actions_storiesStream__ = __webpack_require__("./src/actions/storiesStream.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_config_constants__ = __webpack_require__("./src/config/constants.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_utils_localdb__ = __webpack_require__("./src/utils/localdb.js");
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }













var SectionStream = function (_React$Component) {
  _inherits(SectionStream, _React$Component);

  function SectionStream(props) {
    _classCallCheck(this, SectionStream);

    var _this = _possibleConstructorReturn(this, (SectionStream.__proto__ || Object.getPrototypeOf(SectionStream)).call(this, props));

    _this.loadNextPage = _this._loadNextPage.bind(_this);
    return _this;
  }

  _createClass(SectionStream, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      if (!this.props.section || !this.props.stories || !this.props.stories.length) {
        this.loadStream(this.props);
      } else {
        Object(__WEBPACK_IMPORTED_MODULE_9_utils_localdb__["c" /* setLocalItem */])("lastSeen", this.props.stories[0].id, { expires: 1 });
      }
    }
  }, {
    key: "componentWillReceiveProps",
    value: function componentWillReceiveProps(nextProps) {
      if (this.props.slug !== nextProps.slug || this.props.section !== nextProps.section && !nextProps.section) {
        this.loadStream(nextProps);
      }
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      // TODO: Remove this. Right now components that are rendered outside this
      // component so we need to unset it in state.
      this.props.setSection(null);
      this.props.setLastSeen(null);
      if (this.props.stories && this.props.stories.length) {
        this.props.setStoryStream([]);
      }
    }
  }, {
    key: "getStreamParams",
    value: function getStreamParams(props) {
      return {
        stream: props.slug,
        featured_return_id: props.lastSeen || Object(__WEBPACK_IMPORTED_MODULE_9_utils_localdb__["a" /* getLocalItem */])("lastSeen")
      };
    }
  }, {
    key: "loadStream",
    value: function loadStream(props) {
      this.props.getSection(props.slug);

      // Preserve the lastSeen ID in state when the stream gets loaded so the unread count works.
      this.props.setLastSeen(Object(__WEBPACK_IMPORTED_MODULE_9_utils_localdb__["a" /* getLocalItem */])("lastSeen"));

      return this.props.getStoriesStream(this.getStreamParams(props)).then(function (action) {
        // If there is a first article in the payload, set it as the lastSeen param.
        if (action && action.payload && action.payload[0]) {
          Object(__WEBPACK_IMPORTED_MODULE_9_utils_localdb__["c" /* setLocalItem */])("lastSeen", action.payload[0].id, { expires: 1 });
        }
      });
    }
  }, {
    key: "_loadNextPage",
    value: function _loadNextPage(page) {
      return this.props.getStoriesStream(_extends({
        page: page
      }, this.getStreamParams(this.props)), true);
    }
  }, {
    key: "render",
    value: function render() {
      var queryParams = __WEBPACK_IMPORTED_MODULE_4_qs___default.a.parse(this.props.location.search.slice(1));

      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "div",
        null,
        this.props.section && this.props.slug !== "top" && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_2_react_helmet__["Helmet"],
          null,
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            "title",
            null,
            this.props.section.name,
            " - Axios"
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("meta", { property: "og:url", content: __WEBPACK_IMPORTED_MODULE_8_config_constants__["j" /* FRONTEND_ROOT */] + "/" + this.props.section.slug + "/" }),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("meta", { property: "og:title", content: this.props.section.name + " on Axios" })
        ),
        this.props.section && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_2_react_helmet__["Helmet"],
          null,
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("link", { rel: "alternate", type: "application/rss+xml", title: "Axios", href: __WEBPACK_IMPORTED_MODULE_8_config_constants__["b" /* BACKEND_ROOT */] + "/feed/" + this.props.section.slug + "/" })
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_dashboard_components_TopStories__["a" /* default */], {
          loadNextPage: this.loadNextPage,
          stream: this.props.slug,
          adId: queryParams.adid
        })
      );
    }
  }]);

  return SectionStream;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

SectionStream.propTypes = {
  getSection: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,
  getStoriesStream: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,
  setSection: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
  setLastSeen: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,
  setStoryStream: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,
  slug: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string.isRequired
};

var mapStateToProps = function mapStateToProps(state) {
  return {
    section: state.navigation.data.section,
    lastSeen: state.navigation.data.lastSeen,
    stories: state.storiesStream.results
  };
};

var mapDispatchToProps = {
  getSection: __WEBPACK_IMPORTED_MODULE_6_actions_navigation__["getSection"],
  getStoriesStream: __WEBPACK_IMPORTED_MODULE_7_actions_storiesStream__["a" /* getStoriesStream */],
  setSection: __WEBPACK_IMPORTED_MODULE_6_actions_navigation__["setSection"],
  setLastSeen: __WEBPACK_IMPORTED_MODULE_6_actions_navigation__["setLastSeen"],
  setStoryStream: __WEBPACK_IMPORTED_MODULE_7_actions_storiesStream__["g" /* setStoryStream */]
};

/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_3_react_redux__["b" /* connect */])(mapStateToProps, mapDispatchToProps)(SectionStream));

/***/ }),

/***/ "./src/dashboard/containers/StoryPermalink/StoryPermalink.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__("./node_modules/react/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__("./node_modules/prop-types/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_redux__ = __webpack_require__("./node_modules/react-redux/es/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_helmet__ = __webpack_require__("./node_modules/react-helmet/lib/Helmet.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_helmet___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react_helmet__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_selectn__ = __webpack_require__("./node_modules/selectn/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_selectn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_selectn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_qs__ = __webpack_require__("./node_modules/qs/lib/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_qs___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_qs__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_dashboard_components_TopStories__ = __webpack_require__("./src/dashboard/components/TopStories/TopStories.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_actions_storiesStream__ = __webpack_require__("./src/actions/storiesStream.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_utils_localdb__ = __webpack_require__("./src/utils/localdb.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_utils_analytics__ = __webpack_require__("./src/utils/analytics.js");
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }













var StoryPermalink = function (_React$Component) {
  _inherits(StoryPermalink, _React$Component);

  function StoryPermalink(props) {
    _classCallCheck(this, StoryPermalink);

    var _this = _possibleConstructorReturn(this, (StoryPermalink.__proto__ || Object.getPrototypeOf(StoryPermalink)).call(this, props));

    _this.loadNextPage = _this._loadNextPage.bind(_this);
    return _this;
  }

  _createClass(StoryPermalink, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var params = __WEBPACK_IMPORTED_MODULE_5_qs___default.a.parse(this.props.location.search.slice(1));
      if (!this.props.stream.results.length || params.preview) {
        this.loadStream(this.props);
      } else if (this.props.stream.results && this.props.stream.results.length) {
        __WEBPACK_IMPORTED_MODULE_9_utils_analytics__["a" /* default */].storyPageView(this.props.stream.results[0]); // call analytics for SSRd page
      }
    }
  }, {
    key: "componentWillReceiveProps",
    value: function componentWillReceiveProps(nextProps) {
      if (this.props.match.params.id !== nextProps.match.params.id || this.props.stream.results.length && !nextProps.stream.results.length) {
        this.loadStream(nextProps);
      }
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      if (this.props.stream.results && this.props.stream.results.length) {
        this.props.setStoryStream([]);
      }
    }
  }, {
    key: "getStreamParams",
    value: function getStreamParams(props) {
      return { story: props.match.params.id };
    }
  }, {
    key: "loadStream",
    value: function loadStream(props) {
      var params = __WEBPACK_IMPORTED_MODULE_5_qs___default.a.parse(props.location.search.slice(1));
      var adminToken = Object(__WEBPACK_IMPORTED_MODULE_8_utils_localdb__["a" /* getLocalItem */])("adminToken");
      if (params.preview && adminToken) {
        if (params.revision) {
          return this.props.loadRevision(props.match.params.id, params.revision, adminToken);
        } else {
          return this.props.loadLatest(props.match.params.id, adminToken);
        }
      }

      return this.props.getStoriesStream(this.getStreamParams(props)).then(function (stream) {
        // Block default pageview in GTM and send a virtual pageview for permalink streams
        __WEBPACK_IMPORTED_MODULE_9_utils_analytics__["a" /* default */].storyPageView(stream.payload[0]);
      });
    }
  }, {
    key: "_loadNextPage",
    value: function _loadNextPage(page) {
      return this.props.getStoriesStream(_extends({
        page: page
      }, this.getStreamParams(this.props)), true);
    }
  }, {
    key: "render",
    value: function render() {
      var story = this.props.stream.results[0];
      if (!story) return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_dashboard_components_TopStories__["a" /* default */], null);

      var ogImage = __WEBPACK_IMPORTED_MODULE_4_selectn___default()("social_image.crops.16x9.url", story) || __WEBPACK_IMPORTED_MODULE_4_selectn___default()("primary_image.crops.16x9.url", story);
      var primaryTag = __WEBPACK_IMPORTED_MODULE_4_selectn___default()("primary_tag.name", story);
      var additionalTags = story.tags.map(function (tag) {
        return tag.name;
      });
      // stories converted from RM may not have primary tag
      var tagsForMeta = primaryTag ? [primaryTag].concat(_toConsumableArray(additionalTags)).join(", ") : additionalTags.join(", ");

      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "div",
        null,
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_3_react_helmet__["Helmet"],
          null,
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            "title",
            null,
            story.headline,
            " -\xA0Axios"
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("meta", { property: "og:url", content: story.permalink }),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("link", { rel: "canonical", href: story.permalink }),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("meta", { property: "og:title", content: story.og_headline || story.headline }),
          story.og_description && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("meta", { property: "og:description", content: story.og_description }),
          story.og_description && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("meta", { name: "description", content: story.og_description }),
          ogImage && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("meta", { property: "og:image", content: ogImage }),
          tagsForMeta && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("meta", { name: "keywords", content: tagsForMeta })
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_dashboard_components_TopStories__["a" /* default */], {
          permalinkId: this.props.match.params.id,
          loadNextPage: this.loadNextPage,
          onlyShowSectionForA11y: true
        })
      );
    }
  }]);

  return StoryPermalink;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

StoryPermalink.propTypes = {
  stream: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({
    results: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({
      headline: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string.isRequired,
      permalink: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string.isRequired,
      og_description: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
      og_image: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,
      primary_image: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,
      primary_tag: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,
      tags: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object)
    })).isRequired
  }),
  location: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({
    search: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string.isRequired
  }),
  match: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({
    params: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({
      id: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string.isRequired
    })
  }),
  getStoriesStream: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,
  loadLatest: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
  loadRevision: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func
};

var mapStateToProps = function mapStateToProps(state) {
  return {
    stream: state.storiesStream
  };
};

var mapDispatchToProps = {
  getStoriesStream: __WEBPACK_IMPORTED_MODULE_7_actions_storiesStream__["a" /* getStoriesStream */],
  loadLatest: __WEBPACK_IMPORTED_MODULE_7_actions_storiesStream__["b" /* loadLatest */],
  loadRevision: __WEBPACK_IMPORTED_MODULE_7_actions_storiesStream__["d" /* loadRevision */],
  setStoryStream: __WEBPACK_IMPORTED_MODULE_7_actions_storiesStream__["g" /* setStoryStream */]
};

/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_2_react_redux__["b" /* connect */])(mapStateToProps, mapDispatchToProps)(StoryPermalink));

/***/ }),

/***/ "./src/dashboard/containers/TagStream/TagStream.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__("./node_modules/react/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__("./node_modules/prop-types/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_redux__ = __webpack_require__("./node_modules/react-redux/es/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_helmet__ = __webpack_require__("./node_modules/react-helmet/lib/Helmet.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_helmet___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react_helmet__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_dashboard_components_TopStories__ = __webpack_require__("./src/dashboard/components/TopStories/TopStories.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_actions_storiesStream__ = __webpack_require__("./src/actions/storiesStream.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_actions_navigation__ = __webpack_require__("./src/actions/navigation.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_config_constants__ = __webpack_require__("./src/config/constants.js");
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }











var TagStream = function (_React$Component) {
  _inherits(TagStream, _React$Component);

  function TagStream(props) {
    _classCallCheck(this, TagStream);

    var _this = _possibleConstructorReturn(this, (TagStream.__proto__ || Object.getPrototypeOf(TagStream)).call(this, props));

    _this.loadNextPage = _this._loadNextPage.bind(_this);
    return _this;
  }

  _createClass(TagStream, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this.loadStream(this.props);
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      this.props.setSection(null);
      if (this.props.stream.results && this.props.stream.results.length) {
        this.props.setStoryStream([]);
      }
    }
  }, {
    key: "componentWillReceiveProps",
    value: function componentWillReceiveProps(nextProps) {
      if (this.props.match.params.tag !== nextProps.match.params.tag) {
        this.loadStream(nextProps);
      }
    }
  }, {
    key: "loadStream",
    value: function loadStream(props) {
      this.props.setSectionWithTag(props.match.params.tag);
      this.props.getStoriesStream({ stream: props.match.params.tag });
    }
  }, {
    key: "_loadNextPage",
    value: function _loadNextPage(page) {
      return this.props.getStoriesStream({
        page: page,
        stream: this.props.match.params.tag
      }, true);
    }
  }, {
    key: "render",
    value: function render() {
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "div",
        null,
        this.props.section && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_3_react_helmet__["Helmet"],
          null,
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            "title",
            null,
            this.props.section.name,
            " - Axios"
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("meta", { property: "og:url", content: __WEBPACK_IMPORTED_MODULE_7_config_constants__["j" /* FRONTEND_ROOT */] + "/tag/" + this.props.section.slug + "/" }),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("meta", { property: "og:title", content: this.props.section.name + " on Axios" })
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_dashboard_components_TopStories__["a" /* default */], {
          isTagPage: true,
          loadNextPage: this.loadNextPage,
          onlyShowSectionForA11y: true
        })
      );
    }
  }]);

  return TagStream;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

TagStream.propTypes = {
  match: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({
    params: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({
      tag: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string.isRequired
    })
  }),
  section: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,
  setSectionWithTag: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,
  getStoriesStream: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,
  setSection: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
  stream: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({
    results: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object).isRequired
  })
};

var mapStateToProps = function mapStateToProps(state) {
  return {
    section: state.navigation.data.section,
    stream: state.storiesStream
  };
};

var mapDispatchToProps = {
  setSectionWithTag: __WEBPACK_IMPORTED_MODULE_6_actions_navigation__["setSectionWithTag"],
  getStoriesStream: __WEBPACK_IMPORTED_MODULE_5_actions_storiesStream__["a" /* getStoriesStream */],
  setSection: __WEBPACK_IMPORTED_MODULE_6_actions_navigation__["setSection"],
  setStoryStream: __WEBPACK_IMPORTED_MODULE_5_actions_storiesStream__["g" /* setStoryStream */]
};

/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_2_react_redux__["b" /* connect */])(mapStateToProps, mapDispatchToProps)(TagStream));

/***/ }),

/***/ "./src/events/actions/events.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return getEvents; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__("./node_modules/axios/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__constants_actionTypes__ = __webpack_require__("./src/constants/actionTypes.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__config_constants__ = __webpack_require__("./src/config/constants.js");




var getEvents = function getEvents() {
  return function (dispatch) {
    dispatch({
      type: __WEBPACK_IMPORTED_MODULE_1__constants_actionTypes__["t" /* GET_EVENTS */]
    });

    return __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get(__WEBPACK_IMPORTED_MODULE_2__config_constants__["g" /* EVENTS_API */]).then(function (response) {
      dispatch({
        type: __WEBPACK_IMPORTED_MODULE_1__constants_actionTypes__["v" /* GET_EVENTS_SUCCESS */],
        payload: response.data
      });
    }).catch(function (err) {
      dispatch({
        type: __WEBPACK_IMPORTED_MODULE_1__constants_actionTypes__["u" /* GET_EVENTS_ERROR */],
        payload: err
      });
    });
  };
};

/***/ }),

/***/ "./src/events/components/Events/Events.css":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"events":"Events__events--127iO"};

/***/ }),

/***/ "./src/events/components/Events/Events.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__("./node_modules/react/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_Library_Header__ = __webpack_require__("./src/components/Library/Header/Header.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_Library_Layout__ = __webpack_require__("./src/components/Library/Layout/Layout.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_Library_Layout_Sidebar__ = __webpack_require__("./src/components/Library/Layout/Sidebar.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_Library_Layout_Content__ = __webpack_require__("./src/components/Library/Layout/Content.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__UpcomingEvents__ = __webpack_require__("./src/events/components/UpcomingEvents/UpcomingEvents.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__PassedEvents__ = __webpack_require__("./src/events/components/PassedEvents/PassedEvents.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__Events_css__ = __webpack_require__("./src/events/components/Events/Events.css");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__Events_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__Events_css__);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }












var Events = function (_Component) {
  _inherits(Events, _Component);

  function Events() {
    _classCallCheck(this, Events);

    return _possibleConstructorReturn(this, (Events.__proto__ || Object.getPrototypeOf(Events)).apply(this, arguments));
  }

  _createClass(Events, [{
    key: "render",
    value: function render() {
      var header = __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__components_Library_Header__["a" /* default */], { className: __WEBPACK_IMPORTED_MODULE_7__Events_css___default.a.events, text: "Events" });
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_2__components_Library_Layout__["a" /* default */],
        { includeHeader: true, headerComponent: header },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__components_Library_Layout_Sidebar__["a" /* default */], null),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_4__components_Library_Layout_Content__["a" /* default */],
          { ariaLabel: "Events" },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__UpcomingEvents__["a" /* default */], null),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__PassedEvents__["a" /* default */], { story: this.props.story })
        )
      );
    }
  }]);

  return Events;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

/* harmony default export */ __webpack_exports__["a"] = (Events);

/***/ }),

/***/ "./src/events/components/PassedEvents/PassedEvents.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__("./node_modules/react/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__("./node_modules/react-redux/es/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__actions_events__ = __webpack_require__("./src/events/actions/events.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__actions_storiesStream__ = __webpack_require__("./src/actions/storiesStream.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_Library_StoryCard__ = __webpack_require__("./src/components/Library/StoryCard/StoryCard.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_Library_StoriesStream__ = __webpack_require__("./src/components/Library/StoriesStream/StoriesStream.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_Library_SectionContainer__ = __webpack_require__("./src/components/Library/SectionContainer/SectionContainer.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_Library_Spinner__ = __webpack_require__("./src/components/Library/Spinner/Spinner.js");
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }











var PassedEvents = function (_Component) {
  _inherits(PassedEvents, _Component);

  function PassedEvents() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, PassedEvents);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = PassedEvents.__proto__ || Object.getPrototypeOf(PassedEvents)).call.apply(_ref, [this].concat(args))), _this), _this.loadNextStories = function (page) {
      return _this.props.getStoriesStream({ stream: "events", page: page }, true);
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(PassedEvents, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      if (!this.props.story) {
        this.props.getStoriesStream({ stream: "events" });
      }
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      if (this.props.storiesStream.results && this.props.storiesStream.results.length) {
        this.props.setStoryStream([]);
      }
    }
  }, {
    key: "componentWillReceiveProps",
    value: function componentWillReceiveProps(nextProps) {
      if (this.props.story && !nextProps.story) {
        this.props.getStoriesStream({ stream: "events" });
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _props = this.props,
          story = _props.story,
          storiesStream = _props.storiesStream;

      if (story) return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__components_Library_StoryCard__["a" /* default */], { story: story });

      if (storiesStream.isLoading && storiesStream.results.length === 0) return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__components_Library_Spinner__["a" /* default */], null);
      if (storiesStream.isFinished && storiesStream.results.length === 0) return null;

      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_6__components_Library_SectionContainer__["a" /* default */],
        { header: "Past Events" },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__components_Library_StoriesStream__["a" /* default */], {
          stories: this.props.storiesStream,
          isEvent: true,
          showUnread: false,
          next: this.loadNextStories
        })
      );
    }
  }]);

  return PassedEvents;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

var mapStateToProps = function mapStateToProps(state) {
  return {
    storiesStream: state.storiesStream,
    events: state.upcomingEvents
  };
};

var mapDispatchToProps = {
  getEvents: __WEBPACK_IMPORTED_MODULE_2__actions_events__["a" /* getEvents */],
  getStoriesStream: __WEBPACK_IMPORTED_MODULE_3__actions_storiesStream__["a" /* getStoriesStream */],
  setStoryStream: __WEBPACK_IMPORTED_MODULE_3__actions_storiesStream__["g" /* setStoryStream */]
};

/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1_react_redux__["b" /* connect */])(mapStateToProps, mapDispatchToProps)(PassedEvents));

/***/ }),

/***/ "./src/events/components/UpcomingEvents/UpcomingEvents.css":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"root":"UpcomingEvents__root--270vv","event":"UpcomingEvents__event--3NjS6","headline":"UpcomingEvents__headline--G-3Yc","date":"UpcomingEvents__date--sFRoP","description":"UpcomingEvents__description--bFPQm","image":"UpcomingEvents__image--1Iegc","separator":"UpcomingEvents__separator--23hhm","bounce":"UpcomingEvents__bounce--1pj2V"};

/***/ }),

/***/ "./src/events/components/UpcomingEvents/UpcomingEvents.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__("./node_modules/react/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__("./node_modules/react-redux/es/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_Library_SectionContainer__ = __webpack_require__("./src/components/Library/SectionContainer/SectionContainer.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__actions_events__ = __webpack_require__("./src/events/actions/events.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__UpcomingEvents_css__ = __webpack_require__("./src/events/components/UpcomingEvents/UpcomingEvents.css");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__UpcomingEvents_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__UpcomingEvents_css__);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }









var UpcomingEvents = function (_Component) {
  _inherits(UpcomingEvents, _Component);

  function UpcomingEvents() {
    _classCallCheck(this, UpcomingEvents);

    return _possibleConstructorReturn(this, (UpcomingEvents.__proto__ || Object.getPrototypeOf(UpcomingEvents)).apply(this, arguments));
  }

  _createClass(UpcomingEvents, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this.props.getEvents();
    }
  }, {
    key: "render",
    value: function render() {
      var events = this.props.events;

      if (!events.results.length) return null;

      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_2__components_Library_SectionContainer__["a" /* default */],
        { header: "Upcoming Events", className: __WEBPACK_IMPORTED_MODULE_4__UpcomingEvents_css___default.a.root },
        events.results.map(function (event, index) {
          return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            "div",
            { key: event.title + "-" + index },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              "div",
              { className: __WEBPACK_IMPORTED_MODULE_4__UpcomingEvents_css___default.a.event },
              event.artwork_url && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                "a",
                { target: "_blank", href: event.rsvp_link },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("img", { className: __WEBPACK_IMPORTED_MODULE_4__UpcomingEvents_css___default.a.image, src: event.artwork_url, alt: event.title })
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                "div",
                null,
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  "a",
                  { target: "_blank", href: event.rsvp_link, className: __WEBPACK_IMPORTED_MODULE_4__UpcomingEvents_css___default.a.headline },
                  event.title
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  "div",
                  { className: __WEBPACK_IMPORTED_MODULE_4__UpcomingEvents_css___default.a.date },
                  event.date
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  "div",
                  { className: __WEBPACK_IMPORTED_MODULE_4__UpcomingEvents_css___default.a.description },
                  event.description
                )
              )
            ),
            events.results.length - 1 !== index && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("hr", { className: __WEBPACK_IMPORTED_MODULE_4__UpcomingEvents_css___default.a.separator, "aria-hidden": true })
          );
        })
      );
    }
  }]);

  return UpcomingEvents;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

var mapStateToProps = function mapStateToProps(state) {
  return {
    events: state.upcomingEvents
  };
};

var mapDispatchToProps = {
  getEvents: __WEBPACK_IMPORTED_MODULE_3__actions_events__["a" /* getEvents */]
};

/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1_react_redux__["b" /* connect */])(mapStateToProps, mapDispatchToProps)(UpcomingEvents));

/***/ }),

/***/ "./src/events/reducers/events.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__constants_actionTypes__ = __webpack_require__("./src/constants/actionTypes.js");
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };



var initialState = {
  isLoading: false,
  isFinished: false,
  isError: false,
  error: null,
  data: null,
  results: []
};

/* harmony default export */ __webpack_exports__["a"] = (function () {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
  var action = arguments[1];

  switch (action.type) {
    case __WEBPACK_IMPORTED_MODULE_0__constants_actionTypes__["t" /* GET_EVENTS */]:
      {
        return _extends({}, state, {
          isLoading: true,
          isFinished: false,
          isError: false,
          error: null
        });
      }

    case __WEBPACK_IMPORTED_MODULE_0__constants_actionTypes__["v" /* GET_EVENTS_SUCCESS */]:
      {
        return _extends({}, state, {
          isLoading: false,
          isFinished: true,
          results: action.payload
        });
      }

    case __WEBPACK_IMPORTED_MODULE_0__constants_actionTypes__["u" /* GET_EVENTS_ERROR */]:
      {
        return _extends({}, state, {
          isLoading: false,
          isFinished: true,
          isError: true,
          error: action.payload
        });
      }

    default:
      {
        return state;
      }
  }
});

/***/ }),

/***/ "./src/polyfills.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_core_js_es6_promise__ = __webpack_require__("./node_modules/core-js/es6/promise.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_core_js_es6_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_core_js_es6_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_core_js_fn_object_assign__ = __webpack_require__("./node_modules/core-js/fn/object/assign.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_core_js_fn_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_core_js_fn_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_core_js_fn_object_values__ = __webpack_require__("./node_modules/core-js/fn/object/values.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_core_js_fn_object_values___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_core_js_fn_object_values__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_core_js_fn_string_starts_with__ = __webpack_require__("./node_modules/core-js/fn/string/starts-with.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_core_js_fn_string_starts_with___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_core_js_fn_string_starts_with__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_core_js_fn_array_includes__ = __webpack_require__("./node_modules/core-js/fn/array/includes.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_core_js_fn_array_includes___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_core_js_fn_array_includes__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_core_js_fn_array_from__ = __webpack_require__("./node_modules/core-js/fn/array/from.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_core_js_fn_array_from___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_core_js_fn_array_from__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_core_js_fn_array_fill__ = __webpack_require__("./node_modules/core-js/fn/array/fill.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_core_js_fn_array_fill___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_core_js_fn_array_fill__);








/***/ }),

/***/ "./src/reducers/authDrawer.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__constants_actionTypes__ = __webpack_require__("./src/constants/actionTypes.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_immutability_helper__ = __webpack_require__("./node_modules/immutability-helper/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_immutability_helper___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_immutability_helper__);



var initialState = {
  authDrawerOpen: false,
  step: "",
  emailAvailable: true,
  userData: {},
  authToken: "",
  passwordResetToken: "",
  passwordResetEmail: "",
  emailConfirmed: false,
  emailConfirmError: false
};

/* harmony default export */ __webpack_exports__["a"] = (function () {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
  var action = arguments[1];

  switch (action.type) {
    case __WEBPACK_IMPORTED_MODULE_0__constants_actionTypes__["a" /* AUTH_DRAWER_OPEN */]:
      {
        return Object.assign({}, state, {
          authDrawerOpen: action.payload
        });
      }

    case __WEBPACK_IMPORTED_MODULE_0__constants_actionTypes__["e" /* CHANGE_STEP */]:
      {
        return Object.assign({}, state, {
          step: action.payload
        });
      }

    case __WEBPACK_IMPORTED_MODULE_0__constants_actionTypes__["o" /* EMAIL_NOT_AVAILABLE */]:
      {
        return Object.assign({}, state, {
          emailAvailable: false
        });
      }

    case __WEBPACK_IMPORTED_MODULE_0__constants_actionTypes__["l" /* EMAIL_AVAILABLE */]:
      {
        return Object.assign({}, state, {
          emailAvailable: true
        });
      }

    case __WEBPACK_IMPORTED_MODULE_0__constants_actionTypes__["_27" /* SET_BASIC_INFO */]:
      {
        return Object.assign({}, state, {
          userData: action.payload
        });
      }

    case __WEBPACK_IMPORTED_MODULE_0__constants_actionTypes__["_29" /* SET_OPTIONAL_INFO */]:
      {
        return __WEBPACK_IMPORTED_MODULE_1_immutability_helper___default()(state, {
          userData: {
            $merge: action.payload
          }
        });
      }

    case __WEBPACK_IMPORTED_MODULE_0__constants_actionTypes__["h" /* CREATE_USER_SUCCESS */]:
      {
        return Object.assign({}, state, {
          authToken: action.payload["gigster-token"]
        });
      }

    case __WEBPACK_IMPORTED_MODULE_0__constants_actionTypes__["_30" /* SET_PASSWORD_RESET_INFO */]:
      {
        return Object.assign({}, state, {
          passwordResetToken: action.payload.token,
          passwordResetEmail: action.payload.email
        });
      }

    case __WEBPACK_IMPORTED_MODULE_0__constants_actionTypes__["_26" /* SET_AUTH_TOKEN */]:
      {
        return Object.assign({}, state, {
          authToken: action.payload,
          loggedIn: true
        });
      }

    case __WEBPACK_IMPORTED_MODULE_0__constants_actionTypes__["_20" /* LOG_OUT */]:
      {
        return Object.assign({}, state, {
          authToken: null,
          loggedIn: false
        });
      }

    case __WEBPACK_IMPORTED_MODULE_0__constants_actionTypes__["_19" /* LOGGED_IN_STATUS */]:
      {
        return Object.assign({}, state, {
          loggedIn: action.payload
        });
      }

    case __WEBPACK_IMPORTED_MODULE_0__constants_actionTypes__["n" /* EMAIL_CONFIRM_SUCCESS */]:
      {
        return Object.assign({}, state, {
          emailConfirmed: true
        });
      }

    case __WEBPACK_IMPORTED_MODULE_0__constants_actionTypes__["m" /* EMAIL_CONFIRM_ERROR */]:
      {
        return Object.assign({}, state, {
          emailConfirmError: true
        });
      }

    default:
      {
        return state;
      }
  }
});

/***/ }),

/***/ "./src/reducers/index.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_redux__ = __webpack_require__("./node_modules/redux/es/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__authDrawer__ = __webpack_require__("./src/reducers/authDrawer.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__author_reducers_authors__ = __webpack_require__("./src/author/reducers/authors.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__events_reducers_events__ = __webpack_require__("./src/events/reducers/events.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__latestStories__ = __webpack_require__("./src/reducers/latestStories.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__navigation__ = __webpack_require__("./src/reducers/navigation.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__subscriptions_reducers_newsletters__ = __webpack_require__("./src/subscriptions/reducers/newsletters.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__storiesStream__ = __webpack_require__("./src/reducers/storiesStream.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__subscriptions_reducers_subscriptions__ = __webpack_require__("./src/subscriptions/reducers/subscriptions.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__trending__ = __webpack_require__("./src/reducers/trending.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__search__ = __webpack_require__("./src/reducers/search.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__users_reducers_userSettings__ = __webpack_require__("./src/users/reducers/userSettings.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__user__ = __webpack_require__("./src/reducers/user.js");















/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_0_redux__["c" /* combineReducers */])({
  authDrawer: __WEBPACK_IMPORTED_MODULE_1__authDrawer__["a" /* default */],
  authors: __WEBPACK_IMPORTED_MODULE_2__author_reducers_authors__["a" /* default */],
  upcomingEvents: __WEBPACK_IMPORTED_MODULE_3__events_reducers_events__["a" /* default */],
  latestStories: __WEBPACK_IMPORTED_MODULE_4__latestStories__["a" /* default */],
  navigation: __WEBPACK_IMPORTED_MODULE_5__navigation__["a" /* default */],
  newsletters: __WEBPACK_IMPORTED_MODULE_6__subscriptions_reducers_newsletters__["a" /* default */],
  search: __WEBPACK_IMPORTED_MODULE_10__search__["a" /* default */],
  storiesStream: __WEBPACK_IMPORTED_MODULE_7__storiesStream__["a" /* default */],
  subscriptions: __WEBPACK_IMPORTED_MODULE_8__subscriptions_reducers_subscriptions__["a" /* default */],
  trending: __WEBPACK_IMPORTED_MODULE_9__trending__["a" /* default */],
  userSettings: __WEBPACK_IMPORTED_MODULE_11__users_reducers_userSettings__["a" /* default */],
  user: __WEBPACK_IMPORTED_MODULE_12__user__["a" /* default */]
}));

/***/ }),

/***/ "./src/reducers/latestStories.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__constants_actionTypes__ = __webpack_require__("./src/constants/actionTypes.js");
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };



var initialState = {
  isLoading: false,
  isFinished: false,
  isError: false,
  error: null,
  data: null,
  results: []
};

/* harmony default export */ __webpack_exports__["a"] = (function () {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
  var action = arguments[1];

  switch (action.type) {
    case __WEBPACK_IMPORTED_MODULE_0__constants_actionTypes__["w" /* GET_LATEST_STORIES */]:
      {
        return _extends({}, state, {
          isLoading: true,
          isFinished: false,
          isError: false,
          error: null
        });
      }

    case __WEBPACK_IMPORTED_MODULE_0__constants_actionTypes__["y" /* GET_LATEST_STORIES_SUCCESS */]:
      {
        return _extends({}, state, {
          isLoading: false,
          isFinished: true,
          results: action.payload
        });
      }

    case __WEBPACK_IMPORTED_MODULE_0__constants_actionTypes__["x" /* GET_LATEST_STORIES_ERROR */]:
      {
        return _extends({}, state, {
          isLoading: false,
          isFinished: true,
          isError: true,
          error: action.payload
        });
      }

    default:
      {
        return state;
      }
  }
});

/***/ }),

/***/ "./src/reducers/navigation.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_immutability_helper__ = __webpack_require__("./node_modules/immutability-helper/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_immutability_helper___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_immutability_helper__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__constants_actionTypes__ = __webpack_require__("./src/constants/actionTypes.js");
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };




var initialState = {
  isLoading: false,
  isFinished: false,
  isError: false,
  error: null,
  data: {},
  results: {
    sections: [],
    specialFeatures: []
  }
};

/* harmony default export */ __webpack_exports__["a"] = (function () {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
  var action = arguments[1];

  switch (action.type) {
    case __WEBPACK_IMPORTED_MODULE_1__constants_actionTypes__["K" /* GET_SECTIONS */]:
      {
        return _extends({}, state, {
          isLoading: true
        });
      }

    case __WEBPACK_IMPORTED_MODULE_1__constants_actionTypes__["M" /* GET_SECTIONS_SUCCESS */]:
      {
        var newState = _extends({}, state, {
          isFinished: true,
          isLoading: false,
          isError: false
        });

        return __WEBPACK_IMPORTED_MODULE_0_immutability_helper___default()(newState, {
          results: {
            $merge: {
              sections: action.payload
            }
          }
        });
      }

    case __WEBPACK_IMPORTED_MODULE_1__constants_actionTypes__["_31" /* SET_SECTION */]:
      {
        return _extends({}, state, {
          data: _extends({}, state.data, {
            section: action.section
          })
        });
      }

    case __WEBPACK_IMPORTED_MODULE_1__constants_actionTypes__["O" /* GET_SECTION_SUCCESS */]:
      return _extends({}, state, {
        data: _extends({}, state.data, {
          section: action.payload
        })
      });

    case __WEBPACK_IMPORTED_MODULE_1__constants_actionTypes__["_28" /* SET_LAST_SEEN */]:
      {
        return _extends({}, state, {
          data: _extends({}, state.data, {
            lastSeen: action.lastSeen
          })
        });
      }

    case __WEBPACK_IMPORTED_MODULE_1__constants_actionTypes__["L" /* GET_SECTIONS_ERROR */]:
      {
        return _extends({}, state, {
          isError: true,
          isLoading: false,
          isFinished: true,
          error: action.payload
        });
      }

    case __WEBPACK_IMPORTED_MODULE_1__constants_actionTypes__["P" /* GET_SPECIAL_FEATURES */]:
      {
        return _extends({}, state, {
          isLoading: true
        });
      }

    case __WEBPACK_IMPORTED_MODULE_1__constants_actionTypes__["R" /* GET_SPECIAL_FEATURES_SUCCESS */]:
      {
        var _newState = _extends({}, state, {
          isFinished: true,
          isLoading: false,
          isError: false
        });

        return __WEBPACK_IMPORTED_MODULE_0_immutability_helper___default()(_newState, {
          results: {
            $merge: {
              specialFeatures: action.payload
            }
          }
        });
      }

    case __WEBPACK_IMPORTED_MODULE_1__constants_actionTypes__["Q" /* GET_SPECIAL_FEATURES_ERROR */]:
      {
        return _extends({}, state, {
          isError: true,
          isLoading: false,
          isFinished: true,
          error: action.payload
        });
      }

    default:
      {
        return state;
      }
  }
});

/***/ }),

/***/ "./src/reducers/search.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__constants_actionTypes__ = __webpack_require__("./src/constants/actionTypes.js");
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };



var initialState = {
  isLoading: false,
  isFinished: false,
  isError: false,
  error: null,
  data: null,
  results: []
};

/* harmony default export */ __webpack_exports__["a"] = (function () {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
  var action = arguments[1];

  switch (action.type) {
    case __WEBPACK_IMPORTED_MODULE_0__constants_actionTypes__["F" /* GET_SEARCH_RESULTS */]:
      {
        return _extends({}, state, {
          isLoading: true,
          isFinished: false,
          isError: false,
          error: null
        });
      }

    case __WEBPACK_IMPORTED_MODULE_0__constants_actionTypes__["H" /* GET_SEARCH_RESULTS_SUCCESS */]:
      {
        return _extends({}, state, {
          isLoading: false,
          isFinished: true,
          results: action.payload
        });
      }

    case __WEBPACK_IMPORTED_MODULE_0__constants_actionTypes__["I" /* GET_SEARCH_RESULTS_UPDATE */]:
      {
        return _extends({}, state, {
          isLoading: false,
          isFinished: true,
          results: state.results.concat(action.payload)
        });
      }

    case __WEBPACK_IMPORTED_MODULE_0__constants_actionTypes__["G" /* GET_SEARCH_RESULTS_ERROR */]:
      {
        return _extends({}, state, {
          isLoading: false,
          isFinished: true,
          isError: true,
          error: action.payload
        });
      }

    default:
      {
        return state;
      }
  }
});

/***/ }),

/***/ "./src/reducers/storiesStream.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__constants_actionTypes__ = __webpack_require__("./src/constants/actionTypes.js");
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }



var initialState = {
  isLoading: false,
  isFinished: false,
  isError: false,
  error: null,
  data: null,
  results: []
};

/* harmony default export */ __webpack_exports__["a"] = (function () {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
  var action = arguments[1];

  switch (action.type) {
    case __WEBPACK_IMPORTED_MODULE_0__constants_actionTypes__["W" /* GET_STORY */]:
      {
        return _extends({}, state, {
          isLoading: false,
          isFinished: false,
          isError: false,
          error: null
        });
      }

    case __WEBPACK_IMPORTED_MODULE_0__constants_actionTypes__["S" /* GET_STORIES_STREAM */]:
      {
        return _extends({}, state, {
          isLoading: true,
          isFinished: false,
          isError: false,
          error: null
        });
      }

    case __WEBPACK_IMPORTED_MODULE_0__constants_actionTypes__["Z" /* GET_STORY_UPDATE */]:
      {
        var data = _extends({}, action.payload, { slideIn: !!action.position });
        var results = [].concat(_toConsumableArray(state.results));

        // If story is already in stream, remove it
        var exists = results.findIndex(function (element) {
          return element.id === action.payload.id;
        });
        if (exists >= 0) {
          results.splice(exists, 1);
        }

        // Find index of parent story
        var index = results.findIndex(function (element) {
          return element.id === action.position;
        });

        // Insert story after parent story
        results.splice(index + 1, 0, data);

        return _extends({}, state, {
          isLoading: false,
          isFinished: true,
          results: results
        });
      }

    case __WEBPACK_IMPORTED_MODULE_0__constants_actionTypes__["Y" /* GET_STORY_SUCCESS */]:
      return _extends({}, state, {
        isLoading: false,
        isFinished: true,
        results: [action.payload]
      });

    case __WEBPACK_IMPORTED_MODULE_0__constants_actionTypes__["U" /* GET_STORIES_STREAM_SUCCESS */]:
      {
        return _extends({}, state, {
          isLoading: false,
          isFinished: true,
          results: action.payload
        });
      }

    case __WEBPACK_IMPORTED_MODULE_0__constants_actionTypes__["V" /* GET_STORIES_STREAM_UPDATE */]:
      {
        var _results = [].concat(_toConsumableArray(state.results));
        var existingStories = state.results.map(function (story) {
          return story.id;
        });
        action.payload.forEach(function (story) {
          if (!existingStories.includes(story.id)) {
            _results.push(story);
          }
        });
        return _extends({}, state, {
          isLoading: false,
          isFinished: true,
          results: _results
        });
      }

    case __WEBPACK_IMPORTED_MODULE_0__constants_actionTypes__["X" /* GET_STORY_ERROR */]:
    case __WEBPACK_IMPORTED_MODULE_0__constants_actionTypes__["T" /* GET_STORIES_STREAM_ERROR */]:
      {
        return _extends({}, state, {
          isLoading: false,
          isFinished: true,
          isError: true,
          error: action.payload
        });
      }

    case __WEBPACK_IMPORTED_MODULE_0__constants_actionTypes__["_25" /* RESET_STORIES_STREAM_ERROR */]:
      {
        return _extends({}, state, {
          isError: false,
          error: null
        });
      }

    case __WEBPACK_IMPORTED_MODULE_0__constants_actionTypes__["_32" /* SET_STORY_STREAM */]:
      {
        return _extends({}, state, {
          results: action.payload
        });
      }

    default:
      {
        return state;
      }
  }
});

/***/ }),

/***/ "./src/reducers/trending.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__constants_actionTypes__ = __webpack_require__("./src/constants/actionTypes.js");


var initialState = {
  trendingTopics: [],
  getTrendingTopicsSuccess: false,
  getTrendingTopicsError: null,
  offset: false,
  colors: ["#e74e29", "#7d61e1", "#3faff3", "#a8947b"]
};

/* harmony default export */ __webpack_exports__["a"] = (function () {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
  var action = arguments[1];

  switch (action.type) {
    case __WEBPACK_IMPORTED_MODULE_0__constants_actionTypes__["_12" /* GET_TRENDING_TOPICS_SUCCESS */]:
      {
        return Object.assign({}, state, {
          trendingTopics: action.payload,
          getTrendingTopicsSuccess: true
        });
      }

    case __WEBPACK_IMPORTED_MODULE_0__constants_actionTypes__["_11" /* GET_TRENDING_TOPICS_ERROR */]:
      {
        return Object.assign({}, state, {
          getTrendingTopicsSuccess: false,
          getTrendingTopicsError: action.payload
        });
      }

    case __WEBPACK_IMPORTED_MODULE_0__constants_actionTypes__["_45" /* TOGGLE_OFFSET */]:
      {
        return Object.assign({}, state, {
          offset: action.payload
        });
      }

    default:
      {
        return state;
      }
  }
});

/***/ }),

/***/ "./src/reducers/user.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__constants_actionTypes__ = __webpack_require__("./src/constants/actionTypes.js");
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };



var initialState = {
  isLoading: false,
  isFinished: false,
  isError: false,
  error: null,
  data: null,
  results: []
};

/* harmony default export */ __webpack_exports__["a"] = (function () {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
  var action = arguments[1];

  switch (action.type) {
    case __WEBPACK_IMPORTED_MODULE_0__constants_actionTypes__["_47" /* UPDATE_USER_SUBSCRIPTIONS */]:
    case __WEBPACK_IMPORTED_MODULE_0__constants_actionTypes__["_13" /* GET_USER_DATA */]:
      {
        return _extends({}, state, {
          isLoading: true,
          isFinished: false,
          isError: false,
          error: null
        });
      }

    case __WEBPACK_IMPORTED_MODULE_0__constants_actionTypes__["_15" /* GET_USER_DATA_SUCCESS */]:
      {
        return _extends({}, state, {
          isLoading: false,
          isFinished: true,
          data: action.payload
        });
      }

    case __WEBPACK_IMPORTED_MODULE_0__constants_actionTypes__["_49" /* UPDATE_USER_SUBSCRIPTIONS_SUCCESS */]:
      {
        return _extends({}, state, {
          data: _extends({}, state.data, {
            subscriptions: action.payload
          })
        });
      }

    case __WEBPACK_IMPORTED_MODULE_0__constants_actionTypes__["_48" /* UPDATE_USER_SUBSCRIPTIONS_ERROR */]:
    case __WEBPACK_IMPORTED_MODULE_0__constants_actionTypes__["_14" /* GET_USER_DATA_ERROR */]:
      {
        return _extends({}, state, {
          isLoading: false,
          isFinished: true,
          isError: true,
          error: action.payload
        });
      }

    case __WEBPACK_IMPORTED_MODULE_0__constants_actionTypes__["_20" /* LOG_OUT */]:
      {
        return _extends({}, state, {
          data: null
        });
      }

    default:
      {
        return state;
      }
  }
});

/***/ }),

/***/ "./src/robots.txt":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "robots.txt";

/***/ }),

/***/ "./src/routes.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return routes; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__("./node_modules/react/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_loadable__ = __webpack_require__("./node_modules/react-loadable/lib/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_loadable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react_loadable__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_author_components_Author_Author__ = __webpack_require__("./src/author/components/Author/Author.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_components_Library_Authorize_Authorize__ = __webpack_require__("./src/components/Library/Authorize/Authorize.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_events_components_Events__ = __webpack_require__("./src/events/components/Events/Events.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_search_components_SearchResults__ = __webpack_require__("./src/search/components/SearchResults/SearchResults.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_subscriptions_components_Subscription__ = __webpack_require__("./src/subscriptions/components/Subscription/Subscription.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_subscriptions_components_Subscriptions__ = __webpack_require__("./src/subscriptions/components/Subscriptions/Subscriptions.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_users_components_UserSettings_UserSettings__ = __webpack_require__("./src/users/components/UserSettings/UserSettings.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_users_components_SavedStories_SavedStories__ = __webpack_require__("./src/users/components/SavedStories/SavedStories.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_dashboard_containers_StoryPermalink__ = __webpack_require__("./src/dashboard/containers/StoryPermalink/StoryPermalink.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_dashboard_containers_SectionStream__ = __webpack_require__("./src/dashboard/containers/SectionStream/SectionStream.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_dashboard_containers_TagStream__ = __webpack_require__("./src/dashboard/containers/TagStream/TagStream.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_dashboard_components_NotFound__ = __webpack_require__("./src/dashboard/components/NotFound/NotFound.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_components_Library_Spinner__ = __webpack_require__("./src/components/Library/Spinner/Spinner.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_actions_storiesStream__ = __webpack_require__("./src/actions/storiesStream.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_subscriptions_actions_subscriptions__ = __webpack_require__("./src/subscriptions/actions/subscriptions.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_utils_server__ = __webpack_require__("./src/utils/server.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18_actions_navigation__ = __webpack_require__("./src/actions/navigation.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19_author_actions_author__ = __webpack_require__("./src/author/actions/author.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20_config_constants__ = __webpack_require__("./src/config/constants.js");
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };


























var oldPermalinkRoute = "/:slug([A-Za-z0-9-]+-)?:id([0-9]+).html";
var storyPermalinkRoute = "/:slug([A-Za-z0-9-]+?-)?:id" + __WEBPACK_IMPORTED_MODULE_20_config_constants__["n" /* URL_ID_REGEXP */] + ".html";
var newsletterPermalinkRoute = "/newsletters/:subscription([A-Za-z0-9-]+)?-:newsletter" + __WEBPACK_IMPORTED_MODULE_20_config_constants__["n" /* URL_ID_REGEXP */] + ".html";

var routes = [{
  path: "/",
  exact: true,
  render: function render(props) {
    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_dashboard_containers_SectionStream__["a" /* default */], _extends({}, props, { slug: "top" }));
  },
  fetchData: function fetchData(req, match, dispatch) {
    var featuredReturnId = req.cookies.lastSeen || "";

    return Promise.all([dispatch(Object(__WEBPACK_IMPORTED_MODULE_18_actions_navigation__["getSection"])("top")), dispatch(Object(__WEBPACK_IMPORTED_MODULE_18_actions_navigation__["setLastSeen"])(featuredReturnId)), dispatch(Object(__WEBPACK_IMPORTED_MODULE_15_actions_storiesStream__["a" /* getStoriesStream */])({ stream: "top", featured_return_id: featuredReturnId }))]);
  }
}, {
  path: "/authors/:username",
  exact: true,
  component: __WEBPACK_IMPORTED_MODULE_2_author_components_Author_Author__["a" /* default */],
  fetchData: function fetchData(req, match, dispatch) {
    return dispatch(Object(__WEBPACK_IMPORTED_MODULE_19_author_actions_author__["a" /* getAuthor */])(match.params.username));
  }
}, {
  path: "/authorize",
  exact: true,
  component: __WEBPACK_IMPORTED_MODULE_3_components_Library_Authorize_Authorize__["a" /* default */]
}, {
  path: "/results",
  exact: true,
  component: __WEBPACK_IMPORTED_MODULE_5_search_components_SearchResults__["a" /* default */]
}, {
  path: "/legal",
  exact: true,
  component: __WEBPACK_IMPORTED_MODULE_1_react_loadable___default()({
    loader: function loader() {
      return __webpack_require__.e/* import() */(2).then(__webpack_require__.bind(null, "./src/legal/components/Legal/Legal.js"));
    },
    modules: ["./legal/components/Legal/Legal.js"],
    webpack: function webpack() {
      return [/*require.resolve*/("./src/legal/components/Legal/Legal.js")];
    },
    loading: __WEBPACK_IMPORTED_MODULE_14_components_Library_Spinner__["a" /* default */]
  })
}, {
  path: "/about",
  exact: true,
  component: __WEBPACK_IMPORTED_MODULE_1_react_loadable___default()({
    loader: function loader() {
      return __webpack_require__.e/* import() */(1).then(__webpack_require__.bind(null, "./src/about/components/About/About.js"));
    },
    modules: ["./about/components/About/About.js"],
    webpack: function webpack() {
      return [/*require.resolve*/("./src/about/components/About/About.js")];
    },
    loading: __WEBPACK_IMPORTED_MODULE_14_components_Library_Spinner__["a" /* default */]
  })
}, {
  path: "/events",
  exact: true,
  component: __WEBPACK_IMPORTED_MODULE_4_events_components_Events__["a" /* default */]
}, {
  path: "/newsletters",
  exact: true,
  component: __WEBPACK_IMPORTED_MODULE_7_subscriptions_components_Subscriptions__["a" /* default */]
}, {
  path: newsletterPermalinkRoute,
  exact: true,
  component: __WEBPACK_IMPORTED_MODULE_6_subscriptions_components_Subscription__["a" /* default */],
  fetchData: function fetchData(req, match, dispatch, context) {
    return Promise.all([Object(__WEBPACK_IMPORTED_MODULE_17_utils_server__["a" /* getRedirectPath */])(req, match.params.newsletter, context), dispatch(Object(__WEBPACK_IMPORTED_MODULE_16_subscriptions_actions_subscriptions__["a" /* getNewsletter */])(match.params.newsletter)), dispatch(Object(__WEBPACK_IMPORTED_MODULE_16_subscriptions_actions_subscriptions__["d" /* populateSubscription */])(match.params.subscription))]);
  }
}, {
  path: "/newsletters/:subscription",
  exact: true,
  component: __WEBPACK_IMPORTED_MODULE_6_subscriptions_components_Subscription__["a" /* default */],
  fetchData: function fetchData(req, match, dispatch) {
    return dispatch(Object(__WEBPACK_IMPORTED_MODULE_16_subscriptions_actions_subscriptions__["d" /* populateSubscription */])(match.params.subscription));
  }
}, {
  path: "/users/settings",
  exact: true,
  component: __WEBPACK_IMPORTED_MODULE_8_users_components_UserSettings_UserSettings__["a" /* default */]
}, {
  path: "/users/saved-stories",
  exact: true,
  component: __WEBPACK_IMPORTED_MODULE_9_users_components_SavedStories_SavedStories__["a" /* default */]
}, {
  path: "/tag/:tag",
  exact: true,
  component: __WEBPACK_IMPORTED_MODULE_12_dashboard_containers_TagStream__["a" /* default */],
  fetchData: function fetchData(req, match, dispatch) {
    return dispatch(Object(__WEBPACK_IMPORTED_MODULE_18_actions_navigation__["setSectionWithTag"])(match.params.tag));
  }
}, {
  path: storyPermalinkRoute,
  component: __WEBPACK_IMPORTED_MODULE_10_dashboard_containers_StoryPermalink__["a" /* default */],
  fetchData: function fetchData(req, match, dispatch, context) {
    if (req.query.preview || req.query.revision) return Promise.resolve();
    return Promise.all([Object(__WEBPACK_IMPORTED_MODULE_17_utils_server__["a" /* getRedirectPath */])(req, match.params.id, context), dispatch(Object(__WEBPACK_IMPORTED_MODULE_15_actions_storiesStream__["a" /* getStoriesStream */])({ story: match.params.id }))]);
  }
}, {
  path: oldPermalinkRoute,
  render: function render() {
    null;
  },
  fetchData: function fetchData(req, match, dispatch, context) {
    return Object(__WEBPACK_IMPORTED_MODULE_17_utils_server__["a" /* getRedirectPath */])(req, match.params.id, context);
  }
}, {
  path: "/community/:user",
  fetchData: function fetchData(req, match, dispatch, context) {
    context.status = 301;
    context.path = "/authors/" + match.params.user;
    return Promise.resolve();
  }
}, {
  path: "/:section([a-zA-Z-]+)",
  render: function render(props) {
    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_dashboard_containers_SectionStream__["a" /* default */], _extends({}, props, { slug: props.match.params.section }));
  },
  fetchData: function fetchData(req, match, dispatch) {
    var featuredReturnId = req.cookies.lastSeen || "";

    return Promise.all([dispatch(Object(__WEBPACK_IMPORTED_MODULE_18_actions_navigation__["getSection"])(match.params.section)), dispatch(Object(__WEBPACK_IMPORTED_MODULE_18_actions_navigation__["setLastSeen"])(featuredReturnId)), dispatch(Object(__WEBPACK_IMPORTED_MODULE_15_actions_storiesStream__["a" /* getStoriesStream */])({ stream: match.params.section, featured_return_id: featuredReturnId }))]);
  },
  exact: true
},
// 404 fallback route
{
  path: "/*",
  render: function render(_ref) {
    var staticContext = _ref.staticContext;

    if (staticContext) staticContext.status = 404;
    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13_dashboard_components_NotFound__["a" /* default */], null);
  }
}];

/***/ }),

/***/ "./src/search/components/SearchResults/SearchResults.css":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"empty":"SearchResults__empty--71hcZ","clipboard":"SearchResults__clipboard--WsG6l","content":"SearchResults__content--IfJ7n","bounce":"SearchResults__bounce--3YsR5"};

/***/ }),

/***/ "./src/search/components/SearchResults/SearchResults.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__("./node_modules/react/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__("./node_modules/react-redux/es/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__actions_search__ = __webpack_require__("./src/actions/search.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_Library_Spinner__ = __webpack_require__("./src/components/Library/Spinner/Spinner.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_Library_Layout__ = __webpack_require__("./src/components/Library/Layout/Layout.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_Library_Layout_Sidebar__ = __webpack_require__("./src/components/Library/Layout/Sidebar.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_Library_Layout_Content__ = __webpack_require__("./src/components/Library/Layout/Content.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_Library_StoriesStream__ = __webpack_require__("./src/components/Library/StoriesStream/StoriesStream.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_Library_Header__ = __webpack_require__("./src/components/Library/Header/Header.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__SearchResults_css__ = __webpack_require__("./src/search/components/SearchResults/SearchResults.css");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__SearchResults_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__SearchResults_css__);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }














var SearchResults = function (_Component) {
  _inherits(SearchResults, _Component);

  function SearchResults(props) {
    _classCallCheck(this, SearchResults);

    var _this = _possibleConstructorReturn(this, (SearchResults.__proto__ || Object.getPrototypeOf(SearchResults)).call(this, props));

    _this.loadNextStories = _this.loadNextStories.bind(_this);

    _this.state = {
      search: _this.props.location.search.slice(1)
    };
    return _this;
  }

  _createClass(SearchResults, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this.props.getSearchResults(this.state.search);
    }
  }, {
    key: "componentWillReceiveProps",
    value: function componentWillReceiveProps(nextProps) {
      if (this.props.location.search !== nextProps.location.search) {
        var nextSearch = nextProps.location.search.slice(1);
        this.props.getSearchResults(nextSearch);
        this.setState({ search: nextSearch });
      }
    }
  }, {
    key: "loadNextStories",
    value: function loadNextStories(page) {
      return this.props.getSearchResults(this.state.search, page, true);
    }
  }, {
    key: "render",
    value: function render() {
      var search = this.props.search;

      if (search.results.length === 0 && search.isLoading) return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__components_Library_Spinner__["a" /* default */], null);

      var isEmpty = !search.isLoading && search.isFinished && search.results.length === 0;
      var header = __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__components_Library_Header__["a" /* default */], { className: __WEBPACK_IMPORTED_MODULE_9__SearchResults_css___default.a.clipboard, text: "\u201C" + this.state.search + "\u201D", subText: "Search Results" });

      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_4__components_Library_Layout__["a" /* default */],
        { includeHeader: true, headerComponent: header },
        !isEmpty && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_5__components_Library_Layout_Sidebar__["a" /* default */],
          null,
          " "
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_6__components_Library_Layout_Content__["a" /* default */],
          { className: isEmpty ? __WEBPACK_IMPORTED_MODULE_9__SearchResults_css___default.a.content : {}, ariaLabel: "Search results" },
          isEmpty ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            "div",
            { className: __WEBPACK_IMPORTED_MODULE_9__SearchResults_css___default.a.empty },
            "Your search for \u201C",
            this.state.search,
            "\u201D did not match any results."
          ) : __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__components_Library_StoriesStream__["a" /* default */], {
            stories: search,
            isSummary: true,
            showUnread: false,
            next: this.loadNextStories })
        )
      );
    }
  }]);

  return SearchResults;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

var mapStateToProps = function mapStateToProps(state) {
  return {
    search: state.search
  };
};

/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1_react_redux__["b" /* connect */])(mapStateToProps, { getSearchResults: __WEBPACK_IMPORTED_MODULE_2__actions_search__["a" /* getSearchResults */] })(SearchResults));

/***/ }),

/***/ "./src/store/configureStore.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export history */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_redux__ = __webpack_require__("./node_modules/redux/es/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_redux_immutable_state_invariant__ = __webpack_require__("./node_modules/redux-immutable-state-invariant/dist/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_redux_immutable_state_invariant___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_redux_immutable_state_invariant__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_redux_thunk__ = __webpack_require__("./node_modules/redux-thunk/lib/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_redux_thunk___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_redux_thunk__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_history_createBrowserHistory__ = __webpack_require__("./node_modules/history/createBrowserHistory.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_history_createBrowserHistory___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_history_createBrowserHistory__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_router_redux__ = __webpack_require__("./node_modules/react-router-redux/es/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__reducers__ = __webpack_require__("./src/reducers/index.js");




// 'routerMiddleware': the new way of storing route changes with redux middleware since rrV4.



var history = __WEBPACK_IMPORTED_MODULE_3_history_createBrowserHistory___default()();

function configureStoreProd(initialState) {
  var reactRouterMiddleware = Object(__WEBPACK_IMPORTED_MODULE_4_react_router_redux__["a" /* routerMiddleware */])(history);
  var middlewares = [
  // Add other middleware on this line...

  // thunk middleware can also accept an extra argument to be passed to each thunk action
  // https://github.com/gaearon/redux-thunk#injecting-a-custom-argument
  __WEBPACK_IMPORTED_MODULE_2_redux_thunk___default.a, reactRouterMiddleware];

  return Object(__WEBPACK_IMPORTED_MODULE_0_redux__["e" /* createStore */])(__WEBPACK_IMPORTED_MODULE_5__reducers__["a" /* default */], initialState, Object(__WEBPACK_IMPORTED_MODULE_0_redux__["d" /* compose */])(__WEBPACK_IMPORTED_MODULE_0_redux__["a" /* applyMiddleware */].apply(undefined, middlewares)));
}

function configureStoreDev(initialState) {
  var reactRouterMiddleware = Object(__WEBPACK_IMPORTED_MODULE_4_react_router_redux__["a" /* routerMiddleware */])(history);
  var middlewares = [
  // Add other middleware on this line...

  // Redux middleware that spits an error on you when you try to mutate your state either inside a dispatch or between dispatches.
  __WEBPACK_IMPORTED_MODULE_1_redux_immutable_state_invariant___default()(),

  // thunk middleware can also accept an extra argument to be passed to each thunk action
  // https://github.com/gaearon/redux-thunk#injecting-a-custom-argument
  __WEBPACK_IMPORTED_MODULE_2_redux_thunk___default.a, reactRouterMiddleware];

  var composeEnhancers = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || __WEBPACK_IMPORTED_MODULE_0_redux__["d" /* compose */]; // add support for Redux dev tools
  var store = Object(__WEBPACK_IMPORTED_MODULE_0_redux__["e" /* createStore */])(__WEBPACK_IMPORTED_MODULE_5__reducers__["a" /* default */], initialState, composeEnhancers(__WEBPACK_IMPORTED_MODULE_0_redux__["a" /* applyMiddleware */].apply(undefined, middlewares)));

  if (false) {
    // Enable Webpack hot module replacement for reducers
    module.hot.accept("../reducers", function () {
      var nextReducer = require("../reducers").default; // eslint-disable-line global-require
      store.replaceReducer(nextReducer);
    });
  }

  return store;
}

var configureStore =  true ? configureStoreProd : configureStoreDev;

/* harmony default export */ __webpack_exports__["a"] = (configureStore);

/***/ }),

/***/ "./src/styles/global.css":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"a11yOnly":"global__a11yOnly--3n7m7","focusable":"global__focusable--_TM4N"};

/***/ }),

/***/ "./src/styles/icheck/square/blue.css":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"icheckbox_square-blue":"blue__icheckbox_square-blue--H6Hdg","checked":"blue__checked--23alN"};

/***/ }),

/***/ "./src/styles/main.scss":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "./src/subscriptions/actions/subscriptions.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return getSubscriptions; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return getNewsletter; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return populateSubscription; });
/* unused harmony export getSubscription */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return getSubscriptionNewsletters; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils_backend__ = __webpack_require__("./src/utils/backend.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_qs__ = __webpack_require__("./node_modules/qs/lib/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_qs___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_qs__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__constants_actionTypes__ = __webpack_require__("./src/constants/actionTypes.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_config_constants__ = __webpack_require__("./src/config/constants.js");





var getSubscriptions = function getSubscriptions(params) {
  return function (dispatch) {
    dispatch({
      type: __WEBPACK_IMPORTED_MODULE_2__constants_actionTypes__["_1" /* GET_SUBSCRIPTIONS */]
    });

    return __WEBPACK_IMPORTED_MODULE_0__utils_backend__["a" /* default */].request({
      method: "GET",
      url: "/subscriptions/?" + __WEBPACK_IMPORTED_MODULE_1_qs___default.a.stringify(params)

    }).then(function (response) {
      dispatch({
        type: __WEBPACK_IMPORTED_MODULE_2__constants_actionTypes__["_3" /* GET_SUBSCRIPTIONS_SUCCESS */],
        payload: response.data.results
      });
    }).catch(function (err) {
      dispatch({
        type: __WEBPACK_IMPORTED_MODULE_2__constants_actionTypes__["_2" /* GET_SUBSCRIPTIONS_ERROR */],
        payload: err
      });
    });
  };
};

var getNewsletter = function getNewsletter(newsletterId, token, revision) {
  return function (dispatch) {
    dispatch({
      type: __WEBPACK_IMPORTED_MODULE_2__constants_actionTypes__["z" /* GET_NEWSLETTER */]
    });

    return __WEBPACK_IMPORTED_MODULE_0__utils_backend__["a" /* default */].request({
      method: "GET",
      url: token ? __WEBPACK_IMPORTED_MODULE_3_config_constants__["b" /* BACKEND_ROOT */] + "/api/newsletters/" + newsletterId + "/" + (revision ? "revisions/" + revision + "/" : "") : "/newsletters/" + newsletterId + "/",
      headers: token ? { "Authorization": token } : undefined
    }).then(function (response) {
      dispatch({
        type: __WEBPACK_IMPORTED_MODULE_2__constants_actionTypes__["E" /* GET_NEWSLETTER_SUCCESS */],
        payload: response.data
      });
    }).catch(function (err) {
      dispatch({
        type: __WEBPACK_IMPORTED_MODULE_2__constants_actionTypes__["D" /* GET_NEWSLETTER_ERROR */],
        payload: err
      });
    });
  };
};

var populateSubscription = function populateSubscription(subscriptionId) {
  return function (dispatch) {
    return dispatch(getSubscription(subscriptionId)).then(dispatch(getSubscriptionNewsletters(subscriptionId)));
  };
};

var getSubscription = function getSubscription(subscriptionId) {
  return function (dispatch) {
    dispatch({
      type: __WEBPACK_IMPORTED_MODULE_2__constants_actionTypes__["_0" /* GET_SUBSCRIPTION */]
    });

    return __WEBPACK_IMPORTED_MODULE_0__utils_backend__["a" /* default */].request({
      method: "GET",
      url: "/subscriptions/" + subscriptionId + "/"
    }).then(function (response) {
      dispatch({
        type: __WEBPACK_IMPORTED_MODULE_2__constants_actionTypes__["_8" /* GET_SUBSCRIPTION_SUCCESS */],
        payload: response.data
      });
    }).catch(function (err) {
      dispatch({
        type: __WEBPACK_IMPORTED_MODULE_2__constants_actionTypes__["_4" /* GET_SUBSCRIPTION_ERROR */],
        payload: err
      });
    });
  };
};

var getSubscriptionNewsletters = function getSubscriptionNewsletters(subscriptionId) {
  var page = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 1;

  return function (dispatch) {
    dispatch({
      type: __WEBPACK_IMPORTED_MODULE_2__constants_actionTypes__["_5" /* GET_SUBSCRIPTION_NEWSLETTERS */]
    });

    return __WEBPACK_IMPORTED_MODULE_0__utils_backend__["a" /* default */].request({
      method: "GET",
      url: "/subscriptions/" + subscriptionId + "/newsletters/",
      params: { page: page }
    }).then(function (response) {
      dispatch({
        type: __WEBPACK_IMPORTED_MODULE_2__constants_actionTypes__["_7" /* GET_SUBSCRIPTION_NEWSLETTERS_SUCCESS */],
        payload: response.data
      });
    }).catch(function (err) {
      dispatch({
        type: __WEBPACK_IMPORTED_MODULE_2__constants_actionTypes__["_6" /* GET_SUBSCRIPTION_NEWSLETTERS_ERROR */],
        payload: err
      });
    });
  };
};

/***/ }),

/***/ "./src/subscriptions/components/Newsletter/Newsletter.css":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"story":"Newsletter__story--QIsxY","footer":"Newsletter__footer--Bg3hN","anchor":"Newsletter__anchor--1Rg08","bounce":"Newsletter__bounce--1Ht-p"};

/***/ }),

/***/ "./src/subscriptions/components/Newsletter/Newsletter.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__("./node_modules/react/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__("./node_modules/prop-types/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_Library_StoryCard__ = __webpack_require__("./src/components/Library/StoryCard/StoryCard.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__NewsletterHeader__ = __webpack_require__("./src/subscriptions/components/NewsletterHeader/NewsletterHeader.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Newsletter_css__ = __webpack_require__("./src/subscriptions/components/Newsletter/Newsletter.css");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Newsletter_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__Newsletter_css__);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }









var Newsletter = function (_Component) {
  _inherits(Newsletter, _Component);

  function Newsletter() {
    _classCallCheck(this, Newsletter);

    return _possibleConstructorReturn(this, (Newsletter.__proto__ || Object.getPrototypeOf(Newsletter)).apply(this, arguments));
  }

  _createClass(Newsletter, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var hash = window.location.hash;
      if (hash !== "") {
        var element = document.getElementById(hash.slice(1));
        if (element) {
          setTimeout(function () {
            return element.scrollIntoView();
          }, 2000);
        }
      } else {
        window.scrollTo(0, 0);
      }
    }
  }, {
    key: "render",
    value: function render() {
      var newsletter = this.props.newsletter;

      if (!newsletter) return null;

      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "div",
        null,
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__components_Library_StoryCard__["a" /* default */], {
          key: "intro-" + newsletter.id,
          hideFooter: true,
          className: __WEBPACK_IMPORTED_MODULE_4__Newsletter_css___default.a.story,
          header: __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__NewsletterHeader__["a" /* default */], { newsletter: newsletter }),
          story: { blocks: newsletter.intro },
          storyType: "newsletter" }),
        newsletter.chunks.map(function (chunk, index) {
          return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            "div",
            { key: chunk.id },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", { id: "story" + index, className: __WEBPACK_IMPORTED_MODULE_4__Newsletter_css___default.a.anchor }),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__components_Library_StoryCard__["a" /* default */], {
              story: chunk,
              className: __WEBPACK_IMPORTED_MODULE_4__Newsletter_css___default.a.story,
              hideHeader: true,
              storyType: "newsletter" })
          );
        }),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__components_Library_StoryCard__["a" /* default */], {
          key: "outro-" + newsletter.id,
          hideHeader: true,
          hideFooter: true,
          className: __WEBPACK_IMPORTED_MODULE_4__Newsletter_css___default.a.footer,
          story: { blocks: newsletter.outro },
          storyType: "newsletter" })
      );
    }
  }]);

  return Newsletter;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

Newsletter.propTypes = {
  newsletter: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object
};

/* harmony default export */ __webpack_exports__["a"] = (Newsletter);

/***/ }),

/***/ "./src/subscriptions/components/NewsletterHeader/NewsletterHeader.css":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"root":"NewsletterHeader__root--3i7et","heading":"NewsletterHeader__heading--UDVyG","author":"NewsletterHeader__author--1DD69","bounce":"NewsletterHeader__bounce--2Ropc"};

/***/ }),

/***/ "./src/subscriptions/components/NewsletterHeader/NewsletterHeader.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__("./node_modules/react/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_router_dom__ = __webpack_require__("./node_modules/react-router-dom/es/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__NewsletterHeader_css__ = __webpack_require__("./src/subscriptions/components/NewsletterHeader/NewsletterHeader.css");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__NewsletterHeader_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__NewsletterHeader_css__);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }






var NewsletterHeader = function (_Component) {
  _inherits(NewsletterHeader, _Component);

  function NewsletterHeader() {
    _classCallCheck(this, NewsletterHeader);

    return _possibleConstructorReturn(this, (NewsletterHeader.__proto__ || Object.getPrototypeOf(NewsletterHeader)).apply(this, arguments));
  }

  _createClass(NewsletterHeader, [{
    key: "render",
    value: function render() {
      var newsletter = this.props.newsletter;

      if (!newsletter || !newsletter.authors || newsletter.authors.length === 0) return null;
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "div",
        { className: __WEBPACK_IMPORTED_MODULE_2__NewsletterHeader_css___default.a.root },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "span",
          { className: __WEBPACK_IMPORTED_MODULE_2__NewsletterHeader_css___default.a.heading },
          "By "
        ),
        newsletter.authors.map(function (author, index) {
          return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_1_react_router_dom__["a" /* Link */],
            { key: author.username, to: "/authors/" + author.username, className: __WEBPACK_IMPORTED_MODULE_2__NewsletterHeader_css___default.a.author },
            author.display_name,
            index < newsletter.authors.length - 1 && ", "
          );
        })
      );
    }
  }]);

  return NewsletterHeader;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

/* harmony default export */ __webpack_exports__["a"] = (NewsletterHeader);

/***/ }),

/***/ "./src/subscriptions/components/NewslettersList/NewslettersList.css":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"root":"NewslettersList__root--1cGwX","listItem":"NewslettersList__listItem--3225M","item":"NewslettersList__item--1KkjC","active":"NewslettersList__active--216d0","bounce":"NewslettersList__bounce--341Nv"};

/***/ }),

/***/ "./src/subscriptions/components/NewslettersList/NewslettersList.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__("./node_modules/react/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_router_dom__ = __webpack_require__("./node_modules/react-router-dom/es/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_date_fns_format__ = __webpack_require__("./node_modules/date-fns/format/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_date_fns_format___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_date_fns_format__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_classnames__ = __webpack_require__("./node_modules/classnames/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__NewslettersList_css__ = __webpack_require__("./src/subscriptions/components/NewslettersList/NewslettersList.css");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__NewslettersList_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__NewslettersList_css__);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }









var NewslettersList = function (_Component) {
  _inherits(NewslettersList, _Component);

  function NewslettersList(props) {
    _classCallCheck(this, NewslettersList);

    var _this = _possibleConstructorReturn(this, (NewslettersList.__proto__ || Object.getPrototypeOf(NewslettersList)).call(this, props));

    _this.onClickMoreIssues = _this.onClickMoreIssues.bind(_this);
    _this.state = {
      page: 1
    };
    return _this;
  }

  _createClass(NewslettersList, [{
    key: "onClickMoreIssues",
    value: function onClickMoreIssues() {
      var page = this.state.page + 1;
      this.props.onClickMoreIssues(page);
      this.setState({ page: page });
    }
  }, {
    key: "render",
    value: function render() {
      var _props = this.props,
          subscriptionNewsletters = _props.subscriptionNewsletters,
          subscriptionId = _props.subscriptionId,
          newsletterId = _props.newsletterId,
          className = _props.className;

      if (!subscriptionNewsletters) return null;

      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "div",
        { className: className },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "ul",
          { className: __WEBPACK_IMPORTED_MODULE_4__NewslettersList_css___default.a.root },
          subscriptionNewsletters.results.map(function (sn, index) {
            return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              "li",
              { key: sn.id, className: __WEBPACK_IMPORTED_MODULE_4__NewslettersList_css___default.a.listItem },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_1_react_router_dom__["a" /* Link */],
                {
                  to: "/newsletters/" + subscriptionId + "-" + sn.id + ".html",
                  className: __WEBPACK_IMPORTED_MODULE_3_classnames___default()(__WEBPACK_IMPORTED_MODULE_4__NewslettersList_css___default.a.item, newsletterId === sn.id || !newsletterId && index === 0 ? __WEBPACK_IMPORTED_MODULE_4__NewslettersList_css___default.a.active : {}) },
                __WEBPACK_IMPORTED_MODULE_2_date_fns_format___default()(sn.published_date, "ddd, MMM D")
              )
            );
          }),
          subscriptionNewsletters.next && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            "li",
            {
              key: "more",
              className: __WEBPACK_IMPORTED_MODULE_3_classnames___default()(__WEBPACK_IMPORTED_MODULE_4__NewslettersList_css___default.a.listItem),
              onClick: this.onClickMoreIssues },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              "span",
              { className: __WEBPACK_IMPORTED_MODULE_4__NewslettersList_css___default.a.item },
              "+ More Issues"
            )
          )
        )
      );
    }
  }]);

  return NewslettersList;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

/* harmony default export */ __webpack_exports__["a"] = (NewslettersList);

/***/ }),

/***/ "./src/subscriptions/components/Subscription/Subscription.css":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"mobileIssueList":"Subscription__mobileIssueList--3bmjL"};

/***/ }),

/***/ "./src/subscriptions/components/Subscription/Subscription.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__("./node_modules/react/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__("./node_modules/prop-types/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_redux__ = __webpack_require__("./node_modules/react-redux/es/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_selectn__ = __webpack_require__("./node_modules/selectn/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_selectn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_selectn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_helmet__ = __webpack_require__("./node_modules/react-helmet/lib/Helmet.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_helmet___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react_helmet__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_qs__ = __webpack_require__("./node_modules/qs/lib/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_qs___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_qs__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_date_fns_format__ = __webpack_require__("./node_modules/date-fns/format/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_date_fns_format___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_date_fns_format__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__SubscriptionHeader__ = __webpack_require__("./src/subscriptions/components/SubscriptionHeader/SubscriptionHeader.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__NewslettersList__ = __webpack_require__("./src/subscriptions/components/NewslettersList/NewslettersList.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__Newsletter__ = __webpack_require__("./src/subscriptions/components/Newsletter/Newsletter.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__components_Library_Layout__ = __webpack_require__("./src/components/Library/Layout/Layout.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__components_Library_Layout_Sidebar__ = __webpack_require__("./src/components/Library/Layout/Sidebar.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__components_Library_Layout_Content__ = __webpack_require__("./src/components/Library/Layout/Content.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_components_Library_Spinner__ = __webpack_require__("./src/components/Library/Spinner/Spinner.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_utils_localdb__ = __webpack_require__("./src/utils/localdb.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__actions_subscriptions__ = __webpack_require__("./src/subscriptions/actions/subscriptions.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__actions_navigation__ = __webpack_require__("./src/actions/navigation.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__Subscription_css__ = __webpack_require__("./src/subscriptions/components/Subscription/Subscription.css");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__Subscription_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_17__Subscription_css__);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }























var Subscription = function (_Component) {
  _inherits(Subscription, _Component);

  function Subscription(props) {
    _classCallCheck(this, Subscription);

    var _this = _possibleConstructorReturn(this, (Subscription.__proto__ || Object.getPrototypeOf(Subscription)).call(this, props));

    _this.loadMoreNewsletters = _this.loadMoreNewsletters.bind(_this);

    _this.state = {
      newsletterId: _this.getNewsletterId(props),
      subscriptionId: _this.getSubscriptionId(props)
    };
    return _this;
  }

  _createClass(Subscription, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      if (this.state.newsletterId) {
        var params = __WEBPACK_IMPORTED_MODULE_5_qs___default.a.parse(this.props.location.search.slice(1));
        var adminToken = Object(__WEBPACK_IMPORTED_MODULE_14_utils_localdb__["a" /* getLocalItem */])("adminToken");
        if (params.preview && adminToken) {
          if (params.revision) {
            this.props.getNewsletter(this.state.newsletterId, adminToken, params.revision);
          } else {
            this.props.getNewsletter(this.state.newsletterId, adminToken);
          }
        } else {
          this.props.getNewsletter(this.state.newsletterId);
        }
      }

      this.props.populateSubscription(this.state.subscriptionId);
    }
  }, {
    key: "componentWillReceiveProps",
    value: function componentWillReceiveProps(nextProps) {
      var nextSubscriptionId = this.getSubscriptionId(nextProps);
      if (this.state.subscriptionId !== nextSubscriptionId) {
        this.setState({ subscriptionId: nextSubscriptionId });
        this.props.populateSubscription(nextSubscriptionId);
      }

      if (this.props.subscription !== nextProps.subscription) {
        this.props.setSection({ name: __WEBPACK_IMPORTED_MODULE_3_selectn___default()("subscription.name", nextProps) });
      }

      var nextNewsletterId = this.getNewsletterId(nextProps);
      if (this.state.newsletterId !== nextNewsletterId && nextNewsletterId) {
        this.props.getNewsletter(nextNewsletterId);
        this.setState({ newsletterId: nextNewsletterId });
      }

      var nextNewsletters = __WEBPACK_IMPORTED_MODULE_3_selectn___default()("subscription.subscription_newsletters", nextProps);
      //alternate loading method for first newsletter (when id isn't in url)
      //only perform this if no id in url, no newsletter already loaded, and it's not already loading

      if (!this.props.newsletter && !this.props.newsletterLoading && nextNewsletters && nextNewsletters.results.length > 0 && !nextNewsletterId) {
        this.props.getNewsletter(nextNewsletters.results[0].id);
        this.setState({ newsletterId: nextNewsletters.results[0].id });
      }
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      this.props.setSection(null);
    }
  }, {
    key: "getSubscriptionId",
    value: function getSubscriptionId(props) {
      return __WEBPACK_IMPORTED_MODULE_3_selectn___default()("match.params.subscription", props);
    }
  }, {
    key: "getNewsletterId",
    value: function getNewsletterId(props) {
      return __WEBPACK_IMPORTED_MODULE_3_selectn___default()("match.params.newsletter", props);
    }
  }, {
    key: "loadMoreNewsletters",
    value: function loadMoreNewsletters(page) {
      this.props.getSubscriptionNewsletters(this.state.subscriptionId, page);
    }
  }, {
    key: "renderMeta",
    value: function renderMeta() {
      var canonicalUrl = this.props.newsletter ? this.props.newsletter.permalink : this.props.subscription.permalink;
      var image = __WEBPACK_IMPORTED_MODULE_3_selectn___default()("social_image.crops.16x9.url", this.props.subscription);

      //prefix title with name of subscription plus date IF not on subscription landing page
      var subName = this.props.subscription.name ? this.props.subscription.name + " - " : "";
      var newsletterDate = this.getNewsletterId(this.props) && this.props.newsletter ? __WEBPACK_IMPORTED_MODULE_6_date_fns_format___default()(this.props.newsletter.published_date, "MMMM D, YYYY") + " - " : "";
      var title = "" + subName + newsletterDate + "Axios";
      var description = this.props.newsletter && this.props.newsletter.preview_text || this.props.subscription && this.props.subscription.description;

      if (!this.props.subscription) return null;

      if (this.props.location.search && this.props.newsletter) {
        var params = __WEBPACK_IMPORTED_MODULE_5_qs___default.a.parse(this.props.location.search.substring(1));
        if (params.chunk && this.props.newsletter.chunks[params.chunk]) {
          var chunk = this.props.newsletter.chunks[params.chunk];
          image = __WEBPACK_IMPORTED_MODULE_3_selectn___default()("primary_image.crops.16x9.url", chunk) || image;
          return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_4_react_helmet__["Helmet"],
            null,
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              "title",
              null,
              title
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("meta", { property: "og:title", content: chunk.headline }),
            image && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("meta", { property: "og:image", content: image }),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("link", { rel: "canonical", href: canonicalUrl }),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("meta", { property: "og:url", content: canonicalUrl + "?chunk=" + params.chunk + "#story" + params.chunk }),
            description && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("meta", { property: "og:description", content: description }),
            description && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("meta", { name: "description", content: description })
          );
        }
      }

      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_4_react_helmet__["Helmet"],
        null,
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "title",
          null,
          title
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("meta", { property: "og:title", content: this.props.subscription.name }),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("meta", { property: "og:url", content: canonicalUrl }),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("link", { rel: "canonical", href: canonicalUrl }),
        image && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("meta", { property: "og:image", content: image }),
        description && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("meta", { property: "og:description", content: description }),
        description && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("meta", { name: "description", content: description })
      );
    }
  }, {
    key: "render",
    value: function render() {
      var _props = this.props,
          subscription = _props.subscription,
          newsletter = _props.newsletter,
          newsletterLoading = _props.newsletterLoading;

      if (!subscription) return null;
      if (newsletterLoading || !newsletter || newsletter.id !== this.state.newsletterId) {
        return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "div",
          null,
          this.renderMeta(),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_10__components_Library_Layout__["a" /* default */],
            {
              includeHeader: true,
              headerComponent: __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__SubscriptionHeader__["a" /* default */], {
                text: "",
                subscription: subscription
              })
            },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13_components_Library_Spinner__["a" /* default */], null)
          )
        );
      }

      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "div",
        null,
        this.renderMeta(),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_10__components_Library_Layout__["a" /* default */],
          {
            includeHeader: true,
            headerComponent: __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__SubscriptionHeader__["a" /* default */], {
              text: subscription.name,
              subscription: subscription
            })
          },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_11__components_Library_Layout_Sidebar__["a" /* default */],
            null,
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__NewslettersList__["a" /* default */], {
              subscriptionNewsletters: subscription.subscription_newsletters,
              newsletterId: this.state.newsletterId,
              subscriptionId: this.state.subscriptionId,
              onClickMoreIssues: this.loadMoreNewsletters
            })
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_12__components_Library_Layout_Content__["a" /* default */],
            null,
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__Newsletter__["a" /* default */], { newsletter: newsletter }),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__NewslettersList__["a" /* default */], {
              className: __WEBPACK_IMPORTED_MODULE_17__Subscription_css___default.a.mobileIssueList,
              subscriptionNewsletters: subscription.subscription_newsletters,
              newsletterId: this.state.newsletterId,
              subscriptionId: this.state.subscriptionId,
              onClickMoreIssues: this.loadMoreNewsletters
            })
          )
        )
      );
    }
  }]);

  return Subscription;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

Subscription.propTypes = {
  location: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({
    search: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string.isRequired
  })
};

var mapStateToProps = function mapStateToProps(state) {
  return {
    subscription: state.subscriptions.data,
    newsletter: state.newsletters.data,
    newsletterLoading: state.newsletters.isLoading
  };
};

/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_2_react_redux__["b" /* connect */])(mapStateToProps, {
  populateSubscription: __WEBPACK_IMPORTED_MODULE_15__actions_subscriptions__["d" /* populateSubscription */],
  getNewsletter: __WEBPACK_IMPORTED_MODULE_15__actions_subscriptions__["a" /* getNewsletter */],
  getSubscriptionNewsletters: __WEBPACK_IMPORTED_MODULE_15__actions_subscriptions__["b" /* getSubscriptionNewsletters */],
  setSection: __WEBPACK_IMPORTED_MODULE_16__actions_navigation__["setSection"]
})(Subscription));

/***/ }),

/***/ "./src/subscriptions/components/SubscriptionHeader/SubscriptionHeader.css":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"newsletter":"SubscriptionHeader__newsletter--p8o4P","bounce":"SubscriptionHeader__bounce--2Lfiz"};

/***/ }),

/***/ "./src/subscriptions/components/SubscriptionHeader/SubscriptionHeader.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__("./node_modules/react/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__("./node_modules/prop-types/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_Library_Header__ = __webpack_require__("./src/components/Library/Header/Header.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__SubscriptionHeader_css__ = __webpack_require__("./src/subscriptions/components/SubscriptionHeader/SubscriptionHeader.css");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__SubscriptionHeader_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__SubscriptionHeader_css__);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }








var SubscriptionHeader = function (_Component) {
  _inherits(SubscriptionHeader, _Component);

  function SubscriptionHeader() {
    _classCallCheck(this, SubscriptionHeader);

    return _possibleConstructorReturn(this, (SubscriptionHeader.__proto__ || Object.getPrototypeOf(SubscriptionHeader)).apply(this, arguments));
  }

  _createClass(SubscriptionHeader, [{
    key: "render",
    value: function render() {
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__components_Library_Header__["a" /* default */], {
        className: __WEBPACK_IMPORTED_MODULE_3__SubscriptionHeader_css___default.a.newsletter,
        subText: this.props.subText,
        text: this.props.text,
        subscription: this.props.subscription });
    }
  }]);

  return SubscriptionHeader;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

SubscriptionHeader.propTypes = {
  subText: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  text: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string
};

SubscriptionHeader.defaultProps = {
  text: "Newsletters"
};

/* harmony default export */ __webpack_exports__["a"] = (SubscriptionHeader);

/***/ }),

/***/ "./src/subscriptions/components/Subscriptions/Subscriptions.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__("./node_modules/react/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__("./node_modules/react-redux/es/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__SubscriptionHeader__ = __webpack_require__("./src/subscriptions/components/SubscriptionHeader/SubscriptionHeader.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__SubscriptionsList__ = __webpack_require__("./src/subscriptions/components/SubscriptionsList/SubscriptionsList.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_Library_Layout__ = __webpack_require__("./src/components/Library/Layout/Layout.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_Library_Layout_Sidebar__ = __webpack_require__("./src/components/Library/Layout/Sidebar.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_Library_Layout_Content__ = __webpack_require__("./src/components/Library/Layout/Content.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_Library_LatestStories__ = __webpack_require__("./src/components/Library/LatestStories/LatestStories.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__actions_subscriptions__ = __webpack_require__("./src/subscriptions/actions/subscriptions.js");
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }













var Subscriptions = function (_Component) {
  _inherits(Subscriptions, _Component);

  function Subscriptions(props) {
    _classCallCheck(this, Subscriptions);

    return _possibleConstructorReturn(this, (Subscriptions.__proto__ || Object.getPrototypeOf(Subscriptions)).call(this, props));
  }

  _createClass(Subscriptions, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this.props.getSubscriptions({ subscription_type: "newsletter" });
    }
  }, {
    key: "render",
    value: function render() {
      var subscriptions = this.props.subscriptions;


      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_4__components_Library_Layout__["a" /* default */],
        { includeHeader: true, headerComponent: __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__SubscriptionHeader__["a" /* default */], null) },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_5__components_Library_Layout_Sidebar__["a" /* default */],
          null,
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__components_Library_LatestStories__["a" /* default */], null)
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_6__components_Library_Layout_Content__["a" /* default */],
          null,
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__SubscriptionsList__["a" /* default */], { subscriptions: subscriptions })
        )
      );
    }
  }]);

  return Subscriptions;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

var mapStateToProps = function mapStateToProps(state) {
  return {
    subscriptions: state.subscriptions
  };
};

/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1_react_redux__["b" /* connect */])(mapStateToProps, { getSubscriptions: __WEBPACK_IMPORTED_MODULE_8__actions_subscriptions__["c" /* getSubscriptions */] })(Subscriptions));

/***/ }),

/***/ "./src/subscriptions/components/SubscriptionsList/SubscriptionsList.css":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"root":"SubscriptionsList__root--2Da6g","content":"SubscriptionsList__content---F__n","category":"SubscriptionsList__category--MP2A1","name":"SubscriptionsList__name--30geW","description":"SubscriptionsList__description--3t4qX","separator":"SubscriptionsList__separator--2WjoM","subscribe":"SubscriptionsList__subscribe--2jJ_X","bounce":"SubscriptionsList__bounce--3L-pM"};

/***/ }),

/***/ "./src/subscriptions/components/SubscriptionsList/SubscriptionsList.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__("./node_modules/react/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_router_dom__ = __webpack_require__("./node_modules/react-router-dom/es/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_Library_Spinner__ = __webpack_require__("./src/components/Library/Spinner/Spinner.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_Library_Subscribe__ = __webpack_require__("./src/components/Library/Subscribe/Subscribe.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__SubscriptionsList_css__ = __webpack_require__("./src/subscriptions/components/SubscriptionsList/SubscriptionsList.css");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__SubscriptionsList_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__SubscriptionsList_css__);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }









var SubscriptionsList = function (_Component) {
  _inherits(SubscriptionsList, _Component);

  function SubscriptionsList() {
    _classCallCheck(this, SubscriptionsList);

    return _possibleConstructorReturn(this, (SubscriptionsList.__proto__ || Object.getPrototypeOf(SubscriptionsList)).apply(this, arguments));
  }

  _createClass(SubscriptionsList, [{
    key: "render",
    value: function render() {
      var subscriptions = this.props.subscriptions;

      if (!subscriptions.results || subscriptions.results.length === 0 && subscriptions.isLoading) return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__components_Library_Spinner__["a" /* default */], null);

      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "div",
        null,
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "ul",
          { className: __WEBPACK_IMPORTED_MODULE_4__SubscriptionsList_css___default.a.root },
          subscriptions.results.map(function (subscription, index) {
            return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              "li",
              { key: subscription.id },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                "div",
                { className: __WEBPACK_IMPORTED_MODULE_4__SubscriptionsList_css___default.a.category },
                subscription.category
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                "div",
                { className: __WEBPACK_IMPORTED_MODULE_4__SubscriptionsList_css___default.a.content },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  __WEBPACK_IMPORTED_MODULE_1_react_router_dom__["a" /* Link */],
                  { to: "/newsletters/" + subscription.slug, className: __WEBPACK_IMPORTED_MODULE_4__SubscriptionsList_css___default.a.name },
                  subscription.name
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__components_Library_Subscribe__["a" /* default */], { light: true, className: __WEBPACK_IMPORTED_MODULE_4__SubscriptionsList_css___default.a.subscribe, subscription: subscription })
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                "div",
                { className: __WEBPACK_IMPORTED_MODULE_4__SubscriptionsList_css___default.a.description },
                subscription.description
              ),
              subscriptions.results.length - 1 !== index && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("hr", { className: __WEBPACK_IMPORTED_MODULE_4__SubscriptionsList_css___default.a.separator, "aria-hidden": true })
            );
          })
        )
      );
    }
  }]);

  return SubscriptionsList;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

/* harmony default export */ __webpack_exports__["a"] = (SubscriptionsList);

/***/ }),

/***/ "./src/subscriptions/reducers/newsletters.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__constants_actionTypes__ = __webpack_require__("./src/constants/actionTypes.js");
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };



var initialState = {
  isLoading: false,
  isFinished: false,
  isError: false,
  error: null,
  data: null,
  results: []
};

/* harmony default export */ __webpack_exports__["a"] = (function () {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
  var action = arguments[1];

  switch (action.type) {
    case __WEBPACK_IMPORTED_MODULE_0__constants_actionTypes__["z" /* GET_NEWSLETTER */]:
    case __WEBPACK_IMPORTED_MODULE_0__constants_actionTypes__["A" /* GET_NEWSLETTERS */]:
      {
        return _extends({}, state, {
          isLoading: true,
          isFinished: false,
          isError: false,
          error: null
        });
      }

    case __WEBPACK_IMPORTED_MODULE_0__constants_actionTypes__["E" /* GET_NEWSLETTER_SUCCESS */]:
      {
        return _extends({}, state, {
          isLoading: false,
          isFinished: true,
          data: action.payload
        });
      }

    case __WEBPACK_IMPORTED_MODULE_0__constants_actionTypes__["C" /* GET_NEWSLETTERS_SUCCESS */]:
      {
        return _extends({}, state, {
          isLoading: false,
          isFinished: true,
          results: action.payload
        });
      }

    case __WEBPACK_IMPORTED_MODULE_0__constants_actionTypes__["D" /* GET_NEWSLETTER_ERROR */]:
    case __WEBPACK_IMPORTED_MODULE_0__constants_actionTypes__["B" /* GET_NEWSLETTERS_ERROR */]:
      {
        return _extends({}, state, {
          isLoading: false,
          isFinished: true,
          isError: true,
          error: action.payload
        });
      }

    case __WEBPACK_IMPORTED_MODULE_0__constants_actionTypes__["_0" /* GET_SUBSCRIPTION */]:
      {
        return _extends({}, state, {
          data: null
        });
      }

    default:
      {
        return state;
      }
  }
});

/***/ }),

/***/ "./src/subscriptions/reducers/subscriptions.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__constants_actionTypes__ = __webpack_require__("./src/constants/actionTypes.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_selectn__ = __webpack_require__("./node_modules/selectn/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_selectn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_selectn__);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };




var initialState = {
  isLoading: false,
  isFinished: false,
  isError: false,
  error: null,
  data: null,
  results: []
};

/* harmony default export */ __webpack_exports__["a"] = (function () {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
  var action = arguments[1];

  switch (action.type) {
    case __WEBPACK_IMPORTED_MODULE_0__constants_actionTypes__["_1" /* GET_SUBSCRIPTIONS */]:
    case __WEBPACK_IMPORTED_MODULE_0__constants_actionTypes__["_5" /* GET_SUBSCRIPTION_NEWSLETTERS */]:
      {
        return _extends({}, state, {
          isLoading: true,
          isFinished: false,
          isError: false,
          error: null
        });
      }

    //if we're switching to a new subscription, wipe out old data
    case __WEBPACK_IMPORTED_MODULE_0__constants_actionTypes__["_0" /* GET_SUBSCRIPTION */]:
      {
        return {
          isLoading: true,
          isFinished: false,
          isError: false,
          error: null,
          data: null,
          results: []
        };
      }

    case __WEBPACK_IMPORTED_MODULE_0__constants_actionTypes__["_8" /* GET_SUBSCRIPTION_SUCCESS */]:
      {
        return _extends({}, state, {
          isLoading: false,
          isFinished: true,
          data: _extends({}, state.data, action.payload)
        });
      }

    case __WEBPACK_IMPORTED_MODULE_0__constants_actionTypes__["_3" /* GET_SUBSCRIPTIONS_SUCCESS */]:
      {
        return _extends({}, state, {
          isLoading: false,
          isFinished: true,
          results: action.payload
        });
      }

    case __WEBPACK_IMPORTED_MODULE_0__constants_actionTypes__["_7" /* GET_SUBSCRIPTION_NEWSLETTERS_SUCCESS */]:
      {
        return _extends({}, state, {
          isLoading: false,
          isFinished: true,
          data: _extends({}, state.data, {
            subscription_newsletters: _extends({}, action.payload, {
              results: (__WEBPACK_IMPORTED_MODULE_1_selectn___default()("subscription_newsletters.results", state.data) || []).concat(action.payload.results)
            })
          })
        });
      }

    case __WEBPACK_IMPORTED_MODULE_0__constants_actionTypes__["_4" /* GET_SUBSCRIPTION_ERROR */]:
    case __WEBPACK_IMPORTED_MODULE_0__constants_actionTypes__["_2" /* GET_SUBSCRIPTIONS_ERROR */]:
    case __WEBPACK_IMPORTED_MODULE_0__constants_actionTypes__["_6" /* GET_SUBSCRIPTION_NEWSLETTERS_ERROR */]:
      {
        return _extends({}, state, {
          isLoading: false,
          isFinished: true,
          isError: true,
          error: action.payload
        });
      }

    default:
      {
        return state;
      }
  }
});

/***/ }),

/***/ "./src/users/actions/userSettings.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "typingUserSettings", function() { return typingUserSettings; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "submitUserSettings", function() { return submitUserSettings; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getSubscriptions", function() { return getSubscriptions; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "toggleCheckbox", function() { return toggleCheckbox; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "submitSubscriptions", function() { return submitSubscriptions; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "submitSavedStories", function() { return submitSavedStories; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "deleteAccount", function() { return deleteAccount; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "changePassword", function() { return changePassword; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils_backend__ = __webpack_require__("./src/utils/backend.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__constants_actionTypes__ = __webpack_require__("./src/constants/actionTypes.js");
function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }




var typingUserSettings = function typingUserSettings(obj) {
  return function (dispatch) {
    dispatch({
      type: __WEBPACK_IMPORTED_MODULE_1__constants_actionTypes__["_46" /* TYPING_USER_SETTINGS */],
      payload: obj
    });
  };
};

var submitUserSettings = function submitUserSettings(obj) {
  return function (dispatch) {
    dispatch({
      type: __WEBPACK_IMPORTED_MODULE_1__constants_actionTypes__["_39" /* SUBMIT_USER_SETTINGS */]
    });

    // Omit subscriptions and saved_stories from request otherwise backend will think we are trying to change subscriptions and saved_stories

    var subscriptions = obj.subscriptions,
        saved_stories = obj.saved_stories,
        data = _objectWithoutProperties(obj, ["subscriptions", "saved_stories"]); // eslint-disable-line no-unused-vars

    return __WEBPACK_IMPORTED_MODULE_0__utils_backend__["a" /* default */].request({
      method: "PATCH",
      url: "/readers/update/",
      data: data
    }).then(function () {
      dispatch({
        type: __WEBPACK_IMPORTED_MODULE_1__constants_actionTypes__["_41" /* SUBMIT_USER_SETTINGS_SUCCESS */],
        payload: data
      });
    }).catch(function (err) {
      dispatch({
        type: __WEBPACK_IMPORTED_MODULE_1__constants_actionTypes__["_40" /* SUBMIT_USER_SETTINGS_ERROR */],
        payload: err
      });
    });
  };
};


var getSubscriptions = function getSubscriptions() {
  return function (dispatch) {
    dispatch({
      type: __WEBPACK_IMPORTED_MODULE_1__constants_actionTypes__["_16" /* GET_USER_SUBSCRIPTIONS */]
    });

    return __WEBPACK_IMPORTED_MODULE_0__utils_backend__["a" /* default */].request({
      method: "GET",
      url: "/subscriptions/"
    }).then(function (response) {
      dispatch({
        type: __WEBPACK_IMPORTED_MODULE_1__constants_actionTypes__["_18" /* GET_USER_SUBSCRIPTIONS_SUCCESS */],
        payload: response.data.results
      });
    }).catch(function (err) {
      dispatch({
        type: __WEBPACK_IMPORTED_MODULE_1__constants_actionTypes__["_17" /* GET_USER_SUBSCRIPTIONS_ERROR */],
        payload: err
      });
    });
  };
};

var toggleCheckbox = function toggleCheckbox(subscriptions, name, checked) {
  return function (dispatch) {
    var newSubscriptions = subscriptions;

    if (checked) {
      newSubscriptions = newSubscriptions.concat(name);
    } else {
      newSubscriptions = newSubscriptions.filter(function (subscription) {
        return subscription !== name;
      });
    }

    dispatch({
      type: __WEBPACK_IMPORTED_MODULE_1__constants_actionTypes__["f" /* CHANGE_USER_SUBSCRIPTIONS */],
      payload: newSubscriptions
    });
  };
};

var submitSubscriptions = function submitSubscriptions(subscriptionIds) {
  return function (dispatch) {
    dispatch({
      type: __WEBPACK_IMPORTED_MODULE_1__constants_actionTypes__["_42" /* SUBMIT_USER_SUBSCRIPTIONS */]
    });

    return __WEBPACK_IMPORTED_MODULE_0__utils_backend__["a" /* default */].request({
      method: "PATCH",
      url: "/readers/update/",
      data: {
        subscriptions: subscriptionIds
      }
    }).then(function () {
      dispatch({
        type: __WEBPACK_IMPORTED_MODULE_1__constants_actionTypes__["_44" /* SUBMIT_USER_SUBSCRIPTIONS_SUCCESS */]
      });
    }).catch(function (err) {
      dispatch({
        type: __WEBPACK_IMPORTED_MODULE_1__constants_actionTypes__["_43" /* SUBMIT_USER_SUBSCRIPTIONS_ERROR */],
        payload: err
      });
    });
  };
};

var submitSavedStories = function submitSavedStories(savedStoryIds) {
  return function (dispatch) {
    dispatch({
      type: __WEBPACK_IMPORTED_MODULE_1__constants_actionTypes__["_36" /* SUBMIT_USER_SAVED_STORIES */]
    });

    return __WEBPACK_IMPORTED_MODULE_0__utils_backend__["a" /* default */].request({
      method: "PATCH",
      url: "/readers/update/",
      data: {
        saved_stories: savedStoryIds
      }
    }).then(function () {
      dispatch({
        type: __WEBPACK_IMPORTED_MODULE_1__constants_actionTypes__["_38" /* SUBMIT_USER_SAVED_STORIES_SUCCESS */],
        payload: savedStoryIds
      });
    }).catch(function (err) {
      dispatch({
        type: __WEBPACK_IMPORTED_MODULE_1__constants_actionTypes__["_37" /* SUBMIT_USER_SAVED_STORIES_ERROR */],
        payload: err
      });
    });
  };
};

var deleteAccount = function deleteAccount() {
  return function (dispatch) {
    dispatch({
      type: __WEBPACK_IMPORTED_MODULE_1__constants_actionTypes__["i" /* DELETE_ACCOUNT */]
    });

    return __WEBPACK_IMPORTED_MODULE_0__utils_backend__["a" /* default */].request({
      method: "DELETE",
      url: "/readers/delete/"
    }).then(function () {
      dispatch({
        type: __WEBPACK_IMPORTED_MODULE_1__constants_actionTypes__["k" /* DELETE_ACCOUNT_SUCCESS */]
      });
    }).catch(function (err) {
      dispatch({
        type: __WEBPACK_IMPORTED_MODULE_1__constants_actionTypes__["j" /* DELETE_ACCOUNT_ERROR */],
        payload: err
      });
    });
  };
};

var changePassword = function changePassword(passwords) {
  return function (dispatch) {
    dispatch({
      type: __WEBPACK_IMPORTED_MODULE_1__constants_actionTypes__["b" /* CHANGE_PASSWORD */]
    });

    return __WEBPACK_IMPORTED_MODULE_0__utils_backend__["a" /* default */].request({
      method: "POST",
      url: "/readers/update-password/",
      data: {
        password: passwords.password,
        password1: passwords.password1,
        password2: passwords.password2
      }
    }).then(function () {
      dispatch({
        type: __WEBPACK_IMPORTED_MODULE_1__constants_actionTypes__["d" /* CHANGE_PASSWORD_SUCCESS */]
      });
    }).catch(function (err) {
      dispatch({
        type: __WEBPACK_IMPORTED_MODULE_1__constants_actionTypes__["c" /* CHANGE_PASSWORD_ERROR */],
        payload: err
      });
    });
  };
};

/***/ }),

/***/ "./src/users/components/SavedStories/SavedStories.css":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"blueButton1":"SavedStories__blueButton1--1D-G6","bottomBlock":"SavedStories__bottomBlock--1uHza","block":"SavedStories__block--3KYPp","centered":"SavedStories__centered--3bGU4","mobileBlock":"SavedStories__mobileBlock--3kjz9","disabled":"SavedStories__disabled--HNfca","blueButton2":"SavedStories__blueButton2--X7Ypj","grayButton1":"SavedStories__grayButton1--15yJr","savedStoriesEmpty":"SavedStories__savedStoriesEmpty--Sy72F","emptyIcon":"SavedStories__emptyIcon--x9bQN","emptyText":"SavedStories__emptyText--K59Mz","emptyButton":"SavedStories__emptyButton--fTfeS"};

/***/ }),

/***/ "./src/users/components/SavedStories/SavedStories.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__("./node_modules/react/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_router_dom__ = __webpack_require__("./node_modules/react-router-dom/es/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_redux__ = __webpack_require__("./node_modules/react-redux/es/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_redux__ = __webpack_require__("./node_modules/redux/es/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_classnames__ = __webpack_require__("./node_modules/classnames/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__actions_user__ = __webpack_require__("./src/actions/user.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_Library_UserHeader__ = __webpack_require__("./src/components/Library/UserHeader/UserHeader.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_Library_Layout__ = __webpack_require__("./src/components/Library/Layout/Layout.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_Library_Layout_Sidebar__ = __webpack_require__("./src/components/Library/Layout/Sidebar.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_Library_Layout_Content__ = __webpack_require__("./src/components/Library/Layout/Content.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__components_Library_SummaryCard_SummaryCard__ = __webpack_require__("./src/components/Library/SummaryCard/SummaryCard.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__SavedStoriesEmpty__ = __webpack_require__("./src/users/components/SavedStories/SavedStoriesEmpty.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__UserSettings_UserSettings_css__ = __webpack_require__("./src/users/components/UserSettings/UserSettings.css");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__UserSettings_UserSettings_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12__UserSettings_UserSettings_css__);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
















var SavedStories = function (_Component) {
  _inherits(SavedStories, _Component);

  function SavedStories() {
    _classCallCheck(this, SavedStories);

    return _possibleConstructorReturn(this, (SavedStories.__proto__ || Object.getPrototypeOf(SavedStories)).apply(this, arguments));
  }

  _createClass(SavedStories, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this.props.getUserData();
    }
  }, {
    key: "render",
    value: function render() {
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_7__components_Library_Layout__["a" /* default */],
        { className: __WEBPACK_IMPORTED_MODULE_12__UserSettings_UserSettings_css___default.a.root, includeHeader: true, headerComponent: __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__components_Library_UserHeader__["a" /* default */], { person: { display_name: this.props.userSettings.data.profileInfo.display_name } }) },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_8__components_Library_Layout_Sidebar__["a" /* default */],
          { className: __WEBPACK_IMPORTED_MODULE_12__UserSettings_UserSettings_css___default.a.sidebar },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_1_react_router_dom__["a" /* Link */],
            { to: "/users/saved-stories", className: __WEBPACK_IMPORTED_MODULE_4_classnames___default()(__WEBPACK_IMPORTED_MODULE_12__UserSettings_UserSettings_css___default.a.sidebarLinks, __WEBPACK_IMPORTED_MODULE_12__UserSettings_UserSettings_css___default.a.active) },
            "Saved Stories"
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_1_react_router_dom__["a" /* Link */],
            { to: "/users/settings", className: __WEBPACK_IMPORTED_MODULE_12__UserSettings_UserSettings_css___default.a.sidebarLinks },
            "Account"
          )
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_9__components_Library_Layout_Content__["a" /* default */],
          { ariaLabel: "Save Stories" },
          this.props.userSettings.data.profileInfo.saved_stories.map(function (savedStory, index) {
            return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__components_Library_SummaryCard_SummaryCard__["a" /* default */], { key: index, story: savedStory, showSaveTag: true });
          }),
          this.props.userSettings.data.profileInfo.saved_stories.length === 0 ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__SavedStoriesEmpty__["a" /* default */], null) : null
        )
      );
    }
  }]);

  return SavedStories;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

var mapStateToProps = function mapStateToProps(state) {
  return {
    userSettings: state.userSettings
  };
};

var mapDispatchToProps = function mapDispatchToProps(dispatch) {
  return {
    getUserData: Object(__WEBPACK_IMPORTED_MODULE_3_redux__["b" /* bindActionCreators */])(__WEBPACK_IMPORTED_MODULE_5__actions_user__["a" /* getUserData */], dispatch)
  };
};

/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_2_react_redux__["b" /* connect */])(mapStateToProps, mapDispatchToProps)(SavedStories));

/***/ }),

/***/ "./src/users/components/SavedStories/SavedStoriesEmpty.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__("./node_modules/react/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_router_dom__ = __webpack_require__("./node_modules/react-router-dom/es/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_classnames__ = __webpack_require__("./node_modules/classnames/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_Library_Icon__ = __webpack_require__("./src/components/Library/Icon/Icon.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__SavedStories_css__ = __webpack_require__("./src/users/components/SavedStories/SavedStories.css");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__SavedStories_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__SavedStories_css__);







var SavedStoriesEmpty = function SavedStoriesEmpty() {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    "div",
    { className: __WEBPACK_IMPORTED_MODULE_4__SavedStories_css___default.a.savedStoriesEmpty },
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      "div",
      null,
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__components_Library_Icon__["a" /* default */], { name: "save", description: "Save story", className: __WEBPACK_IMPORTED_MODULE_4__SavedStories_css___default.a.emptyIcon })
    ),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      "h3",
      { className: __WEBPACK_IMPORTED_MODULE_4__SavedStories_css___default.a.emptyText },
      "You haven't saved any stories yet."
    ),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      "div",
      null,
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_1_react_router_dom__["a" /* Link */],
        { to: "/", className: __WEBPACK_IMPORTED_MODULE_2_classnames___default()(__WEBPACK_IMPORTED_MODULE_4__SavedStories_css___default.a.blueButton1, __WEBPACK_IMPORTED_MODULE_4__SavedStories_css___default.a.emptyButton) },
        "Read top stories"
      )
    )
  );
};

/* harmony default export */ __webpack_exports__["a"] = (SavedStoriesEmpty);

/***/ }),

/***/ "./src/users/components/UserSettings/ChangePassword.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__("./node_modules/react/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__("./node_modules/react-redux/es/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_redux__ = __webpack_require__("./node_modules/redux/es/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_classnames__ = __webpack_require__("./node_modules/classnames/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__actions_userSettings__ = __webpack_require__("./src/users/actions/userSettings.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__UserSettings_css__ = __webpack_require__("./src/users/components/UserSettings/UserSettings.css");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__UserSettings_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__UserSettings_css__);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }









var ChangePassword = function (_Component) {
  _inherits(ChangePassword, _Component);

  function ChangePassword() {
    _classCallCheck(this, ChangePassword);

    var _this = _possibleConstructorReturn(this, (ChangePassword.__proto__ || Object.getPrototypeOf(ChangePassword)).call(this));

    _this.state = {
      password: "",
      password1: "",
      password2: ""
    };

    _this.changePassword = _this.changePassword.bind(_this);
    _this.handleChange = _this.handleChange.bind(_this);
    return _this;
  }

  _createClass(ChangePassword, [{
    key: "handleChange",
    value: function handleChange(event) {
      this.setState(_defineProperty({}, event.target.name, event.target.value));
    }
  }, {
    key: "changePassword",
    value: function changePassword() {
      var _this2 = this;

      this.props.userSettingsActions.changePassword(this.state).then(function () {
        _this2.props.toggleChangePassword();
      });
    }
  }, {
    key: "render",
    value: function render() {
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "div",
        { className: __WEBPACK_IMPORTED_MODULE_5__UserSettings_css___default.a.grayOverlay },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "div",
          { className: __WEBPACK_IMPORTED_MODULE_3_classnames___default()(__WEBPACK_IMPORTED_MODULE_5__UserSettings_css___default.a.createNewPasswordBox) },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            "h2",
            null,
            "Create a new password"
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            "div",
            { className: __WEBPACK_IMPORTED_MODULE_5__UserSettings_css___default.a.inputLabels },
            "Current password"
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            "div",
            null,
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("input", { onChange: this.handleChange, name: "password", className: __WEBPACK_IMPORTED_MODULE_5__UserSettings_css___default.a.changePasswordInputs, type: "password", placeholder: "Type your current password", "aria-label": "Current Password" })
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            "div",
            { className: __WEBPACK_IMPORTED_MODULE_5__UserSettings_css___default.a.inputLabels },
            "New password"
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            "div",
            null,
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("input", { onChange: this.handleChange, name: "password1", className: __WEBPACK_IMPORTED_MODULE_5__UserSettings_css___default.a.changePasswordInputs, type: "password", placeholder: "Type your new password", "aria-label": "New Password" })
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            "div",
            { className: __WEBPACK_IMPORTED_MODULE_5__UserSettings_css___default.a.inputLabels },
            "Confirm new password"
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            "div",
            null,
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("input", { onChange: this.handleChange, name: "password2", className: __WEBPACK_IMPORTED_MODULE_5__UserSettings_css___default.a.changePasswordInputs, type: "password", placeholder: "Confirm your new password", "aria-label": "Confirm New Password" })
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            "div",
            { className: __WEBPACK_IMPORTED_MODULE_5__UserSettings_css___default.a.centerButtons },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              "button",
              { onClick: this.changePassword, className: __WEBPACK_IMPORTED_MODULE_3_classnames___default()(__WEBPACK_IMPORTED_MODULE_5__UserSettings_css___default.a.changePasswordConfirmButton, __WEBPACK_IMPORTED_MODULE_5__UserSettings_css___default.a.blueButton1) },
              "Submit"
            )
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            "div",
            { className: __WEBPACK_IMPORTED_MODULE_5__UserSettings_css___default.a.centerButtons },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              "button",
              { onClick: this.props.toggleChangePassword, className: __WEBPACK_IMPORTED_MODULE_3_classnames___default()(__WEBPACK_IMPORTED_MODULE_5__UserSettings_css___default.a.cancelChangePasswordButton, __WEBPACK_IMPORTED_MODULE_5__UserSettings_css___default.a.grayButton1) },
              "Cancel"
            )
          )
        )
      );
    }
  }]);

  return ChangePassword;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

var mapStateToProps = function mapStateToProps(state) {
  return {
    userSettings: state.userSettings
  };
};

var mapDispatchToProps = function mapDispatchToProps(dispatch) {
  return {
    userSettingsActions: Object(__WEBPACK_IMPORTED_MODULE_2_redux__["b" /* bindActionCreators */])(__WEBPACK_IMPORTED_MODULE_4__actions_userSettings__, dispatch)
  };
};

/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1_react_redux__["b" /* connect */])(mapStateToProps, mapDispatchToProps)(ChangePassword));

/***/ }),

/***/ "./src/users/components/UserSettings/DeleteAccount.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__("./node_modules/react/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__("./node_modules/react-redux/es/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_redux__ = __webpack_require__("./node_modules/redux/es/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_classnames__ = __webpack_require__("./node_modules/classnames/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_router_dom__ = __webpack_require__("./node_modules/react-router-dom/es/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__actions_userSettings__ = __webpack_require__("./src/users/actions/userSettings.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__UserSettings_css__ = __webpack_require__("./src/users/components/UserSettings/UserSettings.css");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__UserSettings_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__UserSettings_css__);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }










var DeleteAccount = function (_Component) {
  _inherits(DeleteAccount, _Component);

  function DeleteAccount() {
    _classCallCheck(this, DeleteAccount);

    var _this = _possibleConstructorReturn(this, (DeleteAccount.__proto__ || Object.getPrototypeOf(DeleteAccount)).call(this));

    _this.deleteAccount = _this.deleteAccount.bind(_this);
    return _this;
  }

  _createClass(DeleteAccount, [{
    key: "deleteAccount",
    value: function deleteAccount() {
      var _this2 = this;

      this.props.userSettingsActions.deleteAccount().then(function () {
        _this2.props.history.push({ pathname: "/" });
      });
    }
  }, {
    key: "render",
    value: function render() {
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "div",
        { className: __WEBPACK_IMPORTED_MODULE_6__UserSettings_css___default.a.grayOverlay },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "div",
          { className: __WEBPACK_IMPORTED_MODULE_6__UserSettings_css___default.a.deleteAccountBox },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            "h2",
            null,
            "Are you sure you want to delete your account?"
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            "div",
            { className: __WEBPACK_IMPORTED_MODULE_6__UserSettings_css___default.a.grayText },
            "This action is permanent and cannot be reversed."
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            "div",
            null,
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              "button",
              { onClick: this.deleteAccount, className: __WEBPACK_IMPORTED_MODULE_3_classnames___default()(__WEBPACK_IMPORTED_MODULE_6__UserSettings_css___default.a.deleteConfirmButton, __WEBPACK_IMPORTED_MODULE_6__UserSettings_css___default.a.blueButton1) },
              "Yes, delete"
            )
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            "div",
            null,
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              "button",
              { onClick: this.props.toggleDeleteAccount, className: __WEBPACK_IMPORTED_MODULE_3_classnames___default()(__WEBPACK_IMPORTED_MODULE_6__UserSettings_css___default.a.cancelDeleteButton, __WEBPACK_IMPORTED_MODULE_6__UserSettings_css___default.a.grayButton1) },
              "No, cancel"
            )
          )
        )
      );
    }
  }]);

  return DeleteAccount;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

var mapStateToProps = function mapStateToProps(state) {
  return {
    userSettings: state.userSettings
  };
};

var mapDispatchToProps = function mapDispatchToProps(dispatch) {
  return {
    userSettingsActions: Object(__WEBPACK_IMPORTED_MODULE_2_redux__["b" /* bindActionCreators */])(__WEBPACK_IMPORTED_MODULE_5__actions_userSettings__, dispatch)
  };
};

/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_4_react_router_dom__["e" /* withRouter */])(Object(__WEBPACK_IMPORTED_MODULE_1_react_redux__["b" /* connect */])(mapStateToProps, mapDispatchToProps)(DeleteAccount)));

/***/ }),

/***/ "./src/users/components/UserSettings/ProfileSettings.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__("./node_modules/react/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__("./node_modules/react-redux/es/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_redux__ = __webpack_require__("./node_modules/redux/es/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_reactstrap_lib_Row__ = __webpack_require__("./node_modules/reactstrap/lib/Row.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_reactstrap_lib_Row___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_reactstrap_lib_Row__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_reactstrap_lib_Col__ = __webpack_require__("./node_modules/reactstrap/lib/Col.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_reactstrap_lib_Col___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_reactstrap_lib_Col__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_classnames__ = __webpack_require__("./node_modules/classnames/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__actions_userSettings__ = __webpack_require__("./src/users/actions/userSettings.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__DeleteAccount__ = __webpack_require__("./src/users/components/UserSettings/DeleteAccount.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__ChangePassword__ = __webpack_require__("./src/users/components/UserSettings/ChangePassword.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__utils_toggleScroll__ = __webpack_require__("./src/utils/toggleScroll.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__UserSettings_css__ = __webpack_require__("./src/users/components/UserSettings/UserSettings.css");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__UserSettings_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10__UserSettings_css__);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }







// import Icon from "../../../components/Library/Icon/Icon";








var ProfileSettings = function (_Component) {
  _inherits(ProfileSettings, _Component);

  function ProfileSettings() {
    _classCallCheck(this, ProfileSettings);

    var _this = _possibleConstructorReturn(this, (ProfileSettings.__proto__ || Object.getPrototypeOf(ProfileSettings)).call(this));

    _this.state = {
      showDeleteAccount: false
    };

    _this.handleChange = _this.handleChange.bind(_this);
    _this.handleSubmit = _this.handleSubmit.bind(_this);

    _this.toggleDeleteAccount = _this.toggleDeleteAccount.bind(_this);
    _this.toggleChangePassword = _this.toggleChangePassword.bind(_this);
    return _this;
  }

  _createClass(ProfileSettings, [{
    key: "handleChange",
    value: function handleChange(event) {
      this.props.userSettingsActions.typingUserSettings(_defineProperty({}, event.target.name, event.target.value));
    }
  }, {
    key: "handleSubmit",
    value: function handleSubmit() {
      this.props.userSettingsActions.submitUserSettings(this.props.userSettings.data.profileInfo);
    }
  }, {
    key: "toggleDeleteAccount",
    value: function toggleDeleteAccount() {
      Object(__WEBPACK_IMPORTED_MODULE_9__utils_toggleScroll__["a" /* default */])();
      this.setState({ showDeleteAccount: !this.state.showDeleteAccount });
    }
  }, {
    key: "toggleChangePassword",
    value: function toggleChangePassword() {
      Object(__WEBPACK_IMPORTED_MODULE_9__utils_toggleScroll__["a" /* default */])();
      this.setState({ showChangePassword: !this.state.showChangePassword });
    }
  }, {
    key: "render",
    value: function render() {
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "div",
        { className: __WEBPACK_IMPORTED_MODULE_10__UserSettings_css___default.a.infoWrapper },
        this.state.showDeleteAccount ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__DeleteAccount__["a" /* default */], { toggleDeleteAccount: this.toggleDeleteAccount }) : null,
        this.state.showChangePassword ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__ChangePassword__["a" /* default */], { toggleChangePassword: this.toggleChangePassword }) : null,
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "div",
          { className: __WEBPACK_IMPORTED_MODULE_10__UserSettings_css___default.a.blueHeading },
          "PROFILE"
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_3_reactstrap_lib_Row___default.a,
          { className: __WEBPACK_IMPORTED_MODULE_10__UserSettings_css___default.a.marginTop20 },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_4_reactstrap_lib_Col___default.a,
            { lg: "2", sm: "12", xs: "12", className: __WEBPACK_IMPORTED_MODULE_10__UserSettings_css___default.a.muted },
            "FIRST NAME"
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_4_reactstrap_lib_Col___default.a,
            { lg: "10", sm: "12", xs: "12" },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("input", { "aria-label": "First name", onChange: this.handleChange, name: "first_name", type: "text", className: __WEBPACK_IMPORTED_MODULE_10__UserSettings_css___default.a.bottomLineInputs, value: this.props.userSettings.data.profileInfo.first_name })
          )
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_3_reactstrap_lib_Row___default.a,
          { className: __WEBPACK_IMPORTED_MODULE_10__UserSettings_css___default.a.marginTop20 },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_4_reactstrap_lib_Col___default.a,
            { lg: "2", sm: "12", xs: "12", className: __WEBPACK_IMPORTED_MODULE_10__UserSettings_css___default.a.muted },
            "LAST NAME"
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_4_reactstrap_lib_Col___default.a,
            { lg: "10", sm: "12", xs: "12" },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("input", { "aria-label": "Last Name", onChange: this.handleChange, name: "last_name", type: "text", className: __WEBPACK_IMPORTED_MODULE_10__UserSettings_css___default.a.bottomLineInputs, value: this.props.userSettings.data.profileInfo.last_name })
          )
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_3_reactstrap_lib_Row___default.a,
          { className: __WEBPACK_IMPORTED_MODULE_10__UserSettings_css___default.a.marginTop20 },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_4_reactstrap_lib_Col___default.a,
            { lg: "2", sm: "12", xs: "12", className: __WEBPACK_IMPORTED_MODULE_10__UserSettings_css___default.a.muted },
            "EMAIL"
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_4_reactstrap_lib_Col___default.a,
            { lg: "10", sm: "12", xs: "12" },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("input", { "aria-label": "Email", onChange: this.handleChange, name: "email", type: "email", className: __WEBPACK_IMPORTED_MODULE_10__UserSettings_css___default.a.bottomLineInputs, value: this.props.userSettings.data.profileInfo.email })
          )
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_3_reactstrap_lib_Row___default.a,
          { className: __WEBPACK_IMPORTED_MODULE_10__UserSettings_css___default.a.marginTop20 },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_4_reactstrap_lib_Col___default.a,
            { lg: "2", sm: "12", xs: "12", className: __WEBPACK_IMPORTED_MODULE_10__UserSettings_css___default.a.muted },
            "JOB TITLE"
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_4_reactstrap_lib_Col___default.a,
            { lg: "10", sm: "12", xs: "12" },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("input", { "aria-label": "Job Title", onChange: this.handleChange, name: "job_title", type: "text", className: __WEBPACK_IMPORTED_MODULE_10__UserSettings_css___default.a.bottomLineInputs, value: this.props.userSettings.data.profileInfo.job_title })
          )
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_3_reactstrap_lib_Row___default.a,
          { className: __WEBPACK_IMPORTED_MODULE_10__UserSettings_css___default.a.marginTop20 },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_4_reactstrap_lib_Col___default.a,
            { lg: "2", sm: "12", xs: "12", className: __WEBPACK_IMPORTED_MODULE_10__UserSettings_css___default.a.muted },
            "INDUSTRY"
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_4_reactstrap_lib_Col___default.a,
            { lg: "10", sm: "12", xs: "12" },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("input", { "aria-label": "Industry", onChange: this.handleChange, name: "industry", type: "text", className: __WEBPACK_IMPORTED_MODULE_10__UserSettings_css___default.a.bottomLineInputs, value: this.props.userSettings.data.profileInfo.industry })
          )
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "div",
          { className: __WEBPACK_IMPORTED_MODULE_10__UserSettings_css___default.a.marginTop40 },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            "button",
            { onClick: this.toggleChangePassword, className: __WEBPACK_IMPORTED_MODULE_5_classnames___default()(__WEBPACK_IMPORTED_MODULE_10__UserSettings_css___default.a.grayButton1, __WEBPACK_IMPORTED_MODULE_10__UserSettings_css___default.a.mobileBlock) },
            "Change your password"
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            "button",
            { onClick: this.toggleDeleteAccount, type: "button", className: __WEBPACK_IMPORTED_MODULE_5_classnames___default()(__WEBPACK_IMPORTED_MODULE_10__UserSettings_css___default.a.grayButton1, __WEBPACK_IMPORTED_MODULE_10__UserSettings_css___default.a.mobileBlock, __WEBPACK_IMPORTED_MODULE_10__UserSettings_css___default.a.deleteAccountButton) },
            "Delete your account"
          )
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "div",
          { className: __WEBPACK_IMPORTED_MODULE_10__UserSettings_css___default.a.textCenter },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            "button",
            { onClick: this.handleSubmit, type: "button", className: __WEBPACK_IMPORTED_MODULE_5_classnames___default()(__WEBPACK_IMPORTED_MODULE_10__UserSettings_css___default.a.blueButton1, __WEBPACK_IMPORTED_MODULE_10__UserSettings_css___default.a.mobileBlock, __WEBPACK_IMPORTED_MODULE_10__UserSettings_css___default.a.saveProfileChangesButton) },
            "Save changes"
          )
        )
      );
    }
  }]);

  return ProfileSettings;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

var mapStateToProps = function mapStateToProps(state) {
  return {
    userSettings: state.userSettings
  };
};

var mapDispatchToProps = function mapDispatchToProps(dispatch) {
  return {
    userSettingsActions: Object(__WEBPACK_IMPORTED_MODULE_2_redux__["b" /* bindActionCreators */])(__WEBPACK_IMPORTED_MODULE_6__actions_userSettings__, dispatch)
  };
};

/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1_react_redux__["b" /* connect */])(mapStateToProps, mapDispatchToProps)(ProfileSettings));

/***/ }),

/***/ "./src/users/components/UserSettings/SocialSettings.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__("./node_modules/react/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__("./node_modules/react-redux/es/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_redux__ = __webpack_require__("./node_modules/redux/es/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_reactstrap_lib_Row__ = __webpack_require__("./node_modules/reactstrap/lib/Row.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_reactstrap_lib_Row___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_reactstrap_lib_Row__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_reactstrap_lib_Col__ = __webpack_require__("./node_modules/reactstrap/lib/Col.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_reactstrap_lib_Col___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_reactstrap_lib_Col__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_classnames__ = __webpack_require__("./node_modules/classnames/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__actions_userSettings__ = __webpack_require__("./src/users/actions/userSettings.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__UserSettings_css__ = __webpack_require__("./src/users/components/UserSettings/UserSettings.css");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__UserSettings_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__UserSettings_css__);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }











var SocialSettings = function (_Component) {
  _inherits(SocialSettings, _Component);

  function SocialSettings() {
    _classCallCheck(this, SocialSettings);

    var _this = _possibleConstructorReturn(this, (SocialSettings.__proto__ || Object.getPrototypeOf(SocialSettings)).call(this));

    _this.handleChange = _this.handleChange.bind(_this);
    _this.handleSubmit = _this.handleSubmit.bind(_this);
    return _this;
  }

  _createClass(SocialSettings, [{
    key: "handleChange",
    value: function handleChange(event) {
      this.props.userSettingsActions.typingUserSettings(_defineProperty({}, event.target.name, event.target.value));
    }
  }, {
    key: "handleSubmit",
    value: function handleSubmit() {
      this.props.userSettingsActions.submitUserSettings(this.props.userSettings.data.profileInfo);
    }
  }, {
    key: "render",
    value: function render() {
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "div",
        { className: __WEBPACK_IMPORTED_MODULE_5_classnames___default()(__WEBPACK_IMPORTED_MODULE_7__UserSettings_css___default.a.infoWrapper, __WEBPACK_IMPORTED_MODULE_7__UserSettings_css___default.a.marginTop20) },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "div",
          { className: __WEBPACK_IMPORTED_MODULE_7__UserSettings_css___default.a.blueHeading },
          "SOCIAL MEDIA"
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_3_reactstrap_lib_Row___default.a,
          { className: __WEBPACK_IMPORTED_MODULE_7__UserSettings_css___default.a.marginTop20 },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_4_reactstrap_lib_Col___default.a,
            { lg: "2", sm: "12", xs: "12", className: __WEBPACK_IMPORTED_MODULE_7__UserSettings_css___default.a.muted },
            "LINKEDIN"
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_4_reactstrap_lib_Col___default.a,
            { lg: "10", sm: "12", xs: "12" },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("input", { "aria-label": "LinkedIn", name: "linkedin", onChange: this.handleChange, type: "text", className: __WEBPACK_IMPORTED_MODULE_7__UserSettings_css___default.a.bottomLineInputs, value: this.props.userSettings.data.profileInfo.linkedin })
          )
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_3_reactstrap_lib_Row___default.a,
          { className: __WEBPACK_IMPORTED_MODULE_7__UserSettings_css___default.a.marginTop20 },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_4_reactstrap_lib_Col___default.a,
            { lg: "2", sm: "12", xs: "12", className: __WEBPACK_IMPORTED_MODULE_7__UserSettings_css___default.a.muted },
            "FACEBOOK"
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_4_reactstrap_lib_Col___default.a,
            { lg: "10", sm: "12", xs: "12" },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("input", { "aria-label": "Facebook", name: "facebook", onChange: this.handleChange, type: "text", className: __WEBPACK_IMPORTED_MODULE_7__UserSettings_css___default.a.bottomLineInputs, value: this.props.userSettings.data.profileInfo.facebook })
          )
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_3_reactstrap_lib_Row___default.a,
          { className: __WEBPACK_IMPORTED_MODULE_7__UserSettings_css___default.a.marginTop20 },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_4_reactstrap_lib_Col___default.a,
            { lg: "2", sm: "12", xs: "12", className: __WEBPACK_IMPORTED_MODULE_7__UserSettings_css___default.a.muted },
            "TWITTER"
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_4_reactstrap_lib_Col___default.a,
            { lg: "10", sm: "12", xs: "12" },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("input", { "aria-label": "Twitter", name: "twitter", onChange: this.handleChange, type: "text", className: __WEBPACK_IMPORTED_MODULE_7__UserSettings_css___default.a.bottomLineInputs, value: this.props.userSettings.data.profileInfo.twitter })
          )
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "div",
          { className: __WEBPACK_IMPORTED_MODULE_7__UserSettings_css___default.a.textCenter },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            "button",
            { onClick: this.handleSubmit, type: "button", className: __WEBPACK_IMPORTED_MODULE_5_classnames___default()(__WEBPACK_IMPORTED_MODULE_7__UserSettings_css___default.a.marginTop40, __WEBPACK_IMPORTED_MODULE_7__UserSettings_css___default.a.blueButton1, __WEBPACK_IMPORTED_MODULE_7__UserSettings_css___default.a.mobileBlock, __WEBPACK_IMPORTED_MODULE_7__UserSettings_css___default.a.saveSocialButton) },
            "Save changes"
          )
        )
      );
    }
  }]);

  return SocialSettings;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

var mapStateToProps = function mapStateToProps(state) {
  return {
    userSettings: state.userSettings
  };
};

var mapDispatchToProps = function mapDispatchToProps(dispatch) {
  return {
    userSettingsActions: Object(__WEBPACK_IMPORTED_MODULE_2_redux__["b" /* bindActionCreators */])(__WEBPACK_IMPORTED_MODULE_6__actions_userSettings__, dispatch)
  };
};

/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1_react_redux__["b" /* connect */])(mapStateToProps, mapDispatchToProps)(SocialSettings));

/***/ }),

/***/ "./src/users/components/UserSettings/SubscriptionSettings.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__("./node_modules/react/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__("./node_modules/react-redux/es/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_redux__ = __webpack_require__("./node_modules/redux/es/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_reactstrap_lib_Row__ = __webpack_require__("./node_modules/reactstrap/lib/Row.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_reactstrap_lib_Row___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_reactstrap_lib_Row__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_reactstrap_lib_Col__ = __webpack_require__("./node_modules/reactstrap/lib/Col.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_reactstrap_lib_Col___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_reactstrap_lib_Col__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_icheck_lib_Checkbox__ = __webpack_require__("./node_modules/react-icheck/lib/Checkbox.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_icheck_lib_Checkbox___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_react_icheck_lib_Checkbox__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_classnames__ = __webpack_require__("./node_modules/classnames/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__actions_userSettings__ = __webpack_require__("./src/users/actions/userSettings.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__UserSettings_css__ = __webpack_require__("./src/users/components/UserSettings/UserSettings.css");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__UserSettings_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__UserSettings_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__styles_icheck_square_blue_css__ = __webpack_require__("./src/styles/icheck/square/blue.css");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__styles_icheck_square_blue_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__styles_icheck_square_blue_css__);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }













var SubscriptionSettings = function (_Component) {
  _inherits(SubscriptionSettings, _Component);

  function SubscriptionSettings() {
    _classCallCheck(this, SubscriptionSettings);

    var _this = _possibleConstructorReturn(this, (SubscriptionSettings.__proto__ || Object.getPrototypeOf(SubscriptionSettings)).call(this));

    _this.handleChange = _this.handleChange.bind(_this);
    _this.handleSubmit = _this.handleSubmit.bind(_this);
    return _this;
  }

  _createClass(SubscriptionSettings, [{
    key: "handleChange",
    value: function handleChange(event) {
      this.props.userSettingsActions.toggleCheckbox(this.props.userSettings.data.profileInfo.subscriptionIds, event.target.name, event.target.checked);
    }
  }, {
    key: "handleSubmit",
    value: function handleSubmit() {
      this.props.userSettingsActions.submitSubscriptions(this.props.userSettings.data.profileInfo.subscriptionIds);
    }
  }, {
    key: "createNewsletterName",
    value: function createNewsletterName(name) {
      // Pluralize the newsletter names if found in the lookup
      var lookups = {
        "alert": "Alerts",
        "newsletter": "Newsletters"
      };

      var newName = lookups[name] || name;

      return newName.toUpperCase();
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "div",
        { className: __WEBPACK_IMPORTED_MODULE_6_classnames___default()(__WEBPACK_IMPORTED_MODULE_8__UserSettings_css___default.a.infoWrapper, __WEBPACK_IMPORTED_MODULE_8__UserSettings_css___default.a.marginTop20) },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "div",
          { className: __WEBPACK_IMPORTED_MODULE_8__UserSettings_css___default.a.blueHeading },
          "EMAIL SUBSCRIPTIONS"
        ),
        Object.keys(this.props.userSettings.data.subscriptions).map(function (key, kIndex) {
          var subscriptions = _this2.props.userSettings.data.subscriptions[key];

          return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_3_reactstrap_lib_Row___default.a,
            { key: kIndex, className: __WEBPACK_IMPORTED_MODULE_8__UserSettings_css___default.a.marginTop20 },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              __WEBPACK_IMPORTED_MODULE_4_reactstrap_lib_Col___default.a,
              { lg: "2", sm: "12", xs: "12", className: __WEBPACK_IMPORTED_MODULE_8__UserSettings_css___default.a.muted },
              _this2.createNewsletterName(key)
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              __WEBPACK_IMPORTED_MODULE_4_reactstrap_lib_Col___default.a,
              { lg: "10", sm: "12", xs: "12" },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_3_reactstrap_lib_Row___default.a,
                { className: __WEBPACK_IMPORTED_MODULE_8__UserSettings_css___default.a.checkboxContainer },
                subscriptions.map(function (subscription, sIndex) {
                  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    __WEBPACK_IMPORTED_MODULE_4_reactstrap_lib_Col___default.a,
                    { key: sIndex, lg: "6", sm: "12", xs: "12" },
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                      "div",
                      { className: __WEBPACK_IMPORTED_MODULE_8__UserSettings_css___default.a.checkboxes },
                      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_react_icheck_lib_Checkbox___default.a, { onChange: _this2.handleChange, name: subscription.id, checkboxClass: __WEBPACK_IMPORTED_MODULE_9__styles_icheck_square_blue_css___default.a["icheckbox_square-blue"], checkedClass: __WEBPACK_IMPORTED_MODULE_9__styles_icheck_square_blue_css___default.a.checked, label: subscription.name, checked: _this2.props.userSettings.data.profileInfo.subscriptionIds.indexOf(subscription.id) >= 0 })
                    )
                  );
                })
              )
            )
          );
        }),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "div",
          { className: __WEBPACK_IMPORTED_MODULE_8__UserSettings_css___default.a.textCenter },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            "button",
            { onClick: this.handleSubmit, type: "button", className: __WEBPACK_IMPORTED_MODULE_6_classnames___default()(__WEBPACK_IMPORTED_MODULE_8__UserSettings_css___default.a.marginTop40, __WEBPACK_IMPORTED_MODULE_8__UserSettings_css___default.a.blueButton1, __WEBPACK_IMPORTED_MODULE_8__UserSettings_css___default.a.mobileBlock, __WEBPACK_IMPORTED_MODULE_8__UserSettings_css___default.a.saveSubscriptionsButton) },
            "Save changes"
          )
        )
      );
    }
  }]);

  return SubscriptionSettings;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

var mapStateToProps = function mapStateToProps(state) {
  return {
    userSettings: state.userSettings
  };
};

var mapDispatchToProps = function mapDispatchToProps(dispatch) {
  return {
    userSettingsActions: Object(__WEBPACK_IMPORTED_MODULE_2_redux__["b" /* bindActionCreators */])(__WEBPACK_IMPORTED_MODULE_7__actions_userSettings__, dispatch)
  };
};

/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1_react_redux__["b" /* connect */])(mapStateToProps, mapDispatchToProps)(SubscriptionSettings));

/***/ }),

/***/ "./src/users/components/UserSettings/UserSettings.css":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"marginTop10":"UserSettings__marginTop10--jXv3d","marginTop20":"UserSettings__marginTop20--3XQJ3","marginTop40":"UserSettings__marginTop40--8Ases","marginLeft20":"UserSettings__marginLeft20--3-hWt","textCenter":"UserSettings__textCenter--1tutH","bold":"UserSettings__bold--gBGcW","blackLink":"UserSettings__blackLink--ramkL","underline":"UserSettings__underline--4tLcW","blueButton1":"UserSettings__blueButton1--m7VV1","bottomBlock":"UserSettings__bottomBlock--1oiZ-","block":"UserSettings__block--3ba8z","centered":"UserSettings__centered--2-oPp","mobileBlock":"UserSettings__mobileBlock--BpViT","disabled":"UserSettings__disabled--3Gwj9","blueButton2":"UserSettings__blueButton2--2nUrC","grayButton1":"UserSettings__grayButton1--17vz-","root":"UserSettings__root--3G4Qh","sidebar":"UserSettings__sidebar--1pp3J","infoWrapper":"UserSettings__infoWrapper--3fg3P","blueHeading":"UserSettings__blueHeading--1jcWr","bottomLineInputs":"UserSettings__bottomLineInputs--viuey","muted":"UserSettings__muted--2CSUS","avatar":"UserSettings__avatar--2KG3K","avatarDelete":"UserSettings__avatarDelete--1iZ8H","checkboxes":"UserSettings__checkboxes--3rmJN","checkboxContainer":"UserSettings__checkboxContainer--3Uln2","sidebarLinks":"UserSettings__sidebarLinks--2E-G6","active":"UserSettings__active--3gsOo","twitterIcon":"UserSettings__twitterIcon--2xXvQ","removeConnection":"UserSettings__removeConnection--24c8K","grayOverlay":"UserSettings__grayOverlay--1URix","createNewPasswordBox":"UserSettings__createNewPasswordBox--35Zwi","deleteAccountBox":"UserSettings__deleteAccountBox--C1j2X","grayText":"UserSettings__grayText--Ldenh","deleteConfirmButton":"UserSettings__deleteConfirmButton--1q_7J","cancelDeleteButton":"UserSettings__cancelDeleteButton--NMBqV","centerButtons":"UserSettings__centerButtons--RdP6t","inputLabels":"UserSettings__inputLabels--1q_6I","changePasswordInputs":"UserSettings__changePasswordInputs--3vCfV","changePasswordConfirmButton":"UserSettings__changePasswordConfirmButton--2rf4N","cancelChangePasswordButton":"UserSettings__cancelChangePasswordButton--3g5s_","deleteAccountButton":"UserSettings__deleteAccountButton--2AFQf","saveProfileChangesButton":"UserSettings__saveProfileChangesButton--1hApW","saveSocialButton":"UserSettings__saveSocialButton--3eWLD","saveSubscriptionsButton":"UserSettings__saveSubscriptionsButton--1NQDQ","bounce":"UserSettings__bounce--2x88T"};

/***/ }),

/***/ "./src/users/components/UserSettings/UserSettings.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__("./node_modules/react/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_router_dom__ = __webpack_require__("./node_modules/react-router-dom/es/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_redux__ = __webpack_require__("./node_modules/react-redux/es/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_redux__ = __webpack_require__("./node_modules/redux/es/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_classnames__ = __webpack_require__("./node_modules/classnames/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__actions_user__ = __webpack_require__("./src/actions/user.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__actions_userSettings__ = __webpack_require__("./src/users/actions/userSettings.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_Library_UserHeader__ = __webpack_require__("./src/components/Library/UserHeader/UserHeader.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_Library_Layout__ = __webpack_require__("./src/components/Library/Layout/Layout.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_Library_Layout_Sidebar__ = __webpack_require__("./src/components/Library/Layout/Sidebar.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__components_Library_Layout_Content__ = __webpack_require__("./src/components/Library/Layout/Content.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__ProfileSettings__ = __webpack_require__("./src/users/components/UserSettings/ProfileSettings.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__SocialSettings__ = __webpack_require__("./src/users/components/UserSettings/SocialSettings.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__SubscriptionSettings__ = __webpack_require__("./src/users/components/UserSettings/SubscriptionSettings.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__UserSettings_css__ = __webpack_require__("./src/users/components/UserSettings/UserSettings.css");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__UserSettings_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14__UserSettings_css__);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }



















var UserSettings = function (_Component) {
  _inherits(UserSettings, _Component);

  function UserSettings() {
    _classCallCheck(this, UserSettings);

    return _possibleConstructorReturn(this, (UserSettings.__proto__ || Object.getPrototypeOf(UserSettings)).apply(this, arguments));
  }

  _createClass(UserSettings, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this.props.getUserData();
      this.props.getSubscriptions();
    }
  }, {
    key: "render",
    value: function render() {
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_8__components_Library_Layout__["a" /* default */],
        { className: __WEBPACK_IMPORTED_MODULE_14__UserSettings_css___default.a.root, includeHeader: true, headerComponent: __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__components_Library_UserHeader__["a" /* default */], { person: { display_name: this.props.userSettings.data.profileInfo.display_name } }) },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_9__components_Library_Layout_Sidebar__["a" /* default */],
          { className: __WEBPACK_IMPORTED_MODULE_14__UserSettings_css___default.a.sidebar },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_1_react_router_dom__["a" /* Link */],
            { to: "/users/saved-stories", className: __WEBPACK_IMPORTED_MODULE_14__UserSettings_css___default.a.sidebarLinks },
            "Saved Stories"
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_1_react_router_dom__["a" /* Link */],
            { to: "/users/settings", className: __WEBPACK_IMPORTED_MODULE_4_classnames___default()(__WEBPACK_IMPORTED_MODULE_14__UserSettings_css___default.a.sidebarLinks, __WEBPACK_IMPORTED_MODULE_14__UserSettings_css___default.a.active) },
            "Account"
          )
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_10__components_Library_Layout_Content__["a" /* default */],
          null,
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__ProfileSettings__["a" /* default */], null),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12__SocialSettings__["a" /* default */], null),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13__SubscriptionSettings__["a" /* default */], null)
        )
      );
    }
  }]);

  return UserSettings;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

var mapStateToProps = function mapStateToProps(state) {
  return {
    userSettings: state.userSettings
  };
};

var mapDispatchToProps = function mapDispatchToProps(dispatch) {
  return {
    getUserData: Object(__WEBPACK_IMPORTED_MODULE_3_redux__["b" /* bindActionCreators */])(__WEBPACK_IMPORTED_MODULE_5__actions_user__["a" /* getUserData */], dispatch),
    getSubscriptions: Object(__WEBPACK_IMPORTED_MODULE_3_redux__["b" /* bindActionCreators */])(__WEBPACK_IMPORTED_MODULE_6__actions_userSettings__["getSubscriptions"], dispatch)
  };
};

/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_2_react_redux__["b" /* connect */])(mapStateToProps, mapDispatchToProps)(UserSettings));

/***/ }),

/***/ "./src/users/reducers/userSettings.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_immutability_helper__ = __webpack_require__("./node_modules/immutability-helper/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_immutability_helper___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_immutability_helper__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_groupBy__ = __webpack_require__("./node_modules/lodash/groupBy.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_groupBy___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_lodash_groupBy__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__constants_actionTypes__ = __webpack_require__("./src/constants/actionTypes.js");
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };





var initialState = {
  isLoading: false,
  isFinished: false,
  isError: false,
  error: null,
  results: [],
  data: {
    profileInfo: {
      first_name: "",
      last_name: "",
      email: "",
      job_title: "",
      industry: "",
      subscriptionIds: [],
      savedStoryIds: [],
      saved_stories: [],
      linkedin: "",
      facebook: "",
      twitter: ""
    },
    subscriptions: []
  }
};

/* harmony default export */ __webpack_exports__["a"] = (function () {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
  var action = arguments[1];

  switch (action.type) {
    case __WEBPACK_IMPORTED_MODULE_2__constants_actionTypes__["_13" /* GET_USER_DATA */]:
      {
        return Object.assign({}, state, {
          isLoading: true,
          isFinished: false,
          isError: false,
          error: null
        });
      }

    case __WEBPACK_IMPORTED_MODULE_2__constants_actionTypes__["_15" /* GET_USER_DATA_SUCCESS */]:
      {
        // Pull out subscription IDs from array of objects
        var subscriptionIds = action.payload.subscriptions.map(function (subscription) {
          return subscription.id;
        });

        // Pull out saved story IDs from array of objects
        var savedStoryIds = action.payload.saved_stories.map(function (saved_story) {
          return saved_story.id;
        });

        var payloadWithDetails = Object.assign({}, action.payload, {
          display_name: action.payload.first_name + " " + action.payload.last_name,
          subscriptionIds: subscriptionIds,
          savedStoryIds: savedStoryIds,
          isLoading: false,
          isFinished: true
        });

        return __WEBPACK_IMPORTED_MODULE_0_immutability_helper___default()(state, {
          data: {
            $merge: {
              profileInfo: payloadWithDetails
            }
          }
        });
      }

    case __WEBPACK_IMPORTED_MODULE_2__constants_actionTypes__["_14" /* GET_USER_DATA_ERROR */]:
      {
        return Object.assign({}, state, {
          isLoading: false,
          isFinished: true,
          isError: true,
          error: action.payload
        });
      }

    case __WEBPACK_IMPORTED_MODULE_2__constants_actionTypes__["_46" /* TYPING_USER_SETTINGS */]:
      {
        return __WEBPACK_IMPORTED_MODULE_0_immutability_helper___default()(state, {
          data: {
            profileInfo: {
              $merge: action.payload
            }
          }
        });
      }

    case __WEBPACK_IMPORTED_MODULE_2__constants_actionTypes__["_39" /* SUBMIT_USER_SETTINGS */]:
      {
        return Object.assign({}, state, {
          isLoading: true,
          isFinished: false,
          isError: false,
          error: null
        });
      }

    case __WEBPACK_IMPORTED_MODULE_2__constants_actionTypes__["_41" /* SUBMIT_USER_SETTINGS_SUCCESS */]:
      {
        var newState = Object.assign({}, state, {
          isLoading: false,
          isFinished: true
        });

        return __WEBPACK_IMPORTED_MODULE_0_immutability_helper___default()(newState, {
          data: {
            profileInfo: {
              $merge: {
                display_name: action.payload.first_name + " " + action.payload.last_name
              }
            }
          }
        });
      }

    case __WEBPACK_IMPORTED_MODULE_2__constants_actionTypes__["_40" /* SUBMIT_USER_SETTINGS_ERROR */]:
      {
        return Object.assign({}, state, {
          isLoading: false,
          isFinished: true,
          isError: true,
          error: action.payload
        });
      }

    case __WEBPACK_IMPORTED_MODULE_2__constants_actionTypes__["_16" /* GET_USER_SUBSCRIPTIONS */]:
      {
        return Object.assign({}, state, {
          isLoading: true,
          isFinished: false,
          isError: false,
          error: null
        });
      }

    case __WEBPACK_IMPORTED_MODULE_2__constants_actionTypes__["_18" /* GET_USER_SUBSCRIPTIONS_SUCCESS */]:
      {
        var _newState = Object.assign({}, state, {
          isLoading: false,
          isFinished: true
        });

        return __WEBPACK_IMPORTED_MODULE_0_immutability_helper___default()(_newState, {
          data: {
            subscriptions: {
              $merge: __WEBPACK_IMPORTED_MODULE_1_lodash_groupBy___default()(action.payload, "subscription_type")
            }
          }
        });
      }

    case __WEBPACK_IMPORTED_MODULE_2__constants_actionTypes__["f" /* CHANGE_USER_SUBSCRIPTIONS */]:
      {
        return __WEBPACK_IMPORTED_MODULE_0_immutability_helper___default()(state, {
          data: {
            profileInfo: {
              $merge: {
                subscriptionIds: action.payload
              }
            }
          }
        });
      }

    case __WEBPACK_IMPORTED_MODULE_2__constants_actionTypes__["_38" /* SUBMIT_USER_SAVED_STORIES_SUCCESS */]:
      {
        return __WEBPACK_IMPORTED_MODULE_0_immutability_helper___default()(state, {
          data: {
            profileInfo: {
              $merge: {
                savedStoryIds: action.payload
              }
            }
          }
        });
      }

    case __WEBPACK_IMPORTED_MODULE_2__constants_actionTypes__["_20" /* LOG_OUT */]:
      {
        return _extends({}, state, {
          data: {
            profileInfo: {
              first_name: "",
              last_name: "",
              email: "",
              job_title: "",
              industry: "",
              subscriptionIds: [],
              savedStoryIds: [],
              saved_stories: [],
              linkedin: "",
              facebook: "",
              twitter: ""
            },
            subscriptions: []
          }
        });
      }

    default:
      {
        return state;
      }
  }
});

/***/ }),

/***/ "./src/utils/UniversalRouter.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__("./node_modules/react/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__("./node_modules/prop-types/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_router_dom__ = __webpack_require__("./node_modules/react-router-dom/es/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_router__ = __webpack_require__("./node_modules/react-router/es/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_history__ = __webpack_require__("./node_modules/history/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_history___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_history__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_config_constants__ = __webpack_require__("./src/config/constants.js");
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }









var UniversalRouter = function (_React$Component) {
  _inherits(UniversalRouter, _React$Component);

  function UniversalRouter(props) {
    _classCallCheck(this, UniversalRouter);

    var _this = _possibleConstructorReturn(this, (UniversalRouter.__proto__ || Object.getPrototypeOf(UniversalRouter)).call(this, props));

    _this.trackPageview = _this._trackPageview.bind(_this);

    if (typeof window !== "undefined") {
      _this.history = Object(__WEBPACK_IMPORTED_MODULE_4_history__["createBrowserHistory"])(props);
      _this.history.listen(_this.trackPageview);
    }
    return _this;
  }

  _createClass(UniversalRouter, [{
    key: "_trackPageview",
    value: function _trackPageview(location) {
      var routesToNotTrack = ["/authorize", new RegExp("^/([A-Za-z0-9-]+-)?" + __WEBPACK_IMPORTED_MODULE_5_config_constants__["n" /* URL_ID_REGEXP */] + ".html")];

      if (!routesToNotTrack.some(function (route) {
        return location.pathname.match(route);
      })) {
        window.dataLayer.push({
          "Card": false,
          "event": "GA_Virtual_Pageviews_Event"
        });
      }
    }
  }, {
    key: "render",
    value: function render() {
      if (typeof window === "undefined") {
        return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_router__["b" /* StaticRouter */], {
          location: this.props.path,
          context: this.props.context,
          children: this.props.children
        });
      } else {
        return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_router_dom__["c" /* Router */], {
          children: this.props.children,
          history: this.history
        });
      }
    }
  }]);

  return UniversalRouter;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

/* harmony default export */ __webpack_exports__["a"] = (UniversalRouter);


UniversalRouter.propTypes = {
  children: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.node,
  path: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  context: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object
};

/***/ }),

/***/ "./src/utils/analytics.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* global dataLayer, _sf_async_config, pSUPERFLY, _cc10461, Sailthru, COMSCORE */
function initialize() {
  gtmTitle();
  initComscore();
}

function gtmTitle() {
  if (document.title.indexOf(" - Axios") > 0) {
    var slicedTitle = document.title.slice(0, document.title.indexOf(" - Axios"));
    dataLayer.push({ title: slicedTitle });
  }
}

function initComscore() {
  window._comscore = window._comscore || [];

  window._comscore.push({ c1: "2", c2: "24196029" });

  var s = document.createElement("script");
  var el = document.getElementsByTagName("script")[0];
  s.async = true;
  s.src = (document.location.protocol === "https:" ? "https://sb" : "http://b") + ".scorecardresearch.com/beacon.js";
  el.parentNode.insertBefore(s, el);
}

function setUser(id) {
  dataLayer.push({ "userID Data Layer Var": id });
}

function setStream(stream) {
  dataLayer.push({ "Stream": stream });
}

function setSections(sections) {
  _sf_async_config.sections = sections.map(function (s) {
    return s.slug;
  }).join(",");
}

function setAuthors(authors) {
  _sf_async_config.authors = authors.map(function (author) {
    return author.username;
  }).join(",");
}

function pageView() {
  dataLayer.push({
    "Card": false,
    "event": "GA_Virtual_Pageviews_Event"
  });
}

function storyPageView(story, stream) {
  dataLayer.push({
    "Headline": story.headline,
    "Stream": stream,
    "Authors": story.authors && story.authors.map(function (author) {
      return author.display_name;
    }).join("|"),
    "Primary Section": story.primary_section && story.primary_section.name,
    "Sections": story.sections && story.sections.map(function (section) {
      return section.name;
    }).join("|"),
    "Primary Tag": story.primary_tag && story.primary_tag.name,
    "Tags": story.tags && story.tags.map(function (tag) {
      return tag.name;
    }).join("|"),
    "Post ID": story.id,
    "Card": true,
    "Rubric": story.rubric && story.rubric.name,
    "event": "GA_Virtual_Pageviews_Event"
  });
}

/*
  This event should be triggered if a post is still in view 3 seconds
  after it was initially registered in the viewport
 */
function userScrollsStoryIntoView(data) {
  var story = data.story,
      stream = data.stream;


  storyPageView(story, stream);

  // Chartbeat
  setSections(story.sections.concat(story.primary_section || []));
  setAuthors(story.authors);
  typeof pSUPERFLY !== "undefined" && pSUPERFLY.virtualPage(story.permalink, story.headline);

  // Lotame
  var sectionTags = story.sections.concat(story.primary_section || []).map(function (s) {
    return s.slug;
  }).concat(story.tags.concat(story.primary_tag || []).map(function (t) {
    return t.name;
  }));
  var postAttributes = sectionTags.join().replace(/ /g, "_");
  typeof _cc10461 !== "undefined" && _cc10461.bcpw("int", postAttributes, "act", postAttributes);

  // Sailthru
  typeof Sailthru !== "undefined" && Sailthru.track("pageview", {
    url: story.permalink
  });

  // Comscore
  typeof COMSCORE !== "undefined" && COMSCORE.beacon({ c1: "2", c2: " 24196029" });
}

var isStoryInView = function isStoryInView(card) {
  // In view story is one where top is above top of page and bottom is still in view
  var bounds = card.getBoundingClientRect();
  return bounds.top < 60 && bounds.bottom > 60;
};

/* harmony default export */ __webpack_exports__["a"] = ({
  initialize: initialize,
  gtmTitle: gtmTitle,
  initComscore: initComscore,
  setUser: setUser,
  setStream: setStream,
  setSections: setSections,
  setAuthors: setAuthors,
  pageView: pageView,
  storyPageView: storyPageView,
  userScrollsStoryIntoView: userScrollsStoryIntoView,
  isStoryInView: isStoryInView
});

/***/ }),

/***/ "./src/utils/auth.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export eventFilter */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return refreshToken; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return updateAxiosToken; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return checkAuthStatus; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return backendLogOut; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return setNonce; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return getFacebookUrl; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return getLinkedInUrl; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__constants_authDrawer__ = __webpack_require__("./src/constants/authDrawer.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__config_constants__ = __webpack_require__("./src/config/constants.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__backend__ = __webpack_require__("./src/utils/backend.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__constants_actionTypes__ = __webpack_require__("./src/constants/actionTypes.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__localdb__ = __webpack_require__("./src/utils/localdb.js");
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };







var eventFilter = function eventFilter(event, expectedSource) {
  try {
    return event && event.origin === window.location.origin && event.isTrusted && event.source && "name" in event.source && event.source.name === expectedSource && event.data && "authToken" in event.data && event.data.authToken;
  } catch (e) {
    return false;
  }
};

// Refresh token by opening up invisible iFrame
var refreshToken = function refreshToken() {
  // The token will be refreshed, so there's no reason to keep it anymore.
  Object(__WEBPACK_IMPORTED_MODULE_4__localdb__["b" /* removeLocalItem */])("authToken");

  var framePromise = new Promise(function (resolve) {
    var iframe = document.createElement("iframe");

    iframe.src = __WEBPACK_IMPORTED_MODULE_0__constants_authDrawer__["a" /* AUTH_URL */];
    iframe.width = 0;
    iframe.height = 0;
    iframe.style.border = "none";
    iframe.name = "reauthorization iframe";

    document.body.appendChild(iframe);

    window.addEventListener("message", function (event) {
      if (eventFilter(event, iframe.name)) {
        resolve(event.data.authToken);
        iframe.remove();
      }
    });
  });

  var timeoutPromise = new Promise(function (resolve, reject) {
    var timeoutId = window.setTimeout(function () {
      window.clearTimeout(timeoutId);
      reject();
    }, 5000);
  });

  return Promise.race([framePromise, timeoutPromise]);
};

var updateAxiosToken = function updateAxiosToken(token) {
  var authToken = void 0;

  if (token) {
    authToken = token;

    Object(__WEBPACK_IMPORTED_MODULE_4__localdb__["c" /* setLocalItem */])("authToken", authToken, { expires: 31 });
  } else {
    authToken = Object(__WEBPACK_IMPORTED_MODULE_4__localdb__["a" /* getLocalItem */])("authToken");
  }

  // Update Axios instance to send headers after auth
  __WEBPACK_IMPORTED_MODULE_2__backend__["a" /* default */].defaults.headers.common = _extends({}, __WEBPACK_IMPORTED_MODULE_2__backend__["a" /* default */].defaults.headers.common, {
    Authorization: "Bearer " + authToken
  });
};

var checkAuthStatus = function checkAuthStatus() {
  return function (dispatch) {
    if (Object(__WEBPACK_IMPORTED_MODULE_4__localdb__["a" /* getLocalItem */])("authToken")) {
      return dispatch({
        type: __WEBPACK_IMPORTED_MODULE_3__constants_actionTypes__["_19" /* LOGGED_IN_STATUS */],
        payload: true
      });
    } else {
      dispatch({
        type: __WEBPACK_IMPORTED_MODULE_3__constants_actionTypes__["_19" /* LOGGED_IN_STATUS */],
        payload: false
      });
    }
  };
};

// Log out of the backend
var backendLogOut = function backendLogOut() {
  var iframe = document.createElement("iframe");

  iframe.src = __WEBPACK_IMPORTED_MODULE_0__constants_authDrawer__["i" /* LOGOUT_URL */];
  iframe.width = 0;
  iframe.height = 0;
  iframe.style.border = "none";
  iframe.name = "logout iframe";

  document.body.appendChild(iframe);
};

var setNonce = function setNonce() {
  if (!window) {
    return;
  }
  var socialNonce = void 0;

  if (window.crypto && window.crypto.getRandomValues) {
    socialNonce = window.crypto.getRandomValues(new Uint32Array(1))[0].toString();
  } else {
    socialNonce = (Math.random() * 1e10).toString(36);
  }

  Object(__WEBPACK_IMPORTED_MODULE_4__localdb__["c" /* setLocalItem */])("socialNonce", socialNonce);
};

var getNonce = function getNonce() {
  return Object(__WEBPACK_IMPORTED_MODULE_4__localdb__["a" /* getLocalItem */])("socialNonce");
};

var getAuthorizeUrl = function getAuthorizeUrl() {
  var nonce = getNonce();
  var socialRedirectUri = encodeURIComponent(__WEBPACK_IMPORTED_MODULE_1__config_constants__["j" /* FRONTEND_ROOT */] + "/authorize?next=" + encodeURIComponent(__WEBPACK_IMPORTED_MODULE_1__config_constants__["j" /* FRONTEND_ROOT */]));
  return __WEBPACK_IMPORTED_MODULE_1__config_constants__["b" /* BACKEND_ROOT */] + "/o/authorize?client_id=" + __WEBPACK_IMPORTED_MODULE_0__constants_authDrawer__["b" /* CLIENT_ID */] + "&redirect_uri=" + socialRedirectUri + "&scope=read%20write&response_type=token&state=" + nonce;
};

var getFacebookUrl = function getFacebookUrl() {
  var authUrl = getAuthorizeUrl();
  return __WEBPACK_IMPORTED_MODULE_1__config_constants__["b" /* BACKEND_ROOT */] + "/login/facebook/?next=" + encodeURIComponent(authUrl);
};

var getLinkedInUrl = function getLinkedInUrl() {
  var authUrl = getAuthorizeUrl();
  return __WEBPACK_IMPORTED_MODULE_1__config_constants__["b" /* BACKEND_ROOT */] + "/login/linkedin-oauth2/?next=" + encodeURIComponent(authUrl);
};

/***/ }),

/***/ "./src/utils/backend.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__("./node_modules/axios/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__config_constants__ = __webpack_require__("./src/config/constants.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__auth__ = __webpack_require__("./src/utils/auth.js");




var headers = {};

if (typeof window === "undefined") {
  headers["User-Agent"] = "First Order";
}

var axiosInstance = __WEBPACK_IMPORTED_MODULE_0_axios___default.a.create({
  baseURL: __WEBPACK_IMPORTED_MODULE_1__config_constants__["a" /* API_ROOT */],
  headers: headers
});

var tries = 0;

axiosInstance.interceptors.response.use(null, function (err) {
  if (err.response.status === 403) {
    return Object(__WEBPACK_IMPORTED_MODULE_2__auth__["e" /* refreshToken */])().then(function (authToken) {
      Object(__WEBPACK_IMPORTED_MODULE_2__auth__["g" /* updateAxiosToken */])(authToken);

      tries++;

      if (tries < 5) {
        // Retry the request with all the same configuration, except do _not_ reuse the Auth header
        delete err.config.headers.Authorization;
        return axiosInstance.request(err.config);
      }

      return Promise.reject(err);
    }).catch(function () {
      return Promise.reject(err);
    });
  }

  return Promise.reject(err);
});

/* harmony default export */ __webpack_exports__["a"] = (axiosInstance);

/***/ }),

/***/ "./src/utils/blockHTML.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__("./node_modules/react/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_Library_Caption__ = __webpack_require__("./src/components/Library/Caption/Caption.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_Library_Embed__ = __webpack_require__("./src/components/Library/Embed/Embed.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_Library_Image__ = __webpack_require__("./src/components/Library/Image/Image.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_Library_KeepReading__ = __webpack_require__("./src/components/Library/KeepReading/KeepReading.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_Library_Quote__ = __webpack_require__("./src/components/Library/Quote/Quote.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_Library_QuoteAttribution__ = __webpack_require__("./src/components/Library/QuoteAttribution/QuoteAttribution.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_Library_StoryBody_StoryBody_css__ = __webpack_require__("./src/components/Library/StoryBody/StoryBody.css");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_Library_StoryBody_StoryBody_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__components_Library_StoryBody_StoryBody_css__);









/* harmony default export */ __webpack_exports__["a"] = ({
  "paragraph": __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", { className: __WEBPACK_IMPORTED_MODULE_7__components_Library_StoryBody_StoryBody_css___default.a.paragraph }),
  "unstyled": __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", { className: __WEBPACK_IMPORTED_MODULE_7__components_Library_StoryBody_StoryBody_css___default.a.paragraph }),
  "unordered-list-item": {
    element: __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li", { className: __WEBPACK_IMPORTED_MODULE_7__components_Library_StoryBody_StoryBody_css___default.a.item }),
    nest: __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("ul", { className: __WEBPACK_IMPORTED_MODULE_7__components_Library_StoryBody_StoryBody_css___default.a.unorderedList })
  },
  "ordered-list-item": {
    element: __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li", { className: __WEBPACK_IMPORTED_MODULE_7__components_Library_StoryBody_StoryBody_css___default.a.item }),
    nest: __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("ol", { className: __WEBPACK_IMPORTED_MODULE_7__components_Library_StoryBody_StoryBody_css___default.a.orderedList })
  },
  "styled-quote": __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__components_Library_Quote__["a" /* default */], { styled: true }),
  "plain-quote": __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__components_Library_Quote__["a" /* default */], { styled: false }),
  "quote-attribution": function quoteAttribution(block, extras) {
    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__components_Library_QuoteAttribution__["a" /* default */], { block: block, extras: extras });
  },
  "caption": __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__components_Library_Caption__["a" /* default */], null),
  "header-one": __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("h1", null),
  // header-two needs to be h4 to nest correctly within heading structure for screen readers
  "header-two": __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("h4", { className: __WEBPACK_IMPORTED_MODULE_7__components_Library_StoryBody_StoryBody_css___default.a.subhead }),
  "header-three": __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("h3", null),
  "header-four": __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("h4", null),
  "header-five": __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("h5", null),
  "header-six": __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("h6", null),
  "code-block": __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("pre", null),
  "blockquote": __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("blockquote", null),
  "media": __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("figure", null),
  "image": function image(block) {
    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__components_Library_Image__["a" /* default */], { block: block });
  },
  "embed": function embed(block, extras, isClient) {
    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__components_Library_Embed__["a" /* default */], { block: block, isClient: isClient });
  },
  "keep-reading": function keepReading(block, extras) {
    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__components_Library_KeepReading__["a" /* default */], { block: block, extras: extras });
  },
  "default": __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", { className: __WEBPACK_IMPORTED_MODULE_7__components_Library_StoryBody_StoryBody_css___default.a.paragraph, "data-unsupported": "true" })
});

/***/ }),

/***/ "./src/utils/clipboard.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_styles_global_css__ = __webpack_require__("./src/styles/global.css");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_styles_global_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_styles_global_css__);


/**
 * @param {string} data - data to put on the clipboard
 */
/* harmony default export */ __webpack_exports__["a"] = (function (data) {
  document.getSelection().removeAllRanges();

  var copyInput = document.createElement("input");
  copyInput.classList = __WEBPACK_IMPORTED_MODULE_0_styles_global_css__["a11yOnly"];
  copyInput.style.position = "fixed";
  copyInput.style.zIndex = -100;
  copyInput.style.top = "42vh";
  copyInput.value = data;
  document.body.appendChild(copyInput);
  copyInput.focus();
  copyInput.setSelectionRange(0, copyInput.value.length);
  if (document.queryCommandSupported("copy") && document.execCommand("copy")) {
    copyInput.blur();
    document.body.removeChild(copyInput);
    return true;
  }
});

/***/ }),

/***/ "./src/utils/embed.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return handleEmbed; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_pym_js__ = __webpack_require__("./node_modules/pym.js/dist/pym.v1.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_pym_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_pym_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_config_constants__ = __webpack_require__("./src/config/constants.js");
// @TODO: implement bundle splitting here for pym




var renderXFBML = function renderXFBML(block) {
  var element = document.querySelector(".block-" + block.key);
  window.FB.XFBML.parse(element);
};

var attachJWListerners = function attachJWListerners(htmlId, mediaId, isAutoplay) {
  // JW Player JS documentation
  // https://developer.jwplayer.com/jw-player/docs/javascript-api-reference/
  var player = window.jwplayer(htmlId);
  var gtmTimeout = void 0;
  var gtmCalled = false;

  player.on("firstFrame", function () {
    // Turn on captions by default when the player starts playing.
    // Axios currently only uploads (and plans to upload) one captions track 2/2/2018
    // Note from JW: The caption at index of 0 will always be "off" and will always be returned even if no captions are present.
    // To turn off captions, use setCurrentCaptions(0)
    if (player.getCaptionsList().length > 1) {
      player.setCurrentCaptions(1);
    }
  });

  player.on("play", function () {
    // Ping GTM if a video is played for longer than 3s
    // This is a JPMC KPI for Smarter Faster
    if (!gtmCalled) {
      gtmTimeout = setTimeout(function () {
        window.dataLayer.push({ mediaId: mediaId, event: "jw-player-3s-viewed" });
        gtmCalled = true;
      }, 3000);
    }
  });

  player.on("pause", function () {
    // Clear 3s-viewed timeout if a video pauses
    // A pauses event fires if a user scrolls out of view
    clearTimeout(gtmTimeout);
  });

  player.on("viewable", function (e) {
    // JW emits an event whenever a player scrolls in or out of view.
    // Play videos if they scroll into view
    // Pause if they scroll out of view
    if (e.viewable === 0) {
      player.pause(true);
    } else if (e.viewable === 1 && isAutoplay) {
      player.play(true);
    }
  });

  // player.on("playAttemptFailed", () => {
  //   player.stop();
  // });
};

var handleEmbed = function handleEmbed(block) {
  var _block$data = block.data,
      oembed = _block$data.oembed,
      type = _block$data.type,
      _block$data$config = _block$data.config,
      config = _block$data$config === undefined ? {} : _block$data$config;


  switch (type) {
    case "facebook-post":
    case "facebook-video":
      {
        // Facebook sdk.js documentation
        // https://developers.facebook.com/docs/javascript
        // If Facebook's JS hasn't loaded, append it to the body of the doc,
        // then add an init function once it loads which renders embeds.
        // Otherwise, use FB's JS to render embeds
        if (!window.FB) {
          var script = document.createElement("script");
          script.setAttribute("src", "//connect.facebook.net/en_US/sdk.js#xfbml=1&version=v" + __WEBPACK_IMPORTED_MODULE_1_config_constants__["i" /* FB_JS_SDK_VERSION */]);
          document.body.appendChild(script);
          window.fbAsyncInit = function () {
            window.FB.init({ version: "v" + __WEBPACK_IMPORTED_MODULE_1_config_constants__["i" /* FB_JS_SDK_VERSION */], xfbml: true });
            renderXFBML(block);
          };
        } else {
          renderXFBML(block);
        }
        break;
      }
    case "instagram":
      {
        // Instagram embed documentation
        // https://www.instagram.com/developer/embedding/
        var instgrm = window.instgrm;
        if (instgrm) instgrm.Embeds.process();
        break;
      }
    case "twitter":
      {
        // Twitter embed documentation
        // https://dev.twitter.com/web/embedded-tweets#render-a-tweet-with-javascript
        var twttr = window.twttr;
        if (twttr) twttr.widgets.load();
        break;
      }
    case "jwplayer-video":
      {
        // JW Player JS documentation
        // https://developer.jwplayer.com/jw-player/docs/javascript-api-reference/
        var isAutoplay = config.autoplay;
        var playerId = isAutoplay ? oembed.autoplay_player_id : oembed.default_player_id;
        var htmlId = "botr_" + oembed.media_id + "_" + playerId + "_div";

        var jwEmbedScript = document.createElement("script");
        jwEmbedScript.setAttribute("src", "https://content.jwplatform.com/players/" + oembed.media_id + "-" + playerId + ".js");
        jwEmbedScript.setAttribute("type", "text/javascript");
        document.getElementById("jw-" + oembed.media_id).appendChild(jwEmbedScript);
        jwEmbedScript.onload = function () {
          attachJWListerners(htmlId, oembed.media_id, isAutoplay);
        };
        break;
      }
    case "axios-visual":
      {
        if (oembed.slug && oembed.url) new __WEBPACK_IMPORTED_MODULE_0_pym_js__["Parent"](oembed.slug, oembed.url);
        break;
      }
    default:
      break;
  }
};

/***/ }),

/***/ "./src/utils/entityToHTML.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return entityToHTML; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__("./node_modules/react/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_Library_InternalLoadLink__ = __webpack_require__("./src/components/Library/InternalLoadLink/InternalLoadLink.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__config_constants__ = __webpack_require__("./src/config/constants.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__utils__ = __webpack_require__("./src/utils/utils.js");





var entityToHTML = function entityToHTML(story, styles) {
  return function (entity, originalText) {
    if (entity.type.toLowerCase() === __WEBPACK_IMPORTED_MODULE_2__config_constants__["f" /* ENTITY_TYPE */].LINK) {
      var matches = Object(__WEBPACK_IMPORTED_MODULE_3__utils__["a" /* isInternalURL */])(entity.data.url);
      if (matches && matches.length > 1) {
        return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__components_Library_InternalLoadLink__["a" /* default */], {
          name: originalText,
          href: entity.data.url,
          identifier: matches[1] + "-" + story.id,
          className: styles.link });
      }
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("a", { href: entity.data.url, className: styles.link });
    }
    return originalText;
  };
};

/***/ }),

/***/ "./src/utils/formatPublishedDate.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__("./node_modules/react/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_date_fns_distance_in_words_strict__ = __webpack_require__("./node_modules/date-fns/distance_in_words_strict/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_date_fns_distance_in_words_strict___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_date_fns_distance_in_words_strict__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_date_fns_difference_in_days__ = __webpack_require__("./node_modules/date-fns/difference_in_days/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_date_fns_difference_in_days___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_date_fns_difference_in_days__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_date_fns_difference_in_years__ = __webpack_require__("./node_modules/date-fns/difference_in_years/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_date_fns_difference_in_years___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_date_fns_difference_in_years__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_date_fns_format__ = __webpack_require__("./node_modules/date-fns/format/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_date_fns_format___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_date_fns_format__);






/* harmony default export */ __webpack_exports__["a"] = (function (content) {
  if (content.published_date) {
    if (__WEBPACK_IMPORTED_MODULE_3_date_fns_difference_in_years___default()(content.published_date, new Date()) <= -1) {
      // More than a year: "[3-letter month] [day], [year]"
      return __WEBPACK_IMPORTED_MODULE_4_date_fns_format___default()(content.published_date, "MMM D, YYYY");
    } else if (__WEBPACK_IMPORTED_MODULE_2_date_fns_difference_in_days___default()(content.published_date, new Date()) <= -1) {
      // More than a day but less than a year: "[3-letter month] [day]" (e.g. "Sep 5")
      return __WEBPACK_IMPORTED_MODULE_4_date_fns_format___default()(content.published_date, "MMM D");
    }
    // Less than an hour old: "[x] mins ago"
    // Less than a day but more than an hour: "[x] hrs ago"
    var distance = __WEBPACK_IMPORTED_MODULE_1_date_fns_distance_in_words_strict___default()(new Date(), content.published_date, { addSuffix: true });
    return distance.replace("minute", "min");
  } else {
    if (content.status && content.status !== "published") {
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "i",
        null,
        "unpublished"
      );
    } else {
      // Published items with a published date of null are a big no-no.
      // This maybe should even throw an error.
      return null;
    }
  }
});

/***/ }),

/***/ "./src/utils/localdb.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return getLocalItem; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return setLocalItem; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return removeLocalItem; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_js_cookie__ = __webpack_require__("./node_modules/js-cookie/src/js.cookie.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_js_cookie___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_js_cookie__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__config_constants__ = __webpack_require__("./src/config/constants.js");
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();




var _FRONTEND_ROOT$split = __WEBPACK_IMPORTED_MODULE_1__config_constants__["j" /* FRONTEND_ROOT */].split("://"),
    _FRONTEND_ROOT$split2 = _slicedToArray(_FRONTEND_ROOT$split, 2),
    proto = _FRONTEND_ROOT$split2[0],
    domain = _FRONTEND_ROOT$split2[1];

domain = domain.split(":")[0];

var getLocalItem = function getLocalItem(key) {
  return __WEBPACK_IMPORTED_MODULE_0_js_cookie__["getJSON"](key);
};

var setLocalItem = function setLocalItem(key, value, params) {
  return __WEBPACK_IMPORTED_MODULE_0_js_cookie__["set"](key, value, _extends({
    domain: domain,
    secure: proto === "https"
  }, params));
};

var removeLocalItem = function removeLocalItem(key, params) {
  return __WEBPACK_IMPORTED_MODULE_0_js_cookie__["remove"](key, _extends({ domain: domain }, params));
};

/***/ }),

/***/ "./src/utils/log.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_raven_js__ = __webpack_require__("./node_modules/raven-js/src/singleton.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_raven_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_raven_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_config_constants__ = __webpack_require__("./src/config/constants.js");
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

/* eslint-disable no-console */





var Log = function () {
  function Log() {
    _classCallCheck(this, Log);
  }

  _createClass(Log, null, [{
    key: "setup",
    value: function setup() {
      if (__WEBPACK_IMPORTED_MODULE_1_config_constants__["k" /* IS_PROD */] && !__WEBPACK_IMPORTED_MODULE_0_raven_js___default.a.isSetup()) {
        __WEBPACK_IMPORTED_MODULE_0_raven_js___default.a.config(__WEBPACK_IMPORTED_MODULE_1_config_constants__["l" /* RAVEN_DSN */], {
          environment: "production",
          release: "unknown"
        }).install();
      }
    }

    /**
     * Log an error to Sentry
     * @param {*} msg - Error message or instance
     * @param {String} level - severity
     * @param {Object} extra - supplemental data to pass to Raven
     * @param {Boolean} toConsole - true if this error should be logged to the console as well.
     * @param {Array<String>} fingerprint - see https://docs.sentry.io/learn/rollups/#customize-grouping-with-fingerprints
     */

  }, {
    key: "logger",
    value: function logger(msg, level, extra) {
      var toConsole = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : true;
      var fingerprint = arguments[4];

      if (__WEBPACK_IMPORTED_MODULE_1_config_constants__["k" /* IS_PROD */]) {
        this.setup();
        __WEBPACK_IMPORTED_MODULE_0_raven_js___default.a.captureException(msg, {
          level: level,
          fingerprint: fingerprint,
          extra: _extends({}, extra, msg.context)
        });
      }

      if (toConsole) {
        switch (level) {
          case "error":
            console.error(msg);
            break;
          case "warning":
            console.warn(msg);
            break;
          default:
            console.log(msg);
        }
      }
    }
  }, {
    key: "error",
    value: function error(err) {
      this.logger(err, "error");
    }
  }, {
    key: "warn",
    value: function warn(msg) {
      this.logger(msg, "warning");
    }
  }, {
    key: "log",
    value: function log(msg) {
      this.logger(msg, "info");
    }
  }, {
    key: "context",
    value: function context(fn) {
      if (__WEBPACK_IMPORTED_MODULE_1_config_constants__["k" /* IS_PROD */]) {
        this.setup();
        return __WEBPACK_IMPORTED_MODULE_0_raven_js___default.a.context(fn);
      }
    }
  }]);

  return Log;
}();

/* harmony default export */ __webpack_exports__["a"] = (Log);

/***/ }),

/***/ "./src/utils/scroll.css":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"frozen":"scroll__frozen--1Q9Bb"};

/***/ }),

/***/ "./src/utils/server.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return getRedirectPath; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__("./node_modules/axios/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_url__ = __webpack_require__("./node_modules/url/url.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_url___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_url__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_config_constants__ = __webpack_require__("./src/config/constants.js");





var getRedirectPath = function getRedirectPath(req, uuid, context) {
  return __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get(__WEBPACK_IMPORTED_MODULE_2_config_constants__["a" /* API_ROOT */] + "lookup/" + uuid + "/").then(function (resp) {
    var parsedUrl = new __WEBPACK_IMPORTED_MODULE_1_url__["URL"](resp.data.permalink);

    // If the permalink is different than the url that was requested, pass redirect in context.
    if (parsedUrl.pathname != req.path) {
      context.status = 301;
      context.path = parsedUrl.pathname;
    }
  }).catch(function () {
    return Promise.resolve();
  });
};

/***/ }),

/***/ "./src/utils/toggleScroll.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return freezeScroll; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return thawScroll; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__scroll_css__ = __webpack_require__("./src/utils/scroll.css");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__scroll_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__scroll_css__);


/**
 * Toggle freezing of the stream. Used while modals are open.
 */
/* harmony default export */ __webpack_exports__["a"] = (function () {
  if (typeof document !== "undefined") {
    var body = document.querySelector("body");

    if (body && body.classList) {
      if (body.classList.contains(__WEBPACK_IMPORTED_MODULE_0__scroll_css__["frozen"])) {
        body.classList.remove(__WEBPACK_IMPORTED_MODULE_0__scroll_css__["frozen"]);
      } else {
        body.classList.add(__WEBPACK_IMPORTED_MODULE_0__scroll_css__["frozen"]);
      }
    }
  }
});

var freezeScroll = function freezeScroll() {
  if (typeof document !== "undefined") {
    var body = document.querySelector("body");

    if (body && body.classList) {
      body.classList.add(__WEBPACK_IMPORTED_MODULE_0__scroll_css__["frozen"]);
    }
  }
};

var thawScroll = function thawScroll() {
  if (typeof document !== "undefined") {
    var body = document.querySelector("body");

    if (body && body.classList) {
      body.classList.remove(__WEBPACK_IMPORTED_MODULE_0__scroll_css__["frozen"]);
    }
  }
};

/***/ }),

/***/ "./src/utils/utils.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return isInternalURL; });
/* unused harmony export isStoryIdentifier */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_config_constants__ = __webpack_require__("./src/config/constants.js");


var isInternalURL = function isInternalURL(url) {
  var rootUrl = __WEBPACK_IMPORTED_MODULE_0_config_constants__["j" /* FRONTEND_ROOT */].match(/https?:\/\/(.*)/)[1];
  // eslint-disable-next-line no-useless-escape
  var regex = new RegExp("^(?:https?://)?(?:" + rootUrl + ")(?:/.*?-|/)?" + __WEBPACK_IMPORTED_MODULE_0_config_constants__["n" /* URL_ID_REGEXP */] + "(?:.html){1}", "i");
  return url.match(regex);
};

var isStoryIdentifier = function isStoryIdentifier(url) {
  var regex = /(?:^|-)(?:([0-9a-f]{8}-[0-9a-f]{4}-[1-5][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12})|([0-9]+))(?:\.html){1}/i;
  return url.match(regex);
};

/***/ })

},["./src/browser.js"]);


// WEBPACK FOOTER //
// browser.0a0b0103a3447ba057ad.js